{
  "tooltipsButtons": {
    "chat": {
      "composer": {
        "attachFile": "إرفاق ملف",
        "emoji": "إدراج رمز تعبيري",
        "insertMention": "الإشارة إلى جهة اتصال",
        "send": "إرسال الرسالة",
        "stop": "إيقاف الرد",
        "startVoice": "بدء التسجيل الصوتي",
        "stopVoice": "إيقاف التسجيل الصوتي"
      },
      "codeBlock": {
        "copy": "نسخ الكود",
        "copied": "تم النسخ",
        "download": "تنزيل الكود"
      },
      "webPreview": {
        "refresh": "تحديث المعاينة",
        "openExternal": "فتح في علامة تبويب جديدة",
        "back": "رجوع",
        "forward": "تقدم"
      },
      "manageQuickReplies": {
        "addReply": "إضافة رد",
        "deleteSection": "حذف القسم",
        "editLabel": "اضغط للتعديل",
        "renameSection": "اضغط لإعادة التسمية",
        "openColorPicker": "اختر لون القسم",
        "dragHandle": "اسحب لإعادة الترتيب"
      },
      "messenger": {
        "exitFullscreen": "الخروج من ملء الشاشة",
        "back": "العودة إلى جهات الاتصال",
        "clearSearch": "مسح البحث"
      }
    },
    "eventTypes": {
      "card": {
        "edit": "تعديل نوع الحدث",
        "deactivate": "إلغاء تفعيل النوع",
        "dragHandle": "اسحب لإعادة الترتيب"
      },
      "customFields": {
        "removeField": "إزالة الحقل"
      }
    },
    "auth": {
      "passwordToggle": {
        "show": "إظهار كلمة المرور",
        "hide": "إخفاء كلمة المرور"
      }
    },
    "shared": {
      "copy": "نسخ إلى الحافظة",
      "copied": "تم النسخ",
      "togglePlan": "تبديل الخطة"
    },
    "notifications": {
      "open": "فتح الإشعارات"
    },
    "settings": {
      "open": "فتح الإعدادات",
      "close": "إغلاق الإعدادات",
      "vacation": {
        "add": "إضافة فترة إجازة",
        "remove": "حذف فترة الإجازة",
        "recordStart": "تسجيل تاريخ البداية",
        "recordEnd": "تسجيل تاريخ النهاية",
        "stopRecord": "إيقاف التسجيل",
        "pickDateRange": "اختيار نطاق التاريخ",
        "templates": "فتح القوالب"
      }
    },
    "navigation": {
      "openSidebar": "فتح الشريط الجانبي",
      "closeSidebar": "إغلاق الشريط الجانبي",
      "documents": "المستندات",
      "calendar": "التقويم",
      "dashboard": "لوحة التحكم",
      "previous": "السابق",
      "next": "التالي"
    },
    "documents": {
      "editDefaultTemplate": "تعديل القالب الافتراضي للمستند",
      "openCalendar": "فتح التقويم"
    },
    "admin": {
      "orgSecrets": {
        "toggleVisibility": "تبديل الإظهار",
        "close": "إغلاق"
      }
    }
  },
  "tooltipsTours": {
    "dashboard": {
      "step1Title": "لوحة التحكم في لمحة",
      "step1Description": "أرقام لحظية عن نشاطك.",
      "step1Item0Title": "إجمالي الأحداث",
      "step1Item0Caption": "تتبّع كل حدث محجوز في النطاق المحدد — وانظر ما الذي يتصاعد من فترة إلى أخرى.",
      "step1Item0KpiLabel": "إجمالي الأحداث",
      "step1Item0KpiValue": "1,247",
      "step1Item0KpiDelta": "+12.4%",
      "step1Item0KpiFooter": "مقارنةً بالفترة السابقة",
      "step1Item1Title": "زمن الاستجابة",
      "step1Item1Caption": "مدى سرعة ردّ وكيلك — راقب الخط ينخفض مع تحسين خطط العمل.",
      "step1Item1ChartLabel": "متوسط زمن الاستجابة (دقيقة)",
      "step1Item2Title": "خريطة الرسائل الحرارية",
      "step1Item2Caption": "حدّد الساعات المزدحمة لتوزّع التغطية حين يهمّ الأمر فعلاً.",
      "step1Item2HeatmapLabel": "الساعات المزدحمة · آخر 7 أيام",
      "step2Title": "اقرأ مؤشراتك الرئيسية",
      "step2Description": "ما تعنيه الأرقام الكبيرة فعلاً.",
      "step2KpiConvTitle": "إجمالي الأحداث",
      "step2KpiConvValue": "1,247",
      "step2KpiConvDelta": "+12.4%",
      "step2KpiConvHelp": "الأحداث المحجوزة في النطاق المحدد. انظر إلى الفرق — أي شيء فوق +5% يعني نمواً حقيقياً في الطلب.",
      "step2KpiResponseTitle": "معدّل التحويل",
      "step2KpiResponseValue": "38%",
      "step2KpiResponseDelta": "+3.1%",
      "step2KpiResponseHelp": "نسبة المحادثات التي تنتهي بحدث محجوز. ارتفاع الفرق يعني أن الوكيل يُتمّ حجوزات أكثر.",
      "step2KpiAvgTimeTitle": "متوسط الاستجابة",
      "step2KpiAvgTimeValue": "3.2د",
      "step2KpiAvgTimeDelta": "-18.0%",
      "step2KpiAvgTimeHelp": "الوسيط الزمني للرد الأول. السهم النازل جيّد — ردود أسرع، عملاء أسعد.",
      "step2KpiActiveTitle": "المستخدمون النشطون",
      "step2KpiActiveValue": "47",
      "step2KpiActiveDelta": "+6.2%",
      "step2KpiActiveHelp": "عدد جهات الاتصال النشطة في النطاق المحدد. استخدمه للتخطيط للسعة.",
      "step3Title": "اكتشف الاتجاهات سريعاً",
      "step3Description": "الرسوم البيانية تتحدّث تلقائياً؛ مرّر فوقها للقيم الدقيقة.",
      "step3LineChartTitle": "زمن الاستجابة · 7 أيام",
      "step3LineChartCaption": "وسيط الدقائق حتى الردّ الأول، يوماً بيوم.",
      "step3BarChartTitle": "الأحداث حسب اليوم",
      "step3BarChartCaption": "الأحداث المنشأة، موزّعة حسب اليوم.",
      "step3HoverHint": "مرّر فوق أي نقطة أو شريط لرؤية القيمة الدقيقة.",
      "step4Title": "نصائح احترافية",
      "step4Description": "استفد من لوحة التحكم إلى أقصى حد.",
      "step4TipsHeading": "نصائح",
      "step4Tip1": "خمسة تبويبات — نظرة عامة، الاتجاهات، الرسائل، الرؤى، الملاحظات — لكلٍّ منها رسومه الخاصة.",
      "step4Tip2": "اختر أي نطاق تاريخي من الأعلى — كل البطاقات والرسوم تتبعه.",
      "step4Tip3": "استخدم تبويب الرؤى للحصول على ملخّصات مولّدة بالذكاء الاصطناعي.",
      "step4Tip4": "صدّر لوحة التحكم كاملة بصيغة CSV أو PDF أو JSON أو DOCX من زر التصدير في الأعلى.",
      "completeLabel": "فهمت",
      "dayMon": "إثن",
      "dayTue": "ثلا",
      "dayWed": "أرب",
      "dayThu": "خمي",
      "dayFri": "جمع",
      "daySat": "سبت",
      "daySun": "أحد"
    },
    "account": {
      "welcome": {
        "title": "حسابك بين يديك",
        "description": "تعرّف على أقسامه في أقل من دقيقة."
      },
      "overview": {
        "profile": {
          "title": "الملف الشخصي",
          "description": "اسمك وبريدك وصورتك الرمزية — الأساسيات التي يراها الآخرون."
        },
        "security": {
          "title": "الأمان",
          "description": "الجلسات النشطة ومفاتيح المرور في مكان واحد."
        },
        "privacy": {
          "title": "الخصوصية",
          "description": "حدّد فترات الاحتفاظ وصدّر بياناتك متى شئت."
        },
        "appearance": {
          "title": "المظهر",
          "description": "وضع المظهر والألوان ونمط العناصر — اجعله على ذوقك."
        }
      },
      "preview": {
        "profile": {
          "name": "عائشة صالح",
          "email": "aisha@bavard.com"
        },
        "security": {
          "heading": "كل شيء على ما يرام",
          "session1": "Chrome على macOS",
          "thisDevice": "هذا الجهاز",
          "passkey": "MacBook Pro · مفتاح مرور"
        },
        "privacy": {
          "heading": "المحادثات",
          "conversations": "نافذة الحذف التلقائي"
        },
        "appearance": {
          "heading": "المظهر"
        }
      },
      "security": {
        "title": "حافظ على أمان حسابك",
        "description": "مفاتيح المرور أسهل وأكثر أمانًا من كلمات المرور.",
        "sessionsTitle": "الجلسات النشطة",
        "sessionsSubtitle": "الأجهزة المسجَّل دخولها حاليًا في حسابك.",
        "session": {
          "current": {
            "label": "Chrome على macOS",
            "meta": "الرياض · قبل دقيقتين"
          },
          "old": {
            "label": "Safari على iPhone 14",
            "meta": "جدة · قبل ٦ أيام"
          }
        },
        "thisDevice": "هذا الجهاز",
        "revoke": "إلغاء",
        "passkeyLabel": "MacBook Pro",
        "passkeyMeta": "أُضيف في ٢٨ أبريل ٢٠٢٦",
        "passkeyExplainer": "يتيح لك مفتاح المرور تسجيل الدخول ببصمة إصبعك أو وجهك — دون الحاجة إلى كلمات مرور."
      },
      "privacy": {
        "title": "بياناتك بشروطك",
        "description": "حدّد فترات الاحتفاظ وصدّر بياناتك في أي وقت.",
        "retentionTitle": "الاحتفاظ بالبيانات",
        "retentionSubtitle": "مدة بقاء كل نوع من البيانات قبل حذفه تلقائيًا.",
        "retention": {
          "conversations": "المحادثات",
          "attachments": "المرفقات",
          "auditLogs": "سجلات التدقيق"
        },
        "exportLabel": "تصدير بياناتي",
        "exportExplainer": "احصل على ملف ZIP بكل ما لدينا عنك في أي وقت.",
        "exportCta": "تصدير"
      },
      "appearance": {
        "title": "اجعله على ذوقك",
        "description": "الوضع ولون المظهر ونمط العناصر — كلها قابلة للتبديل.",
        "theme": "المظهر",
        "style": "النمط",
        "colors": "لون المظهر",
        "light": "فاتح",
        "dark": "داكن",
        "system": "النظام",
        "embossed": "بارز",
        "flat": "مسطّح",
        "tipTheme": "المظهر يتبع نظامك تلقائيًا — بدّل بين الفاتح والداكن لتجاوز ذلك.",
        "tipColors": "مرّر فوق أي لون لمعاينته مباشرة — لا يتغيّر شيء حتى تضغط.",
        "tipStyle": "النمط البارز يمنح العناصر عمقًا وملمسًا، والمسطّح يبقيها بسيطة. بدّل متى شئت."
      },
      "completeLabel": "تم"
    },
    "calendar": {
      "closeAriaLabel": "إغلاق الجولة",
      "skipLabel": "تخطّي الجولة",
      "backLabel": "رجوع",
      "nextLabel": "التالي",
      "completeLabel": "لنبدأ",
      "step1": {
        "title": "مرحبًا بك في تقويمك",
        "description": "إليك أهم ما يميّزه — ثلاث دقائق وأربع شاشات.",
        "item": {
          "conversations": {
            "title": "كل المحادثات في مكان واحد",
            "caption": "تظهر محادثات واتساب وتيليجرام وإنستغرام والدردشة على الويب بجانب التقويم لترد دون أن تفقد السياق."
          },
          "calendar": {
            "title": "تقويم يتكيّف مع طريقتك",
            "caption": "اسحب الأحداث وأفلتها وغيّر مدتها. بدّل بين عرض اليوم والأسبوع والشهر — تُحفظ التغييرات فورًا."
          },
          "notifications": {
            "title": "ابقَ على اطلاع بكل جديد",
            "caption": "تظهر الإشارات والحجوزات والتذكيرات في لوحة واحدة منظَّمة — لا صندوق وارد مزدحم."
          }
        }
      },
      "step2": {
        "title": "إدارة محادثاتك",
        "description": "ثبِّت أو أرشِف أو افتح أي محادثة من الشريط الجانبي.",
        "surface": {
          "label": "المحادثات"
        },
        "annotation": {
          "pin": {
            "label": "ثبِّت المحادثات المهمة",
            "description": "أبقِ كبار العملاء والمحادثات النشطة في الأعلى دائمًا."
          },
          "archive": {
            "label": "أرشِف المنتهية",
            "description": "أخفِ المحادثات المغلقة دون حذف سجلّها."
          },
          "search": {
            "label": "اعثر على أيٍّ بسرعة",
            "description": "ابحث بالاسم أو رقم الهاتف أو محتوى الرسالة في أي وقت."
          }
        },
        "tips": {
          "title": "نصائح"
        },
        "tip": {
          "open": "انقر على المحادثة لفتحها في اللوحة الرئيسية.",
          "reorder": "ثبّت المحادثات التي تعمل عليها وأرشف المنتهية — شارات غير المقروء والإشارات تُبقي الباقي ظاهرًا.",
          "search": "استخدم البحث للوصول إلى محادثات قديمة حتى بعد أرشفتها."
        }
      },
      "step3": {
        "title": "نظِّم يومك",
        "description": "اسحب لتنقل، انقر للتحرير، انقر على وقت فارغ للإنشاء.",
        "subtext": "اسحب أي حدث لتغيير موعده. انقر على وقت فارغ لإضافة حدث جديد.",
        "choice": {
          "move": {
            "title": "اسحب لتغيير الموعد",
            "description": "أمسك الحدث وأفلِته في فترة جديدة — تُحفظ التغييرات فورًا."
          },
          "create": {
            "title": "انقر على وقت فارغ للإضافة",
            "description": "انقر على أي فترة شاغرة لإنشاء حدث جديد بضغطة واحدة."
          }
        }
      },
      "step4": {
        "title": "الإشعارات تُبقيك على اطلاع",
        "description": "أيقونة الجرس تُظهر كل ما هو جديد لحظة حدوثه.",
        "surface": {
          "label": "الإشعارات"
        },
        "tips": {
          "title": "نصائح"
        },
        "tip": {
          "click": "انقر على الإشعار لتنتقل مباشرة إلى مصدره — رسالة أو حدث أو جهة اتصال.",
          "autoread": "تُعلَّم الإشعارات كمقروءة تلقائيًا بمجرد فتح اللوحة."
        }
      },
      "preview": {
        "conversations": {
          "label": "صندوق الوارد"
        },
        "calendar": {
          "label": "اليوم"
        },
        "notifications": {
          "label": "الأحدث"
        }
      },
      "mock": {
        "contact": {
          "alex": "أليكس ريفيرا",
          "maya": "مايا بارك",
          "sam": "سام لويد"
        },
        "preview": {
          "alex": "تأكيد موعدنا 11 صباحًا — أراك حينها ☕",
          "maya": "@أنت هل يمكننا تأجيل مراجعة التصميم؟",
          "sam": "شكرًا! نتحدث الأسبوع القادم."
        },
        "event": {
          "standup": "اجتماع يومي",
          "coffee": "قهوة مع أليكس",
          "review": "مراجعة التصميم"
        },
        "notification": {
          "message": {
            "title": "رسالة جديدة من مايا",
            "subtitle": "أشارت إليك في محادثة."
          },
          "event": {
            "title": "تذكير بحدث · قهوة مع أليكس",
            "subtitle": "يبدأ خلال ساعة."
          }
        }
      }
    },
    "documents": {
      "welcome": {
        "title": "مستند بخط اليد لكل جهة اتصال",
        "description": "اكتب بحرّية على لوحة رسم بقلم جهازك اللوحي — لكل جهة اتصال مستندها الخاص."
      },
      "skipAriaLabel": "إغلاق الجولة",
      "backLabel": "رجوع",
      "nextLabel": "التالي",
      "completeLabel": "فهمت",
      "overview": {
        "write": {
          "title": "اكتب بشكل طبيعي",
          "description": "لوحة رسم كاملة بقلم وأشكال ونصوص — مصمّمة للجهاز اللوحي والقلم، وتعمل بالفأرة أيضًا."
        },
        "contact": {
          "title": "مستند لكل جهة اتصال",
          "description": "تعرض لوحة البيانات في الأعلى صاحب المستند الحالي — وكل ما تكتبه يبقى محفوظًا مع جهة الاتصال هذه."
        },
        "autosave": {
          "title": "يُحفظ أثناء الكتابة",
          "description": "كل خط يُحفظ تلقائيًا — ويخبرك مؤشر الحالة عندما يكون كل شيء محفوظًا بأمان."
        }
      },
      "preview": {
        "write": {
          "toolbarLabel": "ارسم، اكتب، امسح"
        },
        "contact": {
          "heading": "بيانات جهة الاتصال",
          "nameLabel": "الاسم",
          "nameValue": "سارة تشن",
          "phoneLabel": "الهاتف"
        },
        "autosave": {
          "savedLabel": "تم الحفظ"
        }
      },
      "canvas": {
        "title": "جهة الاتصال تقود اللوحة",
        "description": "تعرض اللوحة العلوية جهة الاتصال المحمّلة — أكمل بياناتها وتصبح لوحة الرسم جاهزة لك.",
        "editLabel": "تعديل",
        "canvasCaption": "اكتب في أي مكان على اللوحة — يبقى خطّك محفوظًا تمامًا كما رسمته.",
        "lockHint": "تبقى اللوحة مقفلة حتى تُملأ الحقول المطلوبة لجهة الاتصال."
      },
      "tips": {
        "title": "معلومات مفيدة",
        "description": "ثلاثة أشياء توضّح طريقة عمل صفحة المستندات.",
        "heading": "جرّب التالي"
      },
      "tip": {
        "loadContact": "بدّل المستندات من درج التقويم — اضغط Ctrl+Alt+S ثم اختر \"تحميل جهة اتصال\".",
        "lock": "اللوحة مقفلة؟ أكمل أولًا الحقول المطلوبة لجهة الاتصال في اللوحة أعلاها.",
        "viewer": "فعّل العارض من إعدادات الصفحة للحصول على جزء قراءة منفصل، أو انتقل إلى ملء الشاشة للكتابة دون تشتيت."
      }
    },
    "activity": {
      "welcome": {
        "title": "كل تغيير في موجز واحد",
        "description": "يلتقط النشاط من فعل ماذا ومتى — في كامل مساحة عملك."
      },
      "skipAriaLabel": "إغلاق الجولة",
      "backLabel": "رجوع",
      "nextLabel": "التالي",
      "completeLabel": "فهمت",
      "overview": {
        "changes": {
          "title": "تابع ما تغيّر",
          "description": "إشعارات لحظية حين ينشئ زملاؤك أو يعدّلون أو يحذفون أي شيء يخصّك."
        },
        "tabs": {
          "title": "ركّز مع الكل / غير المقروء",
          "description": "تبويبان في الأعلى: كل شيء، أو ما لم تطّلع عليه فقط. زر \"تحديد الكل كمقروء\" يصفّر المتراكم بلمسة."
        },
        "actions": {
          "title": "تصرّف من الموجز مباشرة",
          "description": "ردّ على الرسائل في المكان نفسه، أو انتقل إلى الحدث الذي يشير إليه الإشعار، أو تجاهل الضجيج."
        }
      },
      "preview": {
        "changes": {
          "heading": "أحدث الأنشطة",
          "line1": "أنشأت سارة \"المراجعة الفصلية\"",
          "line2": "تقويم · قبل دقيقتين"
        },
        "tabs": {
          "all": "الكل",
          "unread": "غير المقروء"
        },
        "actions": {
          "messageTitle": "مايا: \"هل يمكن تأجيل موعد الرابعة؟\"",
          "messageMeta": "واتساب · الآن",
          "reply": "ردّ",
          "viewEvent": "عرض الحدث",
          "dismiss": "تجاهل"
        }
      },
      "timeline": {
        "title": "اقرأ المخطط الزمني",
        "description": "السجلات مجمّعة في \"اليوم\" و\"سابقًا\"، الأحدث أولًا. التعديلات تعرض ما تغيّر على البطاقة نفسها.",
        "heading": "النشاط",
        "markAll": "تحديد الكل كمقروء",
        "bucket": {
          "today": "اليوم",
          "earlier": "سابقًا"
        }
      },
      "feed": {
        "sarahCreate": {
          "title": "Sarah Chen أنشأت \"المراجعة الفصلية\"",
          "subtitle": "حدث تقويم · 30 دقيقة، مجدول للجمعة"
        },
        "tomUpdate": {
          "title": "Tom Hardy حدّث ساعات العمل",
          "subtitle": "إعدادات · الإثنين 9ص → 8ص"
        },
        "systemNotify": {
          "title": "أرسل النظام إشعار إعادة تواصل",
          "subtitle": "إشعارات · 12 جهة اتصال خاملة"
        },
        "alexInvite": {
          "title": "Alex Park دعا زميلًا",
          "subtitle": "أعضاء · jordan@bavard.com انضم كمحرر"
        },
        "mayaCancel": {
          "title": "Maya Patel ألغت \"مكالمة تعريفية\"",
          "subtitle": "حدث تقويم · كان مجدولًا في 30 أبريل"
        }
      },
      "tips": {
        "title": "استفد أكثر من النشاط",
        "description": "ثلاث عادات تُبقي الموجز في خدمتك.",
        "heading": "جرّب التالي"
      },
      "tip": {
        "click": "إشعارات الرسائل فيها زر \"ردّ\" — أجب في المكان نفسه دون مغادرة الموجز.",
        "filter": "اعتمد تبويب \"غير المقروء\" واضغط \"تحديد الكل كمقروء\" بعد المتابعة — تبقى الشارة صادقة.",
        "export": "واصل التمرير: السجلات الأقدم تُحمَّل تلقائيًا حتى نهاية السجل."
      }
    },
    "admin": {
      "welcome": {
        "title": "أدر مساحة العمل",
        "description": "اعتمد المستخدمين، أدِر المؤسسات، وادعُ فرقًا كاملة من مكان واحد."
      },
      "skipAriaLabel": "إغلاق الجولة",
      "backLabel": "رجوع",
      "nextLabel": "التالي",
      "completeLabel": "فهمت",
      "overview": {
        "awaiting": {
          "title": "مستخدمون بانتظار الموافقة",
          "description": "ينتهي بهم المطاف هنا — راجع وعيّن وافتح الطريق في ثوانٍ."
        },
        "orgs": {
          "title": "إدارة المؤسسات",
          "description": "عدّل المؤسسات مباشرة في الجدول — الاسم والمعرّف والخطة وحالة التفعيل — ثم احفظ كل شيء دفعة واحدة."
        },
        "invites": {
          "title": "الدعوات",
          "description": "ادعُ الأعضاء بالبريد الإلكتروني مع تحديد الدور — ويُطبَّق حدّ مقاعد المؤسسة تلقائيًا."
        }
      },
      "preview": {
        "awaiting": {
          "heading": "بانتظار الإسناد",
          "user": "Priya Patel · priya.patel@acme.co"
        },
        "orgs": {
          "heading": "المؤسسات النشطة",
          "acme": "Acme Co.",
          "north": "Northwind Labs",
          "pine": "Pinegrove Studio"
        },
        "invites": {
          "heading": "ادعُ زميلًا",
          "subtitle": "بريد إلكتروني + دور — يُحتسب ضمن مقاعد خطة المؤسسة.",
          "cta": "إرسال دعوة"
        }
      },
      "approve": {
        "title": "إسناد المستخدمين المنتظرين",
        "description": "كل صف يعرض الخطة التي اشترك بها المستخدم — أسنده إلى مؤسسة جديدة أو مؤسسة قائمة.",
        "heading": "المستخدمون المنتظرون",
        "refreshLabel": "تحديث تلقائي",
        "column": {
          "user": "المستخدم",
          "plan": "الخطة",
          "actions": "الإجراءات"
        },
        "approve": "مؤسسة جديدة",
        "decline": "مؤسسة قائمة"
      },
      "tips": {
        "title": "أفضل ممارسات الإدارة",
        "description": "ثلاث قواعد تحافظ على صحة مساحة عملك.",
        "heading": "جرّب التالي"
      },
      "tip": {
        "assign": "\"مؤسسة جديدة\" تُنشئ مؤسسة بالخطة التي اشترك بها المستخدم وتجعله مالكها — بنقرة واحدة.",
        "invite": "تعديلات الجدول تُجمَع معًا — شارة التبويب تعدّ التغييرات المعلّقة حتى تضغط حفظ.",
        "audit": "قائمة المستخدمين المنتظرين تتحدّث تلقائيًا كل 30 ثانية — لا حاجة لإعادة تحميل الصفحة."
      }
    },
    "config": {
      "welcome": {
        "title": "اضبط مساحة عملك",
        "description": "ست علامات تبويب تغطي المجالات الرئيسية."
      },
      "overview": {
        "general": {
          "title": "عام",
          "description": "اللغة والسلوك الافتراضي لمساحة العمل بأكملها."
        },
        "calendarDisplay": {
          "title": "عرض التقويم",
          "description": "ما يظهر في التقويم — العروض والألوان والكثافة."
        },
        "columns": {
          "title": "الأعمدة",
          "description": "إظهار وإخفاء وترتيب أعمدة جدول البيانات."
        },
        "emailTemplates": {
          "title": "قوالب البريد",
          "description": "محتوى الرسائل التلقائية للتأكيدات والتذكيرات."
        },
        "notifications": {
          "title": "الإشعارات",
          "description": "توجيه القنوات وساعات الهدوء حسب نوع الحدث."
        },
        "workingHours": {
          "title": "ساعات العمل",
          "description": "متى يكون الفريق متاحًا لاستقبال الحجوزات."
        }
      },
      "workingHours": {
        "title": "ساعات العمل بطريقتك",
        "description": "حدِّد الساعات الأساسية، والنطاقات المخصصة، والتجاوزات لكل يوم.",
        "daysCard": {
          "title": "أيام العمل",
          "description": "اختر أيام العمل والساعات الافتراضية التي تنطبق على كل يوم."
        },
        "startTime": {
          "label": "وقت البدء",
          "tooltip": "أبكر وقت في اليوم يمكن حجز المواعيد فيه. تُخفى الفترات قبل هذا الوقت."
        },
        "endTime": {
          "label": "وقت الانتهاء",
          "tooltip": "أحدث وقت في اليوم يمكن حجز المواعيد فيه. تُخفى الفترات بعد هذا الوقت."
        },
        "customCard": {
          "title": "نطاقات مخصصة للتقويم",
          "description": "تجاوز الساعات الافتراضية لأيام أو نطاقات تواريخ بعينها."
        },
        "customRange": {
          "tag": "مخصص"
        }
      },
      "save": {
        "title": "حفظ التغييرات",
        "description": "حرّر بحرية، واحفظ عندما تكون جاهزًا.",
        "actionsLabel": "الإجراءات",
        "button": "حفظ",
        "undo": "تراجع",
        "discard": "تجاهل",
        "explainer": {
          "batched": "تُتتبّع التعديلات في الشريط السفلي وتُحفظ معًا عند الضغط على «حفظ».",
          "discard": "«تجاهل» يُلغي جميع التغييرات المعلّقة دفعةً واحدة — لا شيء يُكتب حتى تحفظ."
        }
      },
      "tips": {
        "title": "نصائح للمستخدم المحترف",
        "description": "أمور يفوتها أغلب الفرق.",
        "perTab": "كل علامة تبويب تتعقّب تغييراتها المعلّقة بشكل مستقل — والعدّاد على الشريط الجانبي يخبرك بمكانها بالضبط.",
        "availability": "ساعات العمل تُغذّي مؤشّر التوفّر في التقويم وتتحكّم في الفترات القابلة للحجز.",
        "templates": "قوالب البريد تدعم متغيرات مثل {{contactName}} و{{eventDate}} — تتوسّع عند الإرسال.",
        "routing": "يمكن توجيه الإشعارات حسب نوع الحدث من علامة «الإشعارات» — اقرن ساعات الهدوء مع تجاوزات القنوات."
      },
      "completeLabel": "ابدأ التهيئة",
      "step1Title": "إعداد مساحة العمل",
      "step1Description": "تغطي 6 علامات تبويب كل شيء من ساعات العمل إلى الإشعارات.",
      "step1FeatureGeneralTitle": "عام",
      "step1FeatureGeneralDescription": "لغة مساحة العمل، والبلد الافتراضي، وتعليمات الوكيل العامة.",
      "step1FeatureCalendarDisplayTitle": "عرض التقويم",
      "step1FeatureCalendarDisplayDescription": "اختر ما يظهر في التقويم — الألوان، والشارات، وكثافة الخانات.",
      "step1FeatureColumnsTitle": "الأعمدة",
      "step1FeatureColumnsDescription": "حدد الحقول التي تظهر في جداول البيانات وترتيبها.",
      "step1FeatureEmailTemplatesTitle": "قوالب البريد الإلكتروني",
      "step1FeatureEmailTemplatesDescription": "عدّل رسائل البريد الإلكتروني التلقائية المرسلة عند الحجوزات والتذكيرات والمتابعات.",
      "step1FeatureNotificationsTitle": "الإشعارات",
      "step1FeatureNotificationsDescription": "وجّه التنبيهات حسب القناة واكتمها أثناء ساعات الهدوء.",
      "step1FeatureWorkingHoursTitle": "ساعات العمل",
      "step1FeatureWorkingHoursDescription": "حدّد أوقات توفر فريقك — الافتراضيات، والاستثناءات، والنطاقات المخصّصة.",
      "step1ItemCounter": "علامة التبويب {{n}} من {{total}}",
      "step2Title": "ساعات العمل بطريقتك",
      "step2Description": "اضبط الساعات الأساسية، والنطاقات المخصّصة، والاستثناءات حسب اليوم.",
      "step2CardTitle": "أيام العمل",
      "step2CardDescription": "اختر أيام العمل والساعات الافتراضية.",
      "step2WorkingDaysLabel": "أيام العمل",
      "step2WorkingDaysTooltip": "أيام الأسبوع التي يستقبل فيها عملك الحجوزات. تظهر الأيام المعطّلة كمغلقة في التقويم.",
      "step2DayMon": "الاثنين",
      "step2DayTue": "الثلاثاء",
      "step2DayWed": "الأربعاء",
      "step2DayThu": "الخميس",
      "step2DayFri": "الجمعة",
      "step2DaySat": "السبت",
      "step2DaySun": "الأحد",
      "step2DefaultHoursLabel": "الساعات الافتراضية",
      "step2StartTimeLabel": "البداية",
      "step2EndTimeLabel": "النهاية",
      "step2SlotDurationLabel": "مدة الخانة",
      "step2SlotDurationTooltip": "مدة كل خانة قابلة للحجز. اختر من مدد تقسم نافذة العمل بالتساوي.",
      "step2SlotDurationValue": "ساعة واحدة",
      "step2CustomRangeTitle": "نطاق مخصّص",
      "step2CustomRangeBadge": "1 نشط",
      "step2CustomRangeName": "الأربعاء يوم قصير",
      "step2CustomRangeMeta": "الأربعاء · 10:00 – 14:00",
      "step3Title": "حفظ التغييرات",
      "step3Description": "عدّل بحرية؛ احفظ عندما تكون جاهزًا.",
      "step3SaveBarLabel": "تغييرات غير محفوظة",
      "step3DiscardLabel": "تجاهل",
      "step3SaveButtonIdle": "حفظ التغييرات (3)",
      "step3SaveButtonSaving": "جارٍ الحفظ…",
      "step3SaveButtonSaved": "تم الحفظ",
      "step3Subtitle": "نتتبّع التعديلات غير المحفوظة في الشريط السفلي. يؤدي التجاهل إلى التراجع عنها؛ ويحفظ زر الحفظ كل شيء دفعة واحدة.",
      "step4Title": "نصائح للمستخدمين المتقدمين",
      "step4Description": "أمور تفوت معظم الفرق.",
      "step4TipsTitle": "نصائح",
      "step4Tip1": "تُحفَظ كل علامة تبويب بشكل مستقل — لا حاجة لحفظ كل شيء دفعة واحدة.",
      "step4Tip2": "تغذّي ساعات العمل مؤشر التوفر في التقويم.",
      "step4Tip3": "تدعم قوالب البريد متغيرات بأسلوب Liquid: {{contactName}}، {{eventDate}}.",
      "step4Tip4": "يمكن توجيه الإشعارات حسب نوع الحدث — افتح علامة تبويب الإشعارات لضبط القواعد."
    }
  },
  "tooltipsTabs": {
    "account": {
      "credentialsSessions": "البريد الإلكتروني وكلمة المرور ومفاتيح المرور وجلسات تسجيل الدخول",
      "privacyData": "تصدير بياناتك وإدارة الاحتفاظ بها والتحكم في الخصوصية",
      "profile": "الاسم المعروض والصورة الرمزية وبيانات الاتصال الشخصية",
      "notifications": "كيف ومتى يتم إشعارك عبر الفئات المختلفة",
      "appearance": "اختيار السمة ولون التمييز ولغة حسابك"
    },
    "activity": {
      "all": "جميع الإشعارات التي وردت، المقروءة وغير المقروءة",
      "unread": "الإشعارات التي لم تفتحها بعد فقط"
    },
    "admin": {
      "overview": "مؤشرات عالية المستوى عبر جميع المؤسسات",
      "waiting": "المستخدمون في انتظار الموافقة للانضمام إلى مؤسسة",
      "organizations": "إدارة المؤسسات والخطط والفوترة",
      "members": "تصفح وإدارة جميع حسابات الأعضاء في النظام",
      "roles": "تعريف الأدوار والصلاحيات الممنوحة لكل دور",
      "system": "حالة النظام في الوقت الفعلي والطوابير واستخدام الموارد",
      "feedback": "ملاحظات المستخدمين وتقارير الأخطاء المرسلة للتطبيق"
    },
    "adminSecrets": {
      "whatsapp": "بيانات اعتماد WhatsApp Cloud API والتحقق من الويبهوك",
      "messenger": "رموز الوصول إلى صفحة Facebook Messenger وسر التطبيق",
      "slack": "رمز بوت Slack وسر التوقيع وعميل OAuth",
      "discord": "رمز بوت Discord وبيانات اعتماد التطبيق",
      "telegram": "هوية بوت Telegram ومعرّف التوجيه وبيانات اعتماد الـ webhook",
      "teams": "بيانات اعتماد تسجيل تطبيق Microsoft Teams",
      "gchat": "ملف JSON لبيانات اعتماد حساب خدمة Google Chat",
      "github": "رمز الوصول الشخصي لـ GitHub أو بيانات اعتماد التطبيق",
      "linear": "مفتاح API لـ Linear وبيانات اعتماد عميل OAuth",
      "ai": "مفاتيح API لمزودي الذكاء الاصطناعي (OpenRouter)",
      "instagram": "بيانات اعتماد حساب Instagram الاحترافي والتحقق من الويبهوك",
      "x": "بيانات اعتماد تطبيق X ورموز حساب المؤسسة والويبهوك وإعداد المحادثات المشفرة"
    },
    "config": {
      "schedule": "ساعات العمل ومدة الموعد وإعدادات أنواع الفعاليات",
      "eventTypes": "تعريف أنواع الفعاليات التي يمكن للعملاء حجزها",
      "calendarDisplay": "تخطيط التقويم والعرض الافتراضي وتنسيق الوقت والألوان",
      "columns": "اختيار الأعمدة الظاهرة في جداول التقويم والمستندات",
      "appearance": "الثيمات والخطوط واللغات التي يمكن للمستخدمين التبديل إليها",
      "aiAssistant": "شخصية الذكاء الاصطناعي والتعليمات وسلوك الردود",
      "business": "الدولة والمنطقة الزمنية والعملة وموقع النشاط التجاري",
      "notificationRules": "تذكيرات ومتابعات تُرسل تلقائياً للفعاليات",
      "whatsapp": "التحكم في أدوات الذكاء الاصطناعي المتاحة عبر جميع قنوات العملاء",
      "emailTemplates": "قوالب بريد إلكتروني قابلة لإعادة الاستخدام للتأكيدات والتذكيرات"
    },
    "configContent": {
      "calendarColumns": "اختر الأعمدة التي تظهر في صفحة التقويم/جدول البيانات",
      "documentsColumns": "اختر الأعمدة التي تظهر في صفحة المستندات"
    },
    "documentsViewSettings": {
      "documents": "إعدادات محرر المستندات وجزء القراءة",
      "calendar": "إعدادات جزء التقويم المعروض بجانب المستندات"
    },
    "eventTypes": {
      "basics": "الاسم واللون والإعدادات الأساسية لنوع الفعالية",
      "duration": "مدة الموعد ووقت الفاصل والحد الأدنى للإشعار",
      "fields": "الحقول المخصصة التي تُجمع عند حجز هذه الفعالية",
      "rules": "حدود الحجز ونوافذ التوفر والتكرار"
    },
    "settings": {
      "view": "كثافة التخطيط والعرض الافتراضي والأعمدة الظاهرة",
      "general": "السمة واللغة وتنسيق الوقت والإعدادات الافتراضية الأخرى",
      "vacation": "حظر نطاقات تواريخ يرفض فيها التقويم الحجوزات"
    }
  },
  "system_error_try_later": "خطأ في النظام، يرجى المحاولة لاحقاً",
  "event_manager": "Bavard",
  "chat": "الدردشة",
  "left_calendar": "التقويم الأيسر",
  "right_calendar": "التقويم الأيمن",
  "cancel_event": "إلغاء الحجز",
  "cancelled_event": "تم إلغاء الحجز",
  "reinstate_event": "إعادة تفعيل الحجز",
  "past_event": "حجز سابق",
  "open_conversation": "فتح محادثة",
  "open_document": "فتح مستند",
  "view_details": "عرض التفاصيل",
  "save_error": "خطأ في الحفظ",
  "config_save_no_changes": "لا توجد تغييرات للحفظ",
  "config_save_version_conflict": "تم تغيير الإعدادات في مكان آخر. أعد تحميل أحدث نسخة وحاول مرة أخرى.",
  "config_conflict_dialog_title": "حل تعارضات الإعدادات",
  "config_conflict_dialog_desc": "تم دمج كل ما عدا هذه الإعدادات بالفعل. غيّرها شخص آخر أثناء تعديلك لها — اختر القيمة التي تريد اعتمادها.",
  "config_conflict_mine_label": "قيمتك",
  "config_conflict_theirs_label": "قيمتهم",
  "config_conflict_take_all_mine": "اعتماد قيمي كلها",
  "config_conflict_take_all_theirs": "اعتماد قيمهم كلها",
  "config_conflict_cancel": "إلغاء الحفظ",
  "config_conflict_save_merged": "حفظ الدمج",
  "config_save_conflict_cancelled": "تم إلغاء الحفظ.",
  "config_save_ignored_keys": "تم تجاهل {{count}} إعداد غير معروف أثناء الحفظ.",
  "theme_changed": "تم تغيير المظهر",
  "validation_errors": "أخطاء التحقق",
  "missing_required_fields": "الحقول المطلوبة مفقودة",
  "please_fill_prefix": "يرجى ملء: ",
  "create_failed": "فشل الإنشاء",
  "create_failed_verbose": "فشل إنشاء الحجز",
  "cancel_failed": "فشل الإلغاء",
  "update_failed": "فشل التحديث",
  "request_label": "طلب",
  "reason_label": "السبب",
  "view_default": "افتراضي",
  "view_default_tooltip_title": "العرض الافتراضي",
  "view_default_tooltip_desc": "تخطيط تقويم واحد قياسي مع واجهة مستخدم متوازنة وآلفة.",
  "view_free": "حر",
  "view_free_tooltip_title": "التجوال الحر",
  "view_free_tooltip_desc": "تنقل وتخطيط مرن للتصفح السريع وغير المقيد.",
  "view_dual": "ثنائي",
  "view_dual_tooltip_title": "تقويم ثنائي",
  "view_dual_tooltip_desc": "عرض تقويمين جنباً إلى جنب للمقارنة والتخطيط المتوازي.",
  "chat_type_message": "اكتب رسالة…",
  "chat_x_ttl_label": "تنتهي بعد",
  "chat_x_ttl_placeholder": "مللي ثانية",
  "chat_x_ttl_help": "اختياري لرسائل X المشفرة؛ اتركه فارغاً دون مدة مخصصة.",
  "chat_voice_start_recording": "ابدأ الإدخال الصوتي",
  "chat_voice_stop_recording": "إيقاف الإدخال الصوتي",
  "chat_voice_permission_denied": "تم رفض إذن الميكروفون",
  "chat_voice_hold_to_record": "اضغط مع الاستمرار للتسجيل",
  "chat_voice_release_to_send": "حرّر للإرسال",
  "chat_voice_slide_to_cancel": "اسحب للإلغاء",
  "chat_voice_release_to_cancel": "حرّر للإلغاء",
  "chat_voice_cancel_recording": "إلغاء التسجيل",
  "chat_voice_release_to_lock": "أفلت للتثبيت",
  "chat_voice_locked": "تسجيل بدون يدين",
  "chat_voice_paused": "متوقّف مؤقتًا",
  "chat_voice_pause": "إيقاف مؤقت",
  "chat_voice_resume": "استئناف",
  "chat_voice_send": "إرسال الرسالة الصوتية",
  "chat_mic_select": "اختر الميكروفون",
  "chat_mic_default": "الميكروفون الافتراضي",
  "chat_mic_permission": "اسمح بالوصول إلى الميكروفون لعرض الأجهزة",
  "chat_voice_recording": "جارٍ التسجيل…",
  "chat_voice_send_failed": "فشل إرسال الرسالة الصوتية",
  "chat_audio_play": "تشغيل",
  "chat_audio_pause": "إيقاف مؤقت",
  "chat_audio_seek_forward": "تقديم ١٠ ثوانٍ",
  "chat_audio_seek_back": "إرجاع ١٠ ثوانٍ",
  "chat_audio_playback_speed": "سرعة التشغيل",
  "chat_audio_attachment_alt": "رسالة صوتية",
  "chat_audio_load_failed": "تعذّر تحميل الصوت",
  "chat_attachment_preview": "معاينة المرفق",
  "chat_attachment_open": "فتح في علامة تبويب جديدة",
  "chat_attachment_preview_unavailable": "لا يمكن معاينة هذا التنسيق في المتصفح. لا يزال بإمكانك فتحه أو تنزيله.",
  "chat_attachment_download_failed": "تعذّر تنزيل المرفق",
  "chat_no_conversation": "اختر محادثة لبدء الدردشة",
  "chat_no_messages": "لا توجد رسائل في هذه المحادثة بعد",
  "chat_start_conversation": "ابدأ المحادثة بإرسال رسالة",
  "chat_system_agent_greeting_hello": "مرحباً!",
  "chat_system_agent_greeting_help": "كيف يمكنني مساعدتك اليوم؟",
  "chat_cannot_message_no_conversation": "لا يمكنك إرسال رسائل للمستخدمين الذين لم يبدأوا محادثة",
  "chat_messaging_unavailable": "المراسلة غير متاحة بعد 24 ساعة من عدم النشاط",
  "chat_ai_not_configured": "مساعد الذكاء الاصطناعي غير مهيأ. تواصل مع المسؤول.",
  "chat_loading_conversation": "جاري تحميل المحادثة…",
  "chat_loading_conversations": "جاري تحميل المحادثات…",
  "chat_select_conversation": "اختر محادثة",
  "chat_contact_no_messaging_address": "لا توجد وسيلة مراسلة لهذا الشخص.",
  "chat_no_conversations": "لا توجد محادثات متاحة",
  "chat_message_sent": "تم إرسال الرسالة",
  "chat_message_failed": "فشل إرسال الرسالة",
  "chat_instagram_routing_unavailable": "مسار محادثة Instagram غير متاح",
  "chat_instagram_send_failed": "تعذر إرسال رسالة Instagram",
  "chat_backend_unavailable": "خدمة الدردشة غير متاحة مؤقتاً. يرجى المحاولة مرة أخرى.",
  "chat_demo_limit_reached": "لقد وصلت إلى حد النسخة التجريبية — سجّل للمتابعة.",
  "chat_today": "اليوم",
  "chat_yesterday": "الأمس",
  "tool_approval_required_title": "مطلوب موافقة",
  "tool_approval_required_description": "الأداة {toolName} تتطلب موافقتك قبل التنفيذ.",
  "tool_approval_required_parameters": "المعلمات",
  "tool_approval_required_approve": "موافقة",
  "tool_approval_required_deny": "رفض",
  "tool_approval_required_processing": "جارٍ معالجة الموافقة…",
  "chat_actions_label": "إجراءات المحادثة",
  "chat_actions_trigger_label": "فتح إجراءات المحادثة",
  "chat_action_add_favorite": "إضافة إلى المفضلة",
  "chat_action_remove_favorite": "إزالة من المفضلة",
  "chat_action_block": "حظر المستخدم",
  "chat_action_unblock": "إلغاء الحظر",
  "chat_action_download": "تصدير…",
  "chat_action_disable_ai": "تعطيل الذكاء الاصطناعي",
  "chat_action_clear": "مسح المحادثة",
  "chat_action_summarize": "تلخيص بالذكاء الاصطناعي",
  "chat_action_save_as_qa": "حفظ كسؤال وجواب",
  "summary_dialog_title": "ملخص المحادثة",
  "summary_dialog_streaming": "جاري إنشاء الملخص…",
  "summary_dialog_done": "الملخص جاهز.",
  "summary_dialog_error": "تعذّر إنشاء الملخص.",
  "summary_dialog_saving": "جاري الحفظ…",
  "summary_dialog_saved": "تم الحفظ في لوحة التحكم.",
  "summary_dialog_thinking": "جاري التفكير…",
  "summary_dialog_save": "حفظ",
  "summary_dialog_saved_short": "تم الحفظ",
  "summary_dialog_download": "تنزيل",
  "summary_dialog_close": "إغلاق",
  "summary_section_overview": "نظرة عامة",
  "summary_section_reservations": "الحجوزات",
  "summary_section_feedback": "الملاحظات",
  "summary_section_notes": "ملاحظات",
  "summary_section_issues": "مشاكل مفتوحة",
  "summary_col_date": "التاريخ",
  "summary_col_time": "الوقت",
  "summary_col_type": "النوع",
  "summary_col_status": "الحالة",
  "clear_conversation": "مسح المحادثة",
  "clear_conversation_warning": "هل أنت متأكد أنك تريد مسح هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.",
  "clearing": "جارٍ المسح…",
  "clear": "مسح",
  "chat_action_favorited": "تمت الإضافة إلى المفضلة",
  "chat_action_unfavorited": "تمت الإزالة من المفضلة",
  "chat_action_blocked": "تم حظر المستخدم",
  "chat_action_unblocked": "تم إلغاء الحظر",
  "chat_action_cleared": "تم مسح المحادثة",
  "chat_action_error": "فشلت العملية. حاول مرة أخرى.",
  "ai_stream_error_title": "واجه المساعد مشكلة",
  "chat_blocked_notice": "لقد قمت بحظر هذا المستخدم. قم بإلغاء الحظر للمتابعة.",
  "chat_approval_pending_badge": "بحاجة إلى موافقة",
  "chat_approval_pending_tooltip": "هناك أداة ذكاء اصطناعي بانتظار موافقتك",
  "chat_tool_approval_failed": "فشل إرسال قرار الموافقة",
  "chat_system_agent_disabled_notice": "الوكيل الآلي متوقف في مساحة العمل هذه. فعّله من الإعدادات ← مساعد الذكاء الاصطناعي للتحدث معه مجدداً.",
  "messenger_contacts": "المحادثات",
  "messenger_inbox_title": "الوارد",
  "messenger_unread_count_label": "محادثات غير مقروءة",
  "messenger_refresh": "تحديث",
  "messenger_sort_and_actions": "الفرز والإجراءات",
  "messenger_sort_by": "الفرز حسب",
  "messenger_sort_date_newest": "التاريخ (الأحدث أولاً)",
  "messenger_sort_date_oldest": "التاريخ (الأقدم أولاً)",
  "messenger_sort_sender": "المُرسِل",
  "messenger_actions": "إجراءات",
  "messenger_mark_all_read": "تعليم الكل كمقروء",
  "messenger_archive_all_read": "أرشفة المقروء",
  "messenger_compose": "إنشاء",
  "messenger_compose_disabled": "إنشاء (قريباً)",
  "messenger_tab_all": "الكل",
  "messenger_tab_unread": "غير مقروء",
  "messenger_tab_files": "الملفات",
  "messenger_tab_starred": "المميزة",
  "messenger_channel_filter": "التصفية حسب القناة",
  "messenger_channel_all": "الكل",
  "messenger_filter_tabs": "تصفية المحادثات",
  "messenger_tag": "وسم",
  "messenger_labels": "التسميات",
  "messenger_no_labels": "لا توجد تسميات بعد",
  "messenger_new_label": "تسمية جديدة…",
  "messenger_reorder_label": "إعادة ترتيب {{label}}",
  "messenger_label_order_failed": "تعذر حفظ ترتيب الوسوم",
  "messenger_archived": "مؤرشف",
  "messenger_download": "تنزيل المرفق",
  "messenger_archive": "أرشفة",
  "messenger_unarchive": "إلغاء الأرشفة",
  "messenger_new_label_title": "تسمية جديدة",
  "messenger_label_name": "الاسم",
  "messenger_label_name_placeholder": "مثال: تصميم، عمل، مالية",
  "messenger_label_color": "اللون",
  "messenger_label_preview": "معاينة",
  "messenger_create_label": "إنشاء تسمية",
  "messenger_conversations": "محادثة",
  "messenger_search_placeholder": "البحث عن جهات الاتصال…",
  "messenger_search_clear": "مسح البحث",
  "messenger_no_results": "لم يتم العثور على محادثات",
  "messenger_try_different_search": "جرب مصطلح بحث مختلف",
  "messenger_exit_fullscreen": "الخروج من ملء الشاشة",
  "messenger_welcome_title": "مرحباً بك في المراسلة",
  "messenger_welcome_description": "اختر محادثة من اللوحة اليسرى لبدء المحادثة. رسائلك متزامنة في الوقت الفعلي.",
  "messenger_shortcut_hint": "اضغط للخروج من ملء الشاشة",
  "messenger_tap_to_view": "اضغط لعرض الرسائل",
  "messenger_start_conversation": "ابدأ محادثة",
  "documents": "المستندات",
  "documents_calendar": "تقويم المستندات",
  "documents_no_user_loaded_title": "لم يتم تحميل أي جهة اتصال",
  "documents_no_user_loaded_hint": "افتح درج التقويم واستخدم \"تحميل جهة اتصال\" لاختيار جهة اتصال.",
  "documents_default_document_loaded": "يتم تحميل المستند الافتراضي — لا توجد تفاصيل جهة اتصال لعرضها.",
  "documents_load_contact": "البحث عن جهة اتصال",
  "save": "حفظ",
  "loading": "جارٍ التحميل…",
  "saving": "جارٍ الحفظ…",
  "saved": "تم الحفظ",
  "saved_local": "تم الحفظ — محليًا",
  "ready": "جاهز",
  "error": "خطأ",
  "age_recorded": "تم تسجيل العمر",
  "save_failed": "فشل الحفظ",
  "locked": "مقفل",
  "unsaved_changes": "تغييرات غير محفوظة",
  "default_contact": "افتراضي",
  "typing": "يكتب",
  "document_unlock_prompt": "أدخل الاسم والهاتف لفتح القفل",
  "document_lock_message": "يرجى إدخال الاسم والهاتف، أو تحميل عميل",
  "document_loading": "جارٍ تحميل المستند…",
  "documents_empty_title": "لا يوجد مستند مفتوح",
  "documents_empty_description": "أدخل الاسم ورقم الهاتف لفتح مستند، أو ابحث عن جهة الاتصال بالاسم أو من أحد مواعيدها.",
  "documents_empty_load_client": "فتح مستندات جهة اتصال",
  "documents_empty_load_via_appointment": "الفتح من موعد",
  "documents_switch_contact": "التبديل إلى جهة اتصال أخرى",
  "documents_find_contact": "البحث عن جهة اتصال…",
  "documents_from_appointment": "من موعد…",
  "documents_switch_contact_short": "تبديل جهة الاتصال",
  "documents_open_appointment_short": "من موعد",
  "documents_layout_label": "تخطيط الصفحات",
  "documents_layout_single": "صفحة واحدة",
  "documents_layout_side_by_side": "صفحتان جنبًا إلى جنب",
  "documents_layout_stacked": "صفحتان فوق بعضهما",
  "local": "محلي",
  "view_changed": "تم تغيير العرض",
  "load_more": "تحميل المزيد",
  "settings": "الإعدادات",
  "configuration": "التكوين",
  "breadcrumb_home": "الرئيسية",
  "breadcrumb_navigation": "مسار التنقل",
  "breadcrumb_campaign_new": "حملة جديدة",
  "breadcrumb_campaign_details": "تفاصيل الحملة",
  "config_header_subtitle": "اضبط تفضيلات التطبيق",
  "config_header_badge": "مركز التحكم",
  "config_header_status_synced": "متزامن",
  "config_header_updated_label": "آخر تحديث",
  "config_dock_last_saved_label": "آخر حفظ",
  "config_header_timezone_label": "المنطقة الزمنية",
  "timezone_country_choose_button": "اختيار توقيت الدولة",
  "timezone_country_choose": "لهذه الدولة مناطق زمنية متعددة. اختر المنطقة الزمنية لنشاطك.",
  "timezone_auto_button": "استخدام توقيت الدولة",
  "timezone_auto_badge": "الدولة",
  "timezone_auto_badge_hint": "منطقة زمنية لدولة الهاتف المحددة",
  "timezone_auto_select_country": "اختر دولة أولاً",
  "timezone_auto_already_set": "مُعيّن بالفعل للمنطقة الزمنية للدولة",
  "working_days_auto_button": "تلقائي",
  "working_days_auto_select_country": "اختر دولة أولاً",
  "working_days_auto_already_set": "تطابق بالفعل أيام العمل القياسية للدولة",
  "working_days_auto_unavailable": "لا توجد بيانات أيام عمل لهذه الدولة",
  "first_day_auto_button": "تلقائي",
  "first_day_auto_select_country": "اختر دولة أولاً",
  "first_day_auto_already_set": "يطابق بالفعل أول أيام الأسبوع للدولة",
  "first_day_auto_unavailable": "لا توجد بيانات أول أيام الأسبوع لهذه الدولة",
  "config_header_languages_label": "اللغات",
  "config_nav_group_scheduling": "الجدولة",
  "config_nav_group_calendar": "التقويم",
  "config_nav_group_data": "البيانات",
  "config_nav_group_appearance": "المظهر",
  "config_nav_group_ai_business": "الذكاء الاصطناعي والأعمال",
  "config_nav_group_integrations": "التكاملات",
  "config_nav_group_administration": "الإدارة",
  "config_nav_group_display": "العرض",
  "config_nav_group_business": "الأعمال",
  "config_nav_group_ai": "الذكاء الاصطناعي",
  "config_nav_group_communications": "التواصل",
  "config_nav_scheduling": "الجدولة",
  "config_nav_availability": "التوفر",
  "config_nav_display": "العرض",
  "config_nav_table_columns": "أعمدة الجدول",
  "config_nav_themes_languages": "اللغات",
  "config_nav_ai_assistant": "مساعد الذكاء الاصطناعي",
  "config_nav_ai_agents": "وكلاء الذكاء الاصطناعي",
  "config_nav_ai_agents_tooltip": "إجابات RAG متعددة الوكلاء: وكيلا الباحث والمُدقِّق",
  "config_agents_mode_title": "وضع الإجابة",
  "config_agents_mode_description": "كيف يجيب المساعد من قاعدة معرفتك. الأوضاع الأعلى تضيف وكلاء يوثّقون الإجابات ويتحققون منها — مقابل تكلفة وزمن استجابة إضافيين.",
  "config_agents_mode_single": "مفرد",
  "config_agents_mode_single_hint": "وكيل واحد يجيب مباشرةً مع استشهادات موثَّقة. الأسرع والأرخص — دون استدعاءات نماذج إضافية.",
  "config_agents_mode_researcher": "باحث",
  "config_agents_mode_researcher_hint": "يجمع وكيل الباحث الأدلة أولاً، ثم يجيب الوكيل الرئيسي منها. أدق في الأسئلة المعقدة؛ يضيف نموذجاً إضافياً واحداً.",
  "config_agents_mode_verifier": "باحث + مُدقِّق",
  "config_agents_mode_verifier_hint": "يضيف مُدقِّقاً يتحقق من كل ادعاء مقابل استشهاده ويُعيد التصحيحات في حلقات. الأكثر دقة؛ الأعلى تكلفةً وزمن استجابة.",
  "config_agents_researcher_model_label": "نموذج الباحث",
  "config_agents_researcher_model_description": "النموذج الذي يستخدمه وكيل الباحث لجمع الأدلة. متاح في وضعَي الباحث والباحث + المُدقِّق.",
  "config_agents_verifier_model_label": "نموذج المُدقِّق",
  "config_agents_verifier_model_description": "النموذج الذي يستخدمه المُدقِّق للتحقق من الادعاءات. يُنصح بنموذج مساعد رخيص. متاح في وضع الباحث + المُدقِّق.",
  "config_agents_verifier_max_loops_label": "الحد الأقصى لحلقات المُدقِّق",
  "config_agents_verifier_max_loops_tooltip": "كم مرة يمكن للمُدقِّق إعادة التصحيحات قبل الإنهاء (1–3). المزيد من الحلقات يكتشف مشكلات أكثر لكن بتكلفة أعلى.",
  "config_document_summary_model_group_title": "ملخص المستند",
  "config_document_summary_model_group_description": "النموذج الذي يكتب ملخصًا من فقرة واحدة لكل مستند عند استيعابه. تُستخدم الملخصات لدعم الاسترجاع ونظرات عامة على المستندات.",
  "config_document_summary_model_label": "نموذج ملخص المستند",
  "config_document_summary_model_description": "النموذج المستخدم عند الاستيعاب لتلخيص المستندات. يُوصى بنموذج رخيص وسريع. اترك الخيار على تلقائي لاستخدام الافتراضي.",
  "config_sensitive_guard_group_title": "حماية البيانات الحساسة",
  "config_sensitive_guard_group_description": "إخفاء الأرقام الحساسة المأخوذة من مستنداتك قبل أن يرسل المساعد ردًا، على كل القنوات. يتم التحقق من الأرقام عبر خوارزمية تدقيق، فتُلتقط أرقام البطاقات والحسابات الحقيقية بينما تُترك الأرقام العادية دون تغيير.",
  "config_sensitive_guard_cards_label": "إخفاء أرقام البطاقات",
  "config_sensitive_guard_cards_description": "استبدال أرقام بطاقات الدفع الصالحة بقيمة مُخفاة مع الإبقاء على آخر أربعة أرقام فقط.",
  "config_sensitive_guard_ibans_label": "إخفاء أرقام IBAN البنكية",
  "config_sensitive_guard_ibans_description": "استبدال أرقام IBAN الصالحة بقيمة مُخفاة مع الإبقاء على رمز الدولة وآخر أربعة رموز.",
  "config_sensitive_guard_national_ids_label": "إخفاء أرقام الهوية الوطنية",
  "config_sensitive_guard_national_ids_description": "استبدال أرقام الهوية الوطنية بقيمة مُخفاة. يتطلب تحديد دولة حتى يمكن التعرف على صيغة الرقم.",
  "config_sensitive_guard_country_label": "دولة الهوية الوطنية",
  "config_sensitive_guard_country_description": "الدولة التي يبحث الحارس عن صيغة هويتها الوطنية.",
  "config_sensitive_guard_country_sa": "السعودية",
  "config_sensitive_guard_country_eg": "مصر",
  "config_agents_prompts_title": "مطالبات الوكلاء",
  "config_agents_prompts_description": "التعليمات التي يعمل بها وكيلا الباحث والمُدقِّق.",
  "config_agents_prompts_readonly_note": "تُعرض هذه المطالبات للاطّلاع وهي غير قابلة للتحرير بعد. يعمل المسار بهذه الإعدادات الافتراضية.",
  "cfgpage_read_only": "للقراءة فقط",
  "config_agents_researcher_prompt_label": "مطالبة الباحث",
  "config_agents_researcher_prompt_description": "تعليمات وكيل الباحث الجامع للأدلة.",
  "config_agents_researcher_prompt_placeholder": "اتركه فارغًا لاستخدام تعليمات الباحث المدمجة.",
  "config_agents_verifier_prompt_label": "مطالبة المُدقِّق",
  "config_agents_verifier_prompt_description": "تعليمات مُدقِّق أمانة الاستشهاد.",
  "config_agents_verifier_prompt_placeholder": "اتركه فارغًا لاستخدام تعليمات المُدقِّق المدمجة.",
  "config_agents_editor_unavailable": "المحرر غير متاح",
  "rag_preview_open_aria": "معاينة {{filename}}",
  "config_nav_business_regional": "الأعمال والإعدادات الإقليمية",
  "config_nav_notifications": "الإشعارات",
  "config_nav_whatsapp": "صلاحيات أدوات الذكاء الاصطناعي",
  "config_nav_user_management": "إدارة المستخدمين",
  "config_available_themes_title": "السمات المتاحة",
  "config_available_themes_description": "تحكم في السمات المرئية التي تظهر في منتقي السمات داخل التطبيق",
  "config_available_themes_placeholder": "اختر السمات…",
  "config_available_themes_validation": "يجب أن تبقى سمة واحدة على الأقل متاحة",
  "config_available_themes_hint": "المستخدمون يرون فقط السمات التي تبقيها مفعّلة هنا.",
  "config_available_languages_title": "اللغات المتاحة",
  "config_available_languages_description": "اختر اللغات المتاحة للمستخدمين.",
  "config_available_languages_placeholder": "اختر اللغات…",
  "config_available_languages_always_enabled": "(مفعّلة دائماً)",
  "config_available_languages_installed_count": "{{count}} مثبّتة",
  "config_default_country_prefix_title": "بادئة الدولة الافتراضية",
  "config_default_country_prefix_description": "رمز الدولة الافتراضي المستخدم لمنتقي الهاتف",
  "config_import_select_all": "تحديد الكل",
  "config_import_no_fields_found": "لم يتم العثور على حقول",
  "config_more_count": "+{{count}} المزيد",
  "tab_view": "العرض",
  "tab_general": "عام",
  "tab_vacation": "الإجازة",
  "settings_view": "إعدادات العرض",
  "sync_settings_title": "المزامنة دون اتصال",
  "sync_auto_toggle": "مزامنة تلقائية",
  "sync_auto_toggle_desc": "تتم المزامنة تلقائيًا عند عودة الاتصال وكل دقيقة أثناء الاتصال",
  "sync_auto_enabled_toast": "تم تفعيل المزامنة التلقائية",
  "sync_auto_disabled_toast": "تم إيقاف المزامنة التلقائية",
  "sync_window_title": "المستندات المحفوظة دون اتصال",
  "sync_window_desc": "استخدم نافذة حديثة متحركة أو اختر نطاقًا دقيقًا لتاريخ التعديل",
  "sync_window_rolling": "نافذة متحركة",
  "sync_window_custom": "نطاق تاريخ",
  "sync_months_label": "نشاط المستندات الحديث",
  "sync_months_option": "آخر {{count}} أشهر",
  "sync_date_from": "عُدّل ابتداءً من",
  "sync_date_to": "عُدّل حتى",
  "sync_contacts_optional": "جهات اتصال محددة (اختياري)",
  "sync_contacts_optional_desc": "اتركها فارغة لمزامنة كل جهات الاتصال ضمن نطاق التاريخ. اختيار جهات اتصال يتجاوز نطاق التاريخ.",
  "sync_contacts_choose": "اختيار جهات الاتصال",
  "sync_contacts_dialog_title": "اختر جهات الاتصال دون اتصال",
  "sync_contacts_dialog_desc": "ابحث في دليل جهات الاتصال الكامل. اترك القائمة فارغة ليبقى نطاق التاريخ غير مقيّد.",
  "sync_contacts_selected": "جهات الاتصال المحددة",
  "sync_contacts_none_hint": "لم يتم اختيار أي جهة — ينطبق نطاق التاريخ على الجميع.",
  "sync_contacts_override_hint": "ستبقى جهات الاتصال هذه فقط ضمن نطاق المزامنة التلقائي دون اتصال.",
  "sync_contacts_clear": "مسح الكل",
  "sync_contacts_remove": "إزالة {{contact}}",
  "sync_progress_preparing": "جارٍ تجهيز المزامنة",
  "sync_progress_contacts": "جارٍ مزامنة جهات الاتصال",
  "sync_progress_uploading": "جارٍ رفع التعديلات دون اتصال",
  "sync_progress_downloading": "جارٍ تنزيل المستندات",
  "sync_scope_all": "مزامنة كل المستندات",
  "sync_scope_all_desc": "أوقف هذا الخيار لاختيار مستندات بعينها للإبقاء عليها دون اتصال",
  "sync_manage_button": "إدارة",
  "sync_now_button": "مزامنة الآن",
  "sync_status_synced_prefix": "آخر مزامنة",
  "sync_status_never": "لم تتم المزامنة بعد",
  "sync_status_syncing": "جارٍ المزامنة…",
  "sync_status_offline": "دون اتصال — تُحفظ التغييرات على هذا الجهاز",
  "sync_status_error_prefix": "خطأ في المزامنة",
  "sync_pending_docs": "بانتظار المزامنة",
  "sync_conflicts_button": "حل التعارضات",
  "sync_conflict_dialog_title": "تعارضات المزامنة",
  "sync_conflict_dialog_desc": "تغيّرت هذه العناصر على هذا الجهاز وعلى الخادم معًا. قارن النسختين وتوقيتيهما ثم اختر النسخة التي تريد اعتمادها.",
  "sync_conflict_local_label": "هذا الجهاز",
  "sync_conflict_server_label": "الخادم",
  "sync_conflict_keep_local": "اعتماد نسخة هذا الجهاز",
  "sync_conflict_keep_server": "اعتماد نسخة الخادم",
  "sync_conflict_version_prefix": "الإصدار",
  "sync_conflict_side_meta": "{{pages}} صفحات · {{size}}",
  "sync_conflict_contact_title": "تعارض في اسم جهة الاتصال",
  "sync_conflict_contact_desc": "هذا الرقم موجود على الخادم باسم مختلف.",
  "sync_resolved_toast": "تم حل التعارض",
  "sync_resolve_failed_toast": "تعذر حل التعارض",
  "sync_preview_enlarge": "انقر للتكبير",
  "sync_preview_empty": "لا توجد معاينة",
  "sync_manage_dialog_title": "مستندات دون اتصال",
  "sync_manage_dialog_desc": "اختر المستندات التي تبقى متاحة دون اتصال وافتح أيًا منها حتى بدون اتصال.",
  "sync_manage_search_placeholder": "ابحث في جهات الاتصال",
  "sync_manage_open": "فتح",
  "sync_manage_pending_badge": "بانتظار المزامنة",
  "sync_manage_conflict_badge": "تعارض",
  "sync_manage_empty": "لا توجد مستندات دون اتصال بعد",
  "settings_chat": "إعدادات الدردشة",
  "settings_viewer_enable": "تفعيل عارض المستندات",
  "settings_viewer_enable_desc": "إظهار لوحة العارض العلوية لمعاينة المستند",
  "settings_viewer_enabled": "تم تفعيل عارض المستندات",
  "settings_viewer_disabled": "تم تعطيل عارض المستندات",
  "settings_viewer_split_lock": "قفل لوحة التقسيم",
  "settings_viewer_split_lock_desc": "منع تحريك لوحة التقسيم القابلة للتغيير",
  "settings_viewer_split_locked": "تم قفل لوحة التقسيم",
  "settings_viewer_split_unlocked": "تم فتح قفل لوحة التقسيم",
  "settings_viewer_toolbar_hide": "إخفاء شريط أدوات العارض",
  "settings_viewer_toolbar_hide_desc": "إخفاء شريط الأدوات السفلي (تحديد، يد، ليزر) في العارض",
  "settings_viewer_toolbar_hidden": "تم إخفاء شريط أدوات العارض",
  "settings_viewer_toolbar_visible": "شريط أدوات العارض مرئي",
  "settings_editor": "المحرر",
  "settings_editor_toolbar_size": "حجم شريط الأدوات",
  "settings_editor_toolbar_size_desc": "تغيير حجم أزرار شريط الأدوات في أعلى اليسار",
  "settings_toolbar_size_set_prefix": "تم تعيين حجم شريط الأدوات إلى",
  "settings_calendar_density": "كثافة التقويم",
  "settings_calendar_density_desc": "ضبط حجم نص الأحداث والمسافات",
  "settings_calendar_density_set_prefix": "تم تعيين كثافة التقويم إلى",
  "settings_calendar_density_decrease": "تقليل كثافة التقويم",
  "settings_calendar_density_increase": "زيادة كثافة التقويم",
  "settings_calendar_density_input": "نسبة كثافة التقويم",
  "already_showing_today": "أنت بالفعل في اليوم الحالي",
  "go_to_today": "الذهاب إلى اليوم",
  "copy": "نسخ",
  "copied": "تم النسخ",
  "close_dialog": "إغلاق الحوار",
  "discard_changes": "تجاهل التغييرات",
  "save_and_close": "حفظ والإغلاق",
  "cancel": "إلغاء",
  "external_link_title": "فتح رابط خارجي؟",
  "external_link_description": "أنت على وشك زيارة موقع إلكتروني خارجي.",
  "copy_link": "نسخ الرابط",
  "open_link": "فتح الرابط",
  "data_editor_title": "محرر البيانات",
  "data_editor_description": "محرر لإدارة الحجوزات وبيانات المستخدمين",
  "data_editor_empty_title": "لا توجد حجوزات",
  "data_editor_empty_desc": "لا توجد حجوزات في هذا النطاق الزمني بعد. أضف حجزاً للبدء.",
  "data_editor_empty_add": "إضافة حجز",
  "save_changes": "حفظ التغييرات",
  "unsaved_changes_prompt": "لديك تغييرات غير محفوظة. هل تريد حفظ التغييرات قبل الإغلاق؟",
  "user_data_change_warning_title": "تحديث بيانات المستخدم؟",
  "user_data_change_warning_prompt": "سيؤدي تغيير الاسم أو الهاتف هنا إلى تحديث بيانات المستخدم. هل تريد المتابعة؟",
  "save_and_update_user": "حفظ وتحديث المستخدم",
  "calendar": "التقويم",
  "contacts": "جهات الاتصال",
  "widgets": "الأدوات",
  "msg_previous": "السابق",
  "msg_next": "التالي",
  "feat_pagination_page_of": "صفحة {from} من {count}",
  "validation_issues": "مشاكل التحقق",
  "validation_issues_details": "يرجى إصلاح هذه المشاكل قبل الحفظ",
  "row": "الصف",
  "cm_sort_asc": "ترتيب تصاعدي",
  "cm_sort_desc": "ترتيب تنازلي",
  "cm_pin_column": "تثبيت العمود",
  "cm_unpin_column": "إلغاء تثبيت العمود",
  "cm_hide_column": "إخفاء العمود",
  "cm_autosize_column": "تحجيم تلقائي",
  "cm_format": "تنسيق",
  "cm_format_automatic": "تلقائي",
  "cm_format_localized": "محلي",
  "cm_format_distance": "المسافة",
  "cm_format_calendar": "التقويم",
  "cm_close": "إغلاق",
  "cm_filter_search": "البحث عن القيم…",
  "cm_filter_select_all": "تحديد الكل",
  "cm_filter_no_matching": "لا توجد قيم مطابقة",
  "cm_filter_no_values": "لا توجد قيم متاحة",
  "cm_filter_clear": "مسح التصفية",
  "field_scheduled_time": "الوقت المحدد",
  "field_phone": "الهاتف",
  "field_type": "النوع",
  "field_name": "الاسم",
  "field_age": "العمر",
  "toast_event_created": "تم إنشاء الحجز",
  "toast_event_modified": "تم تعديل الحجز",
  "toast_event_modified_no_changes": "تم تحديث الحجز",
  "toast_event_cancelled": "تم إلغاء الحجز",
  "toast_event_reinstated": "تم استعادة الحجز",
  "toast_event_modification_failed": "فشل تعديل الحجز",
  "toast_event_creation_failed": "فشل إنشاء الحجز",
  "toast_event_cancellation_failed": "فشل إلغاء الحجز",
  "toast_user_active_updated": "تم تحديث حالة جهة الاتصال",
  "toast_user_blocked": "تم حظر جهة الاتصال",
  "toast_user_unblocked": "تم إلغاء حظر جهة الاتصال",
  "toast_error_prefix": "خطأ",
  "toast_new_message": "رسالة",
  "toast_dismiss": "إغلاق",
  "toast_undo": "تراجع",
  "toast_undo_successful": "تم التراجع بنجاح",
  "toast_undo_failed": "فشل التراجع",
  "toast_error_generic": "حدث خطأ",
  "toast_no_connection_title": "لا يوجد اتصال بالإنترنت",
  "toast_no_connection_subtitle": "لم يتم حفظ التغيير. يرجى إعادة الاتصال والمحاولة مرة أخرى.",
  "phone_new_number_label": "رقم هاتف جديد",
  "dashboard_title": "لوحة التحكم",
  "dashboard_error_title": "تعذر تحميل لوحة التحكم",
  "dashboard_try_again": "حاول مجدداً",
  "dashboard_subtitle": "نظرة عامة على الأداء والحجوزات والرسائل",
  "dashboard_overview": "نظرة عامة",
  "dashboard_trends": "الاتجاهات",
  "dashboard_messages": "الرسائل",
  "dashboard_insights": "الإحصاءات",
  "dashboard_feedbacks_summaries": "التقارير",
  "dashboard_feedbacks_summaries_short": "التقارير",
  "dashboard_nav_feedbacks_summaries_desc": "ملخصات المحادثات وملاحظات العملاء التي رصدها المساعد",
  "feedbacks_summaries_eyebrow": "أرشيف الذكاء الاصطناعي",
  "feedbacks_summaries_title": "الملاحظات والملخصات",
  "feedbacks_summaries_subtitle": "ملخصات المحادثات المحفوظة وملاحظات العملاء التي جمعها المساعد.",
  "reports_load_error_title": "تعذر تحميل هذا التقرير",
  "reports_load_error_body": "فشل طلب التقرير. أعد المحاولة قبل اعتبار هذه الفترة خالية من البيانات.",
  "feedbacks_summaries_segment_summaries": "الملخصات",
  "feedbacks_summaries_segment_feedbacks": "الملاحظات",
  "summaries_new_summary": "ملخص جديد",
  "summaries_empty_cta": "تلخيص محادثة",
  "summarize_dialog_title": "تلخيص محادثة",
  "summarize_dialog_subtitle": "حمّل جهة اتصال، واختر الجزء المراد تلخيصه من المحادثة، ودع المساعد يكتب الملخص.",
  "summarize_dialog_pick_contact": "تحميل جهة اتصال",
  "summarize_dialog_change_contact": "تغيير",
  "summarize_dialog_scope_title": "ما الذي سيتم تلخيصه",
  "summarize_dialog_last_messages": "آخر الرسائل",
  "summarize_dialog_last_messages_hint": "يحدد الحد الأقصى للمعاينة وطلب التلخيص معًا.",
  "summarize_dialog_date_range": "النطاق الزمني",
  "summarize_dialog_date_range_any": "كل الفترات",
  "summarize_dialog_date_range_clear": "مسح النطاق الزمني",
  "summarize_dialog_preview_title": "معاينة المحادثة",
  "summarize_dialog_preview_hint": "تظهر هنا فقط الرسائل التي تسمح بها الخيارات أعلاه. يمكنك اختيار البداية والنهاية، وستُضمَّن كل الرسائل بينهما.",
  "summarize_dialog_boundary_clear": "مسح التحديد",
  "summarize_dialog_included_count": "سيتم تلخيص {count} رسالة",
  "summarize_dialog_loading_preview": "جارٍ تحميل المحادثة…",
  "summarize_dialog_preview_empty": "لا توجد رسائل تطابق النطاق الزمني والحد الحاليين.",
  "summarize_dialog_generate": "إنشاء الملخص",
  "summarize_dialog_cancel": "إلغاء",
  "summaries_empty_title": "لا توجد ملخصات بعد",
  "summaries_empty_body": "افتح أي محادثة، اختر «تلخيص بالذكاء الاصطناعي» من القائمة، ثم احفظ الملخص ليظهر هنا.",
  "summaries_no_overview": "لم يتم إنشاء نظرة عامة.",
  "summaries_chip_reservations": "حجوزات",
  "summaries_chip_feedback": "ملاحظات",
  "summaries_chip_issues": "مشاكل",
  "summaries_chip_messages": "رسائل",
  "summaries_delete": "حذف",
  "summaries_delete_confirm": "حذف هذا الملخص نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
  "feedbacks_empty_title": "لم يتم تسجيل أي ملاحظات بعد",
  "feedbacks_empty_body": "حين يعطي العملاء ملاحظاتهم تلقائياً، سيتم رصدها هنا.",
  "feedbacks_delete": "حذف",
  "feedbacks_delete_confirm": "حذف هذه الملاحظة نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
  "feedbacks_expand": "توسيع الملاحظة",
  "feedbacks_collapse": "طي الملاحظة",
  "feedbacks_open_source_message": "فتح الرسالة",
  "feedbacks_discussion": "نقاش المشرفين",
  "feedbacks_comment_placeholder": "أضف تعليقاً للمشرفين الآخرين…",
  "feedbacks_comment_send": "إرسال التعليق",
  "feedbacks_comments_empty": "لا توجد تعليقات بعد. ابدأ النقاش.",
  "feedbacks_deleted_admin": "مشرف محذوف",
  "sentiment_all": "الكل",
  "sentiment_positive": "إيجابية",
  "sentiment_negative": "سلبية",
  "sentiment_neutral": "محايدة",
  "dashboard_day": "يوم",
  "dashboard_days": "أيام",
  "dashboard_events": "حجوزات",
  "dashboard_select_date_range": "اختر نطاق التاريخ",
  "dashboard_seven_days": "7 أيام",
  "dashboard_thirty_days": "30 يومًا",
  "dashboard_export": "تصدير",
  "dashboard_nav_overview_desc": "نظرة عامة على مؤشرات الأداء وصحة التشغيل",
  "dashboard_nav_trends_desc": "تتبع الحجوزات والإلغاءات وتطور مسار التحويل",
  "dashboard_nav_messages_desc": "جودة المحادثات وسرعة الاستجابة وساعات الذروة",
  "dashboard_nav_insights_desc": "توصيات عملية وإشعارات ذكية من النظام",
  "vacation": "إجازة",
  "msg_minutes": "د",
  "msg_seconds": "ث",
  "notifications": "الإشعارات",
  "all": "الكل",
  "mark_all_as_read": "وضع الكل كمقروء",
  "unread": "غير مقروء",
  "no_notifications": "لا توجد إشعارات",
  "notifications_empty_state_description": "لا توجد إشعارات جديدة في الوقت الحالي.",
  "view_all_notifications": "عرض كل الإشعارات",
  "conversation_navigation": "التنقل بين المحادثات",
  "older": "الأقدم",
  "more_recent": "الأحدث",
  "new_message": "رسالة جديدة",
  "backend_connection_ensure_localhost": "تأكد من أن الخادم يعمل على http://localhost:8000",
  "phone_country_search_placeholder": "ابحث عن الدول…",
  "phone_country_select_placeholder": "اختر الدولة",
  "phone_no_country_found": "لا توجد دولة.",
  "phone_filter_country": "البلد",
  "phone_filter_date_range": "نطاق التاريخ",
  "media_filter_label": "الوسائط",
  "media_kind_images": "الصور",
  "media_kind_videos": "الفيديوهات",
  "media_kind_voice": "الرسائل الصوتية",
  "media_kind_pdfs": "ملفات PDF",
  "media_kind_documents": "المستندات",
  "media_kind_spreadsheets": "جداول البيانات",
  "media_kind_text_files": "النص وCSV وJSON",
  "media_kind_other_files": "ملفات أخرى",
  "chat_search_filters": "عوامل تصفية البحث",
  "phone_filter_messages": "الرسائل",
  "phone_filter_events": "الحجوزات",
  "phone_filter_registration": "التسجيل",
  "phone_filter_registration_registered": "مسجل",
  "phone_filter_registration_unknown": "غير معروف",
  "phone_filter_status": "الحالة",
  "phone_filter_status_registered": "مسجل",
  "phone_filter_status_unregistered": "غير مسجل",
  "phone_filter_status_has_document": "لديه مستند",
  "phone_filter_status_blocked": "محظور",
  "phone_filter_status_inactive": "غير نشط",
  "phone_filter_status_active": "نشط",
  "phone_filter_status_no_document": "بلا مستند",
  "phone_filter_status_has_doc_short": "له مستند",
  "phone_filter_status_no_doc_short": "بلا مستند",
  "phone_filter_status_section_status": "الحالة",
  "phone_filter_status_section_moderation": "الإشراف",
  "calendar_filter_title": "تصفية",
  "calendar_new_booking": "حجز جديد",
  "calendar_filter_clear_all": "مسح الكل",
  "calendar_filter_search_placeholder": "ابحث بالاسم أو الهاتف…",
  "calendar_filter_event_type": "نوع الحدث",
  "calendar_filter_resource": "المورد",
  "calendar_filter_resource_only": "أحداث الموارد فقط",
  "calendar_filter_resource_only_overridden": "معطّل طالما أن نوع حدث بلا مورد محدَّد.",
  "calendar_filter_booking_status": "حالة الحجز",
  "phone_add_filter_button": "إضافة عامل تصفية",
  "date_preset_today": "اليوم",
  "date_preset_yesterday": "أمس",
  "date_preset_last_7_days": "آخر 7 أيام",
  "date_preset_last_14_days": "آخر 14 يوم",
  "date_preset_last_30_days": "آخر 30 يوم",
  "date_preset_month_to_date": "من بداية الشهر",
  "date_preset_this_month": "هذا الشهر",
  "date_preset_last_month": "الشهر الماضي",
  "date_preset_last_quarter": "الربع الماضي",
  "date_preset_year_to_date": "من بداية السنة",
  "date_preset_last_year": "السنة الماضية",
  "date_preset_clear": "مسح",
  "date_preset_quick_select": "اختيار سريع",
  "date_preset_presets": "القوالب",
  "date_preset_past": "الماضي",
  "date_preset_future": "المستقبل",
  "date_preset_tomorrow": "غداً",
  "date_preset_next_7_days": "الـ 7 أيام القادمة",
  "date_preset_next_14_days": "الـ 14 يوم القادمة",
  "date_preset_next_30_days": "الـ 30 يوم القادمة",
  "date_preset_rest_of_month": "بقية الشهر",
  "date_preset_next_month": "الشهر القادم",
  "date_preset_rest_of_year": "بقية السنة",
  "date_preset_next_year": "السنة القادمة",
  "date_range_picker_quick_range": "نطاق سريع",
  "date_range_picker_custom": "مخصص",
  "date_range_picker_from": "من",
  "date_range_picker_to": "إلى",
  "date_range_picker_reset": "إعادة ضبط",
  "date_range_picker_apply": "تطبيق النطاق",
  "date_range_picker_hide_presets": "إخفاء القوالب",
  "date_range_picker_show_presets": "إظهار القوالب",
  "date_range_picker_one_day": "يوم واحد",
  "date_range_picker_days_count": "{count} يوم",
  "phone_search_placeholder": "بحث بالأسماء/الأرقام",
  "beneficiary_search_placeholder": "ابحث عن جهة اتصال أو مستفيد",
  "phone_search_clear": "مسح البحث",
  "phone_search_start_typing": "ابدأ الكتابة للبحث عن الأشخاص…",
  "searching": "جارٍ البحث…",
  "phone_search_no_matches": "لا توجد نتائج لـ \"{query}\".",
  "phone_filter_no_matches": "لا توجد جهات اتصال تطابق الفلاتر المحددة.",
  "phone_search_try_different": "جرب مصطلح بحث مختلف.",
  "phone_offline_no_synced_contacts": "لا توجد جهات اتصال محفوظة للاستخدام دون اتصال على هذا الجهاز حتى الآن.",
  "phone_selector_expand_beneficiaries": "عرض المستفيدين",
  "search_error": "فشل البحث. يرجى المحاولة مرة أخرى.",
  "phone_no_phone_found": "لا يوجد رقم هاتف.",
  "phone_add_number_label": "إضافة \"{value}\" كرقم هاتف جديد",
  "phone_add_new_title": "إضافة رقم هاتف جديد",
  "phone_add_new_description": "لم نعثر على هذا الرقم. قم بإنشائه لبدء تتبع المحادثات.",
  "phone_add_inline_title": "إضافة هذا الرقم",
  "phone_add_inline_hint": "احفظه كجهة اتصال قابلة لإعادة الاستخدام.",
  "phone_add_button": "إضافة الرقم",
  "phone_add_number_placeholder": "أدخل رقم هاتف",
  "beneficiary_add_name_placeholder": "اكتب اسم المستفيد",
  "beneficiary_add_new_title": "إضافة مستفيد جديد",
  "beneficiary_add_new_description": "أنشئ هذا المستفيد تحت جهة الاتصال الرئيسية المحددة.",
  "beneficiary_add_inline_title": "إضافة كمستفيد جديد",
  "beneficiary_add_inline_hint": "سيتم حجز الموعد لهذا الشخص عبر جهة الاتصال الرئيسية.",
  "beneficiary_add_button": "إضافة المستفيد",
  "name_add_name_placeholder": "اكتب اسم جهة الاتصال",
  "name_add_new_title": "استخدام اسم جهة الاتصال",
  "name_add_new_description": "استخدم هذا الاسم لجهة اتصال الهاتف الجديدة.",
  "name_add_inline_title": "استخدام كاسم جهة الاتصال",
  "name_add_inline_hint": "سيتم إنشاء جهة اتصال رئيسية جديدة عند الحفظ.",
  "name_add_button": "استخدام الاسم",
  "phone_select_placeholder": "اختر رقم هاتف",
  "phone_unknown_label": "غير معروف",
  "phone_group_recent": "حديث",
  "phone_group_all": "الكل",
  "phone_group_selected": "المحدد",
  "phone_group_favorites": "المفضلة",
  "phone_no_results_title": "لا توجد نتائج لبحثك",
  "phone_no_results_description": "جرب استخدام كلمات مختلفة أو تحقق من الإملاء. يمكنك أيضًا تصفح فئاتنا للعثور على ما تبحث عنه.",
  "phone_failed_to_load_title": "فشل التحميل",
  "phone_failed_to_load_description": "تعذر جلب البيانات",
  "phone_retry_button": "إعادة المحاولة",
  "no_results_found": "لم يتم العثور على نتائج",
  "close": "إغلاق",
  "cursor_hint_open": "فتح",
  "cursor_hint_preview": "معاينة",
  "cursor_hint_drag": "اسحب لإعادة الترتيب",
  "delete": "حذف",
  "vacation_parse_error": "فشل تحميل بيانات الإجازة",
  "chat_edit_message_not_found": "تعذر العثور على الرسالة للتعديل. حاول مرة أخرى.",
  "settings_show_tool_calls": "عرض أدوات الاستدعاء",
  "settings_tool_calls_hint": "إظهار تفاصيل استدعاء الأدوات وبيانات JSON في الدردشة",
  "settings_tool_calls_on": "سيتم عرض أدوات الاستدعاء في الدردشة",
  "settings_tool_calls_off": "سيتم إخفاء أدوات الاستدعاء في الدردشة",
  "settings_send_typing": "إرسال مؤشر الكتابة",
  "settings_send_typing_on": "عند تمكينه، سيتم إرسال مؤشر الكتابة إلى المستخدم أثناء الكتابة",
  "settings_send_typing_off": "سيتم إيقاف إرسال مؤشر الكتابة",
  "settings_toolbar_size_decrease": "تصغير شريط الأدوات",
  "settings_toolbar_size_input": "نسبة حجم شريط الأدوات",
  "settings_toolbar_size_increase": "تكبير شريط الأدوات",
  "msg_total": "الإجمالي",
  "msg_page": "صفحة",
  "msg_of": "من",
  "msg_total_conversations": "إجمالي المحادثات",
  "msg_word_cloud": "سحابة الكلمات",
  "msg_avg_messages_per_conversation": "متوسط/محادثة",
  "msg_per_conversation": "لكل محادثة",
  "msg_messages_per_conversation": "رسائل/محادثة",
  "msg_pagination": "التنقل بين الصفحات",
  "msg_previous_page": "الصفحة السابقة",
  "msg_next_page": "الصفحة التالية",
  "msg_word_source_tabs": "مصدر الكلمات",
  "response_time_samples": "عينات الاستجابة",
  "operation_activity_breakdown": "تفصيل النشاط",
  "activity_attribution_made_by": "تم بواسطة",
  "activity_attribution_ai": "وكيل الذكاء الاصطناعي",
  "activity_attribution_system_agent": "وكيل النظام",
  "activity_attribution_via": "عبر",
  "activity_attribution_org_member": "عضو في المنظمة",
  "activity_attribution_external_user": "مستخدم خارجي",
  "activity_attribution_system": "النظام",
  "activity_attribution_unknown": "غير معروف",
  "event_history_menu_item": "سجل الحدث",
  "event_history_title": "سجل الحدث",
  "event_history_description": "دورة حياة هذا الحدث كاملة ومن قام بكل تغيير.",
  "event_history_booked_under": "محجوز عبر {{name}}",
  "event_history_empty": "لا يوجد سجل لهذا الحدث بعد.",
  "event_history_error": "تعذر تحميل سجل الحدث.",
  "event_history_by": "بواسطة",
  "event_history_field_time": "الوقت",
  "event_history_field_type": "النوع",
  "event_history_field_name": "الاسم",
  "event_history_action_created": "تم الإنشاء",
  "event_history_action_rescheduled": "تمت إعادة الجدولة",
  "event_history_action_updated": "تم التعديل",
  "event_history_action_cancelled": "تم الإلغاء",
  "event_history_action_reinstated": "تمت الاستعادة",
  "event_history_action_completed": "اكتمل",
  "event_history_action_no_show": "لم يحضر",
  "activity_open_chat_history": "سجل الدردشة",
  "operation_origin_breakdown": "مصدر العمليات",
  "operation_ai_handled": "عالجها الذكاء الاصطناعي",
  "operation_member_handled": "عالجها عضو المنظمة",
  "operation_external_handled": "حجز ذاتي من العميل",
  "operation_unattributed": "غير منسوبة",
  "operation_by_model": "حسب النموذج",
  "kpi_by_ai": "بواسطة الذكاء الاصطناعي",
  "msg_assistant_replies": "ردود المساعد",
  "msg_inbound_messages": "الرسائل الواردة",
  "kpi_total_events": "إجمالي الحجوزات",
  "kpi_from_last_month": "من الشهر الماضي",
  "kpi_active_users": "عملاء الحجوزات النشطة",
  "kpi_unique_users": "مستخدمون مميزون",
  "kpi_cancellations": "الإلغاءات",
  "kpi_this_period": "خلال هذه الفترة",
  "kpi_conversion_rate": "معدل التحويل",
  "kpi_conversation_to_booking": "من محادثة إلى حجز",
  "kpi_returning_rate": "معدل العودة",
  "kpi_user_retention": "الاحتفاظ بالعملاء",
  "kpi_improvement": "تحسن",
  "kpi_avg_response_time": "متوسط زمن الاستجابة",
  "kpi_returning_users": "عملاء الحجوزات المتكررة",
  "kpi_avg_followups": "متوسط الحجوزات الإضافية",
  "kpi_performance_metrics": "مؤشرات الأداء",
  "kpi_total_events_tooltip": "إجمالي الحجوزات في الفترة المحددة مقارنة بالفترة السابقة المشابهة",
  "kpi_active_users_desc": "عملاء مميزون لديهم حجوزات غير ملغاة خلال الفترة المحددة",
  "kpi_total_events_desc": "جميع الحجوزات المجدولة في هذه الفترة",
  "kpi_cancellations_desc": "الحجوزات المجدولة في هذه الفترة وحالتها الحالية ملغاة",
  "kpi_conversion_rate_desc": "عملاء المراسلة الذين لديهم حجز غير ملغى في هذه الفترة",
  "kpi_avg_response_time_desc": "زمن الرد على رسائل العملاء",
  "kpi_new_users": "عملاء الحجوزات",
  "kpi_new_users_desc": "عملاء مميزون لديهم حجز خلال الفترة المحددة",
  "kpi_returning_users_desc": "عملاء لديهم حجزان أو أكثر خلال الفترة المحددة",
  "kpi_avg_followups_desc": "متوسط الحجوزات الإضافية لكل عميل متكرر",
  "kpi_leads_collected": "العملاء المحتملون",
  "kpi_leads_collected_desc": "العملاء الذين جمعتهم الأداة المساعدة عبر أداة جمع البيانات",
  "kpi_positive_feedback": "ملاحظات إيجابية",
  "kpi_positive_feedback_desc": "رسائل عملاء مسجلة بمشاعر إيجابية أو رضا",
  "kpi_negative_feedback": "ملاحظات سلبية",
  "kpi_negative_feedback_desc": "رسائل عملاء مسجلة بمشاعر سلبية أو إحباط",
  "kpi_neutral_feedback": "ملاحظات محايدة",
  "kpi_neutral_feedback_desc": "رسائل عملاء مسجلة دون مشاعر إيجابية أو سلبية",
  "insights_capture_summary_title": "الاستحواذ والمشاعر",
  "insights_capture_summary_desc": "العملاء المحتملون وملاحظات العملاء المُجمَّعة في هذه الفترة",
  "kpi_vs_previous_period": "مقارنة بالفترة السابقة",
  "kpi_active_users_tooltip": "عملاء لديهم حجز واحد غير ملغى على الأقل خلال الفترة المحددة",
  "kpi_cancellations_tooltip": "الإلغاءات خلال الفترة المحددة مقارنة بالفترة السابقة المشابهة",
  "kpi_avg_response_time_tooltip": "متوسط زمن رد المساعد على العميل (عميل→مساعد) مقارنة بالفترة السابقة",
  "kpi_avg_followups_tooltip": "متوسط الحجوزات الإضافية للمتابعات لكل مستخدم عائد مقارنة بالفترة السابقة",
  "kpi_unique_users_tooltip": "المستخدمون الذين كانت أول حجز لهم خلال هذه الفترة مقارنة بفترة سابقة مشابهة",
  "chat_toolbar_bold": "عريض",
  "chat_toolbar_italic": "مائل",
  "chat_toolbar_strike": "مشطوب",
  "chat_toolbar_code": "أحادي المسافة",
  "chat_toolbar_ai": "الذكاء الاصطناعي",
  "chat_ai_input_placeholder": "اطلب من الذكاء الاصطناعي ما تريد…",
  "chat_ai_followup_placeholder": "حسّن أكثر…",
  "chat_ai_submit_hint": "⌘+Enter للإرسال",
  "chat_ai_back": "رجوع",
  "chat_ai_submit": "إعادة الصياغة",
  "chat_ai_replace": "استبدال",
  "chat_ai_close": "إغلاق",
  "chat_ai_title": "إعادة الصياغة بالذكاء الاصطناعي",
  "chat_ai_insert": "إدراج",
  "chat_ai_refine": "تحسين",
  "ai_action_add": "إضافة",
  "ai_action_clear": "مسح",
  "ai_action_diff": "الفروق",
  "ai_action_result": "النتيجة",
  "ai_action_generate": "إنشاء",
  "ai_mode_refining": "تحرير التحديد",
  "ai_mode_writing": "كتابة من الصفر",
  "ai_generate_placeholder": "صِف ما تريد من الذكاء الاصطناعي أن يكتبه…",
  "ai_vacation_generate_title": "إنشاء رسالة الإجازة",
  "ai_vacation_generate_placeholder": "صِف غيابك (التواريخ، جهة بديلة، مدى العجلة)…",
  "ai_vacation_generate_instruction": "اكتب رسالة رد آلي دافئة ومهنية لكل من يراسل أثناء هذه الإجازة: أشِر باختصار إلى استلام رسالته، ونوّه بأنك غائب، ووضّح متى ستردّ. استخدم فقط التفاصيل الواردة في الوصف أدناه — إن ذُكر تاريخ عودة أو جهة اتصال بديلة فأدرجها، وإلا فاكتفِ بأنك ستردّ في أقرب وقت ممكن.",
  "ai_vacation_trigger_label": "صياغة بالذكاء الاصطناعي",
  "system_prompt_ai_rewrite_label": "إعادة الصياغة بالذكاء الاصطناعي",
  "system_prompt_ai_rewrite_tooltip": "افتح لوحة إعادة الصياغة. عند تحديد جزء تتم إعادة صياغته فقط، وعند عدم وجود تحديد يعيد تحسين البرومبت بالكامل.",
  "system_prompt_ai_rewrite_selection_title": "إعادة صياغة التحديد",
  "system_prompt_ai_rewrite_full_title": "تحسين البرومبت بالكامل",
  "chat_ai_loading": "جارٍ إعادة الصياغة…",
  "chat_ai_failed": "فشلت إعادة الصياغة",
  "chat_ai_unavailable": "الذكاء الاصطناعي غير مُهيأ",
  "chat_ai_original_label": "الأصلي",
  "chat_ai_result_label": "الذكاء الاصطناعي",
  "chat_ai_turn_label": "الجولة {n}",
  "chat_ai_preset_summarize": "تلخيص",
  "chat_ai_preset_professional": "احترافي",
  "chat_ai_preset_friendly": "ودّي",
  "chat_ai_preset_concise": "مختصر",
  "chat_ai_preset_expand": "توسيع",
  "chat_ai_preset_grammar": "تصحيح النحو",
  "emoji_search": "ابحث عن الإيموجي…",
  "kpi_cpu_usage": "استخدام المعالج",
  "kpi_current_usage": "الاستخدام الحالي",
  "kpi_demo_data": "بيانات تجريبية",
  "kpi_memory_usage": "استخدام الذاكرة",
  "kpi_success_rate": "معدل النجاح",
  "kpi_operational_rate": "معدل التشغيل",
  "tooltip_success_rate": "معدل النجاح محسوب من مؤشرات العمليات",
  "operation_metrics_title": "مؤشرات العمليات",
  "operation_attempts": "محاولات",
  "operation_success": "نجاح",
  "operation_failed": "فشل",
  "operation_events": "حجوزات",
  "operation_cancellations": "إلغاءات",
  "operation_modifications": "تعديلات",
  "response_time_analysis_title": "تحليل زمن الاستجابة",
  "response_time_score": "النتيجة",
  "response_time_average": "المتوسط",
  "response_time_median": "الوسيط",
  "response_time_maximum": "الحد الأقصى",
  "response_time_performance": "أداء زمن الاستجابة",
  "response_time_performance_desc": "الأعلى أفضل",
  "response_time_slow": "بطيء",
  "response_time_fast": "سريع",
  "response_time_insights": "رؤى أداء زمن الاستجابة",
  "response_time_excellent": "زمن استجابة ممتاز",
  "response_time_good": "زمن استجابة جيد",
  "response_time_needs_improvement": "بحاجة إلى تحسين",
  "response_time_poor": "زمن استجابة ضعيف",
  "chart_daily_trends_overview": "الاتجاهات اليومية",
  "chart_no_data": "لا توجد بيانات",
  "chart_showing_all_data": "عرض جميع البيانات",
  "chart_showing_last_days": "عرض آخر الأيام",
  "chart_appointment_type_distribution": "توزيع أنواع المواعيد",
  "chart_popular_time_slots": "الأوقات الأكثر شيوعاً",
  "chart_weekly_activity_pattern": "نمط النشاط الأسبوعي",
  "chart_monthly_performance_trends": "اتجاهات الأداء الشهرية",
  "chart_user_segments": "شرائح المستخدمين",
  "chart_avg_events_per_type": "متوسط الحجوزات لكل مستخدم حسب النوع",
  "chart_avg_events_per_type_desc": "متوسط عدد الحجوزات لكل مستخدم لكل نوع موعد",
  "chart_avg_per_user": "المتوسط لكل مستخدم",
  "chart_total_events": "إجمالي الحجوزات",
  "chart_unique_users": "المستخدمين الفريدين",
  "msg_total_messages": "إجمالي الرسائل",
  "msg_avg_message_length": "متوسط طول الرسالة",
  "msg_chars": "حرف",
  "msg_words_avg": "كلمات وسطياً",
  "msg_median": "الوسيط",
  "msg_messages_per_user": "رسائل لكل مستخدم",
  "msg_volume_heatmap": "خريطة كثافة الرسائل",
  "msg_activity_patterns": "أنماط النشاط حسب اليوم والساعة",
  "msg_users": "المستخدمون",
  "msg_assistant": "المساعد",
  "msg_less": "أقل",
  "msg_more": "أكثر",
  "chart_all_data": "كل البيانات",
  "chart_last_30_days": "آخر 30 يوماً",
  "chart_last_14_days": "آخر 14 يوماً",
  "chart_last_7_days": "آخر 7 أيام",
  "appt_checkup": "كشف",
  "appt_followup": "متابعة",
  "appt_unknown": "غير معروف",
  "slot_regular": "عادي",
  "slot_saturday": "السبت",
  "slot_ramadan": "رمضان",
  "slot_unknown": "غير معروف",
  "funnel_messaging_customers": "عملاء المراسلة",
  "funnel_made_event": "أنشأ المساعد حجزًا",
  "funnel_returned_for_another": "عاد لحجز آخر عبر المساعد",
  "funnel_cancelled": "ملغاة",
  "segment_one_booking_in_period": "حجز واحد في الفترة",
  "segment_two_five_bookings_in_period": "2–5 حجوزات في الفترة",
  "segment_six_plus_bookings_in_period": "6+ حجوزات في الفترة",
  "segment_new_users": "مستخدمون جدد",
  "segment_regular_users": "مستخدمون دائمون",
  "segment_vip_users": "مستخدمون مميزون",
  "segment_inactive_users": "مستخدمون غير نشطين",
  "day_monday": "الاثنين",
  "day_tuesday": "الثلاثاء",
  "day_wednesday": "الأربعاء",
  "day_thursday": "الخميس",
  "day_friday": "الجمعة",
  "day_saturday": "السبت",
  "day_sunday": "الأحد",
  "day_mon": "الإث",
  "day_tue": "الث",
  "day_wed": "الأر",
  "day_thu": "الخ",
  "day_fri": "الجم",
  "day_sat": "السب",
  "day_sun": "الأح",
  "slot_duration_minutes": "{{minutes}} دقيقة",
  "slot_duration_hour": "ساعة واحدة",
  "slot_duration_hours": "{{hours}} ساعة",
  "slot_duration_hm": "{{hours}}س {{minutes}}د",
  "msg_across_all_conversations": "عبر جميع المحادثات",
  "msg_avg_response_time": "متوسط زمن الاستجابة",
  "msg_average_conversation_length": "متوسط طول المحادثة",
  "msg_most_active_users": "أكثر المستخدمين نشاطاً",
  "msg_last": "آخر",
  "msg_msgs": "رسائل",
  "msg_bookings": "حجوزات",
  "msg_most_common_words": "الكلمات الأكثر شيوعاً",
  "msg_peak_messages": "أقصى عدد رسائل",
  "msg_peak_hour": "ساعة الذروة",
  "msg_busiest_day": "أكثر يوم ازدحاماً",
  "msg_avg_per_hour": "متوسط/ساعة",
  "msg_user_words": "كلمات المستخدمين",
  "msg_assistant_words": "كلمات المساعد",
  "msg_total_usage": "الاستخدام الكلي",
  "msg_morning": "صباحاً",
  "msg_afternoon": "بعد الظهر",
  "msg_evening": "مساءً",
  "msg_no_messages": "لا رسائل",
  "msg_very_low": "منخفض جداً",
  "msg_low": "منخفض",
  "msg_medium": "متوسط",
  "msg_high": "مرتفع",
  "msg_very_high": "مرتفع جداً",
  "msg_activity": "نشاط",
  "kpi_users_with_multiple_bookings": "مستخدمون لديهم حجوزات متعددة",
  "kpi_additional_bookings_per_returning_user": "حجوزات إضافية لكل مستخدم عائد",
  "conversation_analysis_title": "تحليل المحادثات",
  "conversation_length_average": "متوسط طول المحادثة",
  "conversation_length_median": "الوسيط لطول المحادثة",
  "conversation_length_maximum": "الحد الأقصى لطول المحادثة",
  "conversation_per_user": "محادثات لكل مستخدم",
  "conversation_overview": "نظرة عامة على المحادثات",
  "msg_unique_users": "مستخدمون فريدون",
  "conversation_avg_per_user": "متوسط المحادثات لكل مستخدم",
  "conversation_engagement": "مستوى التفاعل في المحادثات",
  "conversation_engagement_level": "مستوى التفاعل",
  "engagement_high": "تفاعل مرتفع",
  "engagement_medium": "تفاعل متوسط",
  "engagement_low": "تفاعل منخفض",
  "response_time_avg_desc": "متوسط زمن الاستجابة عبر المحادثات",
  "response_time_median_desc": "الوسيط لزمن الاستجابة عبر المحادثات",
  "response_time_max_desc": "أطول زمن استجابة مسجّل",
  "response_time_calculated": "محسوب",
  "response_time_progress_desc": "مؤشر الأداء: شريط أعلى = استجابات أسرع (مقياس 0-60 دقيقة)",
  "dashboard_this_month": "هذا الشهر",
  "dashboard_demo_mode": "وضع العرض التجريبي",
  "dashboard_demo_description": "أنت تشاهد بيانات تجريبية. صِل بالخادم الخلفي لتحميل البيانات الحقيقية.",
  "demo_data_warning": "تحذير بيانات تجريبية",
  "real_data_available": "بيانات حقيقية متاحة",
  "dashboard_business_insights": "رؤى الأعمال",
  "dashboard_peak_hours_title": "وقت ذروة الحجوزات",
  "dashboard_peak_hours_desc": "{{count}} حجز · {{time}}",
  "dashboard_user_retention_title": "معدل تكرار الحجز",
  "dashboard_user_retention_desc": "{{returningRate}}% من عملاء الحجز لديهم عدة حجوزات في هذه الفترة",
  "dashboard_response_time_title": "زمن الاستجابة",
  "dashboard_response_time_desc": "متوسط زمن الاستجابة {{seconds}} ثانية",
  "backend_connection_error_title": "تعذر الاتصال بالخادم الخلفي",
  "backend_offline_documents_title": "غير متصل — مستنداتك محفوظة على هذا الجهاز وستتم مزامنتها عند إعادة الاتصال",
  "backend_connection_error_description": "لم نتمكن من الوصول إلى الخادم الخلفي. يرجى التأكد من تشغيله وإمكانية الوصول إليه.",
  "backend_connection_error_instructions": "انقر إعادة المحاولة بعد التأكد من تشغيل الخادم.",
  "backend_connection_checking": "جارٍ التحقق من الاتصال…",
  "backend_connection_error_retry": "إعادة المحاولة",
  "authorization_error_title": "مطلوب تفويض",
  "authorization_error_description": "انتهت صلاحية جلستك أو ليس لديك إذن للوصول إلى هذا المورد.",
  "authorization_error_instructions": "سجّل دخولك إلى حسابك أو أنشئ حساباً جديداً للمتابعة.",
  "authorization_error_go_to_login": "تسجيل الدخول",
  "authorization_error_go_to_signup": "إنشاء حساب",
  "authorization_error_or_divider": "أو",
  "lib_access_denied_title": "تم رفض الوصول",
  "lib_access_denied_role_message": "ليس لديك الدور المطلوب لعرض هذه الصفحة. تواصل مع مالك المؤسسة أو المسؤول إذا كنت بحاجة إلى الوصول.",
  "lib_access_denied_admin_message": "هذا القسم متاح لمالكي المؤسسة والمسؤولين فقط. تواصل مع أحد المسؤولين إذا كنت بحاجة إلى الوصول.",
  "cm_format_percentage": "نسبة مئوية",
  "cm_format_scientific": "علمي",
  "cm_format_accounting": "محاسبي",
  "theme_mode_system": "النظام",
  "theme_mode_light": "فاتح",
  "theme_mode_dark": "داكن",
  "calendar_events": "أحداث",
  "chart_loading": "جارٍ تحميل المخطط…",
  "conversation_insights": "رؤى المحادثات",
  "conversation_insight_high": "تفاعل مرتفع",
  "conversation_insight_medium": "تفاعل متوسط",
  "conversation_insight_low": "تفاعل منخفض",
  "msg_messages": "الرسائل",
  "msg_default": "افتراضي",
  "period_current": "الفترة الحالية",
  "period_previous": "الفترة السابقة",
  "scroll_to_bottom": "التمرير إلى الأسفل",
  "toast_request_timeout": "انتهت مهلة الطلب",
  "toast_vacation_periods_updated": "تم تحديث فترات الإجازة",
  "slot_fully_booked": "هذا الوقت محجوز بالكامل. يرجى اختيار وقت آخر.",
  "slot_at_capacity": "الوقت ممتلئ ({{count}}/{{capacity}}). لا يمكن إضافة المزيد إلى هذا الوقت.",
  "grid.none": "لا يوجد",
  "calendar_legend_show_button": "إظهار دليل الألوان",
  "calendar_legend_title": "دليل الألوان",
  "calendar_legend_shortcuts": "الاختصارات",
  "calendar_legend_change_view_up": "تغيير العرض للأعلى",
  "calendar_legend_previous_date": "التاريخ السابق",
  "calendar_legend_arrow_left_hint": "السهم اليسار: تنقل التاريخ",
  "calendar_legend_next_date": "التاريخ التالي",
  "calendar_legend_arrow_right_hint": "السهم اليمين: تنقل التاريخ",
  "calendar_legend_change_view_down": "تغيير العرض للأسفل",
  "calendar_legend_arrow_repeat_hint": "السهمين يمين/يسار: تنقل التاريخ (اضغط واستمر للتكرار)",
  "calendar_legend_ctrl_arrow_hint": "تغيير العرض",
  "calendar_legend_navigate_date": "تنقل التاريخ",
  "calendar_legend_navigate_users": "تنقل المستخدمين",
  "calendar_legend_sidebar_closed": "الشريط مغلق",
  "calendar_legend_sidebar_open": "الشريط مفتوح",
  "calendar_legend_search_users": "بحث المستخدمين",
  "calendar_legend_system_agent": "وكيل النظام",
  "calendar_tutorial_title": "شرح الموقع",
  "calendar_tutorial_thumbnail_alt": "شرح نظام الحجز",
  "calendar_tutorial_hint": "شاهد كيفية استخدام الموقع",
  "calendar_legend_conversation": "محادثة",
  "user_last_message": "آخر رسالة",
  "user_unknown": "مستخدم غير معروف",
  "user_since": "مستخدم منذ",
  "user_events": "الحجوزات",
  "user_no_events": "لا توجد حجوزات",
  "status_label": "الحالة",
  "message_label": "الرسالة",
  "search_placeholder": "بحث…",
  "message_in": "وارد",
  "message_out": "صادر",
  "activity_scheduled_events": "المواعيد المجدولة",
  "activity_message_history": "سجل الرسائل",
  "activity_no_messages": "لا توجد رسائل بعد",
  "activity_timeline": "المخطط الزمني",
  "activity_timeline_switch_label": "طريقة عرض السجل",
  "activity_timeline_empty": "لا يوجد نشاط بعد",
  "activity_timeline_error": "تعذر تحميل نشاط جهة الاتصال",
  "activity_timeline_show_lifecycle": "سجل الحجز",
  "activity_messages_count": "تم تحميل {loaded} من {total} رسالة",
  "activity_contact_messages_count": "{count} رسالة",
  "user_show_details": "عرض التفاصيل",
  "user_view_events": "عرض الحجوزات",
  "user_collapse": "طي",
  "user_copy_phone": "نسخ رقم الهاتف",
  "user_phone_copied": "تم نسخ رقم الهاتف",
  "date_unknown": "تاريخ غير معروف",
  "date_label": "التاريخ",
  "time_label": "الوقت",
  "view_year": "السنة",
  "view_month": "الشهر",
  "view_week": "الأسبوع",
  "view_day": "اليوم",
  "view_list": "قائمة",
  "view_timeline": "الجدول الزمني",
  "view_timeline_range": "نطاق الجدول الزمني",
  "calendar_view": "عرض التقويم",
  "view_resources": "الموارد",
  "resource_unassigned": "غير مخصص",
  "field_event_end": "نهاية الحدث",
  "field_event_interval": "توقيت الحدث",
  "field_time_scheduled": "بداية الحدث",
  "field_time_stay_continues": "إقامة مستمرة — عدِّل موعد المغادرة",
  "validation_errors_title": "أخطاء في التحقق",
  "validation.required": "{{field}} مطلوب",
  "validation.thisFieldIsRequired": "هذا الحقل مطلوب",
  "validation.invalidFormat": "تنسيق غير صحيح",
  "validation.invalidDate": "تاريخ غير صحيح",
  "validation.invalidTime": "وقت غير صحيح",
  "validation.invalidPhone": "رقم هاتف غير صحيح",
  "validation.phoneFormatNotRecognized": "تنسيق الهاتف غير معروف",
  "validation.phoneHasInvalidCountryCode": "رمز الدولة غير صحيح",
  "validation.phoneContainsInvalidCharacters": "الهاتف يحتوي على أحرف غير صحيحة",
  "validation.phoneIsTooShort": "رقم الهاتف قصير جداً",
  "validation.phoneIsTooLong": "رقم الهاتف طويل جداً",
  "validation.phoneHasInvalidLengthForCountry": "طول الهاتف غير صحيح لهذه الدولة",
  "validation.phoneInvalidFormat": "تنسيق رقم الهاتف غير صحيح",
  "validation.phoneMayHaveInvalidAreaCode": "قد يكون رمز المنطقة غير صحيح",
  "validation.phoneFormatIsInvalid": "تنسيق الهاتف غير صحيح",
  "validation.invalidName": "اسم غير صحيح",
  "validation.nameRequired": "الاسم مطلوب",
  "validation.nameTooShort": "الاسم قصير جداً",
  "validation.nameInvalidCharacters": "الاسم يحتوي على أحرف غير صحيحة",
  "validation.nameWordsTooShort": "كلمات الاسم قصيرة جداً",
  "validation.nameTooLong": "الاسم طويل جداً",
  "notification_sent_message": "رسالة جديدة",
  "notification_created_event": "حجز جديد",
  "notification_updated_event": "تم تعديل تفاصيل الحجز",
  "notification_rescheduled_event": "تمت إعادة جدولة الحجز",
  "notification_reinstated_event": "تمت استعادة الحجز",
  "notification_vacation_updated": "تم تحديث فترة الإجازة",
  "notification_messages_group": "رسائل جديدة",
  "notification_cancelled_event": "تم إلغاء الحجز",
  "notification_updated_contact_status": "تغيّرت حالة جهة الاتصال",
  "notification_status_active": "نشط",
  "notification_status_inactive": "غير نشط",
  "notification_system_update": "تحديث النظام",
  "notification_user": "المستخدم",
  "vacation_add": "إضافة إجازة",
  "vacation_period_label": "فترة {{index}}",
  "vacation_delete_period": "حذف الفترة",
  "vacation_start": "البداية",
  "vacation_end": "النهاية",
  "vacation_recording": "تسجيل",
  "vacation_stop": "إيقاف",
  "vacation_stop_recording": "إيقاف التسجيل",
  "vacation_start_recording": "بدء تسجيل البداية",
  "vacation_end_recording": "بدء تسجيل النهاية",
  "vacation_no_periods": "لا توجد فترات إجازة",
  "language_label": "اللغة",
  "language_toggle_hint": "التبديل بين العربية والإنجليزية",
  "language_switched_to_arabic": "تم التبديل إلى العربية",
  "language_english": "الإنجليزية",
  "language_ar": "العربية",
  "language_arabic": "العربية",
  "calendar_locale_label": "نظام التقويم",
  "calendar_locale_hint": "اختر نظام التقويم (ميلادي أو هجري). تتبع أسماء الأيام والأشهر لغة التطبيق.",
  "calendar_locale_gregorian": "ميلادي",
  "calendar_locale_hijri": "هجري",
  "calendar_locale_en": "الإنجليزية",
  "calendar_locale_ar": "العربية",
  "calendar_locale_ar_sa": "هجري",
  "theme_label": "المظهر",
  "theme_unknown": "سمة غير معروفة",
  "theme_default": "افتراضي",
  "theme_clerk": "كليرك",
  "theme_amethyst_haze": "ضباب الجمشت",
  "theme_claude": "كلود",
  "theme_art_deco": "آرت ديكو",
  "theme_neo_brutalism": "الوحشية الجديدة",
  "theme_perpetuity": "الخلود",
  "theme_retro_arcade": "أركيد ريترو",
  "theme_soft_pop": "بوب ارتس",
  "theme_ghibli_studio": "استوديو جيبلي",
  "theme_valorant": "فالورانت",
  "theme_t3chat": "تي ثري تشات",
  "theme_perplexity": "بيربليكسيتي",
  "theme_neomorphism": "نيو مورفزم",
  "column_menu_unpin": "إلغاء التثبيت",
  "column_menu_filter": "تصفية",
  "column_menu_copy": "نسخ العمود",
  "column_menu_text_format": "تنسيق النص",
  "column_menu_number_format": "تنسيق الأرقام",
  "column_menu_date_format": "تنسيق التاريخ",
  "cancel_incomplete_data": "بيانات غير كاملة (الهاتف/التاريخ)",
  "cancel_system_error": "خطأ بالنظام، حاول لاحقًا",
  "undo_success": "تم التراجع بنجاح",
  "undo_unknown_error": "خطأ غير معروف",
  "undo_failed": "فشل التراجع",
  "undo_processing": "جاري التراجع",
  "time_am": "ص",
  "time_pm": "م",
  "time_just_now": "قبل ثوانٍ",
  "time_minutes_ago": "دقيقة",
  "time_hours_ago": "ساعة",
  "time_days_ago": "يوم",
  "press_esc_to_exit_fullscreen": "اضغط ESC للخروج من وضع ملء الشاشة",
  "country_AC": "جزيرة أسنسيون",
  "country_AD": "أندورا",
  "country_AE": "الإمارات العربية المتحدة",
  "country_AF": "أفغانستان",
  "country_AG": "أنتيغوا وباربودا",
  "country_AI": "أنغيلا",
  "country_AL": "ألبانيا",
  "country_AM": "أرمينيا",
  "country_AO": "أنغولا",
  "country_AR": "الأرجنتين",
  "country_AS": "ساموا الأمريكية",
  "country_AT": "النمسا",
  "country_AU": "أستراليا",
  "country_AW": "أروبا",
  "country_AX": "جزر آلاند",
  "country_AZ": "أذربيجان",
  "country_BA": "البوسنة والهرسك",
  "country_BB": "باربادوس",
  "country_BD": "بنغلاديش",
  "country_BE": "بلجيكا",
  "country_BF": "بوركينا فاسو",
  "country_BG": "بلغاريا",
  "country_BH": "البحرين",
  "country_BI": "بوروندي",
  "country_BJ": "بنين",
  "country_BL": "سانت بارتيليمي",
  "country_BM": "برمودا",
  "country_BN": "بروناي",
  "country_BO": "بوليفيا",
  "country_BQ": "بونير وسانت يوستاتيوس وسابا",
  "country_BR": "البرازيل",
  "country_BS": "باهاماس",
  "country_BT": "بوتان",
  "country_BW": "بوتسوانا",
  "country_BY": "بيلاروس",
  "country_BZ": "بليز",
  "country_CA": "كندا",
  "country_CC": "جزر كوكوس (كيلينغ)",
  "country_CD": "جمهورية الكونغو الديمقراطية",
  "country_CF": "جمهورية أفريقيا الوسطى",
  "country_CG": "جمهورية الكونغو",
  "country_CH": "سويسرا",
  "country_CI": "ساحل العاج",
  "country_CK": "جزر كوك",
  "country_CL": "تشيلي",
  "country_CM": "الكاميرون",
  "country_CN": "الصين",
  "country_CO": "كولومبيا",
  "country_CR": "كوستاريكا",
  "country_CU": "كوبا",
  "country_CV": "الرأس الأخضر",
  "country_CW": "كوراساو",
  "country_CX": "جزيرة الكريسماس",
  "country_CY": "قبرص",
  "country_CZ": "جمهورية التشيك",
  "country_DE": "ألمانيا",
  "country_DJ": "جيبوتي",
  "country_DK": "الدنمارك",
  "country_DM": "دومينيكا",
  "country_DO": "جمهورية الدومينيكان",
  "country_DZ": "الجزائر",
  "country_EC": "الإكوادور",
  "country_EE": "إستونيا",
  "country_EG": "مصر",
  "country_EH": "الصحراء الغربية",
  "country_ER": "إريتريا",
  "country_ES": "إسبانيا",
  "country_ET": "إثيوبيا",
  "country_FI": "فنلندا",
  "country_FJ": "فيجي",
  "country_FK": "جزر فوكلاند",
  "country_FM": "ولايات ميكرونيسيا المتحدة",
  "country_FO": "جزر فاروس",
  "country_FR": "فرنسا",
  "country_GA": "الغابون",
  "country_GB": "المملكة المتحدة",
  "country_GD": "غرينادا",
  "country_GE": "جورجيا",
  "country_GF": "غيانا الفرنسية",
  "country_GG": "غيرنسي",
  "country_GH": "غانا",
  "country_GI": "جبل طارق",
  "country_GL": "الأرض الخضراء",
  "country_GM": "غامبيا",
  "country_GN": "غينيا",
  "country_GP": "جوادلوب",
  "country_GQ": "غينيا الاستوائية",
  "country_GR": "اليونان",
  "country_GT": "غواتيمالا",
  "country_GU": "غوام",
  "country_GW": "غينيا بيساو",
  "country_GY": "غيانا",
  "country_HK": "هونج كونج",
  "country_HN": "هندوراس",
  "country_HR": "كرواتيا",
  "country_HT": "هايتي",
  "country_HU": "المجر",
  "country_ID": "إندونيسيا",
  "country_IE": "أيرلندا",
  "country_IL": "إسرائيل",
  "country_IM": "جزيرة آيل أوف مان",
  "country_IN": "الهند",
  "country_IO": "إقليم المحيط البريطاني الهندي",
  "country_IQ": "العراق",
  "country_IR": "إيران",
  "country_IS": "آيسلندا",
  "country_IT": "إيطاليا",
  "country_JE": "جيرسي",
  "country_JM": "جامايكا",
  "country_JO": "الأردن",
  "country_JP": "اليابان",
  "country_KE": "كينيا",
  "country_KG": "قيرغيزستان",
  "country_KH": "كمبوديا",
  "country_KI": "كيريباتي",
  "country_KM": "جزر القمر",
  "country_KN": "سانت كيتس ونيفيس",
  "country_KP": "كوريا الشمالية",
  "country_KR": "كوريا الجنوبية",
  "country_KW": "الكويت",
  "country_KY": "جزر كايمان",
  "country_KZ": "كازاخستان",
  "country_LA": "لاوس",
  "country_LB": "لبنان",
  "country_LC": "سانت لوسيا",
  "country_LI": "ليختنشتاين",
  "country_LK": "سريلانكا",
  "country_LR": "ليبيريا",
  "country_LS": "ليسوتو",
  "country_LT": "ليتوانيا",
  "country_LU": "لوكسمبورغ",
  "country_LV": "لاتفيا",
  "country_LY": "ليبيا",
  "country_MA": "المغرب",
  "country_MC": "موناكو",
  "country_MD": "مولدوفا",
  "country_ME": "الجبل الأسود",
  "country_MF": "سانت مارتن (الجزء الفرنسي)",
  "country_MG": "مدغشقر",
  "country_MH": "جزر مارشال",
  "country_MK": "مقدونيا",
  "country_ML": "مالي",
  "country_MM": "ميانمار",
  "country_MN": "منغوليا",
  "country_MO": "ماكاو",
  "country_MP": "جزر مريانا الشمالية",
  "country_MQ": "مارتينيك",
  "country_MR": "موريتانيا",
  "country_MS": "مونتسيرات",
  "country_MT": "مالطا",
  "country_MU": "موريشيوس",
  "country_MV": "جزر المالديف",
  "country_MW": "مالاوي",
  "country_MX": "المكسيك",
  "country_MY": "ماليزيا",
  "country_MZ": "موزمبيق",
  "country_NA": "ناميبيا",
  "country_NC": "كاليدونيا الجديدة",
  "country_NE": "النيجر",
  "country_NF": "جزيرة نورفولك",
  "country_NG": "نيجيريا",
  "country_NI": "نيكاراغوا",
  "country_NL": "هولندا",
  "country_NO": "النرويج",
  "country_NP": "نيبال",
  "country_NR": "ناورو",
  "country_NU": "نيوي",
  "country_NZ": "نيوزيلندا",
  "country_OM": "عمان",
  "country_PA": "بنما",
  "country_PE": "بيرو",
  "country_PF": "بولينيزيا الفرنسية",
  "country_PG": "بابوا غينيا الجديدة",
  "country_PH": "الفلبين",
  "country_PK": "باكستان",
  "country_PL": "بولندا",
  "country_PM": "سانت بيير وميكلون",
  "country_PR": "بورتوريكو",
  "country_PS": "فلسطين",
  "country_PT": "البرتغال",
  "country_PW": "بالاو",
  "country_PY": "باراغواي",
  "country_QA": "قطر",
  "country_RE": "جمع شمل",
  "country_RO": "رومانيا",
  "country_RS": "صربيا",
  "country_RU": "روسيا",
  "country_RW": "رواندا",
  "country_SA": "السعودية",
  "country_SB": "جزر سليمان",
  "country_SC": "سيشل",
  "country_SD": "السودان",
  "country_SE": "السويد",
  "country_SG": "سنغافورة",
  "country_SH": "سانت هيلانة",
  "country_SI": "سلوفينيا",
  "country_SJ": "سفالبارد وجان ماين",
  "country_SK": "سلوفاكيا",
  "country_SL": "سيراليون",
  "country_SM": "سان مارينو",
  "country_SN": "السنغال",
  "country_SO": "الصومال",
  "country_SR": "سورينام",
  "country_SS": "جنوب السودان",
  "country_ST": "ساو تومي وبرينسيب",
  "country_SV": "السلفادور",
  "country_SX": "سينت مارتن",
  "country_SY": "سوريا",
  "country_SZ": "إسواتيني",
  "country_TA": "تريستان دا كونها",
  "country_TC": "جزر تركس وكايكوس",
  "country_TD": "تشاد",
  "country_TG": "توغو",
  "country_TH": "تايلاند",
  "country_TJ": "طاجيكستان",
  "country_TK": "توكيلاو",
  "country_TL": "تيمور الشرقية",
  "country_TM": "تركمانستان",
  "country_TN": "تونس",
  "country_TO": "تونغا",
  "country_TR": "تركيا",
  "country_TT": "ترينيداد وتوباغو",
  "country_TV": "توفالو",
  "country_TW": "تايوان",
  "country_TZ": "تنزانيا",
  "country_UA": "أوكرانيا",
  "country_UG": "أوغندا",
  "country_US": "الولايات المتحدة",
  "country_UY": "الأوروغواي",
  "country_UZ": "أوزبكستان",
  "country_VA": "الكرسي الرسولي (دولة الفاتيكان)",
  "country_VC": "سانت فينسنت والغرينادين",
  "country_VE": "فنزويلا",
  "country_VG": "جزر العذراء البريطانية",
  "country_VI": "جزر فيرجن الأمريكية",
  "country_VN": "فيتنام",
  "country_VU": "فانواتو",
  "country_WF": "واليس وفوتونا",
  "country_WS": "ساموا",
  "country_XK": "كوسوفو",
  "country_YE": "اليمن",
  "country_YT": "مايوت",
  "country_ZA": "جنوب أفريقيا",
  "country_ZM": "زامبيا",
  "country_ZW": "زيمبابوي",
  "not_found_status": "الحالة · 404",
  "not_found_title": "لا يمكننا العثور على هذه الصفحة.",
  "not_found_description": "قد يكون الرابط قديمًا أو نُقلت الصفحة. تحقق من الرابط أو ارجع إلى مكان تعرفه.",
  "not_found_go_back": "رجوع",
  "not_found_take_me_home": "العودة إلى الرئيسية",
  "not_found_resource_home_label": "الرئيسية",
  "not_found_resource_home_description": "العودة إلى نقطة البداية واختيار وجهة جديدة.",
  "not_found_resource_dashboard_label": "لوحة التحكم",
  "not_found_resource_dashboard_description": "مراجعة حالة الأتمتة والحجوزات والمقاييس.",
  "not_found_resource_docs_label": "قاعدة المعرفة",
  "not_found_resource_docs_description": "استكشاف الأخطاء وإصلاحها أو استكشاف أدلة الميزات.",
  "not_found_button_return_home": "العودة إلى الرئيسية",
  "not_found_button_explore_dashboard": "استكشاف لوحة التحكم",
  "not_found_button_back_home": "العودة إلى الرئيسية",
  "global_error_title": "حدث خطأ ما",
  "global_error_description": "تسبب خطأ غير متوقع في انقطاع جلستك. يمكنك إعادة المحاولة أو العودة إلى لوحة التحكم بينما نحافظ على الأمان.",
  "global_error_reference": "مرجع الخطأ:",
  "global_error_button_try_again": "حاول مرة أخرى",
  "global_error_button_return_home": "العودة إلى الرئيسية",
  "sign_in_title": "تسجيل الدخول",
  "sign_in_subtitle": "",
  "sign_in_email_label": "البريد الإلكتروني",
  "sign_in_email_placeholder": "you@company.com",
  "sign_in_password_label": "كلمة المرور",
  "sign_in_password_placeholder": "كلمة المرور الخاصة بك",
  "sign_in_forgot_password": "نسيت كلمة المرور؟",
  "sign_in_button": "تسجيل الدخول",
  "sign_in_loading": "جارٍ تسجيل الدخول…",
  "sign_in_or_continue": "أو المتابعة مع",
  "sign_in_no_account": "ليس لديك حساب؟",
  "sign_in_create_account": "إنشاء حساب",
  "sign_up_title": "إنشاء حساب",
  "sign_up_subtitle": "",
  "sign_up_firstname_label": "الاسم الأول",
  "sign_up_firstname_placeholder": "الاسم الأول (اختياري)",
  "sign_up_lastname_label": "اسم العائلة",
  "sign_up_lastname_placeholder": "اسم العائلة (اختياري)",
  "sign_up_email_label": "البريد الإلكتروني",
  "sign_up_email_placeholder": "you@company.com",
  "sign_up_email_error_required": "البريد الإلكتروني مطلوب",
  "sign_up_email_error_invalid": "يرجى إدخال عنوان بريد إلكتروني صحيح",
  "sign_up_password_label": "كلمة المرور",
  "sign_up_password_placeholder": "أدخل كلمة المرور",
  "sign_up_confirm_password_label": "تأكيد كلمة المرور",
  "sign_up_confirm_password_placeholder": "تأكيد كلمة المرور",
  "sign_up_confirm_password_description": "أعد إدخال كلمة المرور للتأكيد.",
  "sign_up_password_requirement_min": "8 أحرف على الأقل",
  "sign_up_password_requirement_upper": "حرف كبير واحد",
  "sign_up_password_requirement_lower": "حرف صغير واحد",
  "sign_up_password_requirement_number": "رقم واحد",
  "sign_up_password_requirement_special": "حرف خاص واحد",
  "sign_up_password_error_min": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
  "sign_up_password_error_match": "كلمات المرور غير متطابقة",
  "sign_up_name_error_invalid": "يمكن أن يحتوي الاسم على الأحرف والمسافات والشرطات والفواصل العليا فقط",
  "sign_up_button": "إنشاء حساب",
  "sign_up_loading": "جارٍ إنشاء الحساب…",
  "sign_up_or_continue": "أو المتابعة مع",
  "sign_up_has_account": "لديك حساب؟",
  "sign_up_sign_in": "تسجيل الدخول",
  "sign_in_error_email_required": "البريد الإلكتروني مطلوب",
  "sign_in_error_invalid_email": "يرجى إدخال عنوان بريد إلكتروني صحيح",
  "sign_in_error_invalid_credentials": "بيانات اعتماد غير صحيحة",
  "sign_in_error_failed": "فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد.",
  "sign_in_success": "تم تسجيل الدخول بنجاح!",
  "sign_up_error_failed": "فشل إنشاء الحساب",
  "sign_up_error_signin_failed": "تم إنشاء الحساب ولكن فشل تسجيل الدخول. يرجى محاولة تسجيل الدخول يدوياً.",
  "sign_up_success": "تم إنشاء الحساب! تم تسجيل الدخول بنجاح!",
  "sign_up_agree_prefix": "أوافق على",
  "sign_up_terms_link": "شروط الخدمة",
  "sign_up_agree_and": "و",
  "sign_up_privacy_link": "سياسة الخصوصية",
  "auth_continue_agree_prefix": "بمتابعتك، فإنك توافق على",
  "reset_title": "إعادة تعيين كلمة المرور",
  "reset_subtitle": "أدخل بريدك الإلكتروني لتلقي رمز التحقق",
  "reset_email_placeholder": "you@company.com",
  "reset_send_code": "إرسال الرمز",
  "reset_sending": "جارٍ الإرسال…",
  "reset_otp_title": "تحقق من بريدك",
  "reset_otp_subtitle": "أرسلنا رمزاً مكوناً من 6 أرقام إلى",
  "reset_otp_label": "رمز التحقق",
  "reset_otp_resend": "إعادة إرسال الرمز",
  "reset_otp_didnt_receive": "لم تستلم الرمز؟",
  "reset_otp_next": "متابعة",
  "reset_password_title": "كلمة المرور الجديدة",
  "reset_password_subtitle": "اختر كلمة مرور قوية لحسابك",
  "reset_password_placeholder": "كلمة المرور الجديدة",
  "reset_confirm_placeholder": "تأكيد كلمة المرور الجديدة",
  "reset_password_button": "إعادة تعيين كلمة المرور",
  "reset_resetting": "جارٍ إعادة التعيين…",
  "reset_success": "تم إعادة تعيين كلمة المرور بنجاح! يمكنك الآن تسجيل الدخول.",
  "reset_error_failed": "فشل إعادة تعيين كلمة المرور. يرجى المحاولة مرة أخرى.",
  "reset_error_invalid_code": "رمز غير صالح أو منتهي الصلاحية. يرجى المحاولة مرة أخرى.",
  "reset_back_to_login": "العودة لتسجيل الدخول",
  "email_code_button": "تسجيل الدخول برمز البريد",
  "email_code_title": "رمز البريد",
  "email_code_subtitle": "سنرسل رمز تسجيل دخول إلى بريدك الإلكتروني",
  "email_code_email_placeholder": "you@company.com",
  "email_code_send": "إرسال الرمز",
  "email_code_sending": "جارٍ الإرسال…",
  "email_code_otp_title": "تحقق من بريدك",
  "email_code_otp_subtitle": "أرسلنا رمزاً مكوناً من 6 أرقام إلى",
  "email_code_otp_label": "رمز تسجيل الدخول",
  "otp_slot_aria_label": "الرقم {{index}} من {{total}}",
  "otp_code_complete": "اكتمل رمز التحقق",
  "email_code_otp_didnt_receive": "لم تستلم الرمز؟",
  "email_code_sent_toast": "تم إرسال الرمز! تحقق من بريدك.",
  "email_code_resend": "إعادة إرسال الرمز",
  "email_code_verify": "تسجيل الدخول",
  "email_code_verifying": "جارٍ تسجيل الدخول…",
  "email_code_error_failed": "فشل إرسال الرمز. يرجى المحاولة مرة أخرى.",
  "email_code_error_invalid_code": "رمز غير صالح. يرجى المحاولة مرة أخرى.",
  "email_code_error_expired": "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
  "email_code_expired_label": "انتهت صلاحية الرمز",
  "email_code_expires_in": "ينتهي خلال",
  "email_code_change_email": "تغيير البريد",
  "email_code_or_password": "استخدم كلمة المرور بدلاً من ذلك",
  "anonymous_try_demo": "جرّب بدون حساب",
  "anonymous_loading": "جارٍ الإعداد…",
  "model_filter_variant": "نوع النموذج",
  "model_filter_variant_label": "تصفية حسب النوع",
  "model_filter_all_variants": "جميع الأنواع",
  "model_filter_variant_standard": "قياسي",
  "model_filter_variant_standard_desc": "نماذج بدون متغير خاص",
  "model_filter_variant_free": "مجاني",
  "model_filter_variant_free_desc": "نسخة مجانية مع حدود معدل محتملة",
  "model_filter_variant_extended": "موسع",
  "model_filter_variant_extended_desc": "نسخة بنافذة سياق موسعة",
  "model_filter_variant_exacto": "إكساكتو",
  "model_filter_variant_exacto_desc": "نسخة عالية الدقة",
  "model_filter_variant_nitro": "نيترو",
  "model_filter_variant_nitro_desc": "توجيه إنتاجية أعلى",
  "model_filter_variant_floor": "الأرضية",
  "model_filter_variant_floor_desc": "توجيه أقل سعر",
  "model_filter_variant_thinking": "التفكير",
  "model_filter_variant_thinking_desc": "ممكّن للاستدلال/التفكير",
  "model_filter_variant_online": "متصل",
  "model_filter_variant_online_desc": "قادر على الوقت الفعلي/متصل",
  "model_filter_endpoint_provider": "مزود نقطة النهاية",
  "model_filter_author_search": "بحث عن المؤلفين…",
  "model_filter_no_authors": "لم يتم العثور على مؤلفين.",
  "model_filter_all_authors": "جميع المؤلفين",
  "model_filter_provider_search": "بحث عن المزودين…",
  "model_filter_no_providers": "لم يتم العثور على مزودين.",
  "model_filter_all_providers": "جميع المزودين",
  "model_filter_supported_params": "المعلمات المدعومة",
  "model_filter_supported_params_label": "تصفية حسب القدرات",
  "model_filter_clear_params": "مسح الكل",
  "model_filter_param_tools": "الأدوات",
  "model_filter_param_tools_desc": "يدعم استدعاء الوظائف/الأدوات",
  "model_filter_param_reasoning": "الاستدلال",
  "model_filter_param_reasoning_desc": "يدعم وضع الاستدلال/التفكير",
  "model_filter_param_parallel_tools": "أدوات متوازية",
  "model_filter_param_parallel_tools_desc": "يدعم استدعاءات الأدوات المتوازية",
  "model_filter_param_max_tokens": "الحد الأقصى للرموز",
  "model_filter_param_max_tokens_desc": "يدعم معلمة max_tokens",
  "model_filter_param_json_mode": "وضع JSON",
  "model_filter_param_json_mode_desc": "يدعم تنسيق استجابة JSON",
  "model_filter_param_vision": "الرؤية",
  "model_filter_param_vision_desc": "يدعم إدخال الصور",
  "model_filter_param_streaming": "البث",
  "model_filter_param_streaming_desc": "يدعم الاستجابات المتدفقة",
  "reasoning_thinking": "جاري التفكير…",
  "reasoning_thought_for": "فكر لمدة {{duration}} ثانية",
  "button_retry": "إعادة المحاولة",
  "button_refresh": "تحديث",
  "search_emojis_placeholder": "ابحث عن الإيموجي…",
  "recent_emojis_label": "الإيموجي المستخدم مؤخراً",
  "search_status_placeholder": "ابحث عن الحالة…",
  "search_views_placeholder": "ابحث عن العروض…",
  "search_locale_placeholder": "ابحث عن اللغة المحلية…",
  "search_models_placeholder": "ابحث عن النماذج…",
  "search_timezone_placeholder": "ابحث عن المدينة أو الإزاحة (مثل: 3+، GMT-5)…",
  "search_themes_placeholder": "ابحث عن المظاهر…",
  "search_languages_placeholder": "ابحث عن اللغات…",
  "empty_no_emojis_found": "لم يتم العثور على إيموجي.",
  "empty_no_status_found": "لم يتم العثور على حالة.",
  "empty_no_models_found": "لم يتم العثور على نماذج",
  "empty_unable_to_load_models": "تعذر تحميل النماذج",
  "empty_no_language_found": "لم يتم العثور على لغة.",
  "empty_no_theme_found": "لم يتم العثور على مظهر.",
  "empty_no_view_found": "لم يتم العثور على عرض.",
  "empty_no_locale_found": "لم يتم العثور على لغة محلية.",
  "empty_no_users_found": "لم يتم العثور على مستخدمين",
  "empty_no_tools_available": "لا توجد أدوات متاحة",
  "tool_fixed_to_category": "الأداة ثابتة ضمن فئتها",
  "empty_no_capacity_available": "لا توجد سعة متاحة",
  "empty_no_options_found": "لم يتم العثور على خيارات.",
  "empty_no_option_found": "لم يتم العثور على خيار.",
  "empty_no_day_found": "لم يتم العثور على يوم.",
  "loading_emojis": "جارٍ تحميل الإيموجي…",
  "loading_models": "جارٍ تحميل النماذج…",
  "loading_emoji_picker": "جارٍ تحميل منتقي الإيموجي…",
  "error_calendar_loading_title": "خطأ في تحميل التقويم",
  "error_calendar_loading_message": "حدثت مشكلة في تحميل التقويم. من المحتمل أن تكون هذه مشكلة مؤقتة في خادم التطوير.",
  "error_details": "تفاصيل الخطأ",
  "error_config_failed_title": "فشل تحميل التكوين",
  "error_config_failed_message": "يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
  "error_config_failed_details": "تحقق من وحدة تحكم المتصفح للحصول على معلومات خطأ مفصلة.",
  "emoji_category_smileys_people": "الوجوه والأشخاص",
  "emoji_category_animals_nature": "الحيوانات والطبيعة",
  "emoji_category_food_drink": "الطعام والشراب",
  "emoji_category_travel_places": "السفر والأماكن",
  "emoji_category_activities": "الأنشطة",
  "emoji_category_objects": "الأشياء",
  "emoji_category_symbols": "الرموز",
  "emoji_category_flags": "الأعلام",
  "aria_open_emoji_picker": "فتح منتقي الإيموجي",
  "aria_select_emoji": "اختر إيموجي",
  "aria_grid_data_editor": "محرر بيانات الشبكة",
  "aria_document_actions": "إجراءات المستند",
  "aria_edit_default_document_template": "تعديل قالب المستند الافتراضي",
  "aria_close": "إغلاق",
  "aria_phone_editor_button_group": "مجموعة أزرار محرر الهاتف",
  "aria_open_phone_options": "فتح خيارات الهاتف",
  "aria_select_option": "اختر خيار",
  "aria_open_date_range_picker": "فتح منتقي نطاق التاريخ",
  "aria_data_grid_container": "حاوية شبكة البيانات",
  "aria_document_stroke_color_picker": "منتقي لون خط المستند",
  "aria_document_stroke_hex_value": "قيمة hex لخط المستند",
  "aria_previous_source": "المصدر السابق",
  "aria_next_source": "المصدر التالي",
  "aria_clear_selection": "مسح التحديد",
  "aria_open_popup": "فتح النافذة المنبثقة",
  "aria_resize_sidebar": "تغيير حجم الشريط الجانبي",
  "aria_open_video": "فتح الفيديو",
  "aria_close_video_overlay": "إغلاق تراكب الفيديو",
  "aria_scroll_to_bottom": "التمرير إلى الأسفل",
  "aria_error_icon": "أيقونة الخطأ",
  "aria_reset_preview": "إعادة تعيين المعاينة",
  "aria_previous": "السابق",
  "aria_next": "التالي",
  "aria_previous_branch": "الفرع السابق",
  "aria_next_branch": "الفرع التالي",
  "aria_robot_icon": "أيقونة الروبوت",
  "aria_grid_toolbar": "شريط أدوات الشبكة",
  "aria_clock_icon": "أيقونة الساعة",
  "aria_calendar_icon": "أيقونة التقويم",
  "aria_loading": "جارٍ التحميل",
  "aria_analytics_chart": "مخطط التحليلات",
  "aria_age_selector": "منتقي العمر",
  "aria_open_sidebar": "فتح الشريط الجانبي",
  "aria_close_sidebar": "إغلاق الشريط الجانبي",
  "aria_open_calendar": "فتح التقويم",
  "config_auto_use_default": "تلقائي (استخدام الافتراضي)",
  "config_none_disable_fallback": "لا شيء (تعطيل الاحتياطي)",
  "actions": "الإجراءات",
  "export": "تصدير",
  "import": "استيراد",
  "discard": "تجاهل",
  "undo": "تراجع",
  "settings_documents_viewer_subtitle": "إعدادات عارض المستندات",
  "settings_documents_editor_subtitle": "تخصيص إعدادات المحرر",
  "settings_chat_subtitle": "التحكم في الأدوات ومؤشر الكتابة",
  "theme_subtitle": "اختر المظهر المفضل",
  "component_style_label": "نمط المكونات",
  "component_style_hint": "اختر مظهر الأزرار",
  "calendar_locale_en_native": "English",
  "calendar_locale_ar_native": "العربية",
  "calendar_locale_ar_sa_native": "العربية (هجري)",
  "trends_time_analysis": "تحليل الوقت",
  "trends_time_analysis_desc": "أنماط النشاط عبر فترات زمنية مختلفة",
  "trends_event_distribution": "توزيع الأحداث",
  "trends_event_distribution_desc": "تفصيل الأحداث حسب النوع والفئة",
  "trends_user_behavior": "سلوك المستخدم",
  "trends_user_behavior_desc": "رحلة المستخدم ورؤى التصنيف",
  "total_operations": "إجمالي العمليات",
  "name_required_for_event": "الاسم مطلوب لإنشاء الحجز",
  "name_cannot_be_placeholder": "يرجى تقديم اسم حقيقي، وليس 'غير معروف'",
  "name_cannot_be_phone": "لا يمكن أن يكون الاسم هو رقم الهاتف",
  "emoji_category_smileys_emotion": "الوجوه والمشاعر",
  "emoji_category_people_body": "الأشخاص والجسم",
  "emoji_category_people": "أشخاص",
  "aria_remove_filter": "إزالة المرشح",
  "aria_previous_month": "الشهر السابق",
  "aria_next_month": "الشهر التالي",
  "aria_user_profile_menu": "قائمة ملف المستخدم",
  "aria_analytics_dashboard": "لوحة التحليلات",
  "aria_dashboard_overview": "نظرة عامة على لوحة المعلومات",
  "aria_key_performance_indicators": "مؤشرات الأداء الرئيسية",
  "aria_loading_dashboard": "جارٍ تحميل لوحة المعلومات",
  "aria_message_analysis": "تحليل الرسائل",
  "aria_trends_analysis": "تحليل الاتجاهات",
  "aria_analytics_breakdown": "تفصيل التحليلات",
  "aria_chart_visualization": "رسم بياني مرئي",
  "aria_chart_legend": "مفتاح الرسم البياني",
  "aria_open_date_picker": "فتح منتقي التاريخ",
  "aria_open_time_picker": "فتح منتقي الوقت",
  "aria_time_hours": "الساعات",
  "aria_time_minutes": "الدقائق",
  "aria_time_meridiem": "ص/م",
  "aria_open_style_panel": "فتح لوحة الأنماط",
  "aria_previous_page": "الصفحة السابقة",
  "aria_next_page": "الصفحة التالية",
  "aria_document_viewer_canvas": "لوحة عارض المستندات",
  "aria_documents_data_grid": "جدول بيانات المستندات",
  "aria_document_viewer_panel": "لوحة عارض المستندات",
  "aria_loading_editor": "جارٍ تحميل المحرر",
  "aria_toggle_sidebar": "تبديل الشريط الجانبي",
  "aria_notifications_count": "الإشعارات:",
  "aria_events_count": "الأحداث:",
  "chat_skip_thinking": "تخطي التفكير",
  "chat_stop_response": "إيقاف الرد",
  "chat_send_message": "إرسال رسالة",
  "chat_attach_file": "إرفاق ملف",
  "chat_emoji_label": "رمز تعبيري",
  "chat_mention_kbd_navigate": "تنقّل",
  "chat_mention_kbd_insert": "إدراج",
  "chat_action_edit": "تعديل",
  "chat_action_like": "إعجاب",
  "chat_action_react": "تفاعل",
  "chat_action_reply": "رد",
  "chat_reply_to": "الرد على",
  "chat_reply_cancel": "إلغاء الرد",
  "chat_reply_message_not_loaded": "الرسالة الأصلية لم تُحمّل بعد",
  "chat_reminder_label": "تذكير",
  "chat_role_customer": "العميل",
  "chat_role_secretary": "أنت",
  "chat_role_assistant": "المساعد",
  "chat_show_more": "عرض المزيد",
  "chat_appointment_reminder": "تذكير بالموعد",
  "chat_reminder_template_unavailable": "اسم القالب غير محفوظ",
  "chat_reminder_content_unavailable": "لم يتم حفظ محتوى التذكير الأصلي المرسل ولا يمكن استعادته.",
  "chat_show_less": "عرض أقل",
  "chat_thinking": "يفكر",
  "chat_view_as_json": "عرض كـ JSON",
  "chat_view_as_diagram": "عرض كمخطط",
  "chat_tool_show_tool_call": "إظهار استدعاء الأداة",
  "chat_tool_hide_tool_call": "إخفاء استدعاء الأداة",
  "chat_tool_show_widget": "إظهار الأداة المرئية",
  "chat_tool_booking_booked": "تم الحجز",
  "chat_tool_booking_waitlist_added": "تمت الإضافة إلى قائمة الانتظار",
  "chat_tool_booking_waitlisted": "في قائمة الانتظار",
  "chat_tool_booking_failed": "فشل الحجز",
  "chat_tool_usage_ai": "استخدام الذكاء الاصطناعي",
  "chat_tool_usage_credits": "الرصيد",
  "chat_tool_location_sent": "تم إرسال موقع النشاط التجاري",
  "chat_tool_location_open_maps": "فتح في خرائط Google",
  "chat_workflow_title": "مسار توليد الإجابة",
  "chat_workflow_step_research": "البحث في قاعدة المعرفة",
  "chat_workflow_step_research_more": "جمع أدلة إضافية",
  "chat_workflow_step_draft": "صياغة الإجابة",
  "chat_workflow_step_verify": "التحقق من الإجابة",
  "chat_workflow_step_verify_loop": "التحقق من الإجابة (جولة {{loop}})",
  "chat_workflow_step_revise": "مراجعة الإجابة",
  "chat_workflow_evidence_count": "الأدلة المجمعة: {{count}}",
  "chat_workflow_verify_passed": "جميع الادعاءات مدعومة",
  "chat_workflow_verify_problems": "ادعاءات بحاجة لمراجعة: {{count}}",
  "chat_workflow_outcome_success": "اكتمل المسار",
  "chat_workflow_outcome_failed": "فشل المسار",
  "event_status_pending": "قيد الانتظار",
  "chat_tool_calls_group_label": "استخدم {{count}} أدوات",
  "chat_generating_image": "جارٍ إنشاء الصورة…",
  "chat_reasoning": "التفكير",
  "chat_reasoned_for_seconds": "فكّر لبضع ثوانٍ",
  "chat_toggle_plan": "تبديل الخطة",
  "toast_copied_to_clipboard": "تم النسخ إلى الحافظة!",
  "toast_no_text_to_copy": "لا يوجد نص للنسخ!",
  "toast_message_liked": "تم الإعجاب بالرسالة!",
  "toast_message_reacted": "تم إرسال التفاعل!",
  "toast_message_reaction_failed": "تعذّر إرسال التفاعل",
  "toast_cannot_move_to_past": "لا يمكن نقل المواعيد إلى الماضي",
  "toast_template_error": "خطأ في القالب",
  "toast_user_creation_error": "حدث خطأ أثناء إنشاء المستخدم",
  "toast_language_not_available": "هذه اللغة غير متاحة",
  "icon_document": "أيقونة المستند",
  "icon_loader": "جارٍ التحميل",
  "icon_vercel": "أيقونة Vercel",
  "icon_git": "أيقونة Git",
  "icon_box": "أيقونة صندوق",
  "icon_home": "أيقونة الرئيسية",
  "icon_gps": "أيقونة GPS",
  "icon_invoice": "أيقونة الفاتورة",
  "icon_google_logo": "شعار Google",
  "icon_anthropic_logo": "شعار Anthropic",
  "icon_route": "أيقونة المسار",
  "icon_upload": "أيقونة الرفع",
  "icon_menu": "أيقونة القائمة",
  "icon_checked_square": "أيقونة مربع محدد",
  "icon_unchecked_square": "أيقونة مربع غير محدد",
  "icon_more": "أيقونة المزيد",
  "icon_info": "أيقونة معلومات",
  "icon_paperclip": "أيقونة مشبك ورق",
  "icon_more_horizontal": "أيقونة المزيد أفقي",
  "icon_undo": "أيقونة تراجع",
  "icon_redo": "أيقونة إعادة",
  "icon_delta": "أيقونة دلتا",
  "icon_cpu": "أيقونة المعالج",
  "icon_pen": "أيقونة القلم",
  "icon_summarize": "أيقونة التلخيص",
  "icon_sidebar_left": "أيقونة الشريط الجانبي الأيسر",
  "icon_plus": "أيقونة إضافة",
  "icon_thumb_up": "أيقونة إعجاب",
  "icon_thumb_down": "أيقونة عدم إعجاب",
  "icon_check_circle_fill": "أيقونة علامة تأكيد",
  "icon_globe": "أيقونة الكرة الأرضية",
  "icon_lock": "أيقونة القفل",
  "icon_eye": "أيقونة العين",
  "icon_share": "أيقونة المشاركة",
  "icon_code": "أيقونة الكود",
  "icon_play": "أيقونة التشغيل",
  "icon_python": "أيقونة Python",
  "icon_terminal_window": "أيقونة نافذة الطرفية",
  "icon_terminal": "أيقونة الطرفية",
  "icon_clock_rewind": "أيقونة ساعة الرجوع",
  "icon_logs": "أيقونة السجلات",
  "icon_download": "أيقونة التنزيل",
  "icon_line_chart": "أيقونة رسم بياني خطي",
  "icon_warning": "أيقونة تحذير",
  "icon_sun": "أيقونة الشمس",
  "icon_moon": "أيقونة القمر",
  "icon_cloud": "أيقونة السحابة",
  "icon_chevron_down": "أيقونة سهم لأسفل",
  "icon_chevron_up": "أيقونة سهم لأعلى",
  "icon_spinner": "أيقونة التحميل الدوار",
  "icon_expand_collapse": "توسيع/طي",
  "icon_grid_pattern_background": "خلفية نمط شبكي زخرفي",
  "icon_animated_grid_overlay": "طبقة نمط شبكي متحركة",
  "icon_grid_pattern": "خلفية نمط شبكي",
  "icon_plus_title": "زائد",
  "icon_minus_title": "ناقص",
  "icon_check_title": "تحقق",
  "icon_clear_title": "مسح",
  "icon_open_title": "فتح",
  "icon_remove": "إزالة",
  "auth_google": "Google",
  "auth_microsoft": "Microsoft",
  "preview_no_console_output": "لا يوجد مخرجات وحدة التحكم",
  "preview_sandbox": "بيئة اختبار",
  "preview_web_preview": "معاينة الويب",
  "preview_url": "رابط المعاينة",
  "preview_title": "معاينة",
  "preview_hero_video": "فيديو رئيسي",
  "sidebar_title": "الشريط الجانبي",
  "documents_styles": "الأنماط",
  "dashboard_failed_to_load": "فشل تحميل لوحة المعلومات",
  "documents_failed_to_load": "فشل تحميل المستندات",
  "calendar_failed_to_load": "فشل تحميل التقويم",
  "documents_failed_to_load_viewer": "فشل تحميل العارض",
  "loading_users": "جارٍ تحميل المستخدمين…",
  "updating": "جارٍ التحديث…",
  "status_completed": "مكتمل",
  "status_pending": "قيد الانتظار",
  "status_in_progress": "قيد التنفيذ",
  "status_failed": "فشل",
  "access_denied": "تم رفض الوصول",
  "landing_no_credit_card": "لا حاجة لبطاقة ائتمان",
  "landing_section_ai_whatsapp": "مدعوم بالذكاء الاصطناعي",
  "landing_section_features": "المميزات",
  "landing_section_integrations": "التكاملات",
  "landing_section_ecosystem": "نظام بيئي متصل",
  "landing_section_explore": "استكشف",
  "landing_section_pricing": "الأسعار",
  "landing_pricing_title": "أسعار تنمو مع حجم محادثاتك",
  "landing_pricing_most_popular": "الأكثر شعبية",
  "landing_section_how_it_works": "كيف يعمل",
  "landing_how_it_works_subtitle": "جاهز للعمل في ثلاث خطوات",
  "landing_how_it_works_title": "كيف يعمل Bavard؟",
  "landing_footer_product": "المنتج",
  "landing_footer_resources": "الموارد",
  "landing_footer_contact": "تواصل معنا",
  "landing_social_facebook": "فيسبوك",
  "landing_social_twitter": "X (تويتر)",
  "landing_social_instagram": "إنستغرام",
  "landing_events": "الأحداث",
  "landing_chart_event_types": "أنواع الأحداث",
  "landing_chart_conversion_funnel": "قمع التحويل",
  "landing_chart_weekly_activity": "النشاط الأسبوعي",
  "landing_ai_assistant": "المساعد الذكي",
  "landing_customer": "العميل",
  "landing_conversations": "المحادثات",
  "debug_loading_redis_status": "جارٍ تحميل حالة Redis…",
  "debug_no_redis_status": "لا تتوفر حالة Redis",
  "debug_connected": "متصل:",
  "debug_has_redis_client": "يوجد عميل Redis:",
  "debug_redis_connected_prop": "خاصية اتصال Redis:",
  "debug_ping_result": "نتيجة Ping:",
  "debug_ping_error": "خطأ Ping:",
  "debug_error": "خطأ:",
  "debug_orpc_connection_status": "حالة اتصال oRPC",
  "debug_connection_state": "حالة الاتصال:",
  "debug_heartbeat_health": "صحة نبض القلب:",
  "debug_time_since_pong": "الوقت منذ آخر Pong:",
  "debug_ready_state": "حالة الجاهزية:",
  "debug_last_message": "آخر رسالة:",
  "debug_redis_status": "حالة Redis",
  "debug_test_connections": "اختبار الاتصالات",
  "debug_test_messages": "رسائل الاختبار",
  "debug_environment_variables": "متغيرات البيئة",
  "demo_search_placeholder": "بحث…",
  "demo_user_avatar_alt": "صورة المستخدم",
  "demo_more_info": "مزيد من المعلومات",
  "demo_enter_account_name": "أدخل اسم الحساب",
  "validation_issues_label": "مشاكل التحقق",
  "validation_fix_before_saving": "يرجى إصلاح هذه المشاكل قبل الحفظ",
  "config_validation_booking_requirement": "يجب تفعيل خيار طلب الاسم أو طلب الهاتف على الأقل للمواعيد.",
  "config_validation_lead_fields_required": "أضف حقل عميل واحدًا على الأقل قبل تفعيل جمع العملاء المحتملين.",
  "config_validation_tool_language_save_feedback": "أداة saveFeedback مفعّلة لكن لا توجد لغة صالحة لملخص الملاحظات. اختر لغة من لغات العرض.",
  "config_validation_tool_language_summarize": "أداة summarizeConversation مفعّلة لكن لا توجد لغة صالحة للملخص. اختر لغة من لغات العرض.",
  "config_validation_warnings_label": "تحذيرات",
  "config_validation_warnings_description": "لا تمنع هذه العناصر الحفظ، لكنها قد تحتاج إلى انتباهك.",
  "validation_go_to_issue": "انتقل",
  "user_management_title": "إدارة المستخدمين",
  "sidebar_mobile_description": "يعرض الشريط الجانبي للهاتف.",
  "admin_staff_members": "أعضاء الفريق",
  "admin_member": "عضو",
  "admin_members": "أعضاء",
  "admin_seats_used": "مقعد مستخدم",
  "admin_upgrade_plan": "ترقية الخطة",
  "admin_plan_your_plan": "خطتك",
  "admin_seat_limit_reached_title": "تم بلوغ الحد الأقصى للمقاعد",
  "admin_seat_limit_reached_body": "لقد بلغت الحد الأقصى لعدد المقاعد في خطة {plan} ({limit}). قم بالترقية لإضافة المزيد من الأعضاء.",
  "admin_save_changes": "حفظ التغييرات",
  "admin_org": "منظمة",
  "admin_orgs": "منظمات",
  "admin_tenant_org_demo_excluded": "مؤسسة مستأجرة (العرض التجريبي مستبعد)",
  "admin_tenant_orgs_demo_excluded": "مؤسسات مستأجرة (العرض التجريبي مستبعد)",
  "admin_failed_to_load_members": "فشل تحميل الأعضاء: ",
  "admin_failed_to_load_organizations": "فشل تحميل المنظمات: ",
  "admin_member_changes_saved": "تم حفظ تغييرات الأعضاء.",
  "admin_failed_to_save_member_changes": "فشل حفظ تغييرات الأعضاء.",
  "admin_members_custom_role_column": "الدور المخصص",
  "admin_members_custom_role_none": "—",
  "admin_members_custom_role_unassigned": "(غير معين)",
  "admin_members_custom_role_default_suffix": "(افتراضي)",
  "admin_validation_failed": "فشل التحقق.",
  "admin_save_org_first": "احفظ المنظمة أولاً، ثم يمكنك إدارة أسرارها.",
  "admin_org_changes_saved": "تم حفظ تغييرات المنظمة.",
  "admin_failed_to_save_org_changes": "فشل حفظ تغييرات المنظمة.",
  "admin_validation_issue": "مشكلة تحقق",
  "admin_validation_issues": "مشاكل تحقق",
  "admin_col_organization": "المنظمة",
  "admin_col_slug": "المعرّف",
  "admin_col_plan": "الخطة",
  "admin_col_status": "الحالة",
  "admin_col_users": "المستخدمون",
  "admin_col_events": "الأحداث",
  "admin_col_messages": "الرسائل",
  "admin_status_active": "نشط",
  "admin_status_inactive": "غير نشط",
  "admin_total_organizations": "إجمالي المنظمات",
  "admin_active": "نشطة",
  "admin_total_users": "إجمالي المستخدمين",
  "admin_total_events": "إجمالي الأحداث",
  "admin_total_messages": "إجمالي الرسائل",
  "admin_conversations": "المحادثات",
  "admin_active_orgs": "المنظمات النشطة",
  "admin_of_total": "من",
  "admin_total": "إجمالي",
  "admin_inactive_orgs": "المنظمات غير النشطة",
  "admin_failed_to_load_dashboard": "فشل تحميل لوحة المعلومات: ",
  "admin_section_platform_overview": "نظرة عامة على المنصة",
  "admin_section_activity_breakdown": "تفصيل النشاط",
  "admin_section_analytics": "التحليلات",
  "admin_section_per_org_breakdown": "تفصيل حسب المنظمة",
  "admin_no_organizations_found": "لم يتم العثور على منظمات",
  "admin_tabs_roles": "الأدوار والأذونات",
  "admin_roles_title": "الأدوار والأذونات",
  "admin_roles_subtitle": "{{roleCount}} أدوار · {{capCount}} إمكانيات",
  "admin_roles_section_features": "الميزات",
  "admin_roles_capability_chat": "الدردشة",
  "admin_roles_capability_calendar": "التقويم",
  "admin_roles_capability_documents": "المستندات",
  "admin_roles_capability_sidebar": "الشريط الجانبي",
  "admin_roles_section_contacts": "جهات الاتصال",
  "admin_roles_section_config": "الإعدادات",
  "admin_roles_section_org": "المؤسسة",
  "admin_roles_category_workspace": "مساحة العمل",
  "admin_roles_category_configuration": "الإعدادات",
  "admin_roles_category_administration": "الإدارة",
  "admin_roles_summary_allowed": "مسموح",
  "admin_roles_group_members": "الأعضاء",
  "admin_roles_group_campaigns": "الحملات",
  "admin_roles_group_waitlist": "قائمة الانتظار",
  "admin_roles_group_templates": "القوالب",
  "admin_roles_group_secrets": "الأسرار",
  "admin_roles_group_webhooks": "الويب هوك",
  "admin_roles_group_schedulers": "المجدولات",
  "admin_roles_group_privacy": "الخصوصية",
  "admin_roles_group_feedback": "الملاحظات",
  "admin_roles_action_view": "عرض",
  "admin_roles_action_edit": "تحرير",
  "admin_roles_action_reply": "رد",
  "admin_roles_action_manage": "إدارة",
  "admin_roles_action_manage_roles": "إدارة الأدوار",
  "admin_roles_action_manage_billing": "إدارة الفواتير",
  "admin_roles_filter_placeholder": "تصفية الإمكانيات…",
  "admin_roles_show_diff_only": "عرض الاختلافات فقط",
  "admin_roles_legend_allowed": "مسموح",
  "admin_roles_legend_denied": "غير مسموح",
  "admin_roles_legend_na": "غير متاح",
  "admin_roles_editing_as": "التعديل بصلاحية",
  "admin_roles_create_custom": "إنشاء دور مخصص",
  "admin_roles_create_dialog_title": "إنشاء دور",
  "admin_roles_create_dialog_name_label": "اسم الدور",
  "admin_roles_remove_role": "حذف الدور",
  "admin_roles_remove_confirm_body": "هل تريد حذف الدور \"{{role}}\"؟ سيفقد الأعضاء المعينون له جميع أذوناته.",
  "admin_roles_default_tag": "افتراضي",
  "admin_roles_members_count": "{{count}} أعضاء",
  "admin_roles_plan_locked_hint": "غير متاح في خطتك",
  "admin_roles_no_results": "لا توجد إمكانيات تطابق \"{{query}}\".",
  "admin_roles_failed_to_load": "فشل تحميل الأدوار: ",
  "admin_roles_failed_to_save": "فشل حفظ تغييرات الأدوار.",
  "admin_roles_changes_saved": "تم حفظ تغييرات الأدوار.",
  "retry": "إعادة المحاولة",
  "error_boundary_title": "حدث خطأ",
  "error_boundary_details": "تفاصيل الخطأ",
  "error_boundary_suggestion": "يرجى تحديث الصفحة أو المحاولة مرة أخرى.",
  "error_boundary_refresh": "تحديث الصفحة",
  "error_boundary_try_again": "حاول مجدداً",
  "error_boundary_recovering": "جارٍ الاسترداد…",
  "error_boundary_recovering_description": "يتم استعادة التطبيق. يرجى الانتظار…",
  "error_boundary_recovering_attempt": "جارٍ محاولة الاسترداد من الخطأ. يرجى الانتظار…",
  "error_boundary_error_in": "خطأ في: {{context}}",
  "error_boundary_retry_count": "محاولات إعادة المحاولة: {{count}} / {{max}}",
  "ai_error_boundary_default": "حدث خطأ أثناء عرض استجابة الذكاء الاصطناعي.",
  "ai_error_boundary_unexpected": "حدث خطأ غير متوقع.",
  "config_calendar_locale_title": "لغة التقويم والاتجاه",
  "config_calendar_locale_description": "تهيئة لغات التقويم المتاحة واتجاه النص",
  "config_available_calendar_locales": "لغات التقويم المتاحة",
  "config_calendar_locales_infotip": "تتحكم لغات التقويم في أسماء الأيام والأشهر وتنسيق التواريخ. الإنجليزية مضمّنة دائماً.",
  "config_more_locales": "+{{count}} إضافية",
  "config_select_locales_placeholder": "اختر اللغات…",
  "config_always_enabled": "مفعّل دائماً",
  "config_text_direction": "اتجاه النص",
  "config_direction_ltr": "من اليسار إلى اليمين",
  "config_direction_rtl": "من اليمين إلى اليسار",
  "config_direction_auto": "تلقائي (حسب اللغة)",
  "config_direction_ltr_short": "LTR",
  "config_direction_rtl_short": "RTL",
  "config_direction_auto_short": "تلقائي",
  "date_invalid": "تاريخ غير صالح",
  "phone_input_ltr_hint": "تُعرض أرقام الهاتف من اليسار إلى اليمين",
  "mutation_error_toast_title": "فشل الطلب",
  "aria_sidebar_navigation": "التنقل في التطبيق",
  "documents_page_title": "المستندات",
  "documents_no_fields": "لا توجد حقول",
  "documents_edit_fields_title": "تعديل بيانات جهة الاتصال",
  "error_boundary_error_details": "تفاصيل الخطأ",
  "error_boundary_recovering_title": "جاري الاستعادة…",
  "error_boundary_description": "يرجى تحديث الصفحة أو المحاولة مرة أخرى.",
  "landing_nav_features": "المميزات",
  "landing_nav_pricing": "الأسعار",
  "landing_nav_docs": "التوثيق",
  "landing_nav_contact": "تواصل معنا",
  "landing_nav_login": "تسجيل الدخول",
  "landing_nav_get_started": "ابدأ الآن",
  "landing_nav_solutions": "الحلول",
  "landing_nav_solutions_heading": "حسب الاستخدام",
  "landing_nav_solutions_support_title": "خدمة العملاء",
  "landing_nav_solutions_support_desc": "حلّ الاستفسارات فورًا، ولا تُحوّل إلى موظّف إلا ما يستحق",
  "landing_nav_solutions_sales_title": "المبيعات وجذب العملاء",
  "landing_nav_solutions_sales_desc": "أهّل كل زائر، والتقط العملاء المحتملين، واحجز العروض تلقائيًا",
  "landing_hero_prefix": "وكلاء ذكاء اصطناعي يتولّون",
  "landing_hero_em": "خدمة العملاء والمبيعات",
  "landing_hero_suffix": "نيابةً عن عملك.",
  "landing_hero_sub": "درّب وكيلك على محتواك في دقائق. يجيب عن أسئلة العملاء، ويؤهّل العملاء المحتملين، ويحجز العروض التوضيحية — على موقعك وواتساب وكل قناة يستخدمها عملاؤك.",
  "landing_hero_cta_free": "ابدأ تجربتي المجانية",
  "landing_hero_cta_start": "ابدأ الآن",
  "landing_hero_trusted_by": "يثق به أكثر من 1,200 فريق دعم ومبيعات",
  "landing_hero_watch_demo": "شاهد العرض في 90 ثانية",
  "landing_reel_s1_label": "مُدرَّب على نشاطك التجاري",
  "landing_reel_s2_label": "مستند إلى وثائقك",
  "landing_reel_s3_label": "يحجز العروض التوضيحية على مدار الساعة",
  "landing_reel_s4_label": "على واتساب وأكثر",
  "landing_reel_kb_title": "قاعدة المعرفة",
  "landing_reel_kb_count": "٤ مصادر",
  "landing_reel_kb_ready": "تمت الفهرسة · جاهز للرد",
  "landing_reel_src_pricelist": "الأسعار.pdf",
  "landing_reel_src_faq": "مركز المساعدة والأسئلة الشائعة",
  "landing_reel_src_web": "yourcompany.com",
  "landing_reel_src_policy": "سياسة الاسترجاع.docx",
  "landing_reel_chat_user": "ما الذي تشمله باقة Pro؟",
  "landing_reel_chat_ai": "باقة Pro بـ *49$ لكل مستخدم شهريًا* — دعم بأولوية، وتحليلات متقدّمة، ووصول كامل إلى الـ API.",
  "landing_reel_book_day": "الخميس",
  "landing_reel_book_booked": "محجوز",
  "landing_reel_book_pick": "أفضل موعد متاح",
  "landing_reel_book_confirm": "تم الحجز · الخميس 3:00 مساءً",
  "landing_reel_book_noconflict": "أُضيف إلى تقويمك",
  "landing_reel_ch_caption": "وكيل واحد، كل القنوات",
  "landing_reel_play": "تشغيل العرض",
  "landing_reel_pause": "إيقاف العرض",
  "landing_reel_s_skills": "فعّل مهاراته",
  "landing_reel_s_leads": "لا تفوّت أي عميل محتمل",
  "landing_reel_sources_title": "المصادر",
  "landing_reel_add_source": "إضافة مصدر",
  "landing_reel_skills_title": "مهارات الوكيل",
  "landing_reel_skill_book": "حجز العروض التوضيحية",
  "landing_reel_skill_answer": "الإجابة على الأسئلة",
  "landing_reel_skill_remind": "إرسال المتابعات",
  "landing_reel_skill_leads": "جمع العملاء المحتملين",
  "landing_reel_chat_user2": "هل يمكنني استرجاع المبلغ بعد 20 يومًا؟",
  "landing_reel_book_month": "نوفمبر",
  "landing_reel_leads_title": "العملاء المُسجّلون · هذا الشهر",
  "landing_reel_leads_name": "سارة العامر",
  "landing_reel_leads_via": "عميل جديد · عبر واتساب",
  "landing_reel_chat_ai2": "نعم — مهلة الاسترجاع لدينا *30 يومًا* دون أي أسئلة.",
  "landing_reel_tab_sources": "المصادر",
  "landing_reel_tab_skills": "المهارات",
  "landing_reel_tab_chat": "المحادثة",
  "landing_reel_tab_booking": "الحجز",
  "landing_reel_tab_leads": "العملاء",
  "landing_reel_tab_channels": "القنوات",
  "landing_reel_up_drop": "اسحب وأفلِت مستنداتك",
  "landing_reel_up_hint": "PDF · DOCX · CSV — حتى ١٠ ميجابايت",
  "landing_reel_cal_req": "احجز لسارة عرضًا توضيحيًا — الخميس 3 م",
  "landing_reel_cal_new": "سارة · عرض توضيحي",
  "landing_reel_cal_ev1": "ليلى · جلسة تهيئة",
  "landing_reel_cal_ev2": "نور · متابعة",
  "landing_reel_cal_done": "تم — أُضيف يوم الخميس",
  "landing_reel_kpi_booked": "تمّ حلّها",
  "landing_reel_kpi_reply": "متوسط الرد",
  "landing_reel_kpi_active": "نشِط",
  "landing_reel_goal_label": "هدف الشهر",
  "landing_reel_pages": "صفحات",
  "landing_reel_src_indexed": "تمت الفهرسة · جاهز للرد",
  "landing_reel_skill_book_desc": "يجد موعدًا متاحًا ويؤكّد الاجتماع خلال ثوانٍ",
  "landing_reel_skill_answer_desc": "يرد من مستنداتك، مع ذكر المصادر",
  "landing_reel_skill_remind_desc": "يتابع كل عميل محتمل توقّف عن الردّ",
  "landing_reel_skill_leads_desc": "يحفظ بيانات العميل لحظة مراسلته",
  "landing_reel_cal_tool": "find_available_slot",
  "landing_reel_cal_tool_run": "يبحث في يوم الخميس عن موعد متاح…",
  "landing_reel_cal_tool_done": "وجد الساعة 3 مساءً",
  "landing_reel_cal_reply": "تمّ — عرض سارة التوضيحي محجوز *الخميس 3:00 م*.",
  "landing_ai_title": "مُصمَّم خصّيصًا لذكاء اصطناعي يواجه العملاء",
  "landing_ai_sub": "يدمج بافار مستنداتك وتقويمك وكل قنوات المراسلة في وكلاء لن يستطيع عملاؤك تمييزهم عن أفضل موظفيك.",
  "landing_ai_always_on": "دائمًا متاح، بلا انقطاع",
  "landing_ai_always_on_desc": "عطلات نهاية الأسبوع. الأعياد. الثالثة فجرًا يوم ثلاثاء. ذكاؤك الاصطناعي يردّ على كل عميل فورًا — فلن تخسر حجزًا لصالح منافسٍ ردّ قبلك.",
  "landing_ai_fast": "ردود في أقل من 3 ثوانٍ",
  "landing_ai_fast_desc": "البشر يحتاجون دقائق — أو ساعات — للرد. بافار يردّ قبل أن يجد عميلك وقتًا لفتح تبويب منافسٍ.",
  "landing_ai_conversational": "يتحدّث مثلك، لا مثل البوت",
  "landing_ai_conversational_desc": "لا نصوص جاهزة. لا \"يرجى الانتظار\". كل ردّ يتكيّف مع نبرة عميلك — ويبدّل اللغة في منتصف الجملة إذا فعل هو ذلك.",
  "landing_ai_actions": "إجراءات فعلية، لا مجرّد كلام",
  "landing_ai_actions_desc": "يحجز المواعيد. يقرأ تقويمك. يعرض الأسعار من كتالوجك. يرسل التذكيرات. يُعيد الجدولة. يُحوّل إلى موظف بشري عند الحاجة — دون مغادرة المحادثة.",
  "landing_features_title": "خمس أدوات في مساحة عمل واحدة",
  "landing_features_sub": "استبدل أدواتك المتفرّقة — دردشة، تقويم، قاعدة معرفة، تحليلات، CRM — بمنصّة واحدة مترابطة.",
  "landing_bento_title": "كل ما يلمسه عملاؤك، في مكان واحد",
  "landing_bento_sub": "ثماني طرق يُجيب بها بافارد ويحجز ويُتابع عبر كل قناة — مستندًا إلى مستنداتك وتقويمك وأسعارك الحقيقية.",
  "landing_feature_controls": "ضوابط أنت تحدّدها",
  "landing_feature_controls_desc": "قرّر ما يفعله الذكاء الاصطناعي بمفرده — ردٌّ تلقائي، أو تصعيد إلى موظف، أو إيقاف للمراجعة. مع أدوار وصلاحيات لكل موظف.",
  "landing_bento_flow_title": "كيف يعمل Bavard",
  "landing_feature_calendar": "تقويم ذكي",
  "landing_feature_calendar_desc": "العروض والاجتماعات المحجوزة من المحادثة تصل هنا فورًا. اسحب لإعادة الجدولة، وقواعد ساعات العمل، وخمس طرق عرض — دون أي تعارض.",
  "landing_feature_whatsapp": "وكيل دعم بالذكاء الاصطناعي",
  "landing_feature_whatsapp_desc": "يجيب ويحلّ ويتابع — مستندًا إلى وثائقك وأسعارك وسياساتك الحقيقية. لن يفرّق عملاؤك بينه وبين أفضل موظّف لديك.",
  "landing_feature_bulk": "كل القنوات، صندوق وارد واحد",
  "landing_feature_bulk_desc": "واتساب، تيليجرام، ماسنجر، دردشة الويب، البريد. ذكاء اصطناعي واحد يديرها جميعًا — بقاعدة معرفة واحدة، وأسلوب واحد، وسجلٍّ واحد.",
  "landing_feature_analytics": "لوحات تحليلات تُغلق الحلقة",
  "landing_feature_analytics_desc": "معدّل الحلّ، ونسبة الاستفسارات المُحتواة، وأزمنة الاستجابة، والفرص المُولَّدة. اعرف ما يُنجزه الوكيل — وأين يُحوّل المحادثة إلى فريقك.",
  "landing_feature_grid": "ملاحظات بخطّ يدك",
  "landing_feature_grid_desc": "اكتب بخطّ يدك بقلم اللوحي مباشرةً على كل جهة اتصال — بلا ملفّات ضخمة، بلا كتابة، بلا نماذج. كل صفحة تُحفظ كسجلّ رقمي قابل للبحث. تدوين الملاحظات بالطريقة التي اعتدت عليها، أخيرًا بلا ورق.",
  "landing_feature_rag": "قاعدة المعرفة",
  "landing_feature_rag_desc": "أضف مركز المساعدة والأسعار والسياسات. يستشهد الوكيل بمستنداتك الحقيقية — لا يخترع إجابة ولا يفتعل سعرًا.",
  "landing_integration_title": "كل أداة، مترابطة عبر الذكاء الاصطناعي",
  "landing_integration_sub": "المستندات تُدرّب ذكاءك الاصطناعي. المحادثات تُنشئ الحجوزات. الحجوزات تُغذّي لوحتك. حلقة واحدة تُدير عملك — تلقائيًا.",
  "landing_integration_channels": "المحادثات",
  "landing_integration_ai": "محرك الذكاء",
  "landing_integration_calendar": "التقويم",
  "landing_integration_analytics": "التحليلات",
  "landing_integration_documents": "المستندات",
  "landing_cloudflow_documents_desc": "ارفع وفهرس معرفة أعمالك",
  "landing_cloudflow_ai_desc": "طبقة التنسيق الذكي",
  "landing_cloudflow_conversations_desc": "رسائل AI متعددة القنوات",
  "landing_cloudflow_calendar_desc": "حجز وجدولة تلقائية",
  "landing_cloudflow_analytics_desc": "رؤى ومقاييس فورية",
  "landing_cloudflow_conn_docs_ai": "المعرفة تغذي الذكاء",
  "landing_cloudflow_conn_ai_conv": "الذكاء يدعم الردود",
  "landing_cloudflow_conn_conv_cal": "المحادثات تنشئ حجوزات",
  "landing_cloudflow_conn_conv_analytics": "بيانات المحادثات تتدفق",
  "landing_cloudflow_conn_cal_analytics": "بيانات الحجوزات تتدفق",
  "landing_cloudflow_conn_docs_cal": "سياق التوفر",
  "landing_ecosystem_title": "الدردشة، المستندات، التقويم، التحليلات — مترابطة مسبقًا",
  "landing_ecosystem_sub": "يجيب وكيلك من مستنداتك. العملاء المؤهَّلون والاجتماعات المحجوزة تُزامَن مع تقويمك. وكل محادثة تغذّي لوحة التحكّم. دون أي كود ربط.",
  "landing_explore_item_chat_title": "دردشة تحلّ وتُحوِّل",
  "landing_explore_item_chat_body": "قابل عملاءك على موقعك وواتساب وإنستغرام. يجيب الوكيل من مستنداتك، ويحلّ المشكلة، ويلتقط العميل المحتمل — كل ذلك في محادثة واحدة.",
  "landing_explore_item_cal_title": "عروض تُحجز وأنت نائم",
  "landing_explore_item_cal_body": "كل اجتماع يحجزه الوكيل يظهر على التقويم فورًا، مُلوَّنًا حسب الحالة. انقر أي يوم متاح لإضافة اجتماع بنفسك — دون إدخال مزدوج ودون تعارض.",
  "landing_explore_item_docs_title": "مستندات يقرأها وكيلك",
  "landing_explore_item_docs_body": "اكتب الملاحظات وأدلّة العمل والملفات على مساحة مشتركة تُحفظ أولًا بأول. يقرأها وكيلك، فتبقى كل إجابة مستندة إلى معرفتك أنت.",
  "landing_explore_chat_window": "الرسائل",
  "landing_explore_chat_search": "ابحث في المحادثات",
  "landing_explore_chat_ai_pill": "وكيل ذكي",
  "landing_explore_chat_today": "اليوم",
  "landing_explore_chat_online": "متصل",
  "landing_explore_chat_typing": "يكتب",
  "landing_explore_chat_waiting": "بانتظار الرد…",
  "landing_explore_chat_send": "إرسال",
  "landing_explore_chat_c1_name": "سارة حسن",
  "landing_explore_chat_c1_time": "5 دقيقة",
  "landing_explore_chat_c1_preview": "ممتاز، هذا يحلّ الأمر.",
  "landing_explore_chat_c1_m1": "مرحبًا! طلبي ما زال قيد المعالجة — رقم 4821.",
  "landing_explore_chat_c1_m2": "مرحبًا سارة! الطلب 4821 شُحن هذا الصباح وسيصل اليوم. أرسل لك رابط التتبّع؟",
  "landing_explore_chat_c1_m3": "نعم من فضلك.",
  "landing_explore_chat_c1_m4": "أرسلته! وهو في بريدك أيضًا. أي شيء آخر أساعدك به؟ 🌟",
  "landing_explore_chat_c1_event": "تمّ الحل · دون تدخّل بشري",
  "landing_explore_chat_c1_draft1": "هل تودّين تلقّي تحديثات التوصيل على واتساب؟",
  "landing_explore_chat_c1_reply1": "نعم من فضلك، سيكون ذلك رائعًا!",
  "landing_explore_chat_c1_draft2": "تمّ — ستصلك تحديثات في كل مرحلة.",
  "landing_explore_chat_c1_reply2": "لا، هذا كل شيء. شكرًا لك!",
  "landing_explore_chat_c2_name": "آدم ناجي",
  "landing_explore_chat_c2_time": "2 ساعة",
  "landing_explore_chat_c2_preview": "ما الفرق بين الباقات؟",
  "landing_explore_chat_c2_m1": "ما الفرق بين الباقات؟",
  "landing_explore_chat_c2_m2": "الباقة القياسية تشمل الوكيل وقاعدة المعرفة؛ والمميّزة تضيف التحليلات والوصول إلى الـ API والدعم المخصّص. أحجز لك جولة من 15 دقيقة؟",
  "landing_explore_chat_c2_draft1": "أحجز لك عرضًا توضيحيًا هذا الأسبوع؟",
  "landing_explore_chat_c2_reply1": "نعم، صباح الخميس مناسب.",
  "landing_explore_chat_c3_name": "ماريا كوستا",
  "landing_explore_chat_c3_time": "1 يوم",
  "landing_explore_chat_c3_preview": "هل يمكنني الترقية في منتصف الدورة؟",
  "landing_explore_chat_c3_m1": "هل يمكنني الترقية في منتصف الدورة؟",
  "landing_explore_chat_c3_m2": "بالتأكيد — أنت على الباقة المميّزة الآن، واحتسبتُ الفرق بالتناسب.",
  "landing_explore_chat_c3_event": "تمت الترقية · المميّزة",
  "landing_explore_chat_c3_draft1": "أستعرض لك سريعًا ما تتيحه الباقة المميّزة؟",
  "landing_explore_chat_c3_reply1": "ممتاز، شكرًا جزيلًا لك!",
  "landing_explore_cal_title": "يوليو 2025",
  "landing_explore_cal_month": "شهر",
  "landing_explore_cal_week": "أسبوع",
  "landing_explore_cal_day": "يوم",
  "landing_explore_cal_sun": "أحد",
  "landing_explore_cal_mon": "إثنين",
  "landing_explore_cal_tue": "ثلاثاء",
  "landing_explore_cal_wed": "أربعاء",
  "landing_explore_cal_thu": "خميس",
  "landing_explore_cal_fri": "جمعة",
  "landing_explore_cal_sat": "سبت",
  "landing_explore_cal_more": "المزيد",
  "landing_explore_cal_book_hint": "انقر أي يوم لإضافة اجتماع",
  "landing_explore_cal_toast_wa": "حجز عبر واتساب",
  "landing_explore_cal_toast_ig": "حجز عبر إنستغرام",
  "landing_explore_cal_ev_omar": "عمر ك.",
  "landing_explore_cal_ev_lina": "لينا ر.",
  "landing_explore_cal_ev_checkup": "عرض توضيحي",
  "landing_explore_cal_ev_maria": "ماريا ك.",
  "landing_explore_cal_ev_karim": "كريم أ.",
  "landing_explore_cal_ev_nour": "نور س.",
  "landing_explore_cal_ev_sarah": "سارة ح.",
  "landing_explore_cal_ev_adam": "آدم ن.",
  "landing_explore_cal_ev_layla": "ليلى م.",
  "landing_explore_cal_ev_yusuf": "يوسف ت.",
  "landing_explore_cal_ev_you": "اجتماع جديد",
  "landing_explore_docs_page": "ملاحظات الحساب",
  "landing_explore_docs_saving": "جارٍ الحفظ…",
  "landing_explore_docs_saved": "تم الحفظ",
  "landing_explore_docs_sticky": "أرسل عرض الأسعار قبل الجمعة!",
  "landing_explore_docs_checklist": "تحضير الصفقة",
  "landing_explore_docs_item1": "تأكيد عدد المستخدمين",
  "landing_explore_docs_item2": "إرسال عرض السعر",
  "landing_explore_docs_item3": "تجهيز حزمة التهيئة",
  "landing_explore_docs_item4": "تعيين مسؤول الحساب",
  "landing_explore_docs_hint": "أمسك القلم وارسم في أي مكان",
  "landing_eco_tab_inbox": "البريد الوارد",
  "landing_eco_tab_documents": "المستندات",
  "landing_eco_tab_datagrid": "جدول البيانات",
  "landing_eco_tab_dashboard": "لوحة المعلومات",
  "landing_eco_events_label": "فعاليات",
  "landing_eco_reservations": "حجوزات",
  "landing_eco_kpi_total_events": "إجمالي الفعاليات",
  "landing_eco_kpi_messages": "الرسائل",
  "landing_eco_kpi_avg_response": "متوسط الاستجابة",
  "landing_eco_kpi_conversion": "التحويل",
  "landing_eco_segment_standard": "عادي",
  "landing_eco_segment_followup": "متابعة",
  "landing_eco_segment_new_client": "عميل جديد",
  "landing_eco_segment_priority": "أولوية",
  "landing_eco_funnel_conversations": "المحادثات",
  "landing_eco_funnel_interested": "مهتم",
  "landing_eco_funnel_booked": "محجوز",
  "landing_eco_funnel_completed": "مكتمل",
  "landing_eco_col_client": "العميل",
  "landing_eco_col_service": "الخدمة",
  "landing_eco_col_date": "التاريخ",
  "landing_eco_col_time": "الوقت",
  "landing_eco_col_status": "الحالة",
  "landing_eco_col_phone": "الهاتف",
  "landing_eco_filter_all": "الكل",
  "landing_eco_filter_today": "اليوم",
  "landing_eco_filter_this_week": "هذا الأسبوع",
  "landing_eco_filter_pending": "قيد الانتظار",
  "landing_eco_status_confirmed": "مؤكد",
  "landing_eco_status_pending": "قيد الانتظار",
  "landing_eco_status_cancelled": "ملغي",
  "landing_eco_status_upcoming": "قادم",
  "landing_eco_status_completed": "مكتمل",
  "landing_eco_service_haircut": "قص شعر",
  "landing_eco_service_coloring": "صبغة",
  "landing_eco_service_styling": "تصفيف",
  "landing_eco_service_facial": "عناية بالوجه",
  "landing_eco_service_massage": "مساج",
  "landing_eco_service_highlights": "هايلايت",
  "landing_eco_tag_vip": "VIP",
  "landing_eco_tag_regular": "عادي",
  "landing_eco_conv_thanks_tuesday": "شكراً! نراكم يوم الثلاثاء",
  "landing_eco_conv_reschedule": "هل يمكنني تغيير الموعد ليوم الخميس؟",
  "landing_eco_conv_what_services": "ما هي الخدمات التي تقدمونها؟",
  "landing_eco_conv_confirmed": "تم التأكيد، شكراً!",
  "landing_eco_conv_saturday": "هل يوم السبت متاح؟",
  "landing_eco_time_2m": "قبل دقيقتين",
  "landing_eco_time_8m": "قبل 8 دقائق",
  "landing_eco_time_15m": "قبل 15 دقيقة",
  "landing_eco_time_1h": "قبل ساعة",
  "landing_eco_time_2h": "قبل ساعتين",
  "landing_day_mon": "الإثنين",
  "landing_day_tue": "الثلاثاء",
  "landing_day_wed": "الأربعاء",
  "landing_day_thu": "الخميس",
  "landing_day_fri": "الجمعة",
  "landing_day_sat": "السبت",
  "landing_day_sun": "الأحد",
  "landing_pricing_sub": "كل خطة تشمل تجربة مجانية 14 يومًا. بلا بطاقة ائتمان. ألغِ بنقرتين.",
  "landing_pricing_monthly": "شهري",
  "landing_pricing_annual": "سنوي (وفّر 20%)",
  "landing_pricing_currency_note": "الأسعار بعملة {{code}} ولا تشمل ضريبة القيمة المضافة ({{vat}}%).",
  "landing_pricing_per_month": "شهرياً",
  "landing_pricing_billed_annually": "شهرياً، يُدفع {{total}} سنوياً",
  "landing_pricing_tier_chat": "محادثة",
  "landing_pricing_tier_standard": "قياسي",
  "landing_pricing_tier_premium": "متميز",
  "landing_pricing_desc_chat": "وكيل ذكاء اصطناعي وقاعدة معرفة على قناة واحدة — للفرق الصغيرة في بدايتها",
  "landing_pricing_desc_standard": "أضف جدولة الاجتماعات والتحليلات وفريقك كاملًا — لفرق الدعم والمبيعات المتنامية",
  "landing_pricing_desc_premium": "مستندات، تحليلات متقدّمة، وصول API، دعم مخصّص — للعمليات عالية الحجم",
  "landing_pricing_cta_get_started": "ابدأ الآن",
  "landing_pricing_cta_free_trial": "ابدأ التجربة المجانية",
  "landing_pricing_whatsapp": "رسائل واتساب أو تيليجرام",
  "landing_pricing_rag": "قاعدة معرفية AI (RAG)",
  "landing_pricing_ai_assistant": "وكيل دعم ومبيعات بالذكاء الاصطناعي",
  "landing_pricing_ai_1000": "1,000 رسالة AI شهرياً",
  "landing_pricing_staff_unlimited": "عدد غير محدود من الموظفين وإعدادات وكلاء الذكاء الاصطناعي",
  "landing_pricing_rag_auto_refresh": "تحديث تلقائي لقاعدة المعرفة",
  "landing_pricing_email_support": "دعم عبر البريد الإلكتروني",
  "landing_pricing_everything_chat": "كل شيء في محادثة",
  "landing_pricing_calendar": "التقويم وجدولة الاجتماعات",
  "landing_pricing_dashboard": "لوحة تحليلات",
  "landing_pricing_ai_5000": "5,000 رسالة AI شهرياً",
  "landing_pricing_waitlist_offers": "قائمة الانتظار وعروض المواعيد التلقائية",
  "landing_pricing_priority_support": "دعم ذو أولوية",
  "landing_pricing_everything_standard": "كل شيء في قياسي",
  "landing_pricing_documents": "محرر المستندات واللوحة",
  "landing_pricing_advanced_analytics": "تحليلات وتقارير متقدمة",
  "landing_pricing_ai_15000": "15,000 رسالة AI شهرياً",
  "landing_pricing_api_access": "وصول إلى API",
  "landing_pricing_dedicated_support": "دعم مخصص",
  "landing_pricing_everything_chat_plus": "كل شيء في محادثة، بالإضافة إلى:",
  "landing_pricing_everything_standard_plus": "كل شيء في قياسي، بالإضافة إلى:",
  "landing_pricing_note_chat": "لا حاجة لبطاقة ائتمان",
  "landing_pricing_note_standard": "تجربة مجانية 14 يوماً، ألغِ في أي وقت",
  "landing_pricing_note_premium": "إلغاء بنقرتين",
  "landing_how_it_works_sub": "بلا مهندسين. بلا مكالمات إعداد. بلا 30 يوم تأهيل. ثلاث خطوات وفنجان قهوة.",
  "landing_step_1_title": "ارفع معرفتك",
  "landing_step_1_desc": "ضع مركز المساعدة والأسعار والأسئلة الشائعة والسياسات. يفهرس الوكيل كل شيء في دقائق — ويبدأ بالاستشهاد بها في الرسالة التالية.",
  "landing_step_2_title": "اربط قنواتك",
  "landing_step_2_desc": "أضف أداة الموقع أو واتساب أو تيليجرام أو ماسنجر. زامن تقويمك. ادعُ فريقك. يتولّى الوكيل المحادثة التالية.",
  "landing_step_3_title": "دع الذكاء الاصطناعي يتولّى الباقي",
  "landing_step_3_desc": "إجابات، وحلول، وعروض محجوزة، ومتابعات — كلّها تلقائية. لا يرى فريقك إلا ما يحتاج فعلًا إلى تدخّل بشري.",
  "landing_cta_title": "منافسوك يردّون في الثالثة فجرًا. وأنت؟",
  "landing_cta_sub": "انضم إلى أكثر من 1,200 فريق يستخدمون بافار لنشر وكلاء ذكاء اصطناعي مُدرَّبين على أعمالهم — عبر كل قناة يستخدمها عملاؤهم.",
  "landing_cta_start_trial": "ابدأ تجربتي المجانية",
  "landing_cta_contact_us": "تحدّث إلينا",
  "landing_cta_read_docs": "اقرأ التوثيق",
  "landing_contact_label": "تحدّث إلينا",
  "landing_contact_title": "شاهد بافار وهو يردّ على عملائك",
  "landing_contact_sub": "ابدأ مجانًا خلال دقائق، أو اترك رقمك ونتواصل معك لنشرح لك كل شيء في مكالمة.",
  "landing_subscribe_panel_eyebrow": "لماذا بافار",
  "landing_subscribe_panel_heading": "منصّة وكلاء الذكاء الاصطناعي المبنيّة لفرق الخدمات",
  "landing_subscribe_panel_intro": "درّب بافار على مستنداتك في دقائق. انشره على واتساب وتيليجرام والويب. مبنيّ للأعمال التي تخدم عملاءها بالعربية أو الإنجليزية أو كلتيهما.",
  "landing_subscribe_bullet_24_7_title": "24/7 — بلا انقطاع",
  "landing_subscribe_bullet_24_7_desc": "كل عميل يحصل على ردّ — عطلات، أعياد، الثالثة فجرًا. صفر حجوزات ضائعة. صفر إيراداتٍ مفقودة.",
  "landing_subscribe_bullet_fast_title": "ردود في أقل من 3 ثوانٍ",
  "landing_subscribe_bullet_fast_desc": "يحصل العملاء على إجابة حقيقية قبل أن يفكّروا بفتح محادثة منافسٍ. متوسط الرد: 2.4 ثانية.",
  "landing_subscribe_bullet_actions_title": "إجراءات فعلية، لا مجرّد كلام",
  "landing_subscribe_bullet_actions_desc": "يحجز المواعيد. يتحقّق من التوفّر. يعرض الأسعار. يرسل التذكيرات. يُعيد الجدولة. كل ما يفعله فريق الدعم — فوريًا.",
  "landing_subscribe_bullet_natural_title": "يتحدّث مثلك، لا مثل البوت",
  "landing_subscribe_bullet_natural_desc": "لا نصوصًا جاهزة. كل ردّ يتكيّف مع نبرة العميل — ويبدّل اللغة في منتصف الرسالة إذا فعل هو ذلك.",
  "landing_subscribe_pricing_teaser": "تبدأ الخطط من باقة Chat — تشمل المساعد الذكي وقاعدة المعرفة وواتساب أو تيليجرام.",
  "landing_subscribe_or_reach": "أو تواصل معنا مباشرة",
  "landing_subscribe_cta": "ابدأ تجربتي المجانية",
  "landing_lead_form_eyebrow": "اترك بياناتك",
  "landing_lead_form_heading": "تحدّث معنا",
  "landing_lead_form_intro": "أخبرنا عن عملك. سنُعاود الاتصال خلال يوم لنعرض لك بافار مباشرة.",
  "landing_lead_form_privacy": "لن نشارك بياناتك. ردٌّ واحد، بلا إزعاج، يمكنك إلغاء الاشتراك في أي وقت.",
  "landing_contact_response_badge": "نردّ خلال 24 ساعة",
  "landing_contact_info_heading": "لنبدأ محادثة",
  "landing_contact_info_desc": "أخبرنا عن فريقك وسنُريك كيف يتعامل بافار مع محادثات عملائك — مباشرةً، وعلى رقمك أنت.",
  "landing_contact_email_label": "البريد الإلكتروني",
  "landing_contact_name_label": "الاسم",
  "landing_contact_name_placeholder": "اسمك",
  "landing_contact_email_placeholder": "بريدك@الإلكتروني.com",
  "landing_contact_whatsapp_cta": "تحدّث عبر واتساب",
  "landing_contact_whatsapp_badge": "موصى به",
  "landing_contact_whatsapp_desc": "أسرع وسيلة للوصول إلينا — عادةً نردّ خلال دقائق.",
  "landing_contact_phone_label": "رقم الهاتف",
  "landing_contact_phone_placeholder": "رقم هاتفك (اختياري)",
  "landing_contact_company_label": "الشركة",
  "landing_contact_company_placeholder": "اسم شركتك (اختياري)",
  "landing_contact_message_label": "الرسالة",
  "landing_contact_message_placeholder": "أخبرنا عن احتياجات عملك…",
  "landing_contact_submit": "إرسال الرسالة",
  "landing_contact_sending": "جارٍ الإرسال…",
  "landing_contact_success": "شكراً! سنتواصل معك قريباً.",
  "landing_contact_error": "حدث خطأ. يرجى المحاولة مرة أخرى أو التواصل معنا مباشرة.",
  "landing_footer_brand_name": "Bavard",
  "landing_footer_brand_desc": "المنصّة المتكاملة لبناء ونشر وكلاء ذكاء اصطناعي يتولّون خدمة العملاء والمبيعات — على موقعك وواتساب وتيليجرام وما بعدها.",
  "landing_footer_features": "المميزات",
  "landing_footer_pricing": "الأسعار",
  "landing_footer_changelog": "سجل التغييرات",
  "landing_footer_documentation": "التوثيق",
  "landing_footer_api_reference": "مرجع API",
  "landing_footer_support": "الدعم",
  "landing_footer_get_in_touch": "تواصل معنا",
  "landing_footer_rights": "جميع الحقوق محفوظة.",
  "landing_footer_linkedin": "LinkedIn",
  "landing_footer_youtube": "YouTube",
  "landing_footer_legal": "قانوني",
  "landing_footer_newsletter_title": "ابقَ في طليعة الذكاء الاصطناعي",
  "landing_footer_newsletter_desc": "احصل على تحديثات المنتج، ونصائح وكلاء الذكاء الاصطناعي، وأفضل الممارسات — مباشرةً إلى بريدك الإلكتروني. بدون رسائل مزعجة.",
  "landing_footer_newsletter_placeholder": "أدخل بريدك الإلكتروني",
  "landing_footer_subscribe": "اشترك",
  "landing_faq_label": "الأسئلة الشائعة",
  "landing_faq_title": "كل ما تسأله في مكالمة المبيعات",
  "landing_faq_sub": "الإعداد، الفوترة، اللغات، الأمان — الأسئلة التي تطرحها الفرق قبل الاشتراك. سؤالك مفقود؟ تواصل معنا.",
  "landing_faq_cat_started": "البدء",
  "landing_faq_cat_whatsapp": "المراسلة ووكلاء الذكاء الاصطناعي",
  "landing_faq_cat_pricing": "الأسعار والفوترة",
  "landing_faq_cat_security": "الأمان واللغات",
  "landing_faq_search_placeholder": "ابحث في الأسئلة…",
  "landing_faq_search_no_results": "لا توجد أسئلة مطابقة لبحثك.",
  "landing_faq_q_what": "ما هي بافار (Bavard)؟",
  "landing_faq_a_what": "بافار منصّة لبناء وكلاء ذكاء اصطناعي يتولّون خدمة العملاء والمبيعات. درّب وكيلك على محتواك، وانشره على موقعك أو واتساب أو تيليجرام أو ماسنجر، ودعه يجيب عن الأسئلة، ويلتقط العملاء المحتملين، ويحجز الاجتماعات — كل ذلك من لوحة تحكّم واحدة.",
  "landing_faq_q_trial": "هل توجد فترة تجريبية مجانية؟",
  "landing_faq_a_trial": "نعم — كل باقة تشمل تجربة كاملة لمدة 14 يومًا دون الحاجة إلى بطاقة ائتمان. اربط قناة، ودرّب الوكيل على محتواك، ودعه يتولّى محادثات حقيقية قبل أن تقرّر.",
  "landing_faq_q_setup_time": "كم يستغرق الإعداد؟",
  "landing_faq_a_setup_time": "تنطلق معظم الفرق خلال أقل من ساعة. أنشئ الحساب، ارفع وثائقك أو الصق أسئلتك الشائعة، اربط واتساب الأعمال أو بوت تيليجرام، وسيكون الوكيل جاهزًا للحديث. لا حاجة لأي عمل برمجي.",
  "landing_faq_q_developer": "هل أحتاج إلى مطوّر لاستخدام بافار؟",
  "landing_faq_a_developer": "لا. تدريب الوكيل وكتابة تعليماته ودعوة زملائك تتم كلّها من لوحة التحكّم. كما توفّر الباقة المميّزة واجهة REST API إن أردت ربط بافار بأنظمتك الخاصة.",
  "landing_faq_q_existing_number": "هل يمكنني استخدام رقم واتساب الأعمال الحالي؟",
  "landing_faq_a_existing_number": "نعم، لكن يجب ترحيل الرقم إلى واتساب Business API وفقًا لاشتراطات Meta. نُرشدك خطوة بخطوة في التحقّق والإعداد. ملاحظة: لا يمكن نقل سجلّ المحادثات السابقة أثناء الترحيل.",
  "landing_faq_q_ai_training": "كيف يتم تدريب الذكاء الاصطناعي على عملي؟",
  "landing_faq_a_ai_training": "ارفع ملفات PDF، أو الصق أسئلتك الشائعة، أو زامن مركز المساعدة من لوحة التحكّم. يُرسي محرّك الاسترجاع كل إجابة على مصادرك، فيستشهد الوكيل بسياساتك وأسعارك وتفاصيل منتجك الحقيقية بدل اختلاقها.",
  "landing_faq_q_languages": "ما اللغات التي يتحدّثها الوكيل؟",
  "landing_faq_a_languages": "العربية والإنجليزية بدعم كامل — بما في ذلك التخطيط من اليمين إلى اليسار وتجربة استخدام عربية أصيلة. يكتشف الوكيل لغة العميل تلقائيًا ويردّ بها، فبوت واحد يكفي لخدمة الجمهورين.",
  "landing_faq_q_actions": "هل يمكن للوكيل تنفيذ إجراءات فعلية لا مجرّد الردّ؟",
  "landing_faq_a_actions": "نعم. يبحث عن المعلومات، ويحجز الاجتماعات على تقويمك، ويرسل المتابعات، ويلتقط العملاء المحتملين، ويحوّل المحادثة إلى أحد أعضاء فريقك عند تجاوز نطاقه — دون مغادرة المحادثة.",
  "landing_faq_q_credits": "كيف تعمل أرصدة رسائل الذكاء الاصطناعي؟",
  "landing_faq_a_credits": "تتضمّن كل خطة عددًا شهريًا من ردود الذكاء الاصطناعي. كل ردّ يستهلك رصيدًا واحدًا، وتُجدَّد الأرصدة شهريًا. عند نفادها، يمكنك شراء حزم إضافية من صفحة الفوترة أو ترقية خطّتك.",
  "landing_faq_q_whatsapp_fees": "هل رسوم رسائل واتساب مشمولة في الخطة؟",
  "landing_faq_a_whatsapp_fees": "اشتراك المنصّة منفصل عن رسوم Meta لكل محادثة على واتساب. الرسائل الخدمية الواردة من العملاء مجانية، أمّا قوالب التسويق والمرافق التي تبدؤها أنت فتُحاسب عليها Meta بأسعارها القياسية وتُمرَّر إليك بسعر التكلفة دون أي زيادة.",
  "landing_faq_q_change_plan": "هل يمكنني الترقية أو التخفيض أو الإلغاء في أي وقت؟",
  "landing_faq_a_change_plan": "نعم. غيّر خطّتك من صفحة الفوترة — تُحتسب الترقيات بالتناسب، أمّا التخفيض والإلغاء فيسريان في نهاية الدورة الحالية وتحتفظ بالوصول الكامل حتى ذلك الحين. لا توجد رسوم إلغاء.",
  "landing_faq_q_which_plan": "أيّ خطة تناسب نشاطي؟",
  "landing_faq_a_which_plan": "خطة Chat هي مدخلك — صندوق وارد للذكاء الاصطناعي وقاعدة معرفة وواتساب أو تيليجرام. خطة Standard تُضيف الجدولة الذكية وقائمة الانتظار ولوحة الموظفين. خطة Premium تُتيح ذكاءً اصطناعيًا متقدّمًا للمستندات وتحليلات متقدّمة وواجهة API ودعمًا مخصّصًا.",
  "landing_faq_q_security": "هل بياناتي آمنة؟",
  "landing_faq_a_security": "جميع الاتصالات مُشفَّرة أثناء النقل (TLS) وفي حالة التخزين. وثائق ومحادثات كل مؤسّسة معزولة، مع صلاحيات وصول قائمة على الأدوار. ولا تُستخدم محتويات المحادثات في تدريب أي نماذج ذكاء اصطناعي مشتركة.",
  "landing_faq_q_arabic_hijri": "هل تدعمون العربية، الكتابة من اليمين لليسار، والتقويم الهجري؟",
  "landing_faq_a_arabic_hijri": "نعم. واجهة عربية، تخطيط RTL، تواريخ هجرية، وقوالب ثنائية اللغة — كلّها أصلية وليست مضافة لاحقًا. مبنية خصيصًا للأعمال التي تخدم المملكة العربية السعودية ودول الخليج.",
  "landing_faq_q_integrations": "ما التكاملات وواجهات الـ API المتاحة؟",
  "landing_faq_a_integrations": "متوفّر افتراضيًا: واتساب الأعمال، تيليجرام، إنستجرام، منصة X، رفع الوثائق، فوترة Stripe وPaymob، وتسجيل الدخول بـ Google. وتُضيف خطة Premium واجهة REST API وويب هوك صادرة لربط بافار بأنظمتك الخاصة.",
  "landing_faq_q_data_ownership": "لمن تعود ملكية بيانات المحادثات؟",
  "landing_faq_a_data_ownership": "البيانات ملكٌ لك. صدّر جهات الاتصال والمحادثات والتحليلات بصيغة CSV أو عبر الـ API في أي وقت. يعمل بافار كمعالج بياناتٍ بموجب سياسة الخصوصية الخاصّة بك ويحذف بياناتك عند الطلب بعد الإلغاء.",
  "landing_faq_q_no_experience": "هل أحتاج إلى خبرة تقنية لأبدأ؟",
  "landing_faq_a_no_experience": "لا. إن كنت تستخدم واتساب أو تيليجرام فأنت قادرٌ على تشغيل بافار. كل شيء يُضبط من لوحة التحكم دون أي برمجة، وفريقنا يرافقك من أول خطوة وحتى الإطلاق.",
  "landing_faq_q_connect_systems": "كيف أربط بافار بأنظمتي الحالية؟",
  "landing_faq_a_connect_systems": "يعمل بافار افتراضيًا مع الأدوات التي تستخدمها بالفعل — واتساب الأعمال، وتيليجرام، وإنستجرام، ومنصة X، ورفع الوثائق، وفوترة Stripe أو Paymob. وتُضيف خطة Premium واجهة REST API لربطه بأي نظام آخر. ولا حاجة لأي عمل برمجي للبدء.",
  "landing_faq_q_on_behalf": "هل يستطيع الوكيل إدارة المحادثات نيابةً عني؟",
  "landing_faq_a_on_behalf": "نعم. يردّ وكيل بافار، ويتابع، ويُبقي المحادثات سائرة عبر واتساب وتيليجرام وماسنجر والمحادثة على الويب والبريد الإلكتروني — تلقائيًا وعلى مدار الساعة — ولا يُحوّلها إلى فريقك إلا عند الحاجة إلى تدخّل بشري.",
  "landing_faq_q_customize_tone": "هل يمكنني تخصيص نبرة الوكيل وأسلوبه؟",
  "landing_faq_a_customize_tone": "نعم. اضبط شخصية الوكيل ونبرته وأسلوب ردّه ليناسب علامتك التجارية. وهو يتحدّث العربية والإنجليزية بطلاقة، يكتشف لغة كل عميل ويردّ بها تلقائيًا.",
  "landing_faq_q_review_transcripts": "هل يمكنني مراجعة ما قاله الوكيل لعملائي؟",
  "landing_faq_a_review_transcripts": "نعم. تُسجَّل كل محادثة بالكامل وتكون قابلة للبحث في صندوق الوارد المشترك — اقرأ النص الكامل لأي محادثة، وتدخّل لتولّيها في أي لحظة، وصدّر السجلّ متى احتجت إليه.",
  "landing_faq_q_customer_data": "هل من الآمن أن يتعامل الوكيل مع بيانات عملائي؟",
  "landing_faq_a_customer_data": "نعم. بيانات العملاء مُشفَّرة أثناء النقل وفي حالة التخزين، ومعزولة لكل مؤسّسة، وتُعالَج وفق ضوابط خصوصية صارمة. ولا يُستخدم محتوى المحادثات في تدريب أي نماذج ذكاء اصطناعي مشتركة، وتبقى أنت المالك والمتحكّم في البيانات طوال الوقت.",
  "landing_faq_still_question": "ما زال لديك سؤال؟",
  "landing_faq_contact_link": "تحدّث إلينا",
  "landing_demo_tab_booking": "الحجز",
  "landing_demo_tab_services": "الخدمات",
  "landing_demo_ai_retrieving": "AI يسترجع البيانات…",
  "landing_demo_channel": "الدردشة المباشرة",
  "landing_integration_webchat": "دردشة الويب",
  "landing_integration_email": "البريد الإلكتروني",
  "landing_section_integrations_marquee": "التكاملات",
  "landing_integrations_marquee_title": "كل قناة. ذكاء اصطناعي واحد.",
  "landing_integrations_marquee_sub": "اربط واتساب، تيليجرام، ماسنجر، دردشة الويب، والبريد. قاعدة معرفة واحدة. صندوق وارد واحد. كل المحادثات.",
  "landing_demo_btn_9am": "9:00 AM",
  "landing_demo_btn_2pm": "3:00 PM",
  "landing_demo_btn_430pm": "4:30 PM",
  "landing_demo_event_booked": "محجوز",
  "landing_demo_event_open": "متاح",
  "landing_demo_event_haircut": "قص شعر",
  "landing_demo_event_your_appt": "موعدك",
  "landing_demo_c_booking_user_1": "هل لديكم مواعيد متاحة غداً بعد الظهر؟",
  "landing_demo_c_booking_ai_1": "المواعيد المتاحة *غداً بعد الظهر*:",
  "landing_demo_c_booking_action_1": "جارٍ التحقق من التوفر…",
  "landing_demo_c_booking_action_1_done": "تم تحميل التوفر",
  "landing_demo_c_booking_user_2": "احجز لي الساعة 3 مساءً",
  "landing_demo_c_booking_ai_2": "*تم الحجز!* _قص شعر_ مؤكد *غداً الساعة 3:00 مساءً*.",
  "landing_demo_c_booking_action_2": "جارٍ إنشاء الموعد…",
  "landing_demo_c_booking_action_2_done": "تم تأكيد الموعد",
  "landing_demo_c_booking_ai_3": "سيتم إرسال تذكير *قبل ساعة* من موعدك.",
  "landing_demo_c_booking_action_3": "جارٍ جدولة التذكير…",
  "landing_demo_c_booking_action_3_done": "تم ضبط التذكير",
  "landing_demo_c_services_user_1": "ما هي خدماتكم وأين موقعكم؟",
  "landing_demo_c_services_ai_1": "*خدماتنا:*\n• _قص وتصفيف الشعر_ — من *$35*\n• _صبغة الشعر_ — من *$80*\n• _مانيكير/باديكير_ — من *$45*\n• _عناية بالوجه_ — من *$60*\n• _باقة العروس_ — من *$250*",
  "landing_demo_c_services_action_1": "جارٍ البحث في كتالوج الخدمات…",
  "landing_demo_c_services_action_1_done": "تم تحميل كتالوج الخدمات",
  "landing_demo_c_services_user_2": "أين أقرب فرع لكم؟",
  "landing_demo_c_services_ai_2": "إليك موقعنا:",
  "landing_demo_c_services_action_2": "جارٍ البحث عن المواقع…",
  "landing_demo_c_services_action_2_done": "تم العثور على المواقع",
  "landing_demo_c_rag_action_1_done": "تم استرجاع المستندات",
  "landing_demo_c_rag_action_2_done": "تم استرجاع المستندات",
  "landing_demo_doc_service_catalog": "كتالوج الخدمات",
  "landing_demo_doc_service_menu": "قائمة الخدمات ودليل الأسعار",
  "landing_demo_doc_hair_services": "خدمات الشعر",
  "landing_demo_doc_haircut_styling": "قص وتصفيف الشعر — من $35",
  "landing_demo_doc_color_treatment": "صبغة الشعر — من $80",
  "landing_demo_doc_highlights_balayage": "هايلايت وبالاياج — من $120",
  "landing_demo_doc_nail_spa": "أظافر وسبا",
  "landing_demo_doc_manicure": "مانيكير وباديكير — من $45",
  "landing_demo_doc_facial": "عناية بالوجه — من $60",
  "landing_demo_doc_massage": "مساج الأنسجة العميقة — من $90",
  "landing_demo_doc_packages": "الباقات",
  "landing_demo_doc_bridal": "باقة العروس — من $250",
  "landing_demo_doc_vip": "باقة VIP لليوم الكامل — من $180",
  "landing_demo_doc_contact_location": "التواصل والموقع",
  "landing_demo_doc_contact_info": "معلومات التواصل والاتجاهات",
  "landing_demo_doc_address": "العنوان",
  "landing_demo_doc_address_line1": "123 Beauty Lane, الطابق الثاني",
  "landing_demo_doc_address_line2": "منطقة وسط المدينة، بالقرب من المول المركزي",
  "landing_demo_doc_getting_here": "كيفية الوصول",
  "landing_demo_doc_metro": "المترو: محطة المركز (مخرج B، 3 دقائق سيراً)",
  "landing_demo_doc_parking": "مواقف السيارات: مصدّقة في مرآب المول المركزي",
  "landing_demo_doc_contact": "التواصل",
  "landing_demo_doc_studio_name": "LUXE STUDIO",
  "landing_demo_tab_rag": "قاعدة المعرفة",
  "landing_demo_rag_drop_label": "أسقط الملفات هنا",
  "landing_demo_rag_processing": "جارٍ المعالجة…",
  "landing_demo_rag_user_1": "ما إجمالي إيراداتنا في الربع الثالث؟",
  "landing_demo_rag_ai_1": "جارٍ البحث في _تقرير الربع الثالث_…",
  "landing_demo_rag_action_1": "استرجاع Q3-Report.pdf…",
  "landing_demo_rag_ai_2": "إجمالي الإيرادات في الربع الثالث *2.4 مليون دولار*، بزيادة *+18%* مقارنة بالربع الثاني مع *342* عميلاً جديداً.",
  "landing_demo_rag_user_2": "أي منطقة حققت أفضل أداء؟",
  "landing_demo_rag_ai_3": "جارٍ البحث في _التوزيع الإقليمي_…",
  "landing_demo_rag_action_2": "مسح البيانات الإقليمية…",
  "landing_demo_rag_ai_4": "تصدرت *أمريكا الشمالية* بـ *890 ألف دولار (37%)*، تليها أوروبا بـ *650 ألف دولار (27%)*.",
  "landing_capabilities_label": "الإمكانات",
  "landing_capabilities_title": "مُصمَّم خصّيصًا لذكاء اصطناعي يواجه العملاء",
  "landing_capabilities_sub": "يدمج بافار مستنداتك وتقويمك وكل قنوات المراسلة في وكلاء لن يستطيع عملاؤك تمييزهم عن أفضل موظفيك.",
  "landing_cap_kb_eyebrow": "إجابات موثّقة",
  "landing_cap_kb_title": "إجابات مُجمّعة من مختلف ملفاتك",
  "landing_cap_kb_body": "أضف ما تشاء من المستندات — قوائم الطعام والأسعار والسياسات والأسئلة الشائعة. يراجع الذكاء الاصطناعي كل هذه الملفات ليُجمّع إجابة واحدة دقيقة، ويذكر مصدرها.",
  "landing_cap_kb_search": "هل لديكم خيارات نباتية؟",
  "landing_cap_kb_file_menu": "القائمة",
  "landing_cap_kb_file_prices": "قائمة الأسعار",
  "landing_cap_kb_file_policies": "السياسات",
  "landing_cap_kb_cited": "مقتبس من Menu.pdf",
  "landing_cap_kb_metric": "يراجع كل ملف — مهما بلغ عددها.",
  "landing_cap_avail_eyebrow": "متاح دائماً",
  "landing_cap_avail_title": "يعمل في كل ساعة تكون فيها مغلقاً",
  "landing_cap_avail_body": "بينما تنام، يواصل الرد والحجز والتقاط العملاء المحتملين. لا فجوة بعد الدوام، ولا بريد صوتي، ولا إيراد ضائع.",
  "landing_cap_avail_coverage_label": "مفتوح دائماً",
  "landing_cap_avail_uptime_label": "زمن التشغيل",
  "landing_cap_avail_missed_label": "رسائل فائتة",
  "landing_cap_avail_live": "مباشر",
  "landing_cap_avail_sample": "رد على عميل · 3:42 ص",
  "landing_cap_resp_eyebrow": "ردود فورية",
  "landing_cap_resp_title": "يرد قبل أن يفكروا في المغادرة",
  "landing_cap_resp_body": "يرد في أقل من ثانيتين، في أي وقت، بالعربية أو الإنجليزية — رد بجودة بشرية بينما لا يزال الموظف يكتب \"مرحباً\".",
  "landing_cap_resp_metric_label": "متوسط أول رد",
  "landing_cap_resp_bavard": "Bavard AI",
  "landing_cap_resp_human": "موظف بشري",
  "landing_cap_kb_head": "كل ملف،\nإجابة واحدة",
  "landing_cap_kb_lead": "يُجمّع بافارد الإجابات من جميع مستنداتك.",
  "landing_cap_kb_rest": " أضف القوائم والأسعار والسياسات والأسئلة الشائعة — بقدر ما تشاء. يراجع كل ملف ليكوّن إجابة واحدة دقيقة ويذكر مصدرها دائماً. مهما بلغ عدد الملفات، لا يفوته شيء.",
  "landing_cap_kb_card": "قاعدة المعرفة",
  "landing_cap_kb_sub": "ملفات، جميعها مترابطة",
  "landing_cap_kb_desc": "مصادر مُجمّعة في كل إجابة",
  "landing_cap_avail_head": "متاح دائماً،\nلا يُغلق",
  "landing_cap_avail_lead": "يرد بافارد على مدار الساعة، كل أيام السنة.",
  "landing_cap_avail_rest": " بينما تنام، يواصل الرد والحجز والتقاط العملاء — في الثالثة فجراً أو في العطلات. لا فجوة بعد الدوام، ولا بريد صوتي، ولا إيراد ضائع. يحصل عملاؤك دائماً على رد فوري.",
  "landing_cap_avail_card": "التوافر",
  "landing_cap_avail_sub": "على مدار الساعة",
  "landing_cap_avail_desc": "رسائل تُعالَج في كل ساعة من اليوم",
  "landing_cap_resp_head": "يرد في\nأقل من ثانيتين",
  "landing_cap_resp_lead": "يرسل بافارد رداً بجودة بشرية في أقل من ثانيتين.",
  "landing_cap_resp_rest": " في أي وقت، بالعربية أو الإنجليزية، يرد قبل أن ينهي الموظف قراءة الرسالة — فلا ينتظر العملاء، ولا يُتركون دون رد، ولا يذهبون إلى منافس بينما أنت مشغول.",
  "landing_cap_resp_card": "زمن الاستجابة",
  "landing_cap_resp_sub": "متوسط أول رد",
  "landing_cap_resp_desc": "زمن أول رد مقارنةً بموظف بشري",
  "landing_bento_kb_title": "قاعدة المعرفة",
  "landing_bento_kb_desc": "ارفع مستنداتك — يجيب الذكاء الاصطناعي على عملائك فوراً",
  "landing_bento_kb_question": "هل لديكم خيارات نباتية؟",
  "landing_bento_kb_answer": "نعم! لدينا 4 أطباق نباتية تشمل ريزوتو الفطر وطبق الخضار المشوية.",
  "landing_bento_kb_source": "من Menu.pdf",
  "landing_bento_sched_title": "جدولة ذكية",
  "landing_bento_sched_desc": "يحجز الذكاء الاصطناعي المواعيد مباشرة من المحادثات",
  "landing_bento_sched_date": "الخميس، 27 مارس",
  "landing_bento_sched_today": "اليوم",
  "landing_bento_sched_booked": "محجوز",
  "landing_bento_sched_open": "متاح",
  "landing_bento_sched_confirmed": "مؤكد",
  "landing_bento_sched_confirmation_sent": "تم إرسال التأكيد",
  "landing_bento_availability_title": "متاح 24/7",
  "landing_bento_availability_desc": "لا تفوّت أي استفسار من عميل",
  "landing_bento_availability_uptime": "وقت التشغيل",
  "landing_bento_availability_response": "الاستجابة",
  "landing_bento_availability_coverage": "التغطية",
  "landing_bento_availability_live": "مباشر",
  "landing_bento_availability_log": "سجل النشاط",
  "landing_bento_activity_just_now": "الآن",
  "landing_bento_activity_replied": "ردّ العميل خلال 1.2 ثانية",
  "landing_bento_activity_booking": "تم تأكيد الحجز",
  "landing_bento_activity_doc_query": "تمت الإجابة على استعلام مستند",
  "landing_bento_activity_availability_check": "تم التحقق من التوفر",
  "landing_bento_activity_followup": "تم إرسال متابعة تلقائياً",
  "landing_bento_activity_lead": "تم التقاط عميل محتمل",
  "landing_bento_activity_payment": "تم تسليم رابط الدفع",
  "landing_bento_activity_reschedule": "تمت معالجة إعادة الجدولة",
  "landing_bento_replies_title": "ردود فورية",
  "landing_bento_replies_desc": "ردود ذكية في أقل من 3 ثوانٍ",
  "landing_bento_replies_user_msg_1": "هل لديكم توفر في 3 مساءً؟",
  "landing_bento_replies_user_msg_2": "ما ساعات العمل غداً؟",
  "landing_bento_replies_ai_reply": "متاحون 9-6! لدي موعد 3 مساءً. هل أحجزه لك؟",
  "landing_bento_replies_avg": "متوسط الاستجابة",
  "landing_features_preview_chat_title": "دردشة",
  "landing_features_preview_chat_user_msg": "مرحباً، أحتاج حجز موعد غداً الساعة 3 مساءً",
  "landing_features_preview_chat_ai_reply": "تم! تم الحجز غداً، 28 مارس الساعة 3:00 مساءً. تم إرسال التأكيد.",
  "landing_features_preview_kb_title": "قاعدة المعرفة",
  "landing_features_preview_kb_search": "ابحث في المستندات…",
  "landing_features_preview_file_service_catalog": "كتالوج الخدمات",
  "landing_features_preview_file_pricing_sheet": "ورقة الأسعار",
  "landing_features_preview_file_company_policies": "سياسات الشركة",
  "landing_features_preview_calendar_title": "التقويم",
  "landing_features_preview_calendar_available": "متاح",
  "landing_features_preview_calendar_consult_with": "سارة م. - استشارة",
  "landing_features_preview_calendar_appt_label": "10:00 صباحاً - استشارة",
  "landing_features_preview_calendar_confirm": "تأكيد",
  "landing_features_preview_bulk_title": "القنوات",
  "landing_features_preview_bulk_name": "الاسم",
  "landing_features_preview_bulk_phone": "الهاتف",
  "landing_features_preview_bulk_status": "الحالة",
  "landing_features_preview_bulk_active": "نشط",
  "landing_features_preview_bulk_pending": "قيد الانتظار",
  "landing_features_preview_analytics_title": "لوحة المعلومات",
  "landing_features_preview_analytics_response_rate": "معدل الاستجابة",
  "landing_features_preview_analytics_messages": "الرسائل",
  "landing_features_preview_analytics_bookings": "الحجوزات",
  "landing_features_preview_analytics_vs_last_month": "مقارنة بالشهر الماضي",
  "landing_features_preview_grid_title": "شبكة البيانات",
  "landing_testimonials_label": "الشهادات",
  "landing_testimonials_title": "محبوب من فرق الخدمات حول العالم",
  "landing_testimonials_sub": "من المطابخ إلى العيادات إلى إدارة العقارات — اطّلع على كيفية استخدام الفرق لبافار لاسترداد يومهم.",
  "landing_testimonial_1_name": "د. أمل سعيد",
  "landing_testimonial_1_role": "طبيبة نساء وتوليد، صحتي غير، مكة المكرمة، السعودية",
  "landing_testimonial_1_text": "يتعامل بافار مع 80% من حجوزات المواعيد في عيادتنا تلقائيًا. الاستفسار عن المواعيد، المتابعات، وإعادة الجدولة — المرضى يحصلون على إجابات قبل أن يلتقط الاستقبال السماعة.",
  "landing_testimonial_2_name": "ماركوس فيبر",
  "landing_testimonial_2_role": "مدير العمليات، مجموعة Alpine Dental",
  "landing_testimonial_2_text": "أصبح المرضى يحجزون المواعيد في الساعة 2 صباحاً. يعرف الذكاء الاصطناعي جدولنا ويتعامل مع إعادة الجدولة دون أي تدخل من الموظفين.",
  "landing_testimonial_3_name": "بريا شارما",
  "landing_testimonial_3_role": "مؤسِّسة، StyleBox Boutique",
  "landing_testimonial_3_text": "رفعنا كتالوج المنتجات وقائمة الأسعار. الآن يحصل العملاء على إجابات فورية ودقيقة حول التوفر والمقاسات عبر WhatsApp.",
  "landing_testimonial_4_name": "جيمس أوكونور",
  "landing_testimonial_4_role": "الرئيس التنفيذي، Dublin Property Management",
  "landing_testimonial_4_text": "كانت إدارة استفسارات المستأجرين عبر 200 وحدة كابوساً. خفّض Bavard وقت الاستجابة لدينا من ساعات إلى ثوانٍ.",
  "landing_testimonial_rating": "تقييم",
  "landing_testimonials_prev": "الشهادة السابقة",
  "landing_testimonials_next": "الشهادة التالية",
  "landing_nav_lang_toggle_aria": "تبديل اللغة",
  "endpoint_additional_providers": "مزودون إضافيون",
  "endpoint_context_length": "السياق",
  "endpoint_max_output": "أقصى إخراج",
  "endpoint_quantization_description": "التكميم: {{label}}. يستخدم هذا النموذج تكميم {{label}}، مما يقلل من حجم النموذج ويحسّن سرعة الاستدلال مع الحفاظ على جودة مقبولة.",
  "endpoint_tokens": "رموز",
  "language_already_available": "اللغة متوفرة بالفعل",
  "model_filter_add_favorite": "إضافة إلى المفضلة",
  "model_filter_author": "مؤلف النموذج",
  "model_filter_open": "فتح قائمة الفلاتر",
  "model_filter_remove_favorite": "إزالة من المفضلة",
  "model_filter_variant_standard_description": "النماذج القياسية بدون إمكانات متخصصة",
  "no_language_mapping_found": "لم يتم العثور على تطابق لغوي لهذا البلد",
  "select_country": "اختر دولة",
  "timezone_list": "قائمة المناطق الزمنية",
  "timezone_no_matches": "لا توجد نتائج",
  "timezone_select_placeholder": "اختر المنطقة الزمنية",
  "translating": "جارٍ الترجمة…",
  "add_and_translate": "إضافة وترجمة",
  "add_language": "إضافة لغة",
  "add_language_description": "اختر دولة لإضافة لغتها الأساسية. ستتم ترجمة اللغة تلقائيًا باستخدام الذكاء الاصطناعي.",
  "workingHours": {
    "dayOfWeek": {
      "label": "يوم الأسبوع"
    },
    "workingDays": {
      "title": "ساعات العمل",
      "description": "اختر ساعات العمل",
      "atLeastOneRequired": "يلزم تحديد يوم عمل واحد على الأقل *",
      "endMustBeAfterStart": "يجب أن يكون وقت النهاية بعد وقت البداية",
      "endTime": "وقت الانتهاء *",
      "startTime": "وقت البدء *",
      "slotDuration": "مدة الفترة *",
      "selectDuration": "اختر المدة",
      "noValidDurations": "لا توجد مدد صالحة",
      "missing": "مفقود",
      "required": "مطلوب"
    },
    "daySpecific": {
      "title": "التجاوزات",
      "description": "عيّن ساعات مختلفة لأيام معينة",
      "addHours": "إضافة ساعات خاصة باليوم",
      "dayOfWeek": "يوم الأسبوع",
      "start": "البداية",
      "end": "النهاية",
      "endMustBeAfterStart": "يجب أن يكون وقت النهاية بعد وقت البداية",
      "noOverrides": "لم تتم إضافة أي تجاوزات بعد.",
      "noValidDurations": "لا توجد مدد صالحة",
      "removeEntry": "إزالة إدخال الساعات الخاصة باليوم",
      "selectDuration": "اختر المدة",
      "slotDuration": "مدة الفترة",
      "dayOfWeekHelp": "اختر يوم العمل الذي تريد تجاوزه. يمكن تجاوز كل يوم مرة واحدة فقط."
    },
    "customRanges": {
      "title": "تجاوزات نطاق التاريخ",
      "description": "عيّن ساعات عمل مختلفة لنطاقات تواريخ محددة",
      "addRange": "إضافة تجاوز لنطاق تاريخ",
      "dateRange": "نطاق التاريخ",
      "endMustBeAfterStart": "يجب أن يكون وقت النهاية بعد وقت البداية",
      "endTime": "وقت الانتهاء",
      "from": "من",
      "to": "إلى",
      "startTime": "وقت البدء",
      "inherit": "وراثة",
      "inheritAlreadyMatches": "تطابق بالفعل أيام العمل العامة",
      "inheritTooltip": "نسخ أيام العمل العامة",
      "noRanges": "لم يتم تعريف أي نطاقات مخصصة.",
      "rangeName": "اسم النطاق",
      "rangeNamePlaceholder": "اسم النطاق",
      "removeRange": "إزالة النطاق المخصص",
      "resetToDefault": "إعادة التعيين إلى الافتراضي",
      "selectDuration": "اختر المدة",
      "slotDuration": "مدة الفترة",
      "workingDays": "أيام العمل",
      "daySpecific": {
        "addHours": "إضافة ساعات خاصة باليوم",
        "description": "عيّن ساعات مختلفة لأيام معينة ضمن هذا النطاق",
        "noOverrides": "لا توجد تجاوزات خاصة باليوم."
      },
      "rangeNameHelp": "اسم لهذا النطاق (مثل: «ساعات الصيف»). يظهر في شريط أدوات التقويم عند تفعيله.",
      "workingDaysHelp": "الأيام التي تعتبر أيام عمل خلال هذا النطاق. تتجاوز أيام العمل العامة.",
      "recurrence": {
        "openBuilder": "إنشاء نطاق متكرر",
        "title": "منشئ النطاقات المتكررة",
        "description": "صف نمطًا متكررًا وحوّله إلى تجاوزات لنطاقات التواريخ.",
        "frequency": "التكرار",
        "daily": "يومي",
        "weekly": "أسبوعي",
        "monthly": "شهري",
        "every": "كل",
        "onWord": "في",
        "dayWord": "يوم",
        "unitDay": "يوم",
        "unitWeek": "أسبوع",
        "unitMonth": "شهر",
        "unitDays": "أيام",
        "unitWeeks": "أسابيع",
        "unitMonths": "أشهر",
        "onDays": "في هذه الأيام",
        "monthlyOn": "في",
        "monthModeDate": "يوم من الشهر",
        "monthModeWeekday": "يوم من الأسبوع",
        "dayOfMonth": "يوم الشهر",
        "ordinal": "أي واحد",
        "weekday": "يوم الأسبوع",
        "ordinal1": "الأول",
        "ordinal2": "الثاني",
        "ordinal3": "الثالث",
        "ordinal4": "الرابع",
        "ordinalLast": "الأخير",
        "hours": "الساعات",
        "startsOn": "يبدأ في",
        "ends": "ينتهي",
        "endsAfter": "بعد عدد من المرات",
        "endsOn": "في تاريخ",
        "noOccurrences": "لا ينتج عن هذا النمط أي تواريخ. اختر يومًا واحدًا على الأقل.",
        "summaryCollapsed": "يضيف تجاوزًا واحدًا يمتد على هذه التواريخ، مفتوحًا في الأيام المحددة فقط.",
        "summaryExpanded": "يضيف تجاوزًا ليوم واحد لكل تاريخ.",
        "willAdd": "إدخالات التجاوز الجديدة",
        "cancel": "إلغاء",
        "addButton": "إضافة التجاوزات"
      }
    },
    "inheritedDefault": " (افتراضي)",
    "grid": {
      "addRange": "إضافة نطاق زمني",
      "removeRange": "إزالة النطاق الزمني",
      "unavailable": "غير متاح",
      "overlap": "النطاقات الزمنية متداخلة",
      "durationTooLong": "مدة الموعد أطول من أطول نطاق زمني في اليوم",
      "noWorkingDays": "يوم عمل واحد على الأقل",
      "weekStartsOn": "يبدأ الأسبوع من",
      "copyTooltip": "نسخ الأوقات إلى…",
      "copyTimesTo": "نسخ الأوقات إلى",
      "copyEveryDay": "كل الأيام",
      "copyApply": "تطبيق",
      "dragToReorder": "اسحب لإعادة الترتيب",
      "reorderHint": "اسحب يومًا إلى الأعلى لتبدأ به الأسبوع."
    }
  },
  "quickReplies": {
    "dialog": {
      "title": "ردود سريعة",
      "description": "أنشئ أقسامًا وشارات للردود السريعة. انقر على شارة في شريط الدردشة لإدراج نصها."
    },
    "placeholder": {
      "label": "التسمية",
      "text": "نص الرسالة"
    },
    "tooltip": {
      "addReply": "إضافة رد",
      "clickToEdit": "انقر للتعديل",
      "clickToRename": "انقر لإعادة التسمية",
      "deleteSection": "حذف القسم وجميع ردوده"
    },
    "aria": {
      "dragReply": "اسحب لإعادة الترتيب",
      "dragSection": "اسحب لإعادة ترتيب القسم",
      "colorPicker": "منتقي ألوان {{name}}"
    },
    "empty": {
      "noReplies": "أضف ردًا واحدًا على الأقل",
      "noSections": "لا توجد أقسام بعد. أضف واحدًا للبدء."
    },
    "contextMenu": {
      "removeReply": "إزالة الرد السريع",
      "deleteSection": "حذف القسم"
    },
    "confirmDelete": {
      "title": "حذف القسم؟",
      "description": "سيؤدي هذا إلى حذف \"{{name}}\" وجميع الردود السريعة الخاصة به نهائيًا.",
      "confirm": "حذف القسم"
    },
    "button": {
      "addSection": "إضافة قسم",
      "save": "حفظ",
      "saving": "جارٍ الحفظ"
    },
    "error": {
      "saveFailed": "فشل الحفظ. يرجى المحاولة مرة أخرى."
    },
    "section": {
      "defaultName": "القسم {{number}}"
    }
  },
  "chat_action_quick_replies": "ردود سريعة",
  "chat_action_search": "البحث في الرسائل",
  "back": "رجوع",
  "search": "بحث",
  "config_loading_label": "جارٍ تحميل الإعدادات",
  "config_back_to_app": "العودة إلى التطبيق",
  "config_mode_standard": "قياسي",
  "config_mode_advanced": "متقدم",
  "config_mode_aria_label": "وضع الإعدادات",
  "config_mode_tooltip_standard": "الوضع القياسي — إظهار الإعدادات الشائعة فقط",
  "config_mode_tooltip_advanced": "الوضع المتقدم — إظهار جميع الإعدادات",
  "config_nav_event_types": "أنواع الفعاليات",
  "config_nav_email_templates": "قوالب البريد الإلكتروني",
  "config_import_no_differences": "لم يتم العثور على اختلافات. تتطابق الإعدادات المستوردة مع إعداداتك الحالية.",
  "config_import_found_sections": "تم العثور على {{count}} أقسام بها تغييرات. راجع واختر ما تريد استيراده.",
  "config_import_success": "تم استيراد {{count}} حقول بنجاح",
  "config_import_failed": "فشل تطبيق الاستيراد: {{message}}",
  "config_import_ignored_fields": "لم يتم التعرف على {{count}} حقول في الملف المستورد وتم تخطيها.",
  "config_import_deactivate_types_warning": "يزيل هذا الاستيراد {{count}} أنواع فعاليات نشطة ({{names}}). ستظل نشطة ما لم تؤكد التعطيل أدناه.",
  "config_import_deactivate_types_toggle": "تعطيل أنواع الفعاليات المُزالة",
  "config_pending_save_failed": "فشل حفظ التغييرات المعلّقة: {{message}}",
  "config_pending_save_success": "تم حفظ التغييرات",
  "config_save_success": "تم حفظ الإعدادات بنجاح",
  "config_save_failed": "فشل حفظ الإعدادات: {{message}}",
  "config_import_unknown_error": "حدث خطأ غير معروف",
  "config_import_validation_summary": "فشل الاستيراد — {{count}} حقل غير صالح: {{fields}}. راجع وحدة تحكم المتصفح للحصول على التفاصيل الكاملة.",
  "config_import_version_outdated": "يستخدم ملف الإعدادات هذا تنسيقًا قديمًا أو غير مدعوم. أعد تصديره من مساحة عمل حالية ثم استورده مجددًا.",
  "config_import_cancelled": "تم إلغاء الاستيراد",
  "config_import_overwrite_title": "الاستيراد فوق تغييرات غير محفوظة؟",
  "config_import_overwrite_description": "لديك تغييرات غير محفوظة. سيعرض الاستيراد القيم المحددة فوقها كمعاينة. يمكنك إلغاء الاستيراد لاستعادة تغييراتك.",
  "config_import_overwrite_confirm": "متابعة الاستيراد",
  "config_changes_discarded": "تم تجاهل التغييرات",
  "config_form_reset_to_defaults": "تمت إعادة تعيين النموذج إلى الافتراضيات. اضغط حفظ لتطبيق التغييرات.",
  "email_template_name_label": "اسم القالب",
  "email_template_name_placeholder": "مثل: بريد ترحيب، تذكير بموعد",
  "email_template_name_required": "اسم القالب مطلوب",
  "email_template_subject_label": "سطر الموضوع",
  "email_template_subject_placeholder": "مثل: مرحبًا {{name}}، تم تأكيد موعدك",
  "email_template_subject_required": "الموضوع مطلوب",
  "email_template_subject_hint": "استخدم {{name}} و{{email}} للتخصيص.",
  "email_template_body_label": "نص البريد الإلكتروني",
  "email_template_body_placeholder": "اكتب محتوى بريدك الإلكتروني هنا. استخدم {{name}} و{{email}} للتخصيص…",
  "email_template_body_required": "نص البريد الإلكتروني مطلوب",
  "email_template_available_variables": "المتغيرات المتاحة:",
  "email_template_edit_title": "تحرير القالب",
  "email_template_new_title": "قالب جديد",
  "email_template_save": "حفظ القالب",
  "email_template_variable_recipient_name": "اسم المستلم",
  "email_template_variable_recipient_email": "بريد المستلم",
  "config_calendar_week_start_title": "يوم بداية الأسبوع",
  "config_calendar_week_start_description": "حدد اليوم الذي يبدأ به الأسبوع",
  "config_calendar_views_title": "طرق عرض التقويم",
  "config_calendar_views_description": "انقر على طريقة عرض لتفعيلها؛ انقر على الدبوس لتعيينها كافتراضية.",
  "config_calendar_views_default_label": "افتراضي",
  "config_calendar_views_set_default": "تعيين كافتراضي",
  "config_calendar_views_validation": "اختر طريقة عرض تقويم واحدة على الأقل *",
  "config_calendar_view_timeGridWeek": "أسبوع",
  "config_calendar_view_timeGridDay": "يوم",
  "config_calendar_view_dayGridMonth": "شهر",
  "config_calendar_view_listMonth": "قائمة",
  "config_calendar_view_multiMonthYear": "سنة",
  "config_event_time_format_title": "تنسيق وقت الفعالية",
  "config_event_time_format_description": "تكوين كيفية عرض أوقات الفعاليات",
  "config_event_time_format_aria": "تنسيق الوقت",
  "config_event_time_format_12h": "12 ساعة",
  "config_event_time_format_24h": "24 ساعة",
  "config_event_time_format_auto": "تلقائي",
  "config_event_time_format_auto_tip": "يتكيف بين 12 ساعة و24 ساعة حسب لغة متصفح المستخدم.",
  "config_event_time_format_hidden": "مخفي",
  "config_event_time_format_hidden_tip": "يخفي تسمية الوقت على كتل فعاليات التقويم. تحتفظ الفعاليات بفترتها الزمنية.",
  "config_event_time_format_minutes_label": "دقائق",
  "config_event_time_format_minutes_tip": "إظهار أو إخفاء جزء الدقائق (مثل 2 مساءً مقابل 2:30 مساءً).",
  "config_event_time_format_meridiem_label": "ص/م",
  "config_event_time_format_meridiem_tip": "إظهار أو إخفاء لاحقة ص/م. ينطبق فقط في تنسيق 12 ساعة.",
  "config_event_time_format_preview": "معاينة",
  "config_business_info_title": "معلومات العمل",
  "config_business_info_description": "قم بتكوين تفاصيل عملك لاستجابات الذكاء الاصطناعي ومشاركة الموقع",
  "config_business_info_ai_hint": "تتم مشاركة هذه التفاصيل تلقائيًا مع مساعد الذكاء الاصطناعي — لا حاجة لتكرارها في موجّه النظام.",
  "config_business_name_label": "اسم العمل",
  "config_business_name_placeholder": "اسم عملك",
  "config_business_name_tip": "يظهر للعملاء في ردود الذكاء الاصطناعي ودبابيس الموقع على واتساب أو تيليجرام.",
  "config_business_address_label": "عنوان العمل",
  "config_business_address_placeholder": "عنوان الشارع، المدينة، البلد",
  "config_business_address_placeholder_full": "عنوان الشارع، المدينة، البلد، الرمز البريدي",
  "config_business_address_tip": "يُستخدم في ردود الذكاء الاصطناعي ويُدرج في دبابيس الموقع المرسلة عبر واتساب أو تيليجرام.",
  "config_business_google_maps_url_label": "رابط خرائط Google",
  "config_business_google_maps_url_placeholder": "https://maps.app.goo.gl/…",
  "config_business_maps_resolving": "جارٍ قراءة الإحداثيات من الرابط…",
  "config_business_maps_resolved": "تم تعبئة الإحداثيات من الرابط",
  "config_business_maps_not_found": "لم يتم العثور على إحداثيات في هذا الرابط",
  "config_business_maps_error": "تعذّر قراءة الرابط — أدخِل الإحداثيات يدويًا",
  "config_business_landmark_label": "معلم بارز / إرشادات الوصول",
  "config_business_landmark_placeholder": "بالقرب من معلم معروف",
  "config_business_floor_unit_label": "الدور / الوحدة",
  "config_business_floor_unit_placeholder": "رقم الدور والوحدة",
  "config_business_coordinates_label": "الإحداثيات",
  "config_business_latitude_label": "خط العرض",
  "config_business_longitude_label": "خط الطول",
  "ai_unlimited_placeholder": "غير محدود",
  "ai_system_prompts_title": "مطالبات النظام",
  "ai_system_prompts_description": "قم بتكوين مطالبات نظام الذكاء الاصطناعي لسلوك المساعد",
  "ai_assistant_prompt_label": "المساعد",
  "ai_assistant_prompt_description": "مطالبة النظام لتفاعلات المساعد العادية",
  "ai_assistant_prompt_placeholder": "أنت نظام. استخدم الأدوات المتوفرة لفحص التقاويم والفعاليات وإرسال دبابيس الموقع. ردّ بلغة رسالة المستخدم، واستخدم العربية فقط عندما تكون اللغة غير واضحة.",
  "ai_system_agent_prompt_label": "مطالبة وكيل النظام",
  "ai_system_agent_prompt_description": "مطالبة النظام لوكيل النظام مع عمليات مجمعة",
  "ai_system_agent_prompt_placeholder": "أنت وكيل نظام داخلي بعمليات مجمعة قوية. استخدم الأدوات المتوفرة لإدارة فعاليات متعددة، والاستعلام عن البيانات، وتنفيذ العمليات المجمعة بكفاءة.",
  "prompt_versions_label": "سجل الإصدارات",
  "prompt_versions_current": "الحالي",
  "prompt_versions_load_into_editor": "تحميل في المحرر",
  "prompt_versions_revert": "الرجوع إلى هذا الإصدار",
  "prompt_versions_empty": "لا توجد إصدارات محفوظة بعد",
  "prompt_versions_revert_success": "تمت استعادة إصدار المطالبة",
  "system_defaults_prompt_label": "مطالبة النظام",
  "system_defaults_prompt_description": "التعليمات التي يتبعها الذكاء الاصطناعي عند الرد على العملاء عبر واتساب أو تيليجرام أو إنستغرام.",
  "system_defaults_agent_prompt_description": "تعليمات لوكيل النظام الداخلي الذي يتعامل مع المهام المجمعة والإدارية.",
  "system_prompt_editor_placeholder": "أدخل مطالبة النظام…",
  "system_prompt_toolbar_align_center": "محاذاة للوسط",
  "system_prompt_toolbar_align_left": "محاذاة لليسار",
  "system_prompt_toolbar_align_right": "محاذاة لليمين",
  "system_prompt_toolbar_aria": "شريط أدوات تنسيق النص",
  "system_prompt_toolbar_blockquote": "اقتباس",
  "system_prompt_toolbar_bold": "غامق",
  "system_prompt_toolbar_bullet_list": "قائمة نقطية",
  "system_prompt_toolbar_code_block": "كتلة تعليمات برمجية",
  "system_prompt_toolbar_heading": "نمط العنوان",
  "system_prompt_toolbar_inline_code": "تعليمات برمجية ضمن السطر",
  "system_prompt_toolbar_italic": "مائل",
  "system_prompt_toolbar_ordered_list": "قائمة مرقمة",
  "system_prompt_toolbar_redo": "إعادة",
  "system_prompt_toolbar_scroll_left": "تمرير شريط الأدوات لليسار",
  "system_prompt_toolbar_scroll_right": "تمرير شريط الأدوات لليمين",
  "system_prompt_toolbar_strike": "يتوسطه خط",
  "system_prompt_toolbar_task_list": "قائمة مهام",
  "system_prompt_toolbar_underline": "تحته خط",
  "system_prompt_toolbar_undo": "تراجع",
  "event_notes_button_label": "ملاحظات",
  "event_notes_button_unsaved": "احفظ الموعد أولًا لإضافة الملاحظات",
  "event_notes_dialog_title": "ملاحظات الموعد",
  "event_notes_dialog_description": "ملاحظات حرة وحقول منظمة ولوحة رسم محفوظة مع هذا الموعد.",
  "event_notes_tab_text": "ملاحظات",
  "event_notes_tab_fields": "حقول",
  "event_notes_tab_canvas": "لوحة",
  "event_notes_text_placeholder": "اكتب ملاحظات حول هذا الموعد…",
  "event_notes_fields_empty": "لا توجد حقول بعد. أضف أزواج مفتاح-قيمة لتنظيم ملاحظاتك.",
  "event_notes_field_key_placeholder": "المفتاح",
  "event_notes_field_value_placeholder": "القيمة",
  "event_notes_add_field": "إضافة حقل",
  "event_notes_additional_fields": "حقول إضافية",
  "event_notes_remove_field": "إزالة الحقل",
  "column_select_placeholder": "اختر…",
  "event_notes_cancel": "إلغاء",
  "event_notes_save": "حفظ الملاحظات",
  "event_notes_saved": "تم حفظ الملاحظات",
  "event_notes_save_failed": "تعذر حفظ الملاحظات",
  "event_notes_load_failed": "تعذر تحميل الملاحظات",
  "system_prompt_export_docx_failed": "تعذر تصدير المطالبة بصيغة DOCX",
  "system_prompt_import_failed": "تعذر استيراد الملف",
  "system_prompt_drop_failed": "تعذر تحميل الملف المُسقَط",
  "system_prompt_stats_words": "{{count}} كلمة",
  "system_prompt_stats_tokens": "~{{count}} رمز",
  "system_prompt_stats_tokens_tooltip": "عدد تقريبي للرموز (tokens). مُجزّئ Claude الدقيق غير مُعلَن، لذا هذه قيمة تقديرية — النصوص كثيفة الحروف مثل العربية تستهلك رموزًا أكثر لكل حرف.",
  "reasoning_effort_label": "مستوى التفكير",
  "reasoning_effort_tip": "يتحكم في مقدار تفكير الذكاء الاصطناعي قبل الرد. أعلى = جودة أفضل لكن أبطأ وأغلى.",
  "verbosity_label": "الإسهاب",
  "verbosity_tip": "يتحكم في مدى تفصيل وطول ردود الذكاء الاصطناعي.",
  "max_output_tokens_label": "الحد الأقصى لرموز الإخراج",
  "max_output_tokens_tip": "العدد الأقصى للرموز (~كلمات) التي يمكن للذكاء الاصطناعي توليدها لكل رد. اتركه فارغًا للقيمة الافتراضية للنموذج. أعلى = ردود محتملة أطول لكن تكلفة أكثر.",
  "max_output_tokens_default_placeholder": "افتراضي",
  "model_filter_active": "الفلاتر النشطة",
  "model_selector_search_placeholder": "البحث عن نماذج",
  "location_picker_trigger_label": "اختيار الموقع",
  "location_picker_aria_trigger": "اختر الموقع على الخريطة",
  "location_picker_title": "اختيار الموقع",
  "location_picker_description": "ابحث، أو انقر على الخريطة، أو اسحب العلامة لتحديد موقع.",
  "location_picker_close_dialog": "إغلاق الحوار",
  "location_picker_search_aria": "البحث عن موقع",
  "location_picker_search_placeholder": "ابحث عن مدينة أو عنوان أو مكان",
  "location_picker_searching": "جارٍ البحث…",
  "location_picker_map_load_error": "فشل تحميل مكوّن الخريطة",
  "location_picker_try_refresh": "يرجى محاولة تحديث الصفحة",
  "rag_documents_title": "مستندات قاعدة المعرفة",
  "rag_documents_description": "قم برفع المستندات ليبحث فيها الذكاء الاصطناعي ويرجع إليها.",
  "rag_failure_processing": "تعذّرت معالجة الملف. أعد المحاولة، أو تواصل مع الدعم إذا تكرر الخطأ.",
  "rag_failure_corrupt_file": "تعذّرت قراءة الملف وقد يكون تالفًا. صدّره من جديد ثم ارفعه مرة أخرى.",
  "rag_failure_unsupported_format": "لا يمكن معالجة هذا النوع من الملفات.",
  "rag_failure_empty_text": "لم يُعثر على نص مقروء في هذا الملف. إذا كان صورة ممسوحة ضوئيًا، فارفع نسخة أوضح.",
  "rag_failure_duplicate": "محتوى هذا الملف موجود بالفعل في قاعدة المعرفة.",
  "rag_upload_dropzone_aria": "منطقة إسقاط رفع المستندات",
  "rag_delete_document_title": "حذف المستند",
  "rag_delete_document_description": "هل أنت متأكد أنك تريد حذف \"{{filename}}\"؟ سيؤدي ذلك إلى إزالة جميع الأجزاء المفهرسة ولا يمكن التراجع عنه.",
  "rag_loading_documents": "جارٍ تحميل المستندات…",
  "rag_settings_title": "إعدادات البحث",
  "rag_settings_description": "قم بتكوين نموذج التضمين وعتبة البحث لبحث المستندات",
  "rag_search_threshold_label": "عتبة البحث",
  "rag_search_threshold_tip": "الحد الأدنى لدرجة التشابه التي يجب أن تصل إليها الوثيقة لإرجاعها. أقل = نتائج أكثر لكن أقل دقة، أعلى = نتائج أقل لكن أكثر صلة.",
  "rag_threshold_more_results": "نتائج أكثر",
  "rag_threshold_stricter_matching": "مطابقة أكثر صرامة",
  "rag_embedding_model_label": "نموذج التضمين",
  "rag_embedding_model_description": "يتطلب تغيير النموذج إعادة تضمين جميع المستندات",
  "rag_embedding_model_multilingual_hint": "النموذج الافتراضي bge-m3 متعدد اللغات ويتعامل مع العربية والإنجليزية بكفاءة.",
  "rag_embedding_model_search_placeholder": "البحث في نماذج التضمين…",
  "rag_embedding_model_none_available": "لا توجد نماذج تضمين متاحة",
  "rag_embedding_model_no_matches": "لا توجد نماذج تطابق بحثك",
  "rag_option_recommended": "موصى به",
  "rag_option_coming_soon": "قريبًا",
  "rag_embedding_strategy_label": "استراتيجية التضمين",
  "rag_embedding_strategy_tip": "يتحكم في كيفية تضمين أجزاء المستندات. يضيف التضمين السياقي سياقًا مُولَّدًا بواسطة نموذج اللغة الكبير إلى كل جزء لدقة استرجاع أفضل.",
  "rag_embedding_strategy_standard_label": "قياسي",
  "rag_embedding_strategy_standard_description": "تضمين مباشر. سريع ورخيص.",
  "rag_embedding_strategy_contextual_label": "سياقي",
  "rag_embedding_strategy_contextual_description": "يحسّن الاسترجاع بإضافة سياق مُولَّد بواسطة نموذج اللغة الكبير إلى كل جزء قبل التضمين (الاسترجاع السياقي من Anthropic). أكثر دقة لكن أبطأ وأغلى أثناء الاستيعاب.",
  "rag_embedding_strategy_late_label": "التقطيع المتأخر",
  "rag_embedding_strategy_late_description": "يضمّن النافذة كاملةً أولاً ثم يحسب متوسط تضمين كل جزء (التقطيع المتأخر من Jina). قوي مع المستندات الطويلة أو غير المنظمة وبدون تكلفة نموذج لغوي. يتطلب مفتاح Jina API مُهيّأً.",
  "rag_strategy_dialog_title": "استراتيجية المعالجة",
  "rag_strategy_dialog_description": "اختر طريقة تضمين {{filename}}. يعيد التبديل تضمين الأجزاء الحالية دون إعادة تحليل المستند. الأرقام تقديرية وليست رسومًا نهائية؛ يظهر الاستهلاك الفعلي في مقاييس استخدام الذكاء الاصطناعي.",
  "rag_strategy_current_badge": "الحالية",
  "rag_strategy_apply": "تطبيق الاستراتيجية",
  "rag_strategy_late_unavailable": "يتطلب مفتاح Jina API مُهيّأً.",
  "rag_strategy_estimated_caption": "تقديري",
  "rag_strategy_estimated_range_caption": "نطاق تقديري",
  "rag_strategy_chunks_caption": "{{count}} جزء",
  "rag_strategy_time_seconds": "~{{value}} ثانية",
  "rag_strategy_time_minutes": "~{{value}} دقيقة",
  "rag_strategy_estimate_loading": "جارٍ تقدير التكلفة…",
  "rag_strategy_estimate_error": "تعذّر تقدير تكلفة المعالجة. حاول مرة أخرى.",
  "rag_strategy_processing_note": "هذا المستند قيد المعالجة — انتظر حتى ينتهي لتبديل استراتيجيته.",
  "rag_strategy_preview_note": "التقديرات معاينات وليست رسومًا نهائية. يظهر الاستهلاك الفعلي في مقاييس استخدام الذكاء الاصطناعي.",
  "rag_upload_estimate_title": "تكلفة المعالجة التقديرية",
  "rag_upload_estimate_description": "تكلفة تقريبية لتضمين {{count}} ملف/ملفات قبل الرفع.",
  "rag_upload_estimate_note": "تُطبَّق استراتيجية مؤسستك الافتراضية عند الرفع. يمكنك تبديل استراتيجية أي مستند لاحقًا من نافذة استراتيجية المعالجة.",
  "rag_upload_estimate_confirm": "رفع",
  "rag_reranking_label": "إعادة الترتيب",
  "rag_reranking_tip": "عند التمكين، يقوم مُشفِّر متقاطع بإعادة تسجيل نتائج البحث لزيادة الصلة مقابل زمن انتقال إضافي.",
  "rag_saved_queries_enabled_label": "استعلامات جاهزة",
  "rag_saved_queries_enabled_description": "اسمح للمساعد بالإجابة عن الأسئلة الرقمية حول جداولك باستخدام استعلامات محفوظة ومعتمدة مسبقًا تديرها لكل مستند.",
  "rag_saved_queries_only_label": "السماح بالاستعلامات الجاهزة فقط",
  "rag_saved_queries_only_description": "أوقف استعلامات البيانات الحرة بحيث لا يستطيع المساعد سوى تشغيل الاستعلامات الجاهزة التي اعتمدتها.",
  "rag_saved_queries_dialog_title": "الاستعلامات الجاهزة",
  "rag_saved_queries_dialog_description": "استعلامات محفوظة يمكن للمساعد تشغيلها على {filename}.",
  "rag_saved_queries_empty": "لا توجد استعلامات جاهزة بعد.",
  "rag_saved_queries_generate_placeholder": "صف سؤالاً بلغة بسيطة، مثل: إجمالي الطلبات حسب الدولة",
  "rag_saved_queries_generate_button": "إنشاء استعلام",
  "rag_saved_queries_generating": "جارٍ الإنشاء…",
  "rag_saved_queries_generate_failed": "تعذّر إنشاء استعلام. حاول إعادة الصياغة.",
  "rag_saved_queries_dry_run_ok": "نجح التشغيل التجريبي",
  "rag_saved_queries_dry_run_failed": "فشل التشغيل التجريبي",
  "rag_saved_queries_save_button": "حفظ الاستعلام",
  "rag_saved_queries_saved": "تم حفظ الاستعلام الجاهز",
  "rag_saved_queries_save_failed": "تعذّر حفظ الاستعلام.",
  "rag_saved_queries_deleted": "تمت إزالة الاستعلام",
  "rag_saved_queries_delete_aria": "حذف الاستعلام المحفوظ",
  "rag_saved_queries_error": "حدث خطأ ما",
  "rag_reranking_off_label": "معطل",
  "rag_reranking_off_description": "يتم ترتيب النتائج بدرجة البحث الهجين فقط.",
  "rag_reranking_on_label": "ممكّن",
  "rag_reranking_on_description": "يعيد المُشفِّر المتقاطع ترتيب النتائج لمطابقة أعلى. يضيف ~200 مللي ثانية لكل بحث.",
  "rag_reranking_automatic_label": "تلقائي",
  "rag_reranking_automatic_description": "يقرر النظام لكل استعلام ما إذا كان سيعيد الترتيب، موازنًا بين الصلة وزمن الانتقال.",
  "rag_change_embedding_model_title": "تغيير نموذج التضمين",
  "rag_change_embedding_model_confirm": "تأكيد التغيير",
  "rag_change_embedding_model_description_intro": "يتطلب تغيير نموذج التضمين إعادة معالجة جميع المستندات. عندما تحفظ الإعدادات، سيحدث التالي:",
  "rag_change_embedding_model_bullet_reembed": "إعادة تضمين جميع المستندات بالنموذج الجديد",
  "rag_change_embedding_model_bullet_progress": "سيتم عرض التقدم في الوقت الفعلي",
  "rag_change_embedding_model_search_available": "يبقى البحث متاحًا أثناء إعادة التضمين.",
  "rag_model_switch_estimate_documents": "المستندات",
  "rag_model_switch_estimate_chunks": "الأجزاء",
  "rag_model_switch_estimate_qa": "أزواج الأسئلة والأجوبة",
  "rag_model_switch_estimate_cost": "التكلفة التقديرية",
  "rag_model_switch_estimate_duration": "الوقت التقديري",
  "rag_model_switch_estimate_loading": "جارٍ تقدير التكلفة…",
  "rag_model_switch_estimate_failed": "لا يمكن استخدام هذا النموذج مع تخزين قاعدة المعرفة الحالي. اختر نموذج تضمين آخر.",
  "rag_model_switch_estimate_disclaimer": "تكلفة التضمين التقديرية — قد يختلف الاستهلاك الفعلي.",
  "rag_model_switch_progress_title": "إعادة تضمين المعرفة",
  "rag_model_switch_progress_count": "{{done}} من {{total}}",
  "rag_model_switch_progress_hint": "يبقى البحث متاحًا أثناء إعادة تضمين المستندات.",
  "rag_demo_search_placeholder": "استعلام بحث تجريبي…",
  "whatsapp_config_title": "صلاحيات أدوات قنوات العملاء",
  "whatsapp_config_description": "تحكّم في الأدوات التي يستخدمها الذكاء الاصطناعي عبر واتساب وتيليجرام وإنستغرام",
  "whatsapp_test_button": "اختبار تكوين واجهة برمجة واتساب",
  "whatsapp_testing": "جارٍ الاختبار…",
  "whatsapp_test_passed": "نجح اختبار تكوين واجهة برمجة واتساب",
  "whatsapp_test_failed": "فشل اختبار تكوين واجهة برمجة واتساب",
  "whatsapp_test_error": "فشل اختبار تكوين واتساب",
  "whatsapp_unexpected_error": "حدث خطأ غير متوقع",
  "whatsapp_result_passed": "نجح اختبار التكوين",
  "whatsapp_result_failed": "فشل اختبار التكوين",
  "config_nav_channels": "القنوات",
  "cfgpage_section_channels_description": "اختبر اتصال قنوات المراسلة التي يرد عليها مساعدك.",
  "channels_card_description": "تحقق بأمان من بيانات اعتماد {{channel}} المحفوظة لدى المزوّد. لا يتم عرض القيم السرية مطلقًا.",
  "channels_test_button": "اختبار الاتصال",
  "channels_testing": "جارٍ الاختبار…",
  "channels_result_passed": "نجح اختبار الاتصال",
  "channels_result_failed": "فشل اختبار الاتصال",
  "channels_test_error": "تعذّر اختبار الاتصال",
  "channels_not_configured": "لم تُضبط أسرار {{channel}} بالكامل.",
  "channels_not_configured_fields": "لم تُضبط أسرار {{channel}} بالكامل. المفقود: {{fields}}.",
  "notification_rule_untitled": "قاعدة بدون عنوان",
  "notification_rule_delete": "حذف قاعدة الإشعارات",
  "notification_select_template": "اختر قالبًا…",
  "notification_select_variable": "اختر متغيرًا…",
  "notification_no_variables": "لم يتم العثور على متغيرات",
  "notification_map_variables_reminder": "قم بربط جميع المتغيرات للحفظ",
  "notification_variable_mapping_label": "ربط المتغيرات",
  "event_type_filter_search": "ابحث في أنواع الفعاليات…",
  "event_type_filter_empty": "لم يتم العثور على أنواع فعاليات",
  "numeric_range_min_label": "أدنى",
  "numeric_range_max_label": "أقصى",
  "numeric_range_step_label": "الخطوة",
  "numeric_range_step_tip": "الزيادة بين القيم في منتقي العجلة (مثل خطوة=5 تعطي 0، 5، 10…).",
  "numeric_range_invalid_short": "غير صالح",
  "numeric_range_invalid_suffix": "(غير صالح)",
  "column_data_type_text": "نص",
  "column_data_type_name": "اسم",
  "column_data_type_number": "رقم",
  "column_data_type_datetime": "التاريخ والوقت",
  "column_data_type_phone": "هاتف",
  "column_data_type_dropdown": "قائمة منسدلة",
  "column_data_type_boolean": "منطقي",
  "column_data_type_date": "تاريخ",
  "column_data_type_time": "وقت",
  "column_editor_mode_input_label": "إدخال من لوحة المفاتيح",
  "column_editor_mode_input_description": "إدخال قياسي من لوحة المفاتيح لكتابة القيم",
  "column_editor_mode_wheel_label": "منتقي العجلة",
  "column_editor_mode_wheel_description": "عجلة تمرير للاختيار من الخيارات أو نطاق رقمي",
  "column_editor_mode_dropdown_label": "قائمة منسدلة",
  "column_editor_mode_dropdown_description": "قائمة منسدلة للاختيار من الخيارات",
  "column_database_field_user_name": "اسم المستخدم",
  "column_database_field_user_phone": "هاتف المستخدم",
  "column_database_field_user_email": "بريد المستخدم",
  "column_database_field_user_role": "دور المستخدم",
  "column_database_field_profile_name": "اسم الملف الشخصي",
  "column_database_field_profile_age": "عمر الملف الشخصي",
  "column_database_field_preferred_language": "اللغة المفضلة",
  "column_database_field_is_favorite": "هل هو مفضل",
  "column_database_field_event_datetime": "تاريخ ووقت الفعالية",
  "column_database_field_event_end": "نهاية الفعالية",
  "column_database_field_event_type": "نوع الفعالية",
  "column_database_field_event_status": "حالة الفعالية",
  "column_database_field_custom": "مخصص (بيانات وصفية)",
  "column_database_group_user": "المستخدم",
  "column_database_group_profile": "الملف الشخصي",
  "column_database_group_event": "الفعالية",
  "column_database_group_other": "أخرى",
  "column_identifier_placeholder": "مثل: field_time_scheduled",
  "column_identifier_label": "معرف العمود *",
  "column_identifier_tip": "مفتاح فريد لهذا العمود، يُستخدم كمفتاح ترجمة i18n. تتم إزالة المسافات والنقاط.",
  "column_data_type_label": "نوع البيانات *",
  "column_data_type_tip": "يحدد كيفية تخزين قيم الخلايا والتحقق منها (مثل: نص، رقم، هاتف، تاريخ).",
  "column_data_type_placeholder": "اختر نوع البيانات",
  "column_data_type_empty": "لم يتم العثور على نوع بيانات.",
  "column_data_type_search": "ابحث في أنواع البيانات",
  "column_width_label": "العرض (بكسل) *",
  "column_width_placeholder": "100",
  "column_width_required": "العرض مطلوب",
  "column_editor_mode_label": "وضع المحرر",
  "column_editor_mode_tip": "كيف يحرر المستخدمون قيم الخلايا: إدخال من لوحة المفاتيح، أو منتقي عجلة التمرير، أو قائمة منسدلة.",
  "column_editor_mode_select_fallback": "اختر الوضع…",
  "column_database_field_label": "حقل قاعدة البيانات *",
  "column_database_field_tip": "حقل الخلفية الذي يقرأ منه ويكتب إليه هذا العمود.",
  "column_database_field_placeholder": "اختر حقل قاعدة البيانات",
  "column_database_field_empty": "لم يتم العثور على حقل قاعدة بيانات.",
  "column_database_field_search": "ابحث في حقول قاعدة البيانات",
  "column_database_field_auto": "تلقائي",
  "column_database_field_missing": "مطلوب - اختر حقل قاعدة بيانات",
  "column_database_field_mismatch": "عدم تطابق نوع الحقل - فكر في تغيير نوع البيانات",
  "column_numeric_range_description": "حدد النطاق لمنتقي العجلة الرقمي",
  "column_section_configuration": "التكوين",
  "column_section_data_source": "مصدر البيانات",
  "column_section_numeric_range": "النطاق الرقمي",
  "column_section_dropdown_options": "خيارات القائمة المنسدلة",
  "column_section_name_parts": "متطلبات الاسم",
  "column_name_parts_label": "أجزاء الاسم المطلوبة",
  "column_name_parts_tip": "اختر ما إذا كان الاسم يجب أن يتضمن الاسم الأول والأخير، أو الاسم الأول والأوسط والأخير.",
  "column_name_parts_two": "الأول + الأخير",
  "column_name_parts_three": "الأول + الأوسط + الأخير",
  "column_name_parts_description": "يحدد الحد الأدنى لعدد أجزاء الاسم المقبولة في هذا العمود.",
  "column_dropdown_options_empty": "لا توجد خيارات بعد — أضف واحدًا لتفعيل التحديد.",
  "column_dropdown_options_placeholder": "قيمة الخيار (مثل: appt_checkup)",
  "column_dropdown_options_add": "إضافة خيار",
  "column_dropdown_options_remove": "إزالة الخيار",
  "column_dropdown_options_drag": "اسحب لإعادة ترتيب الخيار",
  "column_dropdown_options_event_type_hint": "يتم ملؤها تلقائيًا من أنواع الأحداث — قم بتحريرها في قسم الجدولة.",
  "column_dropdown_options_event_type_empty": "لا توجد أنواع أحداث معرفة بعد.",
  "column_missing_fields_prefix": "مفقود:",
  "column_empty_state": "لم يتم تكوين أعمدة بعد.",
  "column_add_button": "إضافة عمود",
  "column_derived_title": "من أنواع الفعاليات",
  "column_derived_description": "يعرض الجدول أيضًا عمودًا لكل حقل مخصص في نوع الفعالية. عدّلها من أنواع الفعاليات ← الحقول المخصصة.",
  "column_derived_manage": "أنواع الفعاليات",
  "column_documents_max_reached": "نموذج المستندات محدود بأربعة حقول.",
  "column_toggle_editable": "قابل للتحرير",
  "column_toggle_required": "مطلوب",
  "column_required_field": "مطلوب",
  "column_delete_button": "حذف العمود",
  "column_drag_to_reorder_format": "اسحب لإعادة ترتيب العمود {{n}}",
  "column_label_format": "العمود {{n}}: {{title}}",
  "column_fallback_name": "العمود {{n}}",
  "config_timezone_label": "المنطقة الزمنية",
  "config_timezone_description": "يحدد فترات التقويم والطوابع الزمنية واستجابات الذكاء الاصطناعي.",
  "config_timezone_tip_extended": "يؤثر على أوقات فترات التقويم وطوابع المستندات الزمنية وكيفية إبلاغ الذكاء الاصطناعي بالتواريخ والأوقات.",
  "config_default_country_label": "الدولة الافتراضية",
  "config_default_country_prefix_tip": "يختار مسبقًا علم الدولة ورمز الاتصال في جميع حقول أرقام الهواتف.",
  "config_regional_settings_title": "الإعدادات الإقليمية",
  "config_regional_settings_description": "قم بتكوين المنطقة الزمنية والدولة الافتراضية لعملك",
  "config_system_defaults_title": "الإعدادات الافتراضية للنظام",
  "config_system_defaults_description": "قم بتكوين المنطقة الزمنية وبادئة الدولة وتفضيلات نموذج الذكاء الاصطناعي",
  "model_filter_badge_author": "المؤلف",
  "model_filter_badge_variant": "النوع",
  "model_filter_badge_provider": "المزود",
  "model_filter_badge_param": "معامل",
  "rag_status_pending": "قيد الانتظار",
  "rag_status_processing": "قيد المعالجة",
  "rag_status_completed": "مكتمل",
  "rag_status_failed": "فشل",
  "rag_doc_toggle_disable": "تعطيل المستند",
  "rag_doc_toggle_enable": "تفعيل المستند",
  "rag_doc_disabled_badge": "معطل",
  "rag_sensitive_badge": "حساس",
  "rag_sensitive_badge_tooltip": "يحتوي على بيانات حساسة: {{types}}",
  "rag_sensitive_type_card": "أرقام بطاقات",
  "rag_sensitive_type_iban": "أرقام آيبان",
  "rag_sensitive_type_national_id": "أرقام الهوية الوطنية",
  "rag_embedding_model_select_placeholder": "اختر نموذجًا…",
  "rag_embedding_model_count": "نماذج",
  "location_picker_tile_street": "شارع",
  "location_picker_tile_satellite": "قمر صناعي",
  "location_picker_tile_terrain": "تضاريس",
  "location_picker_tile_dark": "داكن",
  "location_picker_change_map_style": "تغيير نمط الخريطة",
  "location_picker_find_my_location": "العثور على موقعي",
  "location_picker_tile_roadmap": "خريطة",
  "location_picker_tile_hybrid": "مختلط",
  "location_picker_maps_not_configured": "الخريطة غير متاحة",
  "location_picker_maps_not_configured_hint": "أدخل الإحداثيات يدويًا، أو الصق رابط خرائط جوجل.",
  "location_picker_geolocation_unsupported": "المتصفح لا يدعم تحديد الموقع الجغرافي.",
  "location_picker_geolocation_denied": "تعذّر تحديد موقعك. يرجى تفعيل الوصول إلى الموقع والمحاولة مرة أخرى.",
  "config_reset_defaults_button": "إعادة التعيين إلى الافتراضيات",
  "config_reset_defaults_title": "إعادة التعيين إلى الافتراضيات",
  "config_reset_defaults_description_prefix": "سيؤدي ذلك إلى إعادة تعيين جميع الحقول إلى قيمها الافتراضية. يمكنك مراجعة التغييرات والضغط على",
  "config_reset_defaults_save_label": "حفظ",
  "config_reset_defaults_description_middle": " لتطبيقها، أو ",
  "config_reset_defaults_discard_label": "إلغاء",
  "config_reset_defaults_description_suffix": " للإلغاء.",
  "notif_reply": "رد",
  "notif_dismiss": "تجاهل",
  "notification_view_event": "عرض الحجز",
  "notification_view_vacation": "عرض الإجازة",
  "notif_panel_title": "الإشعارات",
  "notif_mark_all_read": "تحديد الكل كمقروء",
  "notif_filter_all": "الكل",
  "notif_filter_unread": "غير المقروءة",
  "notif_filter_by_type": "تصفية حسب النوع",
  "notif_type_all": "كل الأنواع",
  "notif_type_messages": "الرسائل",
  "notif_type_events": "المواعيد",
  "notif_section_today": "اليوم",
  "notif_section_earlier": "سابقًا",
  "notif_see_all_activity": "عرض كل النشاط ←",
  "notif_empty_state": "أنت على اطلاع!",
  "notif_loading_more": "جارٍ تحميل المزيد…",
  "notif_end_of_list": "وصلت إلى النهاية",
  "tours_skip": "تخطي",
  "tours_back": "رجوع",
  "tours_next": "التالي",
  "tours_get_started": "هيا نبدأ",
  "tours_step_aria_label": "الخطوة {n}",
  "tours_calendar_welcome_badge": "مرحبًا",
  "tours_calendar_welcome_title": "تقويم لا يقف في طريقك.",
  "tours_calendar_welcome_body": "حجوزاتك ومحادثاتك ووكيل الذكاء الاصطناعي، كلها في مكان واحد هادئ. خذ جولة سريعة لترى ما هو هنا.",
  "tours_calendar_chat_badge": "الخطوة 1",
  "tours_calendar_chat_title": "تواصل مع جميع عملائك في صندوق وارد واحد.",
  "tours_calendar_chat_body": "يجمع الشريط الجانبي للمحادثات رسائل واتساب وتيليجرام وإنستغرام والدردشة على الويب بجوار التقويم، فترد دون أن تغادر الصفحة.",
  "tours_calendar_calendar_badge": "الخطوة 2",
  "tours_calendar_calendar_title": "تقويم يتكيف مع طريقتك في العمل.",
  "tours_calendar_calendar_body": "اسحب وأفلت وغيّر حجم الأحداث. تنقّل بين عرض اليوم والأسبوع والشهر، وتُحفظ تغييراتك فورًا.",
  "tours_calendar_agent_badge": "الخطوة 3",
  "tours_calendar_agent_title": "اترك الوكيل الذكي يتولى المهام الروتينية.",
  "tours_calendar_agent_body": "اطلب منه بلغتك الطبيعية، فيحجز ويعيد جدولة المواعيد ويرد على عملائك، مع سجل واضح بكل ما قام به.",
  "tours_calendar_grid_badge": "الخطوة 4",
  "tours_calendar_grid_title": "عرض جدول بيانات للتعديل بالجملة.",
  "tours_calendar_grid_body": "انتقل إلى عرض الجدول للحصول على واجهة سريعة بلوحة المفاتيح لكل العملاء والأحداث. تتزامن التعديلات مع التقويم مباشرة.",
  "tours_documents_welcome_badge": "مرحبًا",
  "tours_documents_welcome_title": "كل ما تحتاجه لتعلّم Bavard في مكان واحد.",
  "tours_documents_welcome_body": "أدلة ومراجع وعروض حية، صُمّمت لتطلق منتجك أسرع. هذه جولة سريعة في ما حولك.",
  "tours_documents_browse_badge": "الخطوة 1",
  "tours_documents_browse_title": "تصفّح حسب الموضوع، وانتقل إلى أي مكان.",
  "tours_documents_browse_body": "يجمع الشريط الجانبي كل الأدلة حسب القسم. اضغط على قسم لتوسيعه، والعنصر المُبرز هو موقعك الحالي دائمًا.",
  "tours_documents_search_badge": "الخطوة 2",
  "tours_documents_search_title": "اعثر على أي شيء بضغطة أو اثنتين.",
  "tours_documents_search_body": "استخدم مربع البحث في الأعلى للبحث الذكي في كل الصفحات. تظهر النتائج بشكل فوري دون أن تفقد مكانك.",
  "tours_documents_grid_badge": "الخطوة 3",
  "tours_documents_grid_title": "عروض حية يمكنك التفاعل معها.",
  "tours_documents_grid_body": "تتضمن صفحات كثيرة عروضًا حية وتفاعلية، بما فيها جدول البيانات، لتجرّب الميزات قبل دمجها.",
  "tours_documents_pages_badge": "الخطوة 4",
  "tours_documents_pages_title": "كل دليل، بلغتك.",
  "tours_documents_pages_body": "بدّل اللغة من زر التبديل في الشريط العلوي. نترجم الأدلة لتتعلّم باللغة التي تفكّر بها.",
  "tours_dashboard_welcome_badge": "مرحبًا",
  "tours_dashboard_welcome_title": "أرقامك أخيرًا في عرض واحد.",
  "tours_dashboard_welcome_body": "مؤشرات الأداء والاتجاهات وتحليلات المحادثات لمؤسستك بالكامل. خذ جولة سريعة على مكان كل منها.",
  "tours_dashboard_overview_badge": "الخطوة 1",
  "tours_dashboard_overview_title": "أهم المؤشرات في لمحة.",
  "tours_dashboard_overview_body": "تعرض علامة النظرة العامة أبرز مقاييسك من حجوزات وأوقات استجابة وعملاء نشطين، في بطاقات تقرأها في ثوانٍ.",
  "tours_dashboard_trends_badge": "الخطوة 2",
  "tours_dashboard_trends_title": "اطّلع على شكل أسبوعك.",
  "tours_dashboard_trends_body": "ترسم علامة الاتجاهات نشاطك عبر الزمن لتلتقط النمو والانخفاضات والأنماط قبل أن تفاجئك.",
  "tours_dashboard_messages_badge": "الخطوة 3",
  "tours_dashboard_messages_title": "افهم كل محادثة.",
  "tours_dashboard_messages_body": "تحلّل علامة الرسائل الحجم والطول والكلمات الأكثر استخدامًا من قبل عملائك، عبر كل القنوات.",
  "tours_dashboard_insights_badge": "الخطوة 4",
  "tours_dashboard_insights_title": "حوّل البيانات إلى قرارات.",
  "tours_dashboard_insights_body": "تُبرز الرؤى وملخصات الملاحظات ما ينجح وما لا ينجح وما يستحق التجربة، مدعومة ببياناتك الحقيقية.",
  "uploads_cancel": "إلغاء الرفع",
  "uploads_uploading": "جارٍ الرفع…",
  "uploads_failed": "فشل الرفع",
  "uploads_retry": "إعادة محاولة الرفع",
  "uploads_retry_all": "إعادة محاولة الكل",
  "user_menu_dashboard": "لوحة التحكم",
  "user_menu_account_settings": "إعدادات الحساب",
  "user_menu_billing": "الفوترة",
  "user_menu_app_configuration": "إعدادات التطبيق",
  "user_menu_admin_dashboard": "لوحة الإدارة",
  "user_menu_playground": "ساحة التجريب",
  "user_menu_sign_out": "تسجيل الخروج",
  "user_menu_org_overview": "نظرة عامة",
  "user_menu_section_account": "الحساب",
  "user_menu_section_organization": "المؤسسة",
  "user_menu_section_administration": "الإدارة",
  "user_menu_section_support": "الدعم",
  "admin_tabs_members": "الأعضاء",
  "account_page_title": "إعدادات الحساب",
  "account_page_description": "أدِر بيانات اعتمادك وجلساتك وتفضيلاتك الشخصية.",
  "account_nav_group_security": "الأمان",
  "account_nav_group_personal": "شخصي",
  "account_nav_credentials_sessions": "بيانات الاعتماد والجلسات",
  "account_nav_profile": "الملف الشخصي",
  "account_nav_notifications": "الإشعارات",
  "account_nav_appearance": "المظهر",
  "account_appearance_title": "المظهر",
  "account_appearance_description": "خصص شكل التطبيق ومظهره — لون السمة، والوضع الفاتح أو الداكن، ونمط المكونات. تُطبَّق التغييرات فوراً وترافقك عبر أجهزتك.",
  "account_demo_locked_hint": "للعرض فقط في النسخة التجريبية — يتطلب هذا حساباً حقيقياً. أنشئ حساباً لتغيير كلمة المرور، أو إضافة مفتاح مرور، أو ربط مزوّد، أو حذف حسابك.",
  "account_credentials_sessions_title": "بيانات الاعتماد والجلسات",
  "account_credentials_sessions_description": "راجع طريقة تسجيل الدخول والأجهزة التي يمكنها الوصول إلى حسابك.",
  "account_sessions_title": "الجلسات النشطة",
  "account_sessions_subtitle_loading": "جارٍ تحميل الأجهزة النشطة…",
  "account_sessions_subtitle": "{{count}} أجهزة · جلسة واحدة الآن",
  "account_sessions_sign_out_others": "تسجيل الخروج من كل الأجهزة",
  "account_sessions_load_error": "تعذّر تحميل جلساتك.",
  "account_sessions_retry": "إعادة المحاولة",
  "account_sessions_confirm_others_title": "تسجيل الخروج من الأجهزة الأخرى؟",
  "account_sessions_confirm_others_body": "سيؤدي هذا إلى إنهاء جلستك على {{count}} من الأجهزة الأخرى. ستظل مسجّل الدخول هنا.",
  "account_sessions_confirm_cancel": "إلغاء",
  "account_sessions_confirm_others_button": "تسجيل الخروج من كل الأجهزة",
  "account_session_this_device": "هذا الجهاز",
  "account_session_sign_out": "تسجيل الخروج",
  "account_session_signing_out": "جارٍ تسجيل الخروج…",
  "account_session_current_action_label": "الجهاز الحالي — لا يوجد إجراء",
  "account_session_ip_unknown": "عنوان IP غير معروف",
  "account_session_revoke_success": "تم تسجيل الخروج من الجلسة.",
  "account_session_revoke_failed": "تعذّر تسجيل الخروج من تلك الجلسة.",
  "account_session_revoke_others_success": "تم تسجيل الخروج من جميع الأجهزة الأخرى.",
  "account_session_revoke_others_failed": "تعذّر تسجيل الخروج من الجلسات الأخرى.",
  "account_passkeys_title": "مفاتيح المرور ومفاتيح الأمان",
  "account_passkeys_subtitle": "تخطّ كلمة المرور — سجّل الدخول بجهازك أو بمفتاح مادي.",
  "account_passkeys_add": "إضافة مفتاح مرور",
  "account_passkeys_adding": "جارٍ الإضافة…",
  "account_passkeys_empty_title": "لا توجد مفاتيح مرور بعد",
  "account_passkeys_empty_body": "أضف واحداً لتخطّي كلمة المرور — سجّل الدخول فوراً بـ Touch ID أو Windows Hello أو مفتاح أمان.",
  "account_passkeys_loading": "جارٍ تحميل مفاتيح المرور…",
  "account_passkeys_error": "تعذّر تحميل مفاتيح المرور.",
  "account_passkeys_retry": "إعادة المحاولة",
  "account_passkeys_remove": "إزالة",
  "account_passkeys_default_name": "مفتاح مرور",
  "account_passkeys_added_at": "أُضيف {{date}}",
  "account_passkeys_add_success": "تمت إضافة مفتاح المرور.",
  "account_passkeys_add_failed": "تعذّرت إضافة مفتاح المرور.",
  "account_passkeys_remove_success": "تمت إزالة مفتاح المرور.",
  "account_passkeys_remove_failed": "تعذّرت إزالة مفتاح المرور.",
  "account_passkeys_remove_confirm_title": "إزالة هذا المفتاح؟",
  "account_passkeys_remove_confirm_body": "لن تتمكّن من تسجيل الدخول بهذا الجهاز أو مفتاح الأمان بعد الآن. يمكنك إضافته مجدداً في أي وقت.",
  "account_passkeys_remove_confirm_cancel": "إلغاء",
  "account_passkeys_remove_confirm_action": "إزالة المفتاح",
  "account_connected_title": "الحسابات المرتبطة",
  "account_connected_subtitle": "اربط حسابًا خارجيًا لتسجيل الدخول دون كلمة مرور.",
  "account_connected_connect": "ربط",
  "account_connected_connecting": "جارٍ الربط…",
  "account_connected_connect_failed": "تعذّر بدء الربط.",
  "account_connected_disconnect": "إلغاء الربط",
  "account_connected_status_loading": "جارٍ التحقق…",
  "account_connected_status_connected": "مرتبط",
  "account_connected_status_not_connected": "غير مرتبط",
  "account_connected_error": "تعذّر تحميل الحسابات المرتبطة.",
  "account_connected_retry": "إعادة المحاولة",
  "account_connected_disconnect_success": "تم إلغاء ربط {{provider}}.",
  "account_connected_disconnect_failed": "تعذّر إلغاء ربط {{provider}}.",
  "account_connected_disconnect_confirm_title": "إلغاء ربط {{provider}}؟",
  "account_connected_disconnect_confirm_body": "لن تتمكن بعد الآن من تسجيل الدخول عبر {{provider}}. تأكد من أنه لا يزال لديك كلمة المرور أو طريقة تسجيل دخول أخرى.",
  "account_connected_disconnect_confirm_cancel": "إلغاء",
  "account_connected_disconnect_confirm_action": "إلغاء الربط",
  "account_profile_tab_title": "الملف الشخصي",
  "account_profile_tab_description": "حدّث الاسم المعروض وعنوان البريد الإلكتروني وكلمة المرور. تُطبَّق التغييرات هنا على حسابك في كل مكان.",
  "account_profile_save": "حفظ",
  "account_profile_identity_title": "الهوية",
  "account_profile_details_title": "تفاصيل الملف الشخصي",
  "account_profile_details_description": "اسمك وصورتك الرمزية وعنوان بريدك الإلكتروني.",
  "account_profile_details_avatar_label": "الصورة الشخصية",
  "account_profile_identity_description": "كيف يظهر اسمك وصورتك الرمزية في التطبيق.",
  "account_profile_identity_avatar_hint": "انقر على الصورة الرمزية أو اسحب إليها صورة. سنغيّر حجمها تلقائيّاً إلى مربّع 256×256.",
  "account_profile_identity_avatar_change": "تغيير الصورة الرمزية",
  "account_profile_identity_avatar_upload": "رفع صورة",
  "account_profile_identity_avatar_replace": "استبدال الصورة",
  "account_profile_identity_avatar_remove": "إزالة",
  "account_profile_identity_avatar_unsupported": "هذا الملف ليس بصيغة صورة مدعومة.",
  "account_profile_identity_avatar_too_large": "حجم الصورة يتجاوز 5 ميغابايت. جرّب ملفاً أصغر.",
  "account_profile_identity_avatar_decode_failed": "تعذّرت قراءة هذه الصورة. جرّب ملفاً آخر.",
  "account_profile_identity_name_label": "الاسم المعروض",
  "account_profile_identity_name_placeholder": "اسمك",
  "account_profile_identity_name_too_short": "يجب أن يحتوي الاسم على حرفين على الأقل.",
  "account_profile_identity_name_too_long": "يجب ألّا يتجاوز الاسم 50 حرفاً.",
  "account_profile_identity_image_label": "الصورة الرمزية",
  "account_profile_identity_image_placeholder": "https://example.com/avatar.png",
  "account_profile_identity_image_invalid": "الصورة الرمزية ليست صورة صالحة.",
  "account_profile_identity_save_success": "تم تحديث الملف الشخصي.",
  "account_profile_identity_save_failed": "تعذّر تحديث الملف الشخصي.",
  "account_profile_email_title": "عنوان البريد الإلكتروني",
  "account_profile_email_description": "نستخدم هذا العنوان لتسجيل الدخول واستعادة الحساب والإشعارات.",
  "account_profile_email_label": "البريد الإلكتروني",
  "account_profile_email_placeholder": "you@example.com",
  "account_profile_email_required": "البريد الإلكتروني مطلوب.",
  "account_profile_email_invalid": "أدخل بريداً إلكترونياً صالحاً.",
  "account_profile_email_verified_note": "بريدك الحالي موثَّق. تأكيد التغيير يتطلّب رابط تحقق يُرسَل إلى عنوانك الجديد.",
  "account_profile_email_save_success": "تم تحديث البريد الإلكتروني.",
  "account_profile_email_save_failed": "تعذّر تغيير البريد الإلكتروني.",
  "account_profile_email_verification_sent": "تم إرسال بريد التحقق. اضغط الرابط لتأكيد التغيير.",
  "account_profile_password_title": "كلمة المرور",
  "account_profile_password_description": "استخدم كلمة مرور قوية لا تعيد استخدامها في أي مكان آخر.",
  "account_profile_password_current_label": "كلمة المرور الحالية",
  "account_profile_password_current_hint": "تحقّق من هويتك قبل إجراء التغييرات.",
  "account_profile_password_current_required": "أدخل كلمة المرور الحالية.",
  "account_profile_password_current_invalid": "كلمة المرور الحالية غير صحيحة.",
  "account_profile_password_new_label": "كلمة المرور الجديدة",
  "account_profile_password_new_hint": "استخدم 8 أحرف على الأقل وتجنّب إعادة استخدام كلمة مرور قديمة.",
  "account_profile_password_too_short": "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل.",
  "account_profile_password_confirm_label": "تأكيد كلمة المرور الجديدة",
  "account_profile_password_confirm_required": "أكّد كلمة المرور الجديدة.",
  "account_profile_password_mismatch": "كلمتا المرور غير متطابقتين.",
  "account_profile_password_save_button": "تحديث كلمة المرور",
  "account_profile_password_save_success": "تم تغيير كلمة المرور.",
  "account_profile_password_save_failed": "تعذّر تغيير كلمة المرور.",
  "dashboard_heatmap_eyebrow": "النشاط · حجم الرسائل الأسبوعي",
  "dashboard_heatmap_axis_day": "اليوم",
  "dashboard_heatmap_axis_total": "الإجمالي",
  "dashboard_heatmap_table_label": "حجم الرسائل حسب يوم الأسبوع وساعة اليوم",
  "dashboard_heatmap_avg_label": "متوسط / ساعة",
  "dashboard_funnel_eyebrow": "قمع حجوزات المساعد · الفترة الحالية",
  "dashboard_funnel_eyebrow_prefix": "قمع حجوزات المساعد",
  "dashboard_funnel_heading": "رحلة محادثات المساعد إلى الحجز",
  "dashboard_funnel_overall_desc": "عاد {pct}% من المحادثات الواردة لحجز آخر أنشأه المساعد. الحجوزات اليدوية غير مشمولة.",
  "dashboard_funnel_baseline": "الأساس",
  "dashboard_funnel_carry": "تابَع {pct}%",
  "dashboard_funnel_kind_first_action": "أول إجراء",
  "dashboard_funnel_kind_conversion": "تحويل",
  "dashboard_funnel_kind_repeat": "تكرار",
  "dashboard_funnel_kind_exit": "خروج",
  "dashboard_funnel_kind_step": "خطوة",
  "dashboard_funnel_stat_activation": "التفعيل",
  "dashboard_funnel_stat_retention": "الاحتفاظ",
  "dashboard_funnel_stat_overall": "الإجمالي",
  "dashboard_funnel_stat_exit": "نسبة إلغاء حجوزات المساعد",
  "dashboard_funnel_stat_good": "جيد",
  "dashboard_funnel_stat_watch": "مراقبة",
  "dashboard_funnel_stat_low": "منخفض",
  "export_dialog_default_eyebrow": "تصدير",
  "export_dialog_close": "إغلاق",
  "export_dialog_cancel": "إلغاء",
  "export_dialog_export": "تصدير",
  "export_dialog_format_label": "التنسيق",
  "export_dialog_date_range_label": "النطاق الزمني",
  "export_dialog_include_label": "تضمين",
  "export_dialog_include_pii_label": "تضمين بيانات جهات الاتصال والموقع",
  "export_dialog_include_pii_warning": "سيحتوي هذا التصدير على أرقام الهواتف وعنوان النشاط وإحداثيات الخريطة — احفظ الملف وشاركه بحذر.",
  "export_dialog_estimated_size": "الحجم التقديري",
  "export_dialog_subtitle_immediate": "سيبدأ التنزيل فورًا.",
  "export_dialog_subtitle_emailed": "سنرسل إليك رابط التنزيل بالبريد الإلكتروني.",
  "export_dialog_format_csv": "CSV",
  "export_dialog_format_csv_meta": "جدول بيانات · صفوف",
  "export_dialog_format_json": "JSON",
  "export_dialog_format_json_meta": "بيانات خام مع الميتا",
  "export_dialog_format_pdf": "PDF",
  "export_dialog_format_pdf_meta": "تقرير جاهز للطباعة",
  "export_dialog_format_docx": "DOCX",
  "export_dialog_format_docx_meta": "مستند قابل للتحرير",
  "export_dialog_format_html": "HTML",
  "export_dialog_format_html_meta": "تفاعلي · أقسام قابلة للطي",
  "export_dialog_disabled_csv_nested": "الإعدادات متشعبة — التسوية في CSV غير ملائمة.",
  "export_dialog_disabled_csv_text": "كتلة نص واحدة — لا توجد صفوف للتصدير.",
  "export_dialog_chat_title_prefix": "محادثة مع",
  "export_dialog_chat_include_meta": "تضمين بيانات جهة الاتصال",
  "export_dialog_chat_include_system": "تضمين رسائل النظام",
  "export_dialog_config_title": "إعدادات مساحة العمل",
  "export_dialog_prompt_title_prefix": "موجّه الذكاء الاصطناعي ·",
  "export_dialog_toast_success": "التصدير جاهز.",
  "export_dialog_toast_failed": "فشل التصدير.",
  "export_dialog_toast_no_data": "لا يوجد ما يمكن تصديره بعد.",
  "export_dialog_dashboard_title": "تحليلات لوحة التحكم",
  "export_dialog_dashboard_include_stats": "المقاييس الموجزة",
  "export_dialog_dashboard_include_daily_trends": "الاتجاهات اليومية",
  "export_dialog_dashboard_include_type_distribution": "توزيع أنواع الأحداث",
  "export_dialog_dashboard_include_time_slots": "الخريطة الحرارية للفترات الزمنية",
  "export_dialog_dashboard_include_top_users": "أبرز المستخدمين (بيانات شخصية)",
  "export_dialog_dashboard_include_conversation": "تحليل المحادثات",
  "export_dialog_dashboard_include_message_heatmap": "خريطة الرسائل الحرارية (٢٤×٧)",
  "export_dialog_dashboard_include_word_frequency": "تكرار الكلمات (شبه شخصي)",
  "export_dialog_dashboard_include_day_of_week": "النشاط حسب يوم الأسبوع",
  "export_dialog_dashboard_include_monthly_trends": "الاتجاهات الشهرية",
  "export_dialog_dashboard_include_funnel": "قمع التحويل",
  "export_dialog_dashboard_include_user_segments": "شرائح المستخدمين",
  "export_dialog_dashboard_include_avg_events_per_type": "متوسط الأحداث لكل مستخدم حسب النوع",
  "export_dialog_dashboard_include_capture_summary": "أعداد العملاء المحتملين والتعليقات",
  "export_dialog_dashboard_include_ai_usage": "استخدام الذكاء الاصطناعي / الرموز",
  "export_dialog_dashboard_include_captured_leads": "العملاء المحتملون (بيانات شخصية)",
  "export_dialog_dashboard_include_summaries": "ملخصات المحادثات (بيانات شخصية)",
  "export_dialog_dashboard_include_feedbacks": "تعليقات العملاء (بيانات شخصية)",
  "export_dialog_purge_pii": "إزالة البيانات الشخصية",
  "export_dialog_pii_excluded": "تمت إزالة البيانات الشخصية ✓",
  "export_dialog_restore_defaults": "استعادة الإعدادات الافتراضية",
  "export_dialog_pdf_meta_exported": "تم التصدير",
  "export_dialog_pdf_meta_range": "النطاق",
  "export_dialog_pdf_section_overview": "المقاييس الرئيسية",
  "export_dialog_pdf_kpi_sub": "مقارنةً بالفترة السابقة",
  "export_dialog_pdf_subtitle": "الفترة",
  "export_dialog_pdf_sparkline_label_events": "الأحداث في اليوم",
  "export_dialog_pdf_conv_total": "إجمالي المحادثات",
  "export_dialog_pdf_conv_avg_msg": "متوسط الرسائل لكل محادثة",
  "export_dialog_pdf_conv_median_msg": "وسيط الرسائل لكل محادثة",
  "export_dialog_pdf_conv_max_msg": "أكبر عدد رسائل في محادثة",
  "export_dialog_pdf_conv_avg_resp_min": "متوسط زمن الرد",
  "export_dialog_pdf_conv_resolution": "نسبة الحل",
  "export_dialog_pdf_callout_response_title": "مؤشر زمن الاستجابة",
  "export_dialog_pdf_ai_input": "رموز الإدخال",
  "export_dialog_pdf_ai_output": "رموز الإخراج",
  "export_dialog_pdf_ai_total": "إجمالي الرموز",
  "export_dialog_pdf_ai_cost": "التكلفة",
  "export_dialog_pdf_ai_by_model": "حسب النموذج",
  "export_dialog_pdf_methodology": "المنهجية",
  "export_dialog_pdf_methodology_text": "تُحسب على جانب العميل من نطاق التواريخ النشط للوحة. تقارن الاتجاهات الفترة المحددة بفترة سابقة بنفس الطول. لا تظهر الأقسام التي تحتوي على بيانات شخصية إلا بعد تفعيلها صراحةً.",
  "insights_capture_leads": "العملاء المحتملون",
  "stat_total_events": "إجمالي الأحداث",
  "stat_upcoming_events": "الأحداث القادمة",
  "stat_cancelled_events": "الإلغاءات",
  "stat_total_users": "إجمالي المستخدمين",
  "stat_active_users": "المستخدمون النشطون",
  "stat_total_messages": "إجمالي الرسائل",
  "stat_avg_response_time": "متوسط زمن الرد",
  "stat_conversion_rate": "نسبة التحويل",
  "export_dialog_grid_title": "بيانات الجدول",
  "export_dialog_grid_column_fallback": "العمود",
  "export_dialog_grid_channel_contacts_title": "جهات اتصال القنوات",
  "export_dialog_grid_members_title": "الفريق والأعضاء",
  "export_dialog_grid_organizations_title": "المؤسسات",
  "export_dialog_summary_title_prefix": "ملخص ·",
  "export_dialog_summary_disabled_csv": "الملخص مستند مفرد — صيغة CSV غير ملائمة.",
  "command_palette_title": "لوحة الأوامر",
  "command_palette_placeholder": "ابحث عن أمر…",
  "command_palette_empty": "لا توجد أوامر مطابقة.",
  "command_palette_group_navigation": "التنقّل",
  "command_palette_group_account": "إعدادات الحساب",
  "command_palette_group_config": "إعدادات التطبيق",
  "command_palette_group_admin": "لوحة المسؤول",
  "command_palette_group_billing": "الفوترة",
  "command_palette_group_dashboard": "لوحة المعلومات",
  "command_palette_group_system": "النظام",
  "command_palette_jump_to_account_section": "الانتقال إلى قسم الحساب",
  "command_palette_jump_to_billing_section": "الانتقال إلى قسم الفوترة",
  "command_palette_jump_to_config_section": "الانتقال إلى قسم الإعدادات",
  "command_palette_open_admin_tab": "فتح علامة تبويب الإدارة",
  "command_palette_open_dashboard_tab": "فتح علامة تبويب لوحة المعلومات",
  "command_palette_nav_calendar": "التقويم",
  "command_palette_nav_dashboard": "لوحة المعلومات",
  "command_palette_nav_documents": "المستندات",
  "command_palette_nav_account": "إعدادات الحساب",
  "command_palette_nav_billing": "الفوترة",
  "command_palette_nav_config": "إعدادات التطبيق",
  "command_palette_nav_admin": "لوحة المسؤول",
  "command_palette_billing_subscription": "الاشتراك",
  "command_palette_billing_usage": "الاستخدام",
  "command_palette_billing_history": "سجلّ الفوترة",
  "command_palette_billing_root": "فتح الفوترة",
  "command_palette_system_agent": "الوكيل الذكي",
  "command_palette_system_agent_desc": "فتح الوكيل الذكي في الشريط الجانبي للدردشة",
  "command_palette_logout": "تسجيل الخروج",
  "command_palette_theme_system": "استخدام نمط النظام",
  "command_palette_theme_light": "التبديل إلى النمط الفاتح",
  "command_palette_theme_dark": "التبديل إلى النمط الداكن",
  "command_palette_locale_en": "الإنجليزية",
  "command_palette_locale_ar": "العربية",
  "command_palette_switch_language": "تغيير اللغة",
  "command_palette_hint_navigate": "للتنقّل",
  "command_palette_hint_select": "للاختيار",
  "command_palette_hint_close": "للإغلاق",
  "feedback_modal_trigger_label": "أرسل ملاحظاتك",
  "feedback_modal_title": "أرسل لنا ملاحظاتك",
  "feedback_modal_subtitle": "أخبرنا بما لا يعمل، أو ما هو مفقود، أو ما يعمل بشكل جيد. تصل مباشرةً إلى الفريق.",
  "feedback_modal_kind_legend": "ما نوع الملاحظات؟",
  "feedback_modal_kind_bug": "خطأ",
  "feedback_modal_kind_idea": "فكرة",
  "feedback_modal_kind_praise": "إشادة",
  "feedback_modal_kind_bug_desc": "هناك شيء لا يعمل كما تتوقع. أخبرنا بالخطوات حتى نتمكن من إعادة إنتاج المشكلة.",
  "feedback_modal_kind_idea_desc": "ميزة أو تحسين أو سير عمل سيجعل يومك أسهل.",
  "feedback_modal_kind_praise_desc": "هل أصبنا في شيء؟ نود أن نعرف.",
  "feedback_modal_placeholder_bug": "ماذا حدث؟ وماذا توقعت؟ خطوات إعادة الإنتاج تساعدنا كثيراً.",
  "feedback_modal_placeholder_idea": "صف فكرتك — المشكلة التي تحلها لا تقل أهمية عن الحل نفسه.",
  "feedback_modal_placeholder_praise": "أخبرنا بما أعجبك. (نقرأ كل واحدة منها.)",
  "feedback_modal_body_label": "تفاصيل الملاحظات",
  "feedback_modal_attach_screenshot": "إرفاق لقطة شاشة",
  "feedback_modal_remove_screenshot": "إزالة اللقطة",
  "feedback_modal_screenshot_too_large": "يجب ألّا تتجاوز اللقطة 5 ميجابايت.",
  "feedback_modal_include_console_logs": "تضمين سجلات وحدة التحكم الأخيرة",
  "feedback_modal_cancel": "إلغاء",
  "feedback_modal_send": "إرسال الملاحظات",
  "feedback_modal_sending": "جارٍ الإرسال…",
  "feedback_modal_success": "شكراً — تم إرسال ملاحظاتك.",
  "feedback_modal_error": "تعذّر إرسال الملاحظات. الرجاء المحاولة مرة أخرى.",
  "feedback_modal_discard_confirm": "هل تريد تجاهل هذه الملاحظات؟",
  "feedback_admin_eyebrow": "ملاحظات المنتج",
  "feedback_admin_title": "ملاحظات التطبيق",
  "feedback_admin_subtitle": "تقارير الأخطاء والأفكار والإشادات التي أرسلها زملاؤك بشأن Bavard نفسه.",
  "feedback_admin_filter_all": "الكل",
  "feedback_admin_filter_bug": "أخطاء",
  "feedback_admin_filter_idea": "أفكار",
  "feedback_admin_filter_praise": "إشادات",
  "feedback_admin_status_filter_all": "جميع الحالات",
  "feedback_admin_status_new": "جديد",
  "feedback_admin_status_triaged": "قيد المعالجة",
  "feedback_admin_status_resolved": "تم الحل",
  "feedback_admin_status_wontfix": "لن يُعالج",
  "feedback_admin_action_triage": "وضع علامة قيد المعالجة",
  "feedback_admin_action_resolve": "وضع علامة محلول",
  "feedback_admin_action_dismiss": "تجاهل",
  "feedback_admin_expand": "توسيع",
  "feedback_admin_collapse": "تصغير",
  "feedback_admin_show_console_log": "إظهار سجل وحدة التحكم",
  "feedback_admin_hide_console_log": "إخفاء سجل وحدة التحكم",
  "feedback_admin_screenshot_alt": "لقطة الشاشة المرفقة بالملاحظات",
  "feedback_admin_empty_title": "لا توجد ملاحظات بعد",
  "feedback_admin_empty_body": "لم يرسل زملاؤك أي شيء بعد. عند إرسال أول ملاحظة ستظهر هنا.",
  "feedback_admin_empty_filtered_title": "لا توجد ملاحظات تطابق عوامل التصفية",
  "feedback_admin_empty_filtered_body": "جرّب فئة أو حالة أخرى.",
  "dashboard_app_feedback": "ملاحظات التطبيق",
  "dashboard_app_feedback_short": "ملاحظات",
  "dashboard_nav_app_feedback_desc": "تقارير الأخطاء والأفكار والإشادات حول Bavard من فريقك.",
  "account_nav_privacy_data": "الخصوصية والبيانات",
  "account_privacy_tab_title": "الخصوصية والبيانات",
  "account_privacy_tab_description": "تصدير بياناتك، التحكم في فترات الاحتفاظ، أو حذف حسابك.",
  "account_privacy_admin_badge": "مسؤول",
  "account_privacy_export_title": "تصدير بياناتك",
  "account_privacy_export_description": "نزّل فئة واحدة كملف منسّق، أو اجمع كل بياناتك في أرشيف مضغوط.",
  "account_export_instant_title": "تنزيل فئة",
  "account_export_instant_desc": "اختر فئة وصيغة للحصول على تنزيل فوري ومنسّق بأناقة.",
  "account_export_action": "تصدير…",
  "account_export_archive_title": "أرشيف البيانات الكامل (.zip)",
  "account_export_archive_desc": "اجمع كل شيء — بما في ذلك النسخ الاحتياطية — في ملف مضغوط؛ وسنرسل لك رابط التنزيل عند جاهزيته.",
  "account_export_toast_partial": "تم تصدير مجموعة جزئية — استخدم أرشيف البيانات الكامل للحصول على كل شيء.",
  "account_export_range_label": "النطاق الزمني",
  "account_export_range_desc": "الأعداد وعمليات التصدير محصورة ضمن هذه الفترة.",
  "account_export_range_all_time": "كل الأوقات",
  "account_export_open_dialog": "تصدير…",
  "account_export_archive_only": "الأرشيف فقط",
  "account_export_format_archive": "الأرشيف الكامل (‎.zip)",
  "account_export_format_archive_meta": "بيانات كاملة — سنرسل رابط التنزيل عبر البريد.",
  "account_export_zip_forced_note": "فئة واحدة أو أكثر من الفئات المحددة أكبر من أن تُصدَّر فوريًا في هذا النطاق، لذا فإن أرشيف ‎.zip الكامل هو الخيار الوحيد.",
  "account_privacy_export_include_legend": "شمل في الأرشيف",
  "account_privacy_export_cat_conversations": "المحادثات",
  "account_privacy_export_cat_conversations_desc": "كل محادثة يمكنك قراءتها في هذه المساحة.",
  "account_privacy_export_cat_events": "المواعيد",
  "account_privacy_export_cat_events_desc": "أحداث التقويم والحجوزات الخاصة بك.",
  "account_privacy_export_cat_documents": "المستندات",
  "account_privacy_export_cat_documents_desc": "مستندات قاعدة المعرفة المرفوعة إلى مساحة العمل (للمسؤولين فقط).",
  "account_privacy_export_cat_backups": "النسخ الاحتياطية",
  "account_privacy_export_cat_backups_desc": "لقطات قاعدة بيانات مساحة العمل (للمسؤولين فقط).",
  "account_privacy_export_cat_notifications": "الإشعارات",
  "account_privacy_export_cat_notifications_desc": "أحداث نظام الإشعارات (للمسؤولين فقط).",
  "account_privacy_export_generate": "إنشاء التصدير",
  "account_privacy_export_loading": "جاري التحقق من عمليات التصدير الأخيرة…",
  "account_privacy_export_running": "نُحضّر الأرشيف — سنرسل لك الرابط بالبريد.",
  "account_privacy_export_ready_download": "تنزيل الأرشيف",
  "account_privacy_export_idle_hint": "اختر فئة واحدة على الأقل ثم اضغط الإنشاء.",
  "account_privacy_export_idle_ready": "جاهز للإنشاء متى أردت.",
  "account_privacy_export_error": "حدث خطأ أثناء بدء التصدير. حاول مجددًا.",
  "account_privacy_export_started_toast": "تمت جدولة التصدير",
  "account_privacy_export_started_toast_desc": "سنرسل لك رابط التنزيل بالبريد عندما يصبح الأرشيف جاهزًا.",
  "account_privacy_retention_title": "الاحتفاظ بالبيانات",
  "account_privacy_retention_description": "اختر مدة بقاء كل نوع من السجلات قبل الحذف التلقائي.",
  "account_privacy_retention_readonly_banner": "يمكن لمالكي ومسؤولي المؤسسة فقط تعديل قواعد الاحتفاظ.",
  "account_privacy_retention_row_conversations": "المحادثات",
  "account_privacy_retention_row_audit_log": "سجل التدقيق",
  "account_privacy_retention_row_deleted_items": "العناصر المحذوفة",
  "account_privacy_retention_row_notifications": "الإشعارات",
  "account_privacy_retention_preview_conversations": "سيتم حذف المحادثات الأقدم من {{count}} يومًا نهائيًا في نهاية كل شهر.",
  "account_privacy_retention_preview_audit_log": "سيتم تنظيف سجلات التدقيق الأقدم من {{count}} يومًا في نهاية كل شهر.",
  "account_privacy_retention_preview_deleted_items": "سيتم إزالة العناصر الموجودة في سلة المحذوفات الأقدم من {{count}} يومًا نهائيًا.",
  "account_privacy_retention_preview_notifications": "سيتم إزالة سجلات الإشعارات الأقدم من {{count}} يومًا في نهاية كل شهر.",
  "account_privacy_retention_preview_indefinite_conversations": "يتم الاحتفاظ بالمحادثات إلى أجل غير مسمى. لن يتم حذف أي شيء تلقائيًا.",
  "account_privacy_retention_preview_indefinite_audit_log": "يتم الاحتفاظ بسجلات التدقيق إلى أجل غير مسمى. لن يتم حذف أي شيء تلقائيًا.",
  "account_privacy_retention_preview_indefinite_deleted_items": "يتم الاحتفاظ بالعناصر الموجودة في سلة المحذوفات إلى أجل غير مسمى. لن يتم حذف أي شيء تلقائيًا.",
  "account_privacy_retention_preview_indefinite_notifications": "يتم الاحتفاظ بسجلات الإشعارات إلى أجل غير مسمى. لن يتم حذف أي شيء تلقائيًا.",
  "account_privacy_retention_n_days": "{{count}} يوم",
  "account_privacy_retention_forever": "إلى الأبد",
  "account_privacy_retention_group_conversations": "المحادثات والوسائط",
  "account_privacy_retention_group_records": "سجلات العمل",
  "account_privacy_retention_group_system": "النظام والاسترداد",
  "account_privacy_retention_row_aria": "مدة الاحتفاظ بـ {{label}}",
  "account_privacy_retention_summary": "{{deleting}} حذف تلقائي · {{keeping}} دائم",
  "account_privacy_delete_loading": "جاري التحميل…",
  "account_privacy_delete_title": "حذف الحساب",
  "account_privacy_delete_description": "حذف حسابك وكل البيانات التي تملكها بشكل دائم. يمكن إلغاء هذا الإجراء خلال 30 يومًا.",
  "account_privacy_delete_row_now_title": "فورًا",
  "account_privacy_delete_row_now_body": "سيتم تسجيل خروجك من جميع الأجهزة. سيرى زملاؤك حسابك كـ ’مستخدم محذوف‘.",
  "account_privacy_delete_row_grace_title": "خلال 30 يومًا",
  "account_privacy_delete_row_grace_body": "يمكنك تسجيل الدخول مجددًا للإلغاء. بعد انقضاء المهلة، يتم تنفيذ الحذف ولا يمكن التراجع.",
  "account_privacy_delete_row_legal_title": "القانوني والامتثال",
  "account_privacy_delete_row_legal_body": "قد نحتفظ بسجلات محدودة (فواتير، سجلات تدقيق إلزامية) للمدة التي يفرضها القانون.",
  "account_privacy_delete_request_button": "طلب حذف الحساب",
  "account_privacy_delete_confirm_warning": "هل أنت متأكد؟ سيتم جدولة حسابك للحذف خلال 30 يومًا.",
  "account_privacy_delete_confirm_cancel": "احتفظ بالحساب",
  "account_privacy_delete_confirm_submit": "جدولة الحذف",
  "account_privacy_delete_pending_title": "تمت جدولة حذف الحساب",
  "account_privacy_delete_pending_description": "سيتم حذف حسابك نهائيًا في {date}. يمكنك الإلغاء قبل ذلك للاحتفاظ ببياناتك.",
  "account_privacy_delete_days_label": "يوم متبقي",
  "account_privacy_delete_cancel_button": "إلغاء طلب الحذف",
  "account_notifications_tab_title": "الإشعارات",
  "account_notifications_tab_description": "اختر متى وكيف ينبهك Bavard. هذه التفضيلات شخصية ولا تؤثر على زملائك.",
  "account_notifications_events_title": "إشعارات الأحداث",
  "account_notifications_events_description": "كيف تتلقى أخبار حجوزاتك والأحداث المهمة لك.",
  "account_notifications_reminders_enabled_label": "تذكيرات الأحداث",
  "account_notifications_reminders_enabled_description": "احصل على تنبيه قبل الأحداث المجدولة التي تحضرها.",
  "account_notifications_notify_on_cancellation_label": "تنبيهات الإلغاء",
  "account_notifications_notify_on_cancellation_description": "أبلغني عند إلغاء حدث أنا فيه.",
  "account_notifications_channels_title": "قنوات التوصيل",
  "account_notifications_channels_description": "أين يمكن أن يصل إليك Bavard.",
  "account_notifications_email_digest_label": "ملخص بالبريد",
  "account_notifications_email_digest_description": "اجمع النشاط في بريد إلكتروني بدلاً من إشعار واحد لكل حدث.",
  "account_notifications_web_push_label": "إشعارات المتصفح",
  "account_notifications_web_push_description": "أظهر إشعارات سطح المكتب عندما يكون Bavard مفتوحًا في علامة تبويب أخرى.",
  "account_notifications_web_push_unsupported_title": "الإشعارات الفورية غير مدعومة",
  "account_notifications_web_push_unsupported_description": "متصفحك لا يدعم إشعارات الويب الفورية.",
  "account_notifications_web_push_denied_title": "تم رفض الإذن",
  "account_notifications_web_push_denied_description": "الإشعارات محظورة. فعّلها من إعدادات المتصفح ثم أعد المحاولة.",
  "account_notifications_web_push_dismissed_title": "بحاجة إلى إذن",
  "account_notifications_web_push_dismissed_description": "الإشعارات الفورية تحتاج إلى إذنك. حاول مرة أخرى واختر السماح عندما يُطلب منك.",
  "account_notifications_web_push_unconfigured_title": "الإشعارات الفورية غير مهيأة",
  "account_notifications_web_push_unconfigured_description": "لم يتم إعداد الإشعارات الفورية على هذا الخادم. تواصل مع المسؤول.",
  "account_notifications_web_push_failed_title": "تعذّر تفعيل الإشعارات الفورية",
  "account_notifications_web_push_failed_description": "حدث خطأ أثناء تفعيل الإشعارات. حاول مرة أخرى أو حدّث الصفحة.",
  "account_notifications_mentions_title": "الإشارات والرسائل",
  "account_notifications_mentions_description": "ما مدى صخب الإشارات @؟",
  "account_notifications_mention_level_label": "نبهني عند",
  "account_notifications_mention_level_all": "كل الرسائل",
  "account_notifications_mention_level_direct": "الإشارات المباشرة فقط",
  "account_notifications_mention_level_none": "لا شيء",
  "config_nav_notification_rules": "قواعد الإشعارات",
  "feedbacks_summaries_segment_leads": "العملاء المحتملون",
  "leads_empty_title": "لم يتم جمع أي عملاء بعد",
  "leads_empty_body": "عندما يجمع المساعد معلومات عميل محتمل من زبون، ستظهر هنا.",
  "leads_show_with_trashed": "عرض المحذوفة",
  "leads_show_active_only": "النشطة فقط",
  "leads_trashed_badge": "محذوف",
  "leads_soft_delete": "نقل إلى المحذوفات",
  "leads_restore": "استعادة",
  "leads_hard_delete": "حذف نهائي",
  "leads_hard_delete_confirm": "حذف هذا العميل نهائياً؟ لا يمكن التراجع عن هذا الإجراء.",
  "collect_lead_fields_heading": "حقول العميل المحتمل",
  "collect_lead_loading": "جارٍ التحميل…",
  "collect_lead_no_fields_warning": "لم يتم تكوين أي حقول. لا يمكن للمساعد جمع العملاء المحتملين حتى تتم إضافة حقل واحد على الأقل.",
  "collect_lead_add_field": "إضافة حقل",
  "custom_tool_section_title": "الإجراءات المخصصة",
  "custom_tool_section_description": "أدوات تعرّفها مؤسستك لاستدعاء واجهة HTTPS الخاصة بك. يمكن للذكاء الاصطناعي استخدامها مثل أي أداة مدمجة.",
  "custom_tool_new_action": "إجراء مخصص جديد",
  "custom_tool_badge_custom": "مخصص",
  "custom_tool_badge_draft": "مسودة",
  "custom_tool_requires_approval": "يتطلب موافقة قبل التشغيل",
  "custom_tool_plan_locked": "الإجراءات المخصصة غير متضمّنة في خطتك الحالية. قم بالترقية لتعريف أدوات تستدعي واجهات API.",
  "custom_tool_loading": "جارٍ تحميل الإجراءات المخصصة…",
  "custom_tool_empty": "لا توجد إجراءات مخصصة بعد. أنشئ واحدًا ليتمكن الذكاء الاصطناعي من استدعاء واجهتك.",
  "custom_tool_enable": "تفعيل",
  "custom_tool_enabled_count": "{{count}} من {{limit}} مُفعّل",
  "custom_tool_edit": "تعديل الإجراء",
  "custom_tool_delete": "حذف",
  "custom_tool_deleted": "تم حذف الإجراء المخصص",
  "custom_tool_delete_title": "حذف الإجراء المخصص؟",
  "custom_tool_delete_confirm": "سيؤدي هذا إلى إزالة \"{{name}}\" وأسراره المخزّنة نهائيًا. لا يمكن التراجع عن ذلك.",
  "custom_tool_new_title": "إجراء مخصص جديد",
  "custom_tool_edit_title": "تعديل الإجراء المخصص",
  "custom_tool_wizard_description": "عرّف طلب HTTP يمكن للذكاء الاصطناعي استدعاؤه كأداة. تُحفظ كل خطوة على حدة — يمكنك المغادرة والإكمال لاحقًا.",
  "custom_tool_step_general": "عام",
  "custom_tool_step_api": "واجهة API",
  "custom_tool_step_test": "اختبار",
  "custom_tool_step_data_access": "الوصول للبيانات",
  "custom_tool_field_name": "اسم الإجراء",
  "custom_tool_field_name_hint": "المعرّف الذي يستدعيه النموذج. أحرف وأرقام وشرطات سفلية، من 3 إلى 64 حرفًا (مثل check_order_status).",
  "custom_tool_field_when_to_use": "متى تُستخدم",
  "custom_tool_field_when_to_use_placeholder": "صف متى ينبغي للذكاء الاصطناعي استدعاء هذا الإجراء. أدرج أمثلة على أسئلة العملاء وبيانات نموذجية.",
  "custom_tool_field_when_to_use_hint": "يصبح هذا وصف الأداة الذي يقرؤه النموذج. كن دقيقًا بشأن متى يستدعيها.",
  "custom_tool_field_requires_approval": "يتطلب موافقة",
  "custom_tool_field_requires_approval_hint": "التوقف كي يوافق المشغّل على كل استدعاء قبل تشغيله.",
  "custom_tool_target_label": "يُستخدم بواسطة",
  "custom_tool_target_assistant": "المساعد",
  "custom_tool_target_system_agent": "وكيل النظام",
  "custom_tool_target_both": "كلاهما",
  "custom_tool_target_tooltip": "أي وكيل يمكنه استدعاء هذا الإجراء: المساعد الموجه للعملاء، أو وكيل النظام الموجه للمشغّل، أو كلاهما.",
  "custom_tool_inputs_title": "مدخلات البيانات",
  "custom_tool_add_input": "إضافة مدخل",
  "custom_tool_inputs_hint": "قيم يجمعها الذكاء الاصطناعي من المحادثة ويمرّرها إلى الطلب عبر رموز {{variable}}.",
  "custom_tool_input_name": "الاسم",
  "custom_tool_input_type": "النوع",
  "custom_tool_input_type_text": "نص",
  "custom_tool_input_type_number": "رقم",
  "custom_tool_input_type_boolean": "قيمة منطقية",
  "custom_tool_input_type_date": "تاريخ",
  "custom_tool_input_description": "الوصف",
  "custom_tool_input_description_placeholder": "ماهية هذه القيمة؛ إرشاد للنموذج.",
  "custom_tool_input_enum": "القيم المسموح بها (مفصولة بفواصل، اختياري)",
  "custom_tool_input_required": "مطلوب",
  "custom_tool_json_banner": "تُرسل الطلبات بصيغة JSON ويجب أن تكون الاستجابات بصيغة JSON (بحد أقصى 64 كيلوبايت).",
  "custom_tool_field_method": "الطريقة",
  "custom_tool_field_url": "الرابط (HTTPS)",
  "custom_tool_params_title": "معاملات الاستعلام",
  "custom_tool_params_hint": "قيم المصادقة مكانها الترويسات — قد تتسرّب معاملات الاستعلام إلى السجلات والوسطاء.",
  "custom_tool_param_key": "المفتاح",
  "custom_tool_param_value": "القيمة",
  "custom_tool_add_param": "إضافة معامل",
  "custom_tool_headers_title": "الترويسات",
  "custom_tool_headers_hint": "فعّل خيار السر لتخزين القيمة مشفّرة في الخزنة؛ تُخفى بعد الحفظ.",
  "custom_tool_header_key": "الترويسة",
  "custom_tool_header_value": "القيمة",
  "custom_tool_header_secret": "سري",
  "custom_tool_add_header": "إضافة ترويسة",
  "custom_tool_field_body": "المحتوى (JSON)",
  "custom_tool_add_variable": "إضافة متغير:",
  "custom_tool_test_mode": "وضع الاختبار",
  "custom_tool_test_live": "استجابة حية",
  "custom_tool_test_example": "استجابة نموذجية",
  "custom_tool_test_no_inputs": "لا يحتوي هذا الإجراء على مدخلات بيانات.",
  "custom_tool_test_run": "تشغيل الاختبار",
  "custom_tool_test_needs_api_save": "احفظ خطوة API قبل تشغيل اختبار حي.",
  "custom_tool_test_status": "الحالة {{status}}",
  "custom_tool_test_duration": "{{ms}} ملّي ثانية",
  "custom_tool_test_size": "{{bytes}} بايت",
  "custom_tool_test_example_label": "الصق استجابة JSON نموذجية",
  "custom_tool_test_example_hint": "استخدم هذا عندما لا تكون الواجهة جاهزة. يعمل منتقي الوصول للبيانات على هذه العيّنة.",
  "custom_tool_test_example_invalid": "أدخل استجابة JSON صالحة قبل المتابعة.",
  "custom_tool_access_title": "الوصول للبيانات",
  "custom_tool_access_full": "وصول كامل للبيانات",
  "custom_tool_access_full_hint": "يرى النموذج استجابة JSON كاملة.",
  "custom_tool_access_limited": "وصول محدود للبيانات",
  "custom_tool_access_limited_hint": "يرى النموذج فقط حقول الاستجابة التي تختارها أدناه.",
  "custom_tool_access_paths_title": "حقول الاستجابة المسموح بها",
  "custom_tool_paths_empty": "شغّل اختبارًا أو الصق استجابة نموذجية لاختيار الحقول المسموح بها.",
  "custom_tool_save_continue": "حفظ ومتابعة",
  "custom_tool_continue": "متابعة",
  "custom_tool_save": "حفظ",
  "custom_tool_back": "رجوع",
  "custom_tool_cancel": "إلغاء",
  "custom_tool_saved": "تم حفظ الإجراء المخصص",
  "custom_tool_save_failed": "تعذّر حفظ الإجراء المخصص",
  "custom_tool_finish_setup": "أكمل الإعداد لتفعيل هذا الإجراء",
  "custom_tool_try_with_agent": "جرّب مع المساعد",
  "custom_tool_export": "تصدير",
  "custom_tool_import_action": "استيراد",
  "custom_tool_col_name": "الإجراء",
  "custom_tool_col_enabled": "مفعّل",
  "custom_tool_export_failed": "تعذّر تصدير الإجراء المخصص",
  "custom_tool_import_success": "تم استيراد الإجراء المخصص. أعد إدخال أي رؤوس سرية ثم فعّله.",
  "custom_tool_import_failed": "تعذّر استيراد الإجراء المخصص",
  "collect_lead_field_label_aria": "تسمية الحقل",
  "collect_lead_field_label_placeholder": "التسمية (مثل: الاسم الكامل)",
  "collect_lead_field_name_aria": "مفتاح الحقل (lower_snake_case)",
  "collect_lead_field_type_aria": "نوع الحقل",
  "collect_lead_field_description_aria": "وصف الحقل للمساعد",
  "collect_lead_field_description_placeholder": "الوصف الذي يراه المساعد (اختياري)",
  "collect_lead_field_remove_aria": "إزالة الحقل",
  "collect_lead_fields_save": "حفظ الحقول",
  "collect_lead_fields_reset": "تجاهل التغييرات",
  "collect_lead_presets_toggle": "قوالب جاهزة",
  "collect_lead_presets_help": "اختر نقطة بداية — يستبدل قائمة الحقول الحالية.",
  "collect_lead_preset_name_phone_email": "الاسم + الهاتف + البريد",
  "collect_lead_preset_contact_company": "جهة اتصال + شركة",
  "collect_lead_preset_appointment_intake": "استقبال موعد",
  "account_privacy_retention_row_captured_leads": "العملاء المحتملون المحذوفون",
  "account_privacy_retention_preview_captured_leads": "يتم حذف العملاء المحتملين المحذوفين نهائياً بعد {{count}} يوماً.",
  "account_privacy_retention_preview_indefinite_captured_leads": "يتم الاحتفاظ بالعملاء المحتملين المحذوفين إلى أجل غير مسمى.",
  "account_privacy_retention_row_chat_media": "وسائط المحادثة",
  "account_privacy_retention_preview_chat_media": "تُحذف صور المحادثة نهائيًا بعد {{count}} يومًا؛ مع الاحتفاظ بالتعليقات.",
  "account_privacy_retention_preview_indefinite_chat_media": "يتم الاحتفاظ بصور المحادثة إلى أجل غير مسمى.",
  "account_privacy_retention_row_documents": "المستندات",
  "account_privacy_retention_preview_documents": "تُحذف المستندات التي لم تُعدَّل خلال {{count}} يومًا نهائيًا.",
  "account_privacy_retention_preview_indefinite_documents": "يتم الاحتفاظ بالمستندات إلى أجل غير مسمى.",
  "account_privacy_export_cat_captured_leads": "العملاء المحتملون",
  "account_privacy_export_cat_captured_leads_desc": "العملاء المحتملون الذين جمعهم المساعد — قيم مفتاحها الحقول المكوّنة لديك.",
  "tooltipsDashboard": {
    "returningRate": "نسبة عملاء الحجز الذين لديهم حجزان أو أكثر في النطاق المحدد، محسوبة من جميع عملاء الحجز في النطاق.",
    "cpuUsage": "حِمل المعالج الحي على خادم النظام، يُؤخذ من Prometheus كل بضع ثوانٍ. القيم المستمرة فوق 80% تشير إلى ضغط على الخادم.",
    "memoryUsage": "الذاكرة الحالية المُستخدمة بواسطة عملية الخادم، من Prometheus. الشريط يُظهر النسبة من ذاكرة النظام المتاحة، والقيمة المطلقة (ميجابايت/جيجابايت) في النص.",
    "totalEvents": "إجمالي الحجوزات المجدولة للوقوع خلال النطاق الزمني المحدد، بما فيها الحجوزات التي حالتها الحالية ملغاة.",
    "activeUsers": "عدد العملاء المختلفين الذين لديهم حجز غير ملغى داخل النطاق الزمني المحدد. يُحسب كل عميل مرة واحدة.",
    "cancellations": "الحجوزات المجدولة للوقوع خلال النطاق الزمني المحدد وحالتها الحالية ملغاة. الأقل أفضل.",
    "conversionRate": "نسبة العملاء الذين أرسلوا رسالة واردة خلال النطاق المحدد ولديهم أيضًا حجز غير ملغى في النطاق نفسه.",
    "avgResponseTime": "متوسط زمن ردّ المساعد على رسائل المستخدمين، بالثواني، عبر كل المحادثات خلال النطاق الزمني المحدد. الأقل أفضل.",
    "newUsers": "عدد العملاء المختلفين الذين لديهم حجز واحد على الأقل داخل النطاق الزمني المحدد.",
    "returningUsers": "عدد العملاء الذين لديهم حجزان أو أكثر داخل النطاق الزمني المحدد.",
    "avgFollowups": "متوسط عدد الحجوزات الإضافية بعد الحجز الأول لكل عميل لديه أكثر من حجز داخل النطاق الزمني المحدد.",
    "activityBreakdown": "إجماليات الحجوزات والإلغاءات والتعديلات خلال النطاق الزمني المحدد. تُقاس الأشرطة نسبةً للأكبر من القيم الثلاث.",
    "successRate": "نسبة عمليات الأحداث (الحجوزات والإلغاءات والتعديلات مجتمعةً) التي اكتملت دون خطأ خلال النطاق الزمني المحدد. الأعلى يعني فشلاً أقل.",
    "dailyTrendsOverview": "أعداد يومية حسب المنطقة الزمنية للمؤسسة. تستخدم الحجوزات والإلغاءات الحالية تاريخ الموعد المجدول، وتستخدم التعديلات تاريخ تعديلها.",
    "timeAnalysis": "مخططات تُظهر متى يحدث النشاط — عبر ساعات اليوم وأيام الأسبوع — للنطاق الزمني المحدد.",
    "eventDistribution": "حجوزات الفترة المحددة حسب النوع ومتوسط الحجوزات لكل عميل حجز مميز في كل نوع.",
    "userBehavior": "كيف ينتقل المستخدمون عبر مسار التحويل وكيف يتقسّمون حسب مستوى النشاط خلال النطاق الزمني المحدد.",
    "popularTimeSlots": "الحجوزات حسب ساعة الموعد المجدول (00:00–23:00) في المنطقة الزمنية للمؤسسة خلال النطاق المحدد.",
    "weeklyActivity": "الحجوزات والرسائل حسب يوم الأسبوع في المنطقة الزمنية للمؤسسة خلال النطاق المحدد.",
    "avgEventsPerType": "متوسط الحجوزات لكل عميل حجز مميز، مقسّم حسب نوع الحدث خلال النطاق المحدد.",
    "typeDistribution": "عدد الحجوزات حسب النوع خلال النطاق الزمني المحدد.",
    "userSegments": "عملاء الحجز المميزون مجمّعون حسب عدد الحجوزات في النطاق المحدد: حجز واحد، 2–5، أو 6 فأكثر.",
    "funnelHeading": "التسرّب من العملاء الذين أرسلوا رسالة واردة إلى حجز أنشأه المساعد ثم حجز ثانٍ أنشأه المساعد. تُستبعد حجوزات الفريق واليدوية والخارجية من مراحل الحجز.",
    "funnelActivation": "من العملاء الذين أرسلوا رسالة واردة، النسبة التي أنشأ المساعد حجزًا لها. الحجوزات اليدوية والخارجية غير مشمولة.",
    "funnelRetention": "من المستخدمين الذين لديهم حجز أنشأه المساعد، النسبة التي حصلت لاحقًا على حجز آخر أنشأه المساعد.",
    "funnelOverall": "التحويل الكامل من محادثة واردة إلى حجز ثانٍ أنشأه المساعد. الحجوزات اليدوية والخارجية غير مشمولة.",
    "funnelExit": "نسبة الإلغاء بين الحجوزات التي أنشأها المساعد فقط. الحجوزات اليدوية والخارجية غير مشمولة. الأقل أفضل.",
    "responseTimeAnalysis": "مدى سرعة ردّ المساعد على الرسائل، بالدقائق. يقارن المتوسط والقيمة المعتادة (الوسيط) وأسوأ حالة عبر كل المحادثات خلال النطاق الزمني المحدد.",
    "responseAverage": "متوسط زمن الردّ عبر كل العيّنات خلال النطاق الزمني المحدد. حسّاس للقيم الشاذة — بضعة ردود بطيئة جدًا تُصعِّد المتوسط.",
    "responseMedian": "زمن الردّ في المنتصف — نصف الردود أسرع ونصفها أبطأ. يُمثّل التجربة المعتادة أفضل من المتوسط.",
    "responseMaximum": "أبطأ ردّ مرصود خلال النطاق الزمني المحدد. مفيد لرصد أسوأ حالات التأخّر.",
    "performanceScore": "درجة مركّبة (0–100) مشتقّة من متوسط زمن الردّ. 100 يعني ردودًا فورية؛ تتناقص مع زيادة المتوسط.",
    "conversationAnalysis": "طول المحادثات بعدد الرسائل المتبادلة. يُظهر المتوسط والقيمة المعتادة (الوسيط) وأطول محادثة منفردة خلال النطاق الزمني المحدد.",
    "engagementLevel": "تصنيف (منخفض/متوسط/مرتفع) بناءً على متوسط الرسائل لكل محادثة. التفاعل الأعلى يدلّ عادةً على تجارب أعمق، لكن القيم المرتفعة جدًا قد تشير إلى صعوبة المستخدمين في الحصول على إجابات.",
    "totalConversations": "إجمالي عدد المحادثات التي تعامل معها المساعد خلال النطاق الزمني المحدد. كل محادثة قد تحوي رسائل عدّة.",
    "totalMessages": "إجمالي الرسائل الواردة والصادرة المحتفظ بها عبر القنوات المدعومة خلال النطاق الزمني المحدد.",
    "avgMessagesPerConversation": "متوسط عدد الرسائل المتبادلة لكل محادثة خلال النطاق الزمني المحدد.",
    "messageVolumeHeatmap": "الرسائل حسب يوم الأسبوع والساعة في المنطقة الزمنية للمؤسسة خلال النطاق المحدد. الخانات الأوضح أكثر ازدحامًا؛ مرّر للقيمة الدقيقة.",
    "peakHour": "الساعة المحلية للمؤسسة ذات أعلى حجم رسائل خلال النطاق الزمني المحدد.",
    "busiestDay": "يوم الأسبوع المحلي للمؤسسة ذو أعلى حجم رسائل خلال النطاق المحدد.",
    "avgPerHour": "متوسط الرسائل في الساعة عبر أسبوع كامل (168 ساعة)، مُحتسب من إجماليات النطاق الزمني المحدد.",
    "wordFrequency": "أعلى الكلمات نطقًا من المستخدم مقابل المساعد خلال النطاق الزمني المحدد. بدّل الألسنة للمقارنة. كلمات الوقف الشائعة (مثل: من، في، إلى) مُستبعدة.",
    "mostActiveUsers": "ترتيب المستخدمين حسب الحجوزات أو الرسائل خلال النطاق الزمني المحدد. انقر على صف لفتح محادثة المستخدم.",
    "responseTimeInsights": "تقييم بلغة بسيطة لمتوسط زمن ردّ المساعد خلال النطاق الزمني المحدد. مرمَّز ألوانيًا (أخضر/أصفر/أحمر) بناءً على عتبات (≤ دقيقة ممتاز، ≤ 3 دقائق جيد، إلخ.).",
    "conversationInsights": "تقييم بلغة بسيطة لمستوى تفاعل المستخدمين، بناءً على متوسط الرسائل لكل محادثة خلال النطاق الزمني المحدد.",
    "businessInsights": "نصائح مُختارة مستقاة من ساعات الذروة ومعدّل الاحتفاظ بالعملاء وسرعة الردّ خلال النطاق الزمني المحدد.",
    "leadsCollected": "عدد العملاء المحتملين الذين جمعهم المساعد عبر نموذج جمع البيانات خلال النطاق الزمني المحدد. كل صف في تبويب العملاء المحتملين هو عميل واحد.",
    "positiveFeedback": "عدد رسائل التقييم المُصنَّفة إيجابية المشاعر خلال النطاق الزمني المحدد.",
    "negativeFeedback": "عدد رسائل التقييم المُصنَّفة سلبية المشاعر خلال النطاق الزمني المحدد.",
    "neutralFeedback": "عدد رسائل التقييم المُصنَّفة محايدة المشاعر خلال النطاق الزمني المحدد.",
    "aiTokenUsage": "رموز الذكاء الاصطناعي وتكلفتها بالدولار المسجلة ضمن النطاق الزمني ومرشح القناة المحددين، وتشمل رموز الإدخال والإخراج."
  },
  "tooltipsAccount": {
    "profile": {
      "email": "يُستخدم لتسجيل الدخول والتنبيهات المهمة. إذا كان بريدك الحالي مُوثَّقًا فسنُرسل رابط تأكيد إلى البريد الجديد قبل التبديل — ولن يسري التغيير إلا بعد النقر على الرابط.",
      "newPassword": "الحد الأدنى 8 أحرف. استخدم كلمة مرور فريدة لا تكررها في مواقع أخرى؛ العبارة الطويلة أقوى من الكلمة القصيرة المعقّدة.",
      "currentPassword": "نحتاج كلمة مرورك الحالية للتأكد من هويتك قبل التغيير. إن نسيتها فسجّل الخروج واستخدم رابط إعادة تعيين كلمة المرور."
    },
    "privacy": {
      "retention": {
        "section": "نوافذ الحذف التلقائي للبيانات التي تخزّنها مساحة عملك. بعد انقضاء النافذة تُحذف العناصر نهائيًا ولا يمكن استعادتها. خيار ‘للأبد’ يُعطّل الحذف التلقائي لتلك الفئة.",
        "conversations": "مدة الاحتفاظ بسجل المحادثات قبل الحذف التلقائي. بعد هذه المدة تُمسح نصوص الرسائل بالكامل، وقد تُحفظ العدّادات الإجمالية المستخدمة في التحليلات.",
        "auditLog": "مدة الاحتفاظ بسجلات إجراءات المسؤولين (تسجيل الدخول، تغييرات الأدوار، الحذف). النوافذ الأقصر توفّر مساحة، والأطول تساعد في تحقيقات الأمان والامتثال.",
        "deletedItems": "العناصر في سلة المحذوفات قابلة للاستعادة حتى انقضاء هذه النافذة، ثم تُمسح نهائيًا. ‘للأبد’ يحتفظ بها حتى تُفرَّغ يدويًا.",
        "notifications": "مدة الاحتفاظ بسجلات الإشعارات المُسلَّمة. يؤثّر هذا على قائمة الإشعارات داخل التطبيق فقط — ولا يُلغي الرسائل التي أُرسلت بالفعل عبر البريد أو الإشعارات الفورية.",
        "capturedLeads": "مدة الاحتفاظ بسجلات العملاء المحتملين الذين جمعهم المساعد. اختر مدة أطول من دورة المبيعات لديك حتى لا يُحذفوا تلقائيًا قبل التواصل معهم.",
        "chatMedia": "مدة الاحتفاظ بصور المحادثة قبل الحذف التلقائي. بعد هذه المدة تُزال الصورة ويبقى التعليق/النص فقط. لا يؤثر ذلك على صور المستندات.",
        "documents": "مدة الاحتفاظ بالمستند بعد آخر تعديل له. بعد هذه المدة يُحذف المستند وصوره نهائيًا. لا يؤثر ذلك على صور المحادثة."
      },
      "export": {
        "section": "أنشئ أرشيفًا قابلاً للتنزيل لبياناتك. تُبنى الحزمة في الخلفية ثم يُرسَل الرابط إلى بريدك ويظهر هنا عند جاهزيته. تنتهي صلاحية الروابط عادةً بعد بضعة أيام.",
        "events": "أحداث التقويم التي أنشأتها أو حضرتها مع كامل بياناتها الوصفية.",
        "documents": "الملفات المرفوعة إلى قاعدة المعرفة. مقصور على المسؤولين لأنه يشمل مستندات شاركها أعضاء آخرون.",
        "backups": "نسخ احتياطية لقاعدة بيانات مساحة العمل بأكملها. مقصور على المسؤولين — قد تكون كبيرة جدًا وتحوي بيانات مستخدمين آخرين.",
        "notifications": "سجل الإشعارات المُسلَّمة لأعضاء مساحة العمل. مقصور على المسؤولين.",
        "capturedLeads": "العملاء المحتملون الذين جمعهم المساعد بكل الحقول التي أعددتها لجمعها."
      },
      "delete": {
        "section": "يُجدوِل حذفًا نهائيًا لحسابك خلال 30 يومًا. يمكنك الإلغاء في أي وقت خلال فترة السماح بتسجيل الدخول. بعد فترة السماح يصبح الحذف غير قابل للتراجع — تُمسح البيانات والجلسات والإعدادات."
      }
    },
    "sessions": {
      "section": "كل جهاز أو متصفح مُسجَّل دخوله حاليًا في حسابك. زر ‘تسجيل الخروج’ ينهي تلك الجلسة فورًا ويفرض إعادة المصادقة على ذلك الجهاز.",
      "signOutOthers": "ينهي جميع الجلسات عدا الحالية. استخدمه إذا فقدت هاتفًا أو استخدمت حاسوبًا عامًا أو ساورك شك في وصول شخص آخر."
    },
    "passkeys": {
      "section": "مفتاح المرور هو بيانات اعتماد مقاومة للتصيّد مرتبطة ببصمة جهازك أو رقمه السرّي (Touch ID وWindows Hello ومفاتيح الأجهزة). يحلّ محل كلمة المرور ولا يمكن إعادة استخدامه على موقع مزيّف."
    },
    "notifications": {
      "sounds": "يشغّل نغمة قصيرة عند وصول إشعار. إيقاف هذا يُسكِت كل الفئات دفعةً واحدة، ومفاتيح الصوت لكل فئة تُتجاهَل حتى يُعاد تفعيله.",
      "emailDigest": "يُرسل ملخصًا دوريًا للنشاط إلى بريدك بدلًا من رسالة لكل حدث. مفيد إن كانت الرسائل اللحظية مزعجة.",
      "webPush": "يسمح للمتصفح بإظهار الإشعارات حتى لو كانت علامة التبويب مغلقة. يتطلب إذنًا لمرّة واحدة من المتصفح، ويعمل فقط طالما المتصفح يعمل.",
      "mentionLevel": "يحدّد متى تُنبَّه عند الإشارة إليك: ‘الكل’ في أي محادثة، ‘المباشر فقط’ للرسائل الموجَّهة إليك، أو ‘لا شيء’ لكتم الإشارات تمامًا.",
      "inAppColumn": "يظهر شارة وإشعارًا داخل التطبيق أثناء استخدامك له.",
      "soundColumn": "يشغّل نغمة الإشعار لهذه الفئة. يتطلب تفعيل المفتاح الرئيسي للأصوات أعلاه."
    }
  },
  "tooltipsPhoneSelector": {
    "selected": "جهة الاتصال التي رقم هاتفها مختار حاليًا لهذا الحقل. تظهر دائمًا في الأعلى لتعرف ما المرتبط الآن.",
    "favorites": "جهات اتصال مثبَّتة للوصول السريع. افتح ملف جهة الاتصال وفعّل النجمة لإضافتها أو إزالتها من هذه القائمة.",
    "recent": "جهات الاتصال التي راسلتك حديثًا، مرتّبة حسب آخر رسالة. تظهر هنا تلقائيًا دون أي إجراء منك.",
    "all": "كل جهات الاتصال في مساحة عملك مرتّبة أبجديًا. اكتب في خانة البحث أعلاه لتصفية الاسم أو رقم الهاتف."
  },
  "tooltipsConfig": {
    "general": {
      "defaultCountryPrefix": "يُستخدم عند إدخال أرقام الهواتف بدون رمز الدولة. اختر الدولة التي يكتب منها عملاؤك في الغالب.",
      "availableThemes": "السمات اللونية التي يمكن لفريقك الاختيار من بينها في منتقي المظهر. تعطيل سمة يخفيها عن جميع أعضاء مساحة العمل.",
      "availableLanguages": "اللغات التي يمكن للمستخدمين التبديل إليها داخل التطبيق. الإنجليزية مفعّلة دائمًا؛ إيقاف لغة يحذفها من قائمة اللغات.",
      "systemPrompt": "تعليمات رئيسية يتّبعها الذكاء الاصطناعي في كل رد محادثة. استخدمها لتحديد النبرة أو الشخصية أو أي قواعد ثابتة يجب أن يلتزم بها.",
      "systemAgentPrompt": "تعليمات إضافية لمهام الذكاء الاصطناعي التي تتّخذ إجراءات (الحجز، البحث، إلخ). اجعلها مركّزة على كيفية استخدام الأدوات.",
      "latitude": "الإحداثي الشمالي–الجنوبي لموقع عملك بالدرجات العشرية (مثل 24.7136). استخدم زر الخريطة إن لم تكن تعرفه.",
      "longitude": "الإحداثي الشرقي–الغربي لموقع عملك بالدرجات العشرية (مثل 46.6753). استخدم زر الخريطة إن لم تكن تعرفه."
    },
    "calendarDisplay": {
      "firstDay": "اليوم الذي يظهر كأول عمود في أسبوع التقويم (مثل الأحد أو الإثنين). اختر ما يعتاد عليه فريقك.",
      "availableViews": "تخطيطات التقويم التي يمكن لفريقك التنقّل بينها (أسبوع، يوم، شهر، قائمة، سنة). ضع نجمة على واحدة لجعلها الافتراضية.",
      "textDirection": "يفرض اتجاه نص التقويم من اليسار إلى اليمين أو العكس. اتركه على ‘تلقائي’ ليتبع لغة الواجهة الحالية."
    },
    "emailTemplates": {
      "name": "اسم داخلي يساعدك على إيجاد هذا القالب لاحقًا (مثل ‘رسالة ترحيب’). لا يراه العملاء إطلاقًا.",
      "subject": "سطر الموضوع الذي يراه المستلمون. يمكنك إدراج متغيّرات مثل {{name}} لتخصيص كل رسالة.",
      "body": "محتوى الرسالة الكامل. استخدم شارات المتغيّرات بالأسفل لإدراج بيانات المستلم تلقائيًا."
    },
    "notifications": {
      "ruleName": "اسم داخلي لهذه القاعدة (مثل ‘تذكير قبل يوم’). يساعدك على إيجادها وتعديلها لاحقًا.",
      "trigger": "ما الحدث الذي يُطلق هذا الإشعار — تذكير زمني، إجراء حجز، أو إرسال مخصّص لمرة واحدة.",
      "daysBefore": "عدد الأيام قبل الموعد لإرسال التذكير. 1 = اليوم السابق، 7 = قبل أسبوع.",
      "daysAfter": "عدد الأيام بعد الموعد لإرسال المتابعة. 1 = اليوم التالي، 7 = بعد أسبوع.",
      "delayHours": "عدد الساعات التي ننتظرها بعد عدم الحضور قبل إرسال الرسالة. تُسمح خطوات نصف ساعة (مثل 1.5 = 90 دقيقة).",
      "delayMinutes": "عدد الدقائق التي ننتظرها بعد المُحفّز قبل الإرسال. 0 يُرسل فورًا، والقيم الأكبر تمنحك نافذة للإلغاء.",
      "inactiveDays": "عدد الأيام التي يجب أن يبقى فيها العميل صامتًا قبل إرسال رسالة إعادة التفاعل. 30 = بعد فترة سكون شهر كامل.",
      "sendAtTime": "وقت اليوم المحلي لإرسال الرسالة. مع إعداد اليوم أعلاه، يحدّد ذلك لحظة الإرسال بدقّة.",
      "scheduledAt": "التاريخ والوقت المحدّدان لإرسال هذه الرسالة المخصّصة لمرة واحدة. يُضبط بتوقيت عملك المحلي.",
      "eventTypeFilter": "قَصر هذه القاعدة على أنواع مواعيد محددة (مثل الاستشارات فقط). اتركه فارغًا لتطبيقها على كل الأنواع.",
      "targetPhones": "جهات اتصال محددة تتلقّى هذه الرسالة. اتركه فارغًا لإرسالها إلى صاحب الموعد نفسه.",
      "template": "قالب واتساب المعتمَد المستخدم في الرسالة. يجب اعتماد القوالب من ميتا قبل أن تُرسل.",
      "reminderName": "المفتاح الذي يخزّن به المجدول هذا التذكير. حروف وأرقام وشرطات سفلية وشرطات فقط — ويجب أن يكون فريدًا.",
      "reminderSendTime": "وقت اليوم المحلي الذي يُرسل فيه هذا التذكير، للمواعيد التي تقع في اليوم التالي."
    },
    "workingHours": {
      "startTime": "أبكر وقت يمكن فيه حجز المواعيد. الفترات قبل هذا الوقت ستُخفى من التقويم.",
      "endTime": "آخر وقت يمكن فيه حجز المواعيد. الفترات بعد هذا الوقت ستُخفى من التقويم.",
      "slotDuration": "مدة كل فترة قابلة للحجز بالساعة. يجب أن تقسم يوم العمل بالتساوي (مثل 0.5 ساعة = فترات من 30 دقيقة).",
      "workingDaysGrid": "أيام الأسبوع التي تستقبل فيها الحجوزات. الأيام المعطّلة تظهر كأيام إغلاق في التقويم.",
      "daySpecificDayOfWeek": "اختر أي يوم من أيام العمل ينطبق عليه هذا التجاوز. لكل يوم تجاوز واحد فقط.",
      "daySpecificStart": "وقت بداية يُستخدم لهذا اليوم فقط بدلًا من الوقت الافتراضي. مفيد لجمعة قصيرة أو افتتاحات متأخرة.",
      "daySpecificEnd": "وقت نهاية يُستخدم لهذا اليوم فقط بدلًا من الوقت الافتراضي. مفيد لجمعة قصيرة أو إغلاقات مبكرة.",
      "daySpecificSlotDuration": "تجاوز مدة الفترة لهذا اليوم فقط. اتركه على الافتراضي ليرث المدة العامة.",
      "customRangeDateRange": "تواريخ بداية ونهاية تفعيل هذا التجاوز (مثل ١–٣١ ديسمبر). تنطبق ساعات العمل العامة خارج هذه التواريخ.",
      "customRangeStart": "وقت الافتتاح اليومي خلال هذه الفترة. يحلّ محل وقت البداية الافتراضي خلال هذه التواريخ فقط.",
      "customRangeEnd": "وقت الإغلاق اليومي خلال هذه الفترة. يحلّ محل وقت النهاية الافتراضي خلال هذه التواريخ فقط.",
      "customRangeSlotDuration": "مدة الفترة المستخدمة خلال هذه الفترة. أعِد ضبطها لترث المدة العامة."
    }
  },
  "billing": {
    "page_title": "الفوترة",
    "page_description": "إدارة اشتراكك، عرض الفواتير، ومتابعة استخدام مؤسستك.",
    "loading": "جارٍ التحميل…",
    "error": "تعذّر تحميل بيانات الفوترة.",
    "subscription": {
      "title": "الاشتراك",
      "description": "خطتك الحالية وتفاصيل التجديد.",
      "next_renewal": "التجديد القادم",
      "cancel_at_period_end": "سيتم الإلغاء في نهاية الفترة",
      "payment_method": "طريقة الدفع",
      "no_payment_method": "لا توجد بطاقة محفوظة",
      "manage_button": "إدارة الفوترة",
      "manage_error": "تعذّر فتح بوابة الفوترة",
      "no_portal_contact_support": "لتغيير الخطة، يرجى التواصل مع الدعم.",
      "unconfigured": "لم يتم إعداد الفوترة في هذه البيئة بعد.",
      "cancel_button": "إلغاء الاشتراك",
      "cancel_confirm": "إلغاء اشتراكك في نهاية فترة الدفع الحالية؟ ستحتفظ بالوصول حتى ذلك الحين.",
      "cancel_success": "سينتهي اشتراكك في نهاية فترة الدفع الحالية.",
      "cancel_error": "تعذّر إلغاء الاشتراك. حاول مرة أخرى أو تواصل مع الدعم.",
      "upgrade_button": "ترقية الخطة",
      "per_month": "شهرياً",
      "per_month_yearly": "شهرياً (يُحاسَب سنوياً)",
      "excl_vat": "غير شامل ضريبة القيمة المضافة ({{vat}}%)",
      "status": {
        "none": "غير مفعّل",
        "active": "مفعّل",
        "trialing": "تجريبي",
        "past_due": "متأخر السداد",
        "canceled": "ملغى"
      }
    },
    "history": {
      "title": "سجلّ الفوترة",
      "description": "الفواتير السابقة الصادرة لمؤسستك.",
      "column_date": "التاريخ",
      "column_description": "الوصف",
      "column_amount": "المبلغ",
      "column_status": "الحالة",
      "column_invoice": "الفاتورة",
      "download_pdf": "تنزيل PDF",
      "view_invoice": "عرض الفاتورة",
      "subscription_invoice": "فاتورة اشتراك",
      "empty_title": "لا توجد فواتير بعد",
      "empty_description": "ستظهر فواتيرك هنا بعد معالجة أوّل دفعة لك.",
      "empty_no_customer": "اشترك في خطة مدفوعة لتبدأ في استلام الفواتير.",
      "empty_unconfigured": "لم يتم إعداد الفوترة بعد. ستظهر الفواتير هنا بعد ربط مزوّد دفع.",
      "invoice_status": {
        "draft": "مسوّدة",
        "open": "مفتوحة",
        "paid": "مدفوعة",
        "void": "ملغاة",
        "uncollectible": "غير قابلة للتحصيل"
      }
    },
    "usage": {
      "title": "الاستخدام",
      "description": "استخدام حصة مؤسستك في الفترة الحالية.",
      "seats_label": "مقاعد الفريق",
      "messages_label": "رسائل الذكاء الاصطناعي",
      "storage_label": "التخزين",
      "unlimited": "غير محدود",
      "period_resets_on": "تتم إعادة الضبط في {{date}}",
      "ai_pace": "أنت في طريقك للوصول إلى حد {cap} حوالي {date}.",
      "ai_pace_this_month": "أنت في طريقك للوصول إلى حد {cap} هذا الشهر."
    },
    "ai_spend_by_member": {
      "title": "إنفاق الذكاء الاصطناعي حسب العضو",
      "description": "إنفاق الاستدلال المنسوب إلى كل عضو خلال الفترة.",
      "assistant": "مساعد مراسلة العملاء"
    },
    "ai_cost_chart": {
      "forecast": "التوقّع"
    }
  },
  "orgOverview": {
    "eyebrow": "المؤسسة",
    "fallback_name": "مؤسستك",
    "plan_label": "خطة {{plan}}",
    "since": "منذ {{date}}",
    "alerts": {
      "healthy": "كل شيء يبدو على ما يرام — لا توجد مشكلات في الفوترة أو الاستخدام حاليًا.",
      "past_due_title": "السداد متأخر",
      "past_due_detail": "حدّث طريقة الدفع لتجنّب فقدان الوصول.",
      "cancel_title": "ينتهي الاشتراك قريبًا",
      "cancel_detail": "تُلغى خطتك {{when}}.",
      "no_card_title": "لا توجد طريقة دفع مسجّلة",
      "no_card_detail": "أضف بطاقة حتى لا يفشل التجديد القادم.",
      "limit_reached_title": "تم بلوغ حد {{label}}",
      "limit_reached_detail": "قم بترقية خطتك للمتابعة في الإضافة.",
      "near_limit_title": "{{label}} قارب على بلوغ الحد",
      "near_limit_detail": "تم استخدام {{pct}}٪ من خطتك.",
      "ai_over_title": "تجاوز إنفاق الذكاء الاصطناعي الحد الشهري",
      "ai_over_detail": "قد تتباطأ ردود الذكاء الاصطناعي حتى إعادة ضبط الفترة.",
      "ai_near_title": "إنفاق الذكاء الاصطناعي عند {{pct}}٪ من الحد",
      "ai_near_detail": "ننصح بالترقية أو بشحن الرصيد.",
      "ai_near_projected": "متوقع {{amount}} بنهاية الفترة.",
      "credits_empty_title": "رصيد النقاط فارغ",
      "credits_empty_detail": "اطلب من مسؤول المنصة شحن رصيد الذكاء الاصطناعي.",
      "invites_pending_title": "دعوات قيد الانتظار",
      "invites_pending_detail": "{{count}} بانتظار القبول."
    },
    "usage": {
      "title": "الاستخدام والإنفاق",
      "seats": "المقاعد",
      "seats_caption": "من {{limit}} مقعدًا",
      "unlimited_seats_caption": "مقاعد غير محدودة",
      "messages": "رسائل الذكاء الاصطناعي",
      "messages_caption": "من {{limit}} هذا الشهر",
      "storage": "التخزين",
      "storage_caption": "من {{limit}}",
      "ai_spend": "إنفاق الذكاء الاصطناعي",
      "ai_spend_caption": "من حد {{limit}}",
      "ai_projected": "متوقع {{amount}}",
      "this_month": "هذا الشهر",
      "unavailable": "بيانات الاستخدام غير متاحة."
    },
    "billing": {
      "title": "الفوترة",
      "next_bill": "الفاتورة القادمة",
      "renews": "يتجدد {{date}} · {{when}}",
      "no_upcoming": "لا توجد فاتورة قادمة",
      "cycle": "دورة الفوترة",
      "payment": "الدفع",
      "no_card": "لا توجد",
      "credit_balance": "رصيد النقاط",
      "credits": "{{count}} نقطة",
      "manage": "إدارة الفوترة",
      "not_configured": "لم تُهيّأ الفوترة.",
      "monthly": "شهري",
      "yearly": "سنوي",
      "status": {
        "active": "نشط",
        "trialing": "تجريبي",
        "past_due": "متأخر",
        "canceled": "ملغى",
        "none": "لا يوجد اشتراك"
      }
    },
    "people": {
      "title": "الفريق",
      "manage": "إدارة",
      "members": "الأعضاء",
      "roles": "الأدوار",
      "custom_roles": "أدوار مخصصة",
      "pending_invites": "دعوات معلّقة",
      "owners_admins": "المالكون والمشرفون",
      "secretaries": "السكرتارية",
      "guests": "الضيوف",
      "roles_link": "الأدوار والصلاحيات"
    },
    "activity": {
      "title": "النشاط الأخير",
      "view_all": "عرض الكل",
      "empty": "لا يوجد نشاط حديث بعد."
    },
    "quick_links": {
      "members": "الأعضاء",
      "members_desc": "الدعوة والتعديل والإزالة",
      "roles": "الأدوار",
      "roles_desc": "أدوار مخصصة وصلاحيات",
      "billing": "الفوترة",
      "billing_desc": "الخطة والفواتير والنقاط",
      "settings": "الإعدادات",
      "settings_desc": "إعدادات المؤسسة"
    },
    "countdown": {
      "overdue": "متأخر",
      "today": "اليوم",
      "tomorrow": "غدًا",
      "in_days": "خلال {{n}} يومًا"
    }
  },
  "account_notifications_master_title": "عناصر التحكم الرئيسية",
  "account_notifications_master_description": "تُطبّق على كل الفئات. لا يزال بإمكانك تبديل الأصوات والقنوات لكل فئة أدناه.",
  "account_notifications_sounds_enabled_label": "الأصوات مفعّلة",
  "account_notifications_sounds_enabled_description": "عند إيقافها، لن يصدر أي صوت لأي إشعار بغض النظر عن إعدادات كل فئة.",
  "account_notifications_column_inapp": "داخل التطبيق",
  "account_notifications_column_sound": "الصوت",
  "account_notifications_column_preview": "معاينة الصوت",
  "account_notifications_preview_sound_aria": "معاينة صوت هذه الفئة",
  "account_notifications_group_messages_title": "الرسائل",
  "account_notifications_group_messages_description": "المحادثات وإشارات ملاحظات العملاء من صندوق الوارد.",
  "account_notifications_group_events_title": "الأحداث",
  "account_notifications_group_events_description": "الحجوزات، وإعادة الجدولة، والإلغاءات في تقويمك.",
  "account_notifications_category_messageNew_label": "رسالة جديدة",
  "account_notifications_category_messageNew_description": "أرسل لك شخص رسالة في أي محادثة يمكنك رؤيتها.",
  "account_notifications_category_messageInOpenChat_label": "رسالة في المحادثة المفتوحة",
  "account_notifications_category_messageInOpenChat_description": "وصلت رسالة جديدة في المحادثة التي تعرضها حاليًا.",
  "account_notifications_category_conversationFeedback_label": "ملاحظات العملاء",
  "account_notifications_category_conversationFeedback_description": "استخرج الذكاء الاصطناعي ملاحظات إيجابية أو سلبية من محادثة.",
  "account_notifications_category_eventCreated_label": "تم إنشاء حدث",
  "account_notifications_category_eventCreated_description": "تمت جدولة حدث جديد.",
  "account_notifications_category_eventModified_label": "تم تعديل حدث",
  "account_notifications_category_eventModified_description": "تمت إعادة جدولة حدث، أو تغيير نوعه، أو إعادته بعد الإلغاء.",
  "account_notifications_category_eventCancelled_label": "تم إلغاء حدث",
  "account_notifications_category_eventCancelled_description": "تم إلغاء حدث.",
  "dashboard_assistant": "المساعد",
  "dashboard_nav_assistant_desc": "نتائج الذكاء الاصطناعي والتكلفة واستخدام قاعدة المعرفة",
  "dashboard": {
    "outcomes": {
      "compared_previous": "مقارنة بالفترة السابقة",
      "minutes_value": "{count} د",
      "hours_value": "{count} س",
      "scheduling_title": "نتائج المواعيد",
      "no_show_hint": "حالات عدم الحضور من بين المواعيد المكتملة أو المسجلة كعدم حضور",
      "no_show_counts": "{noShows} عدم حضور · {resolved} محسومة",
      "no_resolved": "لا توجد مواعيد محسومة",
      "no_show_rate": "معدل عدم الحضور",
      "time_to_booking_hint": "الوسيط من أول رسالة واردة مرصودة إلى أول حجز",
      "booking_samples": "{count} جهة اتصال مرصودة",
      "no_booking_samples": "لا توجد عينات مؤهلة",
      "time_to_first_booking": "الوقت حتى أول حجز",
      "no_show_by_type": "معدل عدم الحضور حسب نوع الحدث",
      "event_type": "نوع الحدث",
      "resolved": "محسومة",
      "containment_proxy_hint": "مؤشر تقريبي من القياس: المحادثات التي تفاعل فيها الذكاء الاصطناعي دون طلب تحويل إلى موظف",
      "containment_counts": "{handoffs} طلب تحويل · {engaged} محادثة تفاعل فيها الذكاء الاصطناعي",
      "no_ai_threads": "لا توجد محادثات للذكاء الاصطناعي في هذه الفترة",
      "handoff_free_rate": "معدل عدم التحويل",
      "ai_engaged_threads": "محادثات تفاعل فيها الذكاء الاصطناعي",
      "handoffs_requested": "طلبات تحويل",
      "no_shows": "حالات عدم حضور",
      "minutes_short": "د",
      "observable_contacts": "جهات اتصال مرصودة"
    },
    "assistant": {
      "roi_title": "نتائج الذكاء الاصطناعي",
      "cost_this_period": "تكلفة الذكاء الاصطناعي لهذه الفترة",
      "cost_per_appointment": "التكلفة لكل موعد محجوز",
      "ai_share_of_operations": "حصة الذكاء الاصطناعي من العمليات",
      "actions_title": "ماذا فعل مساعدك",
      "actions_empty": "لا توجد إجراءات للذكاء الاصطناعي في هذه الفترة بعد.",
      "action_failed": "({count} فشل)",
      "action_booked": "حجز {count} مواعيد",
      "action_rescheduled": "أعاد جدولة {count}",
      "action_cancelled": "ألغى {count}",
      "action_answered": "أجاب عن {count} سؤالًا باستخدام مستنداتك",
      "action_handoff": "حوّل {count} محادثات إلى فريقك",
      "action_leads": "جمع {count} عملاء محتملين",
      "action_feedback": "سجّل {count} ملاحظات",
      "action_menus": "أرسل {count} قوائم ومواقع",
      "action_lookups": "راجع الجداول والتوافر {count} مرة",
      "action_other": "إجراءات أخرى {count}",
      "knowledge_base_storage": "مساحة التخزين الحالية لقاعدة المعرفة",
      "storage_caption": "لقطة حالية · يتضمن الحد {limit}",
      "retrieval_gaps_more_available": "تتوفر أسئلة أخرى بلا إجابة",
      "knowledge_base_title": "قاعدة المعرفة",
      "knowledge_base_empty": "لم يستعن الذكاء الاصطناعي بقاعدة معرفتك بعد.",
      "knowledge_base_headline": "{count}٪ من إجابات الذكاء الاصطناعي استندت إلى قاعدة معرفتك",
      "most_referenced_documents": "أكثر المستندات استخدامًا",
      "citations_count": "{count} استشهادات",
      "coverage_footnote": "استنادًا إلى {count}٪ من ردود الذكاء الاصطناعي",
      "empty_state": "سيظهر نشاط مساعد الذكاء الاصطناعي هنا.",
      "operation_origin_desc": "من تولى كل عملية جدولة",
      "events_per_model": "الأحداث المنشأة حسب النموذج",
      "retrieval_gaps_title": "أسئلة بلا إجابات",
      "retrieval_gaps_desc": "عمليات بحث حديثة لم يتمكن الذكاء الاصطناعي من الإجابة عنها من قاعدة معرفتك — ارفع مستندات لسد الفجوة.",
      "retrieval_gaps_empty": "وجد الذكاء الاصطناعي مصادر لكل سؤال.",
      "retrieval_gaps_error": "تعذّر تحميل الأسئلة غير المُجاب عنها.",
      "retrieval_gaps_no_query": "(لا يوجد نص للاستعلام)",
      "retrieval_gaps_overflow": "+{count} أسئلة أخرى بلا إجابة"
    }
  },
  "citation_status_verified": "موثّق",
  "citation_status_partial": "مدعوم جزئياً",
  "citation_status_contradicted": "متناقض",
  "citation_status_not_verified": "غير موثّق",
  "citation_status_failed": "تعذّر التحقق",
  "citation_status_unverified": "لم يُتحقق",
  "citation_view_source": "عرض المصدر",
  "citation_chip_aria": "الاستشهاد {number}",
  "citation_more_aria": "{count} استشهادات إضافية",
  "citation_quoted": "مقتبس",
  "citation_untitled_source": "مصدر بلا عنوان",
  "citation_sources_count": "المصادر ({count})",
  "citation_sources_title": "المصادر",
  "citation_count": "{count} استشهادات",
  "citation_pdf_load_error": "تعذّر تحميل معاينة المستند.",
  "citation_no_text_preview": "لا تتوفر معاينة نصية لهذا المصدر.",
  "citation_no_image_preview": "معاينة الصورة غير متوفرة.",
  "citation_sheet_default": "ورقة",
  "citation_sheet_rows": "الصفوف {start}–{end}",
  "citation_region_counter": "{index} / {total}",
  "citation_prev_region": "الاستشهاد السابق",
  "citation_next_region": "الاستشهاد التالي",
  "citation_view_page": "الصفحة",
  "citation_view_text": "النص",
  "citation_check": "التحقق من الاستشهادات",
  "citation_preview_document": "معاينة المستند",
  "metrics_agents": "الوكلاء",
  "metrics_agents_mode": "الوضع {mode}",
  "metrics_agents_tokens": "{tokens} رمز",
  "metrics_agents_loops": "{loops} دورات",
  "chat_action_rewind": "التراجع إلى هنا",
  "chat_rewind_failed": "تعذّر التراجع عن الرسالة",
  "admin_roles_tab_permissions": "الأذونات",
  "admin_roles_tab_members": "الأعضاء",
  "admin_roles_members_column_name": "الاسم",
  "admin_roles_members_column_email": "البريد الإلكتروني",
  "admin_roles_members_column_org_role": "دور المؤسسة",
  "admin_roles_members_column_assigned": "معيَّن",
  "admin_roles_members_other_role_title": "العضو موجود في دور آخر — التبديل سينقله إلى هنا",
  "admin_roles_members_assignment_failed": "فشل تحديث تعيين العضو.",
  "admin_roles_members_failed_to_load": "فشل تحميل الأعضاء.",
  "admin_roles_members_empty": "لا يوجد أعضاء في هذه المؤسسة بعد.",
  "config_event_colors_document_highlight_label": "تمييز المستند",
  "config_event_colors_document_highlight_tip": "لون حد مميز للفعاليات التي تحتوي على مستندات مرفقة.",
  "config_event_colors_document_picker_aria": "منتقي ألوان حلقة المستند",
  "config_event_colors_document_hex_aria": "قيمة هيكس حلقة المستند",
  "contact_active_label": "نشط",
  "contact_add_contact": "إضافة جهة اتصال",
  "contact_add_dialog_description": "أدخل اسم جهة الاتصال ورقم هاتف يمكن الوصول إليه.",
  "contact_add_to_queue": "إضافة إلى القائمة",
  "contact_ai_auto_reply_label": "الرد التلقائي بالذكاء الاصطناعي",
  "contact_apply_button": "تطبيق",
  "contact_beneficiaries_count": "{{count}} مستفيد",
  "contact_beneficiary_add": "إضافة مستفيد",
  "contact_beneficiary_add_desc": "أضف شخصاً يُحجز له عبر {{name}}. لا يملك هاتفاً خاصاً — تصل التذكيرات إلى جهة الاتصال.",
  "contact_beneficiary_delete": "حذف المستفيد",
  "contact_beneficiary_delete_desc": "أرشفة {{name}}؟ يبقى سجل حجوزاته ويمكن استعادته لاحقاً.",
  "contact_beneficiary_merge": "دمج في جهة الاتصال الأصلية",
  "contact_beneficiary_merge_confirm": "دمج",
  "contact_beneficiary_merge_desc": "دمج {{name}} في {{parent}}؟ ستنتقل حجوزاته إلى {{parent}}، وستُضاف صفحات مستنده إلى مستند {{parent}}، وسيُحذف {{name}}. لا يمكن التراجع عن هذا الإجراء.",
  "contact_beneficiary_merge_failed": "فشل الدمج في جهة الاتصال الأصلية",
  "contact_beneficiary_move": "نقل إلى جهة اتصال أخرى",
  "contact_beneficiary_move_desc": "اختر جهة الاتصال التي ستحجز لـ {{name}} من الآن فصاعداً.",
  "contact_beneficiary_name_placeholder": "اسم المستفيد",
  "contact_beneficiary_pull": "سحب جهة اتصال كمستفيد",
  "contact_beneficiary_pull_confirm": "سحب جهة الاتصال",
  "contact_beneficiary_pull_desc": "اختر جهة اتصال لتصبح مستفيداً لدى {{name}}.",
  "contact_beneficiary_pull_warning": "هذه عملية فقدان بيانات: تفقد جهة الاتصال رقم هاتفها وسجل رسائلها وملخصات المحادثات المحفوظة ومحادثاتها النشطة. يتم الاحتفاظ بحجوزاتها ومستنداتها.",
  "contact_beneficiary_pull_warning_named": "سيفقد {{name}} رقم هاتفه وسجل رسائله وملخصات المحادثات المحفوظة ومحادثاته النشطة. يتم الاحتفاظ بحجوزاته ومستنداته.",
  "contact_beneficiary_rename": "إعادة تسمية",
  "contact_beneficiary_separate": "فصل كجهة اتصال",
  "contact_beneficiary_separate_confirm": "فصل",
  "contact_beneficiary_separate_desc": "امنح {{name}} رقم هاتف خاصاً به ليصبح جهة اتصال مستقلة ويحتفظ بحجوزاته.",
  "contact_beneficiary_separate_merge_hint": "هذا الرقم يعود إلى {{target}} — ستنتقل حجوزات {{name}} وصفحات مستنده إلى {{target}}، وسيُحذف {{name}}. لا يمكن التراجع عن هذا الإجراء.",
  "contact_beneficiary_sibling_merge": "دمج في مستفيد آخر",
  "contact_beneficiary_sibling_merge_confirm": "دمج المستفيدين",
  "contact_beneficiary_sibling_merge_desc": "اختر المستفيد الذي سيحتفظ بحجوزات {{name}} ومحادثاته وصفحات مستنده.",
  "contact_beneficiary_sibling_merge_empty": "لا يوجد مستفيد آخر محمّل ضمن جهة الاتصال هذه.",
  "contact_beneficiary_sibling_merge_failed": "فشل دمج المستفيدين",
  "contact_beneficiary_sibling_merge_placeholder": "اختر المستفيد الذي سيبقى",
  "contact_beneficiary_sibling_merge_target": "المستفيد الذي سيبقى",
  "contact_beneficiary_sibling_merge_warning": "سيُحذف {{source}}، وتنتقل حجوزاته ومحادثاته وصفحات مستنده إلى {{target}}. لا يمكن التراجع عن هذا الإجراء.",
  "contact_beneficiary_sibling_merge_warning_generic": "سيحتفظ المستفيد المحدد بالحجوزات والمحادثات وصفحات المستند المدمجة، وسيُحذف المستفيد الآخر. لا يمكن التراجع عن هذا الإجراء.",
  "contact_bookings_count": "{{count}} حجوزات",
  "contact_bool_no": "لا",
  "contact_bool_yes": "نعم",
  "contact_bulk_delete_failed": "فشل حذف جهات الاتصال",
  "contact_change_reverted_toast": "تم التراجع عن التغيير",
  "contact_changes_reverted_toast": "تم التراجع عن التغييرات",
  "contact_changes_saved_toast": "تم حفظ تغييرات جهة الاتصال",
  "contact_channel_manual": "يدوي",
  "contact_channel_system": "النظام",
  "contact_channel_web": "الويب",
  "contact_channels_label": "القنوات",
  "contact_collapse_details": "طي تفاصيل جهة الاتصال",
  "contact_copy_contact_id": "نسخ معرّف جهة الاتصال",
  "contact_copy_phone": "نسخ رقم الهاتف",
  "contact_count": "{{count}} جهات اتصال",
  "contact_create_failed": "فشل إنشاء جهة الاتصال",
  "contact_delete_contact": "حذف جهة الاتصال",
  "contact_delete_failed": "فشل حذف جهة الاتصال",
  "contact_deleted_badge": "محذوف",
  "contact_detail_activity_bookings": "النشاط والحجوزات",
  "contact_detail_archived_at": "تاريخ الأرشفة",
  "contact_detail_attached": "مرفق",
  "contact_detail_beneficiaries": "المستفيدون",
  "contact_detail_bookings": "الحجوزات",
  "contact_detail_channels_ai": "القنوات والذكاء الاصطناعي",
  "contact_detail_contact_id": "معرّف جهة الاتصال",
  "contact_detail_country": "الدولة",
  "contact_detail_created": "تاريخ الإنشاء",
  "contact_detail_documents": "المستندات",
  "contact_detail_first_seen": "أول ظهور",
  "contact_detail_identity": "الهوية",
  "contact_detail_last_active": "آخر نشاط",
  "contact_detail_last_booking": "آخر حجز",
  "contact_detail_messages": "الرسائل",
  "contact_detail_next_booking": "الحجز القادم",
  "contact_detail_nickname": "الاسم المستعار",
  "contact_detail_none": "لا يوجد",
  "contact_details_label": "التفاصيل",
  "contact_diff_field_active": "نشط",
  "contact_diff_field_channel": "القناة",
  "contact_diff_field_deleted": "محذوف",
  "contact_diff_field_name": "الاسم",
  "contact_diff_field_phone": "الهاتف",
  "contact_edit_button": "تعديل",
  "contact_edit_contact": "تعديل جهة الاتصال",
  "contact_edit_contact_title": "تعديل جهة الاتصال",
  "contact_edit_sheet_edit_description": "حدّث تفاصيل جهة الاتصال هذه. التغييرات تبقى معلّقة حتى تحفظ الجدول.",
  "contact_edit_sheet_new_description": "أدخل تفاصيل جهة الاتصال ثم اضغط حفظ.",
  "contact_expand_details": "توسيع تفاصيل جهة الاتصال",
  "contact_failed_to_load_appointments": "فشل تحميل المواعيد: {{message}}",
  "contact_failed_to_load_contacts": "فشل تحميل جهات الاتصال: {{message}}",
  "contact_failed_to_load_history": "فشل تحميل السجل: {{message}}",
  "contact_favorite_label": "مفضّلة",
  "contact_favorite_update_failed": "فشل تحديث المفضّلة",
  "contact_field_active": "نشط",
  "contact_field_channel": "القناة",
  "contact_field_name": "الاسم",
  "contact_field_phone": "الهاتف",
  "contact_full_name_placeholder": "الاسم الكامل",
  "contact_generic_label": "جهة اتصال",
  "contact_history_actor_system": "النظام",
  "contact_history_by_actor": "بواسطة {{actor}}",
  "contact_history_description": "سجل التغييرات وسجل المواعيد المجمّع لجهة الاتصال هذه.",
  "contact_history_event_created": "تم الإنشاء",
  "contact_history_event_restored": "تمت الاستعادة",
  "contact_history_event_reverted": "تم التراجع",
  "contact_history_event_soft_deleted": "تم الحذف المؤقت",
  "contact_history_event_updated": "تم التحديث",
  "contact_history_tab_appointments": "المواعيد",
  "contact_history_tab_history": "السجل",
  "contact_history_title": "جهة الاتصال",
  "contact_actions_group_history": "السجل",
  "contact_actions_group_manage": "إدارة",
  "contact_id_copied_toast": "تم نسخ معرّف جهة الاتصال",
  "contact_id_copy_failed_toast": "تعذّر نسخ معرّف جهة الاتصال",
  "contact_inactive_hint": "جهات الاتصال غير النشطة مخفية عن المساعد.",
  "contact_inactive_label": "غير نشط",
  "contact_loading_ellipsis": "جارٍ التحميل...",
  "contact_loading_more": "جارٍ تحميل المزيد من جهات الاتصال…",
  "contact_merge_failed": "فشل دمج جهات الاتصال",
  "contact_messages_count": "{{count}} رسائل",
  "contact_new_badge": "جديد",
  "contact_new_contact_title": "جهة اتصال جديدة",
  "contact_no_appointments": "لا توجد مواعيد لهذا المريض.",
  "contact_no_beneficiaries": "لا يوجد مستفيدون",
  "contact_no_bookings": "لا توجد حجوزات",
  "contact_no_channels": "لا توجد قنوات",
  "contact_no_contact_details": "لا توجد تفاصيل لجهة الاتصال",
  "contact_no_contacts_found": "لم يتم العثور على جهات اتصال",
  "contact_no_contacts_yet": "لا توجد جهات اتصال بعد.",
  "contact_no_history_events": "لا توجد أحداث سجل بعد.",
  "contact_no_messages": "لا توجد رسائل",
  "contact_no_name": "(بلا اسم)",
  "contact_open_conversation": "فتح المحادثة",
  "contact_org_contact_required_history": "المؤسسة وجهة الاتصال مطلوبتان لتحميل السجل",
  "contact_org_required_create": "المؤسسة مطلوبة لإنشاء جهات الاتصال",
  "contact_org_required_delete": "المؤسسة مطلوبة لحذف جهات الاتصال",
  "contact_org_required_fetch": "المؤسسة مطلوبة لجلب جهات الاتصال",
  "contact_org_required_list": "المؤسسة مطلوبة لعرض جهات الاتصال",
  "contact_org_required_merge": "المؤسسة مطلوبة لدمج جهات الاتصال",
  "contact_org_required_restore": "المؤسسة مطلوبة لاستعادة جهات الاتصال",
  "contact_org_required_revert_event": "المؤسسة مطلوبة للتراجع عن أحداث جهة الاتصال",
  "contact_org_required_stats": "المؤسسة مطلوبة لتحميل إحصائيات جهات الاتصال",
  "contact_org_required_unmerge": "المؤسسة مطلوبة لإلغاء دمج جهات الاتصال",
  "contact_org_required_update": "المؤسسة مطلوبة لتحديث جهات الاتصال",
  "contact_page_subtitle": "كل من يتحدث معهم مساعدك، عبر كل قناة.",
  "contact_page_title": "جهات الاتصال",
  "contact_row_save": "حفظ جهة الاتصال",
  "contact_row_revert": "تجاهل تغييرات هذا الصف",
  "contact_phone_copied_toast": "تم نسخ رقم الهاتف",
  "contact_phone_copy_failed_toast": "تعذّر نسخ رقم الهاتف",
  "contact_phone_e164_label": "الهاتف (E.164)",
  "contact_phone_editor_label": "محرّر الهاتف",
  "contact_picker_invalid_target": "لا يمكن اختيار جهة الاتصال هذه هنا.",
  "contact_restore_failed": "فشل استعادة جهة الاتصال",
  "contact_revert_button": "تراجع",
  "contact_revert_confirm_intro": "سيؤدي هذا إلى إعادة جهة الاتصال إلى الحالة التي كانت عليها في",
  "contact_revert_confirm_title": "التراجع عن هذا التغيير؟",
  "contact_revert_discard_suffix": "سيتم تجاهلها بهذا التراجع.",
  "contact_revert_event_failed": "فشل التراجع عن حدث جهة الاتصال",
  "contact_revert_failed": "فشل التراجع",
  "contact_revert_newer_change": "{{count}} تغييرات أحدث",
  "contact_reverted_toast": "تم التراجع إلى النسخة المحددة",
  "contact_reverting_ellipsis": "جارٍ التراجع…",
  "contact_save_failed": "فشل حفظ جهات الاتصال",
  "contact_search_contacts": "البحث في جهات الاتصال",
  "contact_search_placeholder": "ابحث بالاسم أو رقم الهاتف…",
  "contact_select_visible": "تحديد جهات الاتصال الظاهرة",
  "contact_show_deleted": "إظهار المحذوفة",
  "contact_state_ai_replies": "ردود الذكاء الاصطناعي",
  "contact_state_archived": "مؤرشف",
  "contact_state_blocked": "محظور",
  "contact_state_manual": "يدوي",
  "contact_stats_active": "نشط",
  "contact_stats_active_hint": "راسل خلال آخر 30 يومًا",
  "contact_stats_new_hint": "أُضيف منذ بداية الشهر",
  "contact_stats_new_this_month": "جديد هذا الشهر",
  "contact_stats_total_contacts": "إجمالي جهات الاتصال",
  "contact_stats_upcoming_bookings": "الحجوزات القادمة",
  "contact_stats_upcoming_hint": "حجز مؤكد أو قيد الانتظار",
  "contact_status_toggle_activate": "غير نشط — اضغط للتفعيل",
  "contact_status_toggle_deactivate": "نشط — اضغط للتعطيل",
  "contact_summary_added": "{{count}} أُضيفت",
  "contact_summary_deleted": "{{count}} حُذفت",
  "contact_summary_updated": "{{count}} حُدّثت",
  "contact_undo_bool_no": "لا",
  "contact_undo_bool_yes": "نعم",
  "contact_undo_deselect_all": "إلغاء تحديد الكل",
  "contact_undo_dialog_description": "راجع ما تم حفظه واختر جهات الاتصال التي تريد التراجع عنها. الجانب الأيسر يعرض حالتها قبل التغيير.",
  "contact_undo_dialog_title": "التراجع عن التغييرات المحفوظة",
  "contact_undo_failed": "فشل التراجع عن التغييرات",
  "contact_undo_fallback_label": "جهة الاتصال",
  "contact_undo_keep_changes": "الاحتفاظ بالتغييرات",
  "contact_undo_kind_added": "أُضيفت",
  "contact_undo_kind_deleted": "حُذفت",
  "contact_undo_kind_updated": "حُدّثت",
  "contact_undo_revert_count": "التراجع عن {{count}} تغييرات",
  "contact_undo_select_all": "تحديد الكل",
  "contact_undo_selected": "محدَّد",
  "contact_undo_selected_count": "{{selected}} من {{total}} محدَّدة",
  "contact_unmerge_button": "إلغاء الدمج",
  "contact_unmerge_failed": "فشل إلغاء الدمج",
  "contact_unmerge_mutation_failed": "فشل إلغاء دمج جهة الاتصال",
  "contact_unmerged_toast": "تم إلغاء دمج جهة الاتصال",
  "contact_unmerging_ellipsis": "جارٍ إلغاء الدمج…",
  "contact_unnamed": "بلا اسم",
  "contact_unnamed_contact": "جهة اتصال بلا اسم",
  "contact_update_failed": "فشل تحديث جهة الاتصال",
  "contact_validation_duplicate_phone": "توجد جهة اتصال أخرى في هذه المؤسسة تستخدم رقم الهاتف هذا بالفعل.",
  "contact_validation_failed": "فشل التحقق من الصحة",
  "contact_validation_name_required": "الاسم مطلوب عند إضافة جهة اتصال جديدة.",
  "contact_validation_name_too_long": "يجب ألا يزيد الاسم على 120 حرفًا.",
  "contact_validation_phone_invalid_area": "رقم الهاتف غير صالح لرمز الدولة أو المنطقة الخاص به.",
  "contact_validation_phone_invalid_format": "رقم الهاتف غير مكتمل أو بصيغة غير معروفة.",
  "contact_validation_phone_required": "رقم الهاتف مطلوب عند عدم توفر اسم.",
  "contact_validation_phone_required_for_new_contact": "رقم الهاتف مطلوب عند إضافة جهة اتصال جديدة.",
  "contact_validation_row_label": "الصف {{row}}",
  "contact_verb_added": "أُضيفت",
  "contact_verb_deleted": "حُذفت",
  "contact_verb_updated": "حُدّثت",
  "contact_view_history": "عرض سجل جهة الاتصال",
  "mutation_error_generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "mutation_error_org_roles_not_seeded": "لم يتم إعداد أدوار مؤسستك بعد — تواصل مع أحد المسؤولين.",
  "feat_users_toast_create_failed": "فشل إنشاء المستخدم",
  "feat_users_toast_update_failed": "فشل تحديث المستخدم",
  "feat_users_toast_delete_failed": "فشل حذف المستخدم",
  "feat_users_toast_update_profile_failed": "فشل تحديث الملف الشخصي",
  "feat_users_toast_save_document_failed": "فشل حفظ مستند المستخدم",
  "feat_users_toast_update_favorite_failed": "فشل تحديث المفضلة",
  "feat_users_toast_update_active_status_failed": "فشل تحديث حالة التفعيل",
  "feat_users_toast_modify_phone_failed": "فشل تعديل رقم الهاتف",
  "feat_team_console_toast_send_notice_failed": "فشل إرسال الإشعار",
  "feat_team_console_toast_update_member_status_failed": "فشل تحديث حالة العضو",
  "feat_team_console_toast_remove_member_failed": "فشل إزالة العضو",
  "feat_config_toast_update_failed": "فشل تحديث الإعدادات",
  "feat_config_toast_create_failed": "فشل إنشاء الإعدادات",
  "feat_auth_toast_delete_org_failed": "فشل حذف المؤسسة",
  "feat_playground_toast_upload_document_failed": "فشل رفع المستند",
  "feat_playground_toast_delete_document_failed": "فشل حذف المستند",
  "feat_playground_toast_toggle_document_failed": "فشل تبديل حالة المستند",
  "feat_playground_toast_clear_failed": "فشل مسح مساحة التجربة",
  "feat_playground_toast_search_failed": "فشل البحث",
  "feat_playground_toast_agent_run_failed": "فشل تشغيل الوكيل",
  "feat_playground_upload_cancel": "إلغاء الرفع",
  "feat_playground_upload_dismiss": "إخفاء",
  "feat_playground_upload_cancel_hint_queued": "لم يُرسل أي شيء بعد — هذا يوقفه تمامًا.",
  "feat_playground_upload_cancel_hint_sending": "يوقف الإرسال. قد يكون الخادم يحتفظ بالملف بالفعل؛ وإذا ظهر مستند فسيُحذف.",
  "feat_playground_upload_cancel_hint_accepted": "يحذف المستند. أي تحليل أو تضمين قيد التنفيذ سيكتمل، وما أُنفق يبقى منفقًا.",
  "feat_playground_upload_client_bytes_caption": "مقاسة في متصفحك — بايتات مُرسلة، لا عمل منجز.",
  "feat_playground_upload_phase_queued": "في الانتظار",
  "feat_playground_upload_phase_uploading": "جارٍ الإرسال",
  "feat_playground_upload_phase_sent": "بانتظار الخادم",
  "feat_playground_upload_phase_accepted": "مقبول",
  "feat_playground_upload_phase_cancelling": "جارٍ الإلغاء",
  "feat_playground_upload_phase_cancelled": "أُلغي",
  "feat_playground_upload_phase_failed": "فشل",
  "feat_playground_upload_phase_done": "تمت المعالجة",
  "feat_playground_upload_orphan_pending": "يجري التحقق مما إذا كان الخادم قد احتفظ بنسخة من هذا الملف.",
  "feat_playground_upload_orphan_reaped": "كان الخادم يحتفظ بنسخة، وقد أُزيلت.",
  "feat_playground_upload_orphan_ambiguous": "أكثر من مستند قد يكون هذا الرفع، لذلك لم يُحذف أي منها. احذف الزائد بنفسك.",
  "feat_playground_upload_orphan_unresolved": "لم يظهر أي مستند مطابق. إذا ظهر لاحقًا فاحذفه بنفسك.",
  "feat_playground_upload_too_large": "حجم هذا الملف أكبر من الحد المسموح به للرفع.",
  "rag_stage_uploading_client": "جارٍ إرسال الملف",
  "rag_cost_source_actual": "فعلية",
  "rag_cost_source_unknown": "غير مسعّرة",
  "rag_cost_unknown_count": "{{count}} استدعاءات",
  "rag_stage_analyzing": "جارٍ تحليل الملف",
  "rag_stage_parsing": "جارٍ استخراج النص",
  "rag_stage_figures": "جارٍ قراءة الأشكال",
  "rag_stage_summarizing": "جارٍ التلخيص",
  "rag_stage_chunking": "جارٍ التقسيم إلى مقاطع",
  "rag_stage_contextualizing": "جارٍ إضافة السياق",
  "rag_stage_embedding": "جارٍ إنشاء التضمينات",
  "rag_stage_storing": "جارٍ حفظ الفهرس",
  "rag_stage_completed": "جاهز",
  "rag_stage_failed": "فشل",
  "rag_stage_substep_progress": "{{label}} {{done}}/{{total}}",
  "pg_ingest_upload_client_hint": "بايتات الطلب التي أرسلها هذا المتصفح. لم يبدأ الخادم العمل بعد.",
  "feat_event_types_toast_save_failed": "فشل حفظ نوع الحدث",
  "feat_event_types_toast_deactivate_failed": "فشل إلغاء تفعيل نوع الحدث",
  "feat_event_types_toast_reorder_failed": "فشل إعادة ترتيب أنواع الأحداث",
  "feat_event_types_toast_add_field_failed": "فشل إضافة الحقل",
  "feat_event_types_toast_update_field_failed": "فشل تحديث الحقل",
  "feat_event_types_toast_remove_field_failed": "فشل إزالة الحقل",
  "feat_event_types_toast_reorder_fields_failed": "فشل إعادة ترتيب الحقول",
  "feat_roles_toast_create_failed": "فشل إنشاء الدور",
  "feat_roles_toast_update_failed": "فشل تحديث الدور",
  "feat_roles_toast_delete_failed": "فشل حذف الدور",
  "feat_app_config_toast_upload_document_failed": "فشل رفع المستند",
  "feat_app_config_toast_delete_document_failed": "فشل حذف المستند",
  "feat_app_config_toast_toggle_document_failed": "فشل تبديل حالة المستند",
  "feat_app_config_toast_apply_strategy_failed": "فشل تطبيق استراتيجية التضمين",
  "feat_app_config_toast_schema_preload_failed": "فشل تحديث التحميل المسبق للمخطط",
  "feat_app_config_rag_schema_preload_label": "تحميل المخطط مسبقًا",
  "feat_app_config_rag_schema_preload_tooltip": "حقن مخطط جدول البيانات هذا في موجّه المساعد",
  "feat_app_config_toast_image_policy_failed": "فشل تحديث طريقة التعامل مع الصور",
  "rag_image_policy_label": "الصور في الإجابات",
  "rag_image_policy_tooltip": "اختر طريقة استخدام أشكال هذا المستند",
  "rag_image_policy_describe_label": "وصف",
  "rag_image_policy_attach_label": "إرفاق",
  "rag_image_policy_ocr_label": "قراءة النص",
  "rag_image_policy_ignore_label": "تجاهل",
  "rag_image_policy_describe_hint": "يكتب نموذج رؤية وصفًا موجزًا لكل شكل، ويصبح هذا الوصف قابلًا للبحث مع بقية المستند.",
  "rag_image_policy_attach_hint": "يُرسَل الشكل نفسه إلى المساعد عندما يستطيع النموذج رؤية الصور. لا يُكتب أي وصف، لذا لا يمكن الوصول إلى الشكل إلا عبر النص المحيط به، وليس عبر سؤال يصف الصورة.",
  "rag_image_policy_ocr_hint": "يُقرأ النص داخل كل شكل حرفًا بحرف ويصبح قابلًا للبحث. الأنسب للصفحات الممسوحة ولقطات الشاشة والرسوم المليئة بالتسميات.",
  "rag_image_policy_ignore_hint": "تُتجاهَل الأشكال تمامًا: بلا وصف ولا نص ولا صورة مخزَّنة.",
  "rag_image_policy_ingest_note": "لن يؤثر هذا التغيير في الإجابات إلا بعد إعادة معالجة المستند.",
  "rag_image_policy_reprocess_hint": "استخدم «استبدال» في هذا الصف لإعادة معالجته الآن.",
  "rag_image_policy_answer_note": "يسري فورًا ابتداءً من الإجابة التالية.",
  "rag_image_policy_inherits": "يتبع الإعداد الافتراضي للمنظمة ({{mode}}).",
  "rag_image_policy_default_label": "الافتراضي للمستندات الجديدة",
  "rag_image_policy_default_tip": "كيفية التعامل مع الأشكال في المستندات التي ترفعها من الآن فصاعدًا. يمكن لأي مستند تجاوز هذا من صفه الخاص.",
  "feat_app_config_rag_schema_preload_token_warning": "المخططات المحمّلة مسبقًا كبيرة (~{{tokens}} رمزًا) وقد تبطئ الاستجابات.",
  "feat_app_config_toast_revert_prompt_failed": "فشل استرجاع نسخة التوجيه",
  "feat_superadmin_toast_create_org_failed": "فشل إنشاء المؤسسة",
  "feat_superadmin_toast_update_org_failed": "فشل تحديث المؤسسة",
  "feat_superadmin_toast_toggle_org_status_failed": "فشل تبديل حالة المؤسسة",
  "feat_superadmin_toast_update_org_secrets_failed": "فشل تحديث أسرار المؤسسة",
  "feat_superadmin_toast_update_member_failed": "فشل تحديث العضو",
  "feat_superadmin_toast_delete_org_failed": "فشل حذف المؤسسة",
  "feat_superadmin_toast_create_member_failed": "فشل إنشاء العضو",
  "feat_superadmin_toast_delete_member_failed": "فشل حذف العضو",
  "feat_superadmin_toast_delete_members_failed": "فشل حذف الأعضاء",
  "feat_app_feedback_toast_update_status_failed": "فشل تحديث حالة الملاحظات",
  "feat_account_privacy_toast_update_retention_failed": "فشل تحديث قواعد الاحتفاظ",
  "feat_account_privacy_toast_request_deletion_failed": "فشل طلب حذف الحساب",
  "feat_account_privacy_toast_cancel_deletion_failed": "فشل إلغاء طلب الحذف",
  "feat_account_sessions_toast_revoke_others_failed": "فشل تسجيل الخروج من الجلسات الأخرى",
  "feat_account_sessions_toast_add_passkey_failed": "فشل إضافة مفتاح المرور",
  "feat_account_profile_toast_update_failed": "فشل تحديث الملف الشخصي",
  "feat_account_profile_toast_change_email_failed": "فشل تغيير البريد الإلكتروني",
  "feat_billing_toast_checkout_failed": "فشل بدء عملية الدفع",
  "feat_billing_toast_portal_failed": "فشل فتح بوابة الفوترة",
  "feat_billing_toast_cancel_failed": "فشل إلغاء الاشتراك",
  "feat_billing_toast_sync_failed": "فشل مزامنة الفوترة",
  "feat_billing_toast_checkout_status_failed": "فشل التحقق من حالة الدفع",
  "feat_admin_plans_toast_create_draft_failed": "فشل إنشاء مسودة الخطة",
  "feat_admin_plans_toast_update_pricing_failed": "فشل تحديث التسعير",
  "feat_admin_plans_toast_publish_failed": "فشل نشر الخطة",
  "feat_admin_plans_toast_phase_out_failed": "فشل إيقاف الخطة تدريجياً",
  "feat_admin_org_balance_toast_credit_failed": "فشل إضافة رصيد للمؤسسة",
  "admin_a_actions_for": "إجراءات لـ {{name}}",
  "admin_a_active": "نشط",
  "admin_a_active_since": "نشط {{since}}",
  "admin_a_activity": "النشاط",
  "admin_a_add_member": "إضافة عضو",
  "admin_a_add_organization": "إضافة مؤسسة",
  "admin_a_ai_observability": "مراقبة الذكاء الاصطناعي",
  "admin_a_ai_runs": "تشغيلات الذكاء الاصطناعي",
  "admin_a_amount_this_month": "{{amount}} هذا الشهر",
  "admin_a_amount_total": "{{amount}} إجمالي",
  "admin_a_applying": "جارٍ التطبيق…",
  "admin_a_authenticated_count": "{{count}} موثّق",
  "admin_a_avg_value": "المتوسط {{value}}",
  "admin_a_balance_and_ledger": "الرصيد وسجل الحركات",
  "admin_a_banned": "محظور",
  "admin_a_billing": "الفوترة",
  "admin_a_by_model": "حسب النموذج",
  "admin_a_by_organization": "حسب المؤسسة",
  "admin_a_cache_hit_rate": "معدل إصابة الذاكرة المؤقتة",
  "admin_a_cache_read_write": "{{read}} قراءة / {{write}} كتابة",
  "admin_a_cache_savings_est": "توفير الذاكرة المؤقتة (تقديري)",
  "admin_a_cached_read_tokens": "{{count}} رمز قراءة مخزّن مؤقتًا",
  "admin_a_cancel": "إلغاء",
  "admin_a_catalog_estimate_vs_billed": "التقدير المرجعي مقابل التكلفة المفوترة",
  "admin_a_channel_contacts": "جهات اتصال القناة",
  "admin_a_channels_and_secrets": "القنوات والأسرار",
  "admin_a_chart_unavailable": "الرسم البياني غير متاح",
  "admin_a_clear": "سليم",
  "admin_a_close_email_templates": "إغلاق قوالب البريد الإلكتروني",
  "admin_a_col_actual": "الفعلي",
  "admin_a_col_cache": "الذاكرة المؤقتة",
  "admin_a_col_channel": "القناة",
  "admin_a_col_drift": "الانحراف",
  "admin_a_col_estimated": "المقدّر",
  "admin_a_col_last_message": "آخر رسالة",
  "admin_a_col_model": "النموذج",
  "admin_a_col_name": "الاسم",
  "admin_a_col_phone": "الهاتف",
  "admin_a_col_reasoning": "الاستدلال",
  "admin_a_col_runs": "التشغيلات",
  "admin_a_col_speed": "السرعة",
  "admin_a_col_status": "الحالة",
  "admin_a_col_tool_err": "خطأ الأداة",
  "admin_a_collapse_member_details": "طي تفاصيل العضو",
  "admin_a_collapse_org_details": "طي تفاصيل المؤسسة",
  "admin_a_confirm_quarantine": "حجر",
  "admin_a_confirm_release": "إلغاء الحجر",
  "admin_a_confirm_suspend": "تعليق",
  "admin_a_confirm_unsuspend": "إلغاء التعليق",
  "admin_a_contact_count": "{{count}} جهة اتصال",
  "admin_a_contacts_count": "{{count}} جهات اتصال",
  "admin_a_copy_org_id": "نسخ معرّف المؤسسة",
  "admin_a_cost": "التكلفة",
  "admin_a_cost_efficiency": "كفاءة التكلفة",
  "admin_a_credit_org": "إضافة رصيد للمؤسسة…",
  "admin_a_credits": "الرصيد",
  "admin_a_initial_ai_credits_no_payment": "رصيد الذكاء الاصطناعي الأولي (بدون دفع)",
  "admin_a_credits_available": "الرصيد متاح",
  "admin_a_credits_lower": "رصيد",
  "admin_a_credits_value": "{{amount}} رصيد",
  "admin_a_custom_role": "دور مخصص",
  "admin_a_daily_trend": "الاتجاه اليومي",
  "admin_a_data_grid_unavailable": "جدول البيانات غير متاح",
  "admin_a_day_window": "نافذة {{days}} يوم",
  "admin_a_default_suffix": "(افتراضي)",
  "admin_a_delayed": "متأخر",
  "admin_a_delete_member": "حذف العضو",
  "admin_a_delete_organization": "حذف المؤسسة",
  "admin_a_deleted": "محذوف",
  "admin_a_demo": "تجريبي",
  "admin_a_demo_org": "مؤسسة تجريبية",
  "admin_a_details": "التفاصيل",
  "admin_a_done": "منجز",
  "admin_a_edit_limits": "تعديل الحدود",
  "admin_a_edit_limits_title": "تعديل الحدود",
  "admin_a_email": "البريد الإلكتروني",
  "admin_a_email_placeholder": "name@example.com…",
  "admin_a_email_templates": "قوالب البريد الإلكتروني",
  "admin_a_enter_org": "الدخول إلى المؤسسة",
  "admin_a_errored_aborted_runs": "تشغيلات فاشلة / مُلغاة",
  "admin_a_estimated_vs_actual": "المقدّر مقابل الفعلي",
  "admin_a_expand_member_details": "توسيع تفاصيل العضو",
  "admin_a_expand_org_details": "توسيع تفاصيل المؤسسة",
  "admin_a_failed_count": "{{count}} فشل",
  "admin_a_failed_to_load_channel_contacts": "فشل تحميل جهات اتصال القناة: ",
  "admin_a_failed_to_load_ledger": "فشل تحميل سجل الحركات",
  "admin_a_failed_to_load_system_health": "فشل تحميل حالة النظام: ",
  "admin_a_failed_to_send_invitation": "فشل إرسال الدعوة",
  "admin_a_finish": "الإنهاء",
  "admin_a_full_name": "الاسم الكامل",
  "admin_a_healthy": "سليم",
  "admin_a_identity": "الهوية",
  "admin_a_internal_identifiers": "المعرّفات الداخلية",
  "admin_a_interval": "الفترة",
  "admin_a_invalid_email": "بريد إلكتروني غير صالح",
  "admin_a_invitation_sent_to": "تم إرسال الدعوة إلى {{email}}",
  "admin_a_invite_member": "دعوة عضو",
  "admin_a_invite_member_desc": "أرسل بريدًا إلكترونيًا للدعوة لإضافة عضو جديد إلى المؤسسة.",
  "admin_a_job_queues": "طوابير المهام",
  "admin_a_joined": "تاريخ الانضمام",
  "admin_a_last_active": "آخر نشاط",
  "admin_a_last_activity": "آخر نشاط",
  "admin_a_last_sign_in": "آخر تسجيل دخول",
  "admin_a_latency_speed_cost": "الكمون، السرعة، التكلفة",
  "admin_a_list_price": "السعر المعلن",
  "admin_a_loading": "جارٍ التحميل",
  "admin_a_loading_ledger": "جارٍ تحميل سجل الحركات…",
  "admin_a_manage_secrets": "إدارة الأسرار",
  "admin_a_manage_secrets_title": "إدارة الأسرار",
  "admin_a_member": "عضو",
  "admin_a_member_id": "معرّف العضو",
  "admin_a_messages_all_time": "الرسائل (كل الأوقات)",
  "admin_a_messages_per_month": "الرسائل / شهريًا",
  "admin_a_messages_this_month": "الرسائل هذا الشهر",
  "admin_a_messenger_page_id": "معرّف صفحة Messenger",
  "admin_a_missing_performance": "بيانات الأداء مفقودة",
  "admin_a_missing_usage": "بيانات الاستخدام مفقودة",
  "admin_a_moderation": "الإشراف",
  "admin_a_moderation_reason_placeholder": "لماذا يُتخذ هذا الإجراء؟ يظهر عند حظر الوصول.",
  "admin_a_name": "الاسم",
  "admin_a_new": "جديد",
  "admin_a_no_ai_cost_data": "لا توجد بيانات تكلفة للذكاء الاصطناعي في هذه الفترة.",
  "admin_a_no_ai_model_metrics": "لا توجد مقاييس لنماذج الذكاء الاصطناعي في هذه الفترة.",
  "admin_a_no_channel": "لا توجد قناة",
  "admin_a_no_channel_contacts_found": "لم يتم العثور على جهات اتصال للقناة",
  "admin_a_no_channel_contacts_yet": "لا توجد جهات اتصال للقناة بعد.",
  "admin_a_no_credits_remaining": "لا يوجد رصيد متبقٍ",
  "admin_a_no_daily_trend_data": "لا توجد بيانات اتجاه يومي للذكاء الاصطناعي في هذه الفترة.",
  "admin_a_no_finish_data": "لا توجد بيانات إنهاء.",
  "admin_a_no_job_queue_data": "لا توجد بيانات لطوابير المهام. سيعرض مراقب الطوابير البيانات عند الاتصال بخادم فعّال.",
  "admin_a_no_member_details": "لا توجد تفاصيل للعضو",
  "admin_a_no_members_found": "لم يتم العثور على أعضاء",
  "admin_a_no_members_yet": "لا يوجد أعضاء بعد.",
  "admin_a_no_messages": "لا توجد رسائل",
  "admin_a_no_options": "لا توجد خيارات",
  "admin_a_no_org_ai_metrics": "لا توجد مقاييس ذكاء اصطناعي للمؤسسات في هذه الفترة.",
  "admin_a_no_organization_details": "لا توجد تفاصيل للمؤسسة",
  "admin_a_no_organization_selected": "لم يتم اختيار مؤسسة",
  "admin_a_no_organizations_found": "لم يتم العثور على مؤسسات",
  "admin_a_no_organizations_yet": "لا توجد مؤسسات بعد.",
  "admin_a_no_recent_activity": "لا يوجد نشاط حديث",
  "admin_a_no_restrictions": "لا توجد قيود",
  "admin_a_no_secrets_set": "لا توجد أسرار محددة",
  "admin_a_no_status_data": "لا توجد بيانات حالة.",
  "admin_a_non_fatal_provider_warnings": "تحذيرات غير حرجة من المزوّد",
  "admin_a_none": "لا شيء",
  "admin_a_org_id": "معرّف المؤسسة",
  "admin_a_org_id_copied": "تم نسخ معرّف المؤسسة",
  "admin_a_org_name_placeholder": "شركة أكمي",
  "admin_a_organization": "المؤسسة",
  "admin_a_organization_role": "دور المؤسسة",
  "admin_a_p95_latency": "زمن الاستجابة p95",
  "admin_a_past_due": "متأخر السداد",
  "admin_a_plan": "الخطة",
  "admin_a_plan_limits_vs_actual": "حدود الخطة مقابل الفعلي",
  "admin_a_platform_overview": "نظرة عامة على المنصة",
  "admin_a_presence": "الحضور",
  "admin_a_presence_idle": "خامل",
  "admin_a_presence_offline": "غير متصل",
  "admin_a_presence_online": "متصل",
  "admin_a_presence_unknown": "غير معروف",
  "admin_a_quarantine": "حجر…",
  "admin_a_quarantine_confirm_title": "حجر {{name}}؟",
  "admin_a_quarantine_desc": "يعزل الحجر المؤسسة لأغراض التحقيق. يُسجَّل السبب مع طابع زمني.",
  "admin_a_quarantined": "محجوز",
  "admin_a_quotas_and_usage": "الحصص والاستخدام",
  "admin_a_realtime_connections": "اتصالات الوقت الفعلي",
  "admin_a_realtime_rooms": "غرف الوقت الفعلي",
  "admin_a_reason": "السبب",
  "admin_a_reasoning_share": "نسبة الاستدلال",
  "admin_a_reasoning_tokens": "{{count}} رمز استدلال",
  "admin_a_recent_activity": "النشاط الأخير",
  "admin_a_release_confirm_title": "إلغاء حجر {{name}}؟",
  "admin_a_release_desc": "يرفع الحجر ويمسح طابعه الزمني.",
  "admin_a_release_quarantine": "إلغاء الحجر…",
  "admin_a_reliability": "الموثوقية",
  "admin_a_restricted": "مقيّد",
  "admin_a_retry": "إعادة المحاولة",
  "admin_a_role": "الدور",
  "admin_a_role_admin": "مسؤول",
  "admin_a_role_guest": "ضيف",
  "admin_a_role_member": "عضو",
  "admin_a_role_owner": "مالك",
  "admin_a_role_secretary": "سكرتير",
  "admin_a_save_first": "احفظ أولاً",
  "admin_a_save_org_to_see_details": "احفظ المؤسسة لعرض التفاصيل",
  "admin_a_secret_keys": "مفاتيح الأسرار",
  "admin_a_secret_set": "تم تعيين {{count}} سر",
  "admin_a_secrets_set": "تم تعيين {{count}} أسرار",
  "admin_a_seeded_demo_org": "مؤسسة تجريبية أولية",
  "admin_a_select_a_plan": "اختر خطة",
  "admin_a_select_organization": "اختر المؤسسة",
  "admin_a_select_visible_members": "تحديد الأعضاء الظاهرين",
  "admin_a_send_invitation": "إرسال الدعوة",
  "admin_a_sending": "جارٍ الإرسال…",
  "admin_a_since": "منذ {{date}}",
  "admin_a_slowest_p95_first": "الأبطأ (p95) أولاً",
  "admin_a_slug": "المعرّف النصي",
  "admin_a_staff_members": "أعضاء الفريق",
  "admin_a_staff_seats": "مقاعد الموظفين",
  "admin_a_staff_users": "مستخدمو الفريق",
  "admin_a_status_and_finish_reasons": "الحالة وأسباب الإنهاء",
  "admin_a_storage": "التخزين",
  "admin_a_subscription": "الاشتراك",
  "admin_a_superuser": "مستخدم متميز",
  "admin_a_superuser_only": "للمستخدمين المتميزين فقط",
  "admin_a_suspend": "تعليق…",
  "admin_a_suspend_confirm_title": "تعليق {{name}}؟",
  "admin_a_suspend_desc": "يمنع التعليق وصول المؤسسة حتى يُرفع. يظهر السبب للأعضاء المحظورين ويُسجَّل مع طابع زمني.",
  "admin_a_suspended": "معلّق",
  "admin_a_system_status": "حالة النظام",
  "admin_a_tool_calls_ratio": "{{errors}} / {{total}} استدعاء أداة",
  "admin_a_tool_err": "خطأ الأداة",
  "admin_a_tool_error_rate": "معدل خطأ الأداة",
  "admin_a_unassigned": "غير معيّن",
  "admin_a_unnamed_contact": "جهة اتصال بلا اسم",
  "admin_a_unsuspend": "إلغاء التعليق…",
  "admin_a_unsuspend_confirm_title": "إلغاء تعليق {{name}}؟",
  "admin_a_unsuspend_desc": "يستعيد وصول المؤسسة ويمسح طابع زمن التعليق.",
  "admin_a_uptime": "مدة التشغيل",
  "admin_a_user_email_placeholder": "user@example.com",
  "admin_a_user_id": "معرّف المستخدم",
  "admin_a_utc_buckets": "فترات بتوقيت UTC",
  "admin_a_value_per_response": "{{value}} / استجابة",
  "admin_a_waiting": "قيد الانتظار",
  "admin_a_warnings": "تحذيرات",
  "admin_a_wasted": "مهدر",
  "admin_a_wasted_spend": "الإنفاق المهدر",
  "admin_a_configured": "تم الإعداد",
  "admin_a_channels_linked": "القنوات المرتبطة: {{channels}}",
  "admin_a_telegram_bot": "بوت تيليجرام",
  "admin_a_telegram_linked": "تيليجرام مرتبط",
  "admin_a_whatsapp_linked": "واتساب مرتبط",
  "admin_a_whatsapp_telegram_linked": "واتساب + تيليجرام مرتبطان",
  "admin_a_whatsapp_phone_id": "معرّف رقم واتساب",
  "admin_b_add_user_as_member_of_existing_org": "إضافة {{user}} كعضو في مؤسسة موجودة.",
  "admin_b_api_keys": "مفاتيح واجهة البرمجة",
  "admin_b_assign": "تعيين",
  "admin_b_assign_to_existing": "التعيين إلى مؤسسة موجودة",
  "admin_b_assign_to_existing_org_title": "التعيين إلى مؤسسة موجودة",
  "admin_b_assign_to_new_org": "التعيين إلى مؤسسة جديدة",
  "admin_b_assign_user_to_new_org_title": "تعيين المستخدم إلى مؤسسة جديدة",
  "admin_b_assigning": "جارٍ التعيين…",
  "admin_b_assignment_failed": "فشل التعيين",
  "admin_b_billing_label": "الفوترة",
  "admin_b_billing_monthly": "شهري",
  "admin_b_billing_yearly": "سنوي",
  "admin_b_col_email": "البريد الإلكتروني",
  "admin_b_col_intended_billing": "الفوترة المقصودة",
  "admin_b_col_intended_plan": "الخطة المقصودة",
  "admin_b_col_name": "الاسم",
  "admin_b_col_signed_up": "تاريخ التسجيل",
  "admin_b_continue_anyway": "المتابعة على أي حال",
  "admin_b_could_not_exit_impersonation": "تعذّر الخروج من وضع الانتحال",
  "admin_b_create_org_and_assign": "إنشاء المؤسسة والتعيين",
  "admin_b_create_paid_org_desc": "إنشاء مؤسسة مدفوعة لـ {{user}} وإضافته كمالك. تُضبط حالة الاشتراك إلى {{status}} (مدفوعة دون اتصال).",
  "admin_b_creating": "جارٍ الإنشاء…",
  "admin_b_defaults_to_slug": "يستخدم المعرّف المختصر افتراضيًا",
  "admin_b_effective_label": "الفعلي:",
  "admin_b_engagement_active": "نشِطة",
  "admin_b_engagement_dormant": "خاملة",
  "admin_b_engagement_low_activity": "نشاط منخفض",
  "admin_b_exit": "خروج",
  "admin_b_exited_impersonation": "تم الخروج من وضع الانتحال",
  "admin_b_exiting": "جارٍ الخروج…",
  "admin_b_failed_to_assign_user": "فشل تعيين المستخدم",
  "admin_b_failed_to_load_organizations": "فشل تحميل المؤسسات",
  "admin_b_failed_to_load_waiting_users": "فشل تحميل المستخدمين المنتظرين.",
  "admin_b_failed_to_save_secrets": "فشل حفظ الأسرار",
  "admin_b_failed_to_update_limits": "فشل تحديث الحدود",
  "admin_b_hide": "إخفاء",
  "admin_b_impersonating_badge": "انتحال",
  "admin_b_inactive_suffix": "— غير نشطة",
  "admin_b_integration_coverage": "تغطية التكاملات",
  "admin_b_leave_blank_plan_default": "اتركه فارغًا = الافتراضي للخطة ({{value}})",
  "admin_b_loading_organizations": "جارٍ تحميل المؤسسات…",
  "admin_b_lower_seat_limit_desc": "حد المقاعد الجديد ({{seats}}) أقل من عدد أعضاء هذه المؤسسة الحالي ({{count}}). يحتفظ الأعضاء الحاليون بوصولهم، لكن لن تُقبل دعوات جديدة حتى يُرفع الحد. هل تريد المتابعة؟",
  "admin_b_lower_seat_limit_title": "خفض حد المقاعد دون الاستخدام الحالي؟",
  "admin_b_member_role_distribution": "توزيع أدوار الأعضاء",
  "admin_b_messages_per_month": "{{count}} / شهريًا",
  "admin_b_monthly_message_limit_label": "حد رسائل الذكاء الاصطناعي الشهري",
  "admin_b_name_label": "الاسم",
  "admin_b_no_email": "لا يوجد بريد إلكتروني",
  "admin_b_no_organizations": "لا توجد مؤسسات",
  "admin_b_no_waiting_users_body": "عندما ينقر أحدهم على «{{waitAction}}» في شاشة المؤسسة المعلّقة، سيظهر هنا حتى تتمكن من إنشاء مؤسسة له يدويًا.",
  "admin_b_no_waiting_users_title": "لا يوجد مستخدمون بانتظار التعيين",
  "admin_b_onboarding_eyebrow": "الإعداد",
  "admin_b_optional_suffix": "(اختياري)",
  "admin_b_org_activity_ranking": "ترتيب نشاط المؤسسات",
  "admin_b_org_engagement_health": "صحة تفاعل المؤسسات",
  "admin_b_organization_label": "المؤسسة",
  "admin_b_override_badge": "تجاوز",
  "admin_b_pick_org_and_role": "اختر مؤسسة ودورًا.",
  "admin_b_plan_chat": "محادثة",
  "admin_b_plan_default_badge": "الافتراضي للخطة",
  "admin_b_plan_default_value": "/ الافتراضي للخطة: {{value}}",
  "admin_b_plan_defaults_summary": "الافتراضيات — {{seats}} مقعد موظفين · {{messages}} رسالة/شهريًا · {{storage}} ميبيبايت تخزين",
  "admin_b_plan_distribution": "توزيع الخطط",
  "admin_b_plan_label": "الخطة: {{plan}}",
  "admin_b_plan_label_short": "الخطة",
  "admin_b_plan_limits_eyebrow": "عناصر تحكم الخطة",
  "admin_b_plan_limits_footer_note": "تسري التجاوزات فورًا. يعيد المسح الحقل إلى الافتراضي للخطة. قد يؤدي خفض الحد دون الاستخدام الحالي للمؤسسة إلى منع الدعوات أو التحميلات الجديدة، لكنه لن يزيل الأعضاء أو البيانات الحالية.",
  "admin_b_plan_limits_section_title": "تجاوز حدود الخطة",
  "admin_b_plan_limits_subtitle": "تجاوز خاص بالمشرف العام. اتركه فارغًا لاستخدام الحد الافتراضي للخطة.",
  "admin_b_plan_limits_title": "حدود الخطة: {{name}}",
  "admin_b_plan_limits_updated": "تم تحديث حدود الخطة",
  "admin_b_plan_premium": "مميزة",
  "admin_b_plan_standard": "قياسية",
  "admin_b_resource_distribution_per_org": "توزيع الموارد لكل مؤسسة",
  "admin_b_role_admin": "مسؤول",
  "admin_b_role_guest": "ضيف",
  "admin_b_role_label": "الدور",
  "admin_b_role_owner": "مالك",
  "admin_b_role_secretary": "سكرتير",
  "admin_b_seats_count": "{{count}} مقعد",
  "admin_b_secret_clear_badge": "مسح",
  "admin_b_secret_enter_new_value": "أدخل قيمة جديدة للاستبدال",
  "admin_b_secret_group_ai_voice": "الذكاء الاصطناعي والصوت",
  "admin_b_secrets_group_messaging": "المراسلة",
  "admin_b_secrets_group_developer_ai": "المطور والذكاء الاصطناعي",
  "admin_b_secrets_section_eyebrow": "بيانات اعتماد التكامل",
  "admin_b_secret_label_access_token": "رمز الوصول",
  "admin_b_secret_label_api_key": "مفتاح واجهة البرمجة",
  "admin_b_secret_label_app_id": "معرّف التطبيق",
  "admin_b_secret_label_app_password": "كلمة مرور التطبيق",
  "admin_b_secret_label_app_secret": "سر التطبيق",
  "admin_b_secret_label_application_id": "معرّف التطبيق",
  "admin_b_secret_label_bot_id": "معرّف البوت",
  "admin_b_secret_label_bot_token": "رمز البوت",
  "admin_b_secret_label_business_account_id": "معرّف حساب الأعمال",
  "admin_b_secret_label_instagram_account_id": "معرّف حساب Instagram",
  "admin_b_secret_label_client_id": "معرّف العميل",
  "admin_b_secret_label_client_secret": "سر العميل",
  "admin_b_secret_label_installation_id": "معرّف التثبيت",
  "admin_b_secret_label_page_access_token": "رمز وصول الصفحة",
  "admin_b_secret_label_page_id": "معرّف الصفحة",
  "admin_b_secret_label_personal_access_token": "رمز الوصول الشخصي",
  "admin_b_secret_label_phone_number_id": "معرّف رقم الهاتف",
  "admin_b_secret_label_private_key": "المفتاح الخاص",
  "admin_b_secret_label_public_key": "المفتاح العام",
  "admin_b_secret_label_service_account_json": "ملف JSON لحساب الخدمة",
  "admin_b_secret_label_signing_secret": "سر التوقيع",
  "admin_b_secret_label_tenant_id": "معرّف المستأجر",
  "admin_b_secret_label_webhook_secret": "سر الويبهوك",
  "admin_b_secret_label_webhook_route_id": "معرّف مسار الويبهوك",
  "admin_b_secret_label_webhook_secret_token": "رمز سر الويبهوك",
  "admin_b_secret_label_verify_token": "رمز التحقق",
  "admin_b_secret_instagram_access_token_help": "رمز الوصول لحساب Instagram الاحترافي الخاص بهذه المؤسسة. لا تُعرض القيم الحالية أبداً.",
  "admin_b_secret_instagram_app_secret_help": "سر تطبيق Meta المستخدم للتحقق من حمولة الويبهوك الموقّعة. حافظ على سريته.",
  "admin_b_secret_instagram_verify_token_help": "رمز مستقل يستخدمه Bavard وMeta عند التحقق من اشتراك الويبهوك.",
  "admin_b_secret_instagram_account_id_help": "المعرّف الرقمي لحساب Instagram الاحترافي المستخدم في توجيه المؤسسة، وليس اسم المستخدم.",
  "admin_b_secret_telegram_bot_token_help": "رمز سري يصدره BotFather. لا تُعرض القيم الحالية أبداً.",
  "admin_b_secret_telegram_bot_id_help": "المعرّف الرقمي لحساب بوت Telegram، وهو ليس رمز البوت.",
  "admin_b_secret_telegram_route_id_help": "معرّف توجيه مبهم وغير سري يُستخدم في رابط الويبهوك. استخدم قيمة فريدة لكل مؤسسة.",
  "admin_b_secret_telegram_webhook_secret_help": "رمز سري ترسله Telegram في ترويسة التحقق من الويبهوك. حافظ على سريته.",
  "admin_b_secret_not_set": "غير معيّن",
  "admin_b_secret_set_badge": "معيّن",
  "admin_b_secret_will_be_cleared": "سيُمسح عند الحفظ",
  "admin_b_secrets_integration_sections": "أقسام التكاملات",
  "admin_b_secrets_missing_required": "الحقول المطلوبة الناقصة: {{fields}}",
  "admin_b_secrets_invalid_fields": "صحّح الحقول غير الصالحة قبل الحفظ: {{fields}}",
  "admin_b_secrets_saved": "تم حفظ الأسرار بنجاح",
  "admin_b_secrets_subtitle": "إدارة مفاتيح واجهة البرمجة والرموز. لا تُعرض الأسرار الحالية أبدًا.",
  "admin_b_secrets_title": "الأسرار: {{name}}",
  "admin_b_select_an_org": "اختر مؤسسة",
  "admin_b_show": "إظهار",
  "admin_b_show_impersonation_status": "إظهار حالة الانتحال",
  "admin_b_slug_already_taken": "هذا المعرّف المختصر مستخدم بالفعل",
  "admin_b_slug_label": "المعرّف المختصر",
  "admin_b_staff_seat_limit_label": "حد مقاعد الموظفين",
  "admin_b_storage_effective": "{{value}} ميبيبايت",
  "admin_b_storage_limit_label": "حد التخزين (ميبيبايت)",
  "admin_b_storage_range_hint": "أكبر من ٠ – {{max}} ميبيبايت. يُسمح بالكسور العشرية (مثال: 1.5).",
  "admin_b_this_user": "هذا المستخدم",
  "admin_b_unknown_organization": "مؤسسة غير معروفة",
  "admin_b_unlimited": "غير محدود",
  "admin_b_user_already_belongs_refreshing": "هذا المستخدم ينتمي بالفعل إلى مؤسسة. جارٍ تحديث القائمة.",
  "admin_b_user_already_member_of_org": "المستخدم عضو بالفعل في هذه المؤسسة.",
  "admin_b_user_already_member_refreshing": "هذا المستخدم عضو بالفعل في مؤسسة. جارٍ تحديث القائمة…",
  "admin_b_user_assigned_to_org": "تم تعيين المستخدم إلى المؤسسة",
  "admin_b_user_assigned_to_org_slug": "تم تعيين المستخدم إلى المؤسسة {{slug}}",
  "admin_b_wait_for_assignment": "انتظار التعيين",
  "admin_b_waiting_users_desc": "المستخدمون الذين نقروا على «{{waitAction}}» في شاشة المؤسسة المعلّقة. استخدم «{{assignAction}}» لإنشاء مؤسسة مدفوعة وإضافة المستخدم كمالك.",
  "admin_b_waiting_users_title": "المستخدمون المنتظرون",
  "admin_b_whole_number_range_hint": "١ – {{max}}. عدد صحيح.",
  "auth_anonymous_demo_failed": "تعذر بدء النسخة التجريبية",
  "auth_back_to_home": "العودة إلى الصفحة الرئيسية",
  "calendar_booking_horizon_limit": "لا يمكن حجز هذا النوع قبل أكثر من {{days}} يوم من اليوم (آخر تاريخ متاح: {{latestDate}})",
  "calendar_date_beyond_booking_horizon": "التاريخ يتجاوز الحد الأقصى للحجز",
  "calendar_time_outside_working_hours": "الوقت خارج ساعات العمل",
  "cfg_all_event_types": "جميع أنواع الفعاليات",
  "cfg_auto_language_hint_already_set": "تم ضبطه بالفعل على لغة الدولة الافتراضية ({{language}})",
  "cfg_auto_language_hint_fill_with": "التعبئة بـ {{language}} (لغة الدولة {{countryPrefix}})",
  "cfg_auto_language_hint_no_country": "اختر دولة افتراضية أولاً لتفعيل الاختصار المشتق من الدولة",
  "cfg_auto_language_hint_no_mapping": "لا يوجد ربط لغوي للدولة \"{{countryPrefix}}\"",
  "cfg_auto_language_hint_not_enabled": "{{language}} غير مفعّلة ضمن لغات العرض",
  "cfg_edit": "تعديل",
  "cfg_email_template_created_toast": "تم إنشاء القالب",
  "cfg_email_template_delete_confirm": "حذف قالب البريد الإلكتروني؟",
  "cfg_email_template_delete_failed_toast": "تعذّر حذف القالب",
  "cfg_email_template_deleted_toast": "تم حذف القالب",
  "cfg_email_template_save_failed_toast": "تعذّر حفظ القالب",
  "cfg_email_template_updated_toast": "تم تحديث القالب",
  "cfg_email_templates_description": "أنشئ قوالب البريد الإلكتروني وأدرها لمؤسستك.",
  "cfg_email_templates_empty": "لا توجد قوالب بعد. أنشئ أول قالب بريد إلكتروني.",
  "cfg_event_types_none_configured": "لم يتم تكوين أي أنواع فعاليات.",
  "cfg_feedback_summary_language_label": "لغة ملخص التقييم",
  "cfg_location_picker_lat": "خط العرض",
  "cfg_location_picker_lng": "خط الطول",
  "cfg_location_picker_loading_map": "جارٍ تحميل الخريطة…",
  "cfg_location_picker_locating": "جارٍ تحديد الموقع…",
  "cfg_location_picker_search_failed": "فشل البحث عن الموقع. حاول مرة أخرى.",
  "cfg_location_picker_selected_location": "الموقع المحدد",
  "cfg_location_picker_use_location": "استخدام الموقع",
  "cfg_location_picker_use_my_location": "استخدام موقعي",
  "cfg_location_picker_use_this_location": "استخدام هذا الموقع",
  "cfg_model_benchmarks_title": "المعايير القياسية",
  "cfg_model_context_window_desc_model": "أقصى عدد من الرموز يمكن لهذا النموذج قراءتها في طلب واحد — المطالبة إضافة إلى المحادثة السابقة.",
  "cfg_model_context_window_desc_provider": "أقصى عدد من الرموز يمكن لهذا المزوّد قراءتها في طلب واحد — المطالبة إضافة إلى المحادثة السابقة.",
  "cfg_model_context_window_title": "نافذة السياق",
  "cfg_model_developer_label": "المطوّر",
  "cfg_model_hide_hosting_providers_aria": "إخفاء {{count}} من مزوّدي الاستضافة",
  "cfg_model_hide_providers_aria": "إخفاء {{count}} من المزوّدين",
  "cfg_model_hosting_providers_desc": "يستضيف {{count}} من المزوّدين هذا النموذج. اضغط للمقارنة بين الأسعار وزمن الاستجابة والميزات.",
  "cfg_model_hosting_providers_title": "مزوّدو الاستضافة",
  "cfg_model_max_output_desc_provider": "أقصى عدد من الرموز يمكن لهذا المزوّد توليدها في استجابة واحدة.",
  "cfg_model_pricing_desc_model_credits": "الرصيد المخصوم لكل رسالة. وسّع للمقارنة بين تكلفة كل مزوّد.",
  "cfg_model_pricing_desc_model_super": "التكلفة التقريبية لكل مليون رمز — الإدخال/الإخراج. وسّع للمقارنة بين أسعار المزوّدين.",
  "cfg_model_pricing_desc_model_tier": "التكلفة النسبية لهذا النموذج — كلما زادت علامات $ زادت تكلفة الفئة.",
  "cfg_model_pricing_desc_provider_credits": "الرصيد المخصوم لكل رسالة عندما يجيب هذا المزوّد.",
  "cfg_model_pricing_desc_provider_super": "التكلفة التقريبية لكل مليون رمز لهذا المزوّد — الإدخال/الإخراج.",
  "cfg_model_pricing_desc_provider_tier": "التكلفة النسبية لهذا المزوّد — كلما زادت علامات $ زادت تكلفة الفئة.",
  "cfg_model_pricing_title_cost_per_message": "التكلفة لكل رسالة",
  "cfg_model_pricing_title_cost_tier": "فئة التكلفة",
  "cfg_model_providers_label": "المزوّدون",
  "cfg_model_released_label": "تاريخ الإصدار",
  "cfg_model_show_hosting_providers_aria": "إظهار {{count}} من مزوّدي الاستضافة",
  "cfg_model_show_providers_aria": "إظهار {{count}} من المزوّدين",
  "cfg_models_empty_connection_hint": "قد تكون خوادم OpenRouter معطلة أو قد تكون فقدت الاتصال بالإنترنت. تحقق من اتصالك وحاول مرة أخرى.",
  "cfg_models_empty_filters_hint": "جرّب تعديل عوامل التصفية لرؤية نتائج أكثر.",
  "cfg_notif_add_rule": "إضافة قاعدة",
  "cfg_notif_channel_email": "البريد الإلكتروني",
  "cfg_notif_channel_whatsapp": "واتساب",
  "cfg_notif_channels_label": "قنوات الإرسال",
  "cfg_notif_channels_tooltip": "القنوات التي يُرسل عبرها هذا الإشعار. واتساب هو الافتراضي؛ اختر واحدة أو أكثر.",
  "cfg_notif_event_type_filter_label": "تصفية حسب نوع الفعالية",
  "cfg_notif_group_action_based": "حسب الإجراء",
  "cfg_notif_group_custom": "مخصص",
  "cfg_notif_group_time_based": "حسب الوقت",
  "cfg_notif_loading_templates": "جارٍ تحميل القوالب…",
  "cfg_notif_no_approved_templates": "لا توجد قوالب معتمدة.",
  "cfg_notif_no_templates_found": "لم يتم العثور على قوالب",
  "cfg_notif_rule_name_label": "اسم القاعدة",
  "cfg_notif_rule_name_placeholder": "مثال: تذكير قبل يوم واحد",
  "cfg_notif_search_templates": "البحث عن القوالب…",
  "cfg_notif_select_target_contacts": "اختر جهات الاتصال المستهدفة…",
  "cfg_notif_subtype_after_event": "بعد الفعالية",
  "cfg_notif_subtype_after_event_desc": "الإرسال بعد الفعالية",
  "cfg_notif_subtype_after_no_show": "بعد عدم الحضور",
  "cfg_notif_subtype_after_no_show_desc": "الإرسال بعد عدم الحضور",
  "cfg_notif_subtype_before_event": "قبل الفعالية",
  "cfg_notif_subtype_before_event_desc": "الإرسال قبل الفعالية",
  "cfg_notif_subtype_custom_desc": "الإرسال إلى جهات اتصال محددة في وقت مجدول",
  "cfg_notif_subtype_on_cancellation": "عند الإلغاء",
  "cfg_notif_subtype_on_cancellation_desc": "عند إلغاء فعالية",
  "cfg_notif_subtype_on_creation": "عند الإنشاء",
  "cfg_notif_subtype_on_creation_desc": "عند إنشاء فعالية",
  "cfg_notif_subtype_on_modification": "عند التعديل",
  "cfg_notif_subtype_on_modification_desc": "عند إعادة جدولة فعالية",
  "cfg_notif_subtype_re_engagement": "إعادة التفاعل",
  "cfg_notif_subtype_re_engagement_desc": "التواصل بعد فترة من عدم النشاط",
  "cfg_notif_target_phones_count_hint": "سيستلم {{count}} من جهات الاتصال هذا الإشعار.",
  "cfg_notif_target_phones_default_hint": "يُرسل إلى جهة اتصال الفعالية.",
  "cfg_notif_target_phones_done": "تم",
  "cfg_notif_target_phones_label": "أرقام الهاتف المستهدفة",
  "cfg_notif_target_phones_select_hint": "اختر جهات الاتصال لإرسال هذا الإشعار إليها.",
  "cfg_notif_target_phones_selected_count": "تم تحديد {{count}} من جهات الاتصال",
  "cfg_notif_template_no_variables": "لا يحتوي هذا القالب على أي عناصر نائبة للمتغيرات.",
  "cfg_notif_trigger_label": "المُحفِّز",
  "cfg_notif_whatsapp_template_label": "قالب واتساب",
  "cfg_optional_suffix": "(اختياري)",
  "cfg_pick_a_language": "اختر لغة",
  "cfg_pick_date_and_time": "اختر التاريخ والوقت",
  "cfg_provider_rail_scroll_down": "التمرير لأسفل بين المزوّدين",
  "cfg_provider_rail_scroll_up": "التمرير لأعلى بين المزوّدين",
  "cfg_reasoning_effort_desc_high": "تفكير عميق للمهام المعقدة",
  "cfg_reasoning_effort_desc_low": "تفكير خفيف للمهام البسيطة",
  "cfg_reasoning_effort_desc_medium": "تفكير متوازن لمعظم الأعمال",
  "cfg_reasoning_effort_desc_off": "بدون تفكير إطلاقاً -- يجيب النموذج مباشرة",
  "cfg_reasoning_effort_off_unavailable": "هذا النموذج يفكر دائماً -- لا يمكن إيقاف تفكيره",
  "cfg_reasoning_effort_option_off": "إيقاف",
  "cfg_reminder_add": "إضافة تذكير",
  "cfg_reminder_delete": "حذف التذكير",
  "cfg_reminder_name_label": "مفتاح التذكير",
  "cfg_reminder_name_placeholder": "مثال: day-before",
  "cfg_reminder_name_missing_lead": "لا يحمل هذا التذكير اسمًا بعد.",
  "cfg_reminder_name_missing_reason": "الاسم هو المفتاح الذي يخزّن به المجدول التذكير، ولذلك سيتعارض تذكيران بلا اسم.",
  "cfg_reminder_name_invalid_lead": "يحتوي هذا الاسم على أحرف لا يستطيع المجدول استخدامها.",
  "cfg_reminder_name_invalid_reason": "استخدم حروفًا وأرقامًا وشرطات سفلية وشرطات فقط.",
  "cfg_reminder_send_time_label": "وقت الإرسال",
  "cfg_reminder_untitled": "تذكير بلا اسم",
  "cfg_reminders_description": "يُرسل قبل الموعد بيوم واحد، في الوقت الذي تحدده. يحتاج كل تذكير إلى قالب معتمد مع ربط كل متغيّر فيه.",
  "cfg_reminders_empty": "لا توجد تذكيرات بعد. أضف تذكيرًا لمراسلة العملاء قبل موعدهم بيوم.",
  "cfg_reminders_title": "تذكيرات المواعيد",
  "cfg_remove_item_aria": "إزالة {{name}}",
  "cfg_summary_language_label": "لغة الملخص",
  "cfg_target_contacts_description": "اختر جهات الاتصال المستهدفة",
  "cfg_target_contacts_label": "جهات الاتصال المستهدفة",
  "cfg_tool_requires_approval_tooltip": "عند التفعيل، يجب أن يحصل الوكيل الآلي على موافقة المسؤول في المحادثة قبل تنفيذ هذه الأداة.",
  "cfg_tool_not_available_chat_plan": "غير متاح في خطة المحادثة",
  "cfg_tool_default_model_gate_reason": "النموذج المحدد لا يستطيع استدعاء الأدوات. اختر نموذجاً يتضمن 'tools' ضمن معاييره المدعومة لاستخدام هذه الأداة.",
  "cfg_model_disabled_no_tool_support": "هذا النموذج لا يستطيع استدعاء الأدوات، والأدوات مفعّلة في مساعدك. اختر نموذجاً يتضمن 'tools' ضمن معاييره المدعومة.",
  "cfg_tool_scheduling_locked_reason": "أدوات الجدولة غير متاحة في خطة المحادثة",
  "cfg_tool_business_location_locked_reason": "أدخل اسم النشاط التجاري والعنوان والإحداثيات لتفعيل هذه الأداة",
  "cfg_tool_channel_only": "{{channel}} فقط",
  "cfg_tool_channel_supported": "مدعوم على {{channel}}",
  "cfg_tooldesc_getCurrentDatetime": "يتيح للذكاء الاصطناعي معرفة تاريخ ووقت اليوم.",
  "cfg_tooldesc_searchDocs": "يبحث في معرفتك المرفوعة للإجابة على الأسئلة بدقة.",
  "cfg_tooldesc_getDocumentSchemas": "يتيح للذكاء الاصطناعي رؤية المستندات والجداول التي رفعتها.",
  "cfg_tooldesc_queryStructuredData": "يبحث عن الإجابات داخل جداول البيانات المرفوعة (Excel/CSV).",
  "cfg_tooldesc_scheduleEvent": "يحجز موعداً للعميل في وقت متاح.",
  "cfg_tooldesc_joinWaitlist": "يضيف العميل إلى قائمة الانتظار عندما لا يتوفر موعد مناسب.",
  "cfg_tooldesc_modifyEvent": "ينقل موعداً قائماً إلى وقت آخر.",
  "cfg_tooldesc_cancelEvent": "يلغي موعد العميل.",
  "cfg_tooldesc_getUserData": "يطّلع على ملف العميل ومواعيده القادمة.",
  "cfg_tooldesc_getAvailableTimeSlots": "يتحقق من الأوقات المتاحة في يوم محدد.",
  "cfg_tooldesc_searchAvailableAppointments": "يجد أقرب المواعيد المتاحة عبر الأيام.",
  "cfg_tooldesc_sendBusinessLocation": "يرسل عنوان نشاطك وموقعه على الخريطة إلى العميل.",
  "cfg_tooldesc_sendInteractiveButtons": "يعرض أزرار رد سريع للاختيارات القصيرة.",
  "cfg_tooldesc_sendInteractiveList": "يعرض قائمة قابلة للنقر عند وجود عدة خيارات.",
  "cfg_tooldesc_requestPhoneNumber": "يطلب من العميل مشاركة رقم هاتفه عند الحاجة.",
  "cfg_tooldesc_handoffToHuman": "يحوّل المحادثة إلى فريقك ويوقف ردود الذكاء الاصطناعي مؤقتاً.",
  "cfg_tooldesc_saveFeedback": "يحفظ مديح العملاء أو شكاواهم لمراجعتها لاحقاً.",
  "cfg_tooldesc_collectLead": "يجمع بيانات تواصل العميل المهتم للمتابعة لاحقاً.",
  "cfg_tooldesc_scheduleEvents": "يحجز مواعيد لعدة عملاء دفعة واحدة.",
  "cfg_tooldesc_modifyEvents": "يعيد جدولة عدة مواعيد دفعة واحدة.",
  "cfg_tooldesc_modifyEventRange": "ينقل المواعيد أو يعدّلها عبر نطاق زمني.",
  "cfg_tooldesc_cancelEvents": "يلغي عدة مواعيد دفعة واحدة.",
  "cfg_tooldesc_cancelEventRange": "يلغي المواعيد عبر نطاق زمني.",
  "cfg_tooldesc_getEventSnapshots": "يطّلع على المواعيد عبر التواريخ والعملاء.",
  "cfg_tooldesc_getAvailableSlotsBatch": "يتحقق من التوفر عبر عدة تواريخ دفعة واحدة.",
  "cfg_tooldesc_summarizeConversation": "يلخّص محادثة العميل لك.",
  "cfg_tooldesc_getAnalytics": "يجيب عن أسئلتك حول أرقام نشاطك.",
  "cfg_tooldesc_getUsageBreakdown": "يعرض استخدامك للذكاء الاصطناعي ورصيدك المتبقي.",
  "cfg_tooldesc_getKnowledgeGaps": "يجد الأسئلة التي لم تستطع قاعدة المعرفة الإجابة عنها.",
  "cfg_tooldesc_renderChart": "يرسم مخططاً من بياناتك داخل المحادثة.",
  "cfg_tooldesc_manageKnowledgeSource": "يقترح إضافة مصدر معرفة أو تحديثه أو إزالته.",
  "cfg_tooldesc_ingestUploadedFile": "يضيف ملفاً شاركته في المحادثة إلى قاعدة المعرفة.",
  "cfg_tooldesc_triggerRetraining": "يحدّث قاعدة المعرفة من جميع المصادر المفعّلة.",
  "cfg_tooldesc_getAgentSettings": "يقرأ إعدادات مساعدك الحالية (قراءة فقط).",
  "cfg_tooldesc_getContactSnapshot": "يطّلع على السجل الكامل لجهة اتصال.",
  "cfg_tooldesc_manageContact": "يقترح تحديث جهة اتصال أو إزالتها (الإزالة تتطلب موافقتك دائماً).",
  "cfg_tooldesc_manageBeneficiary": "يقترح دمج سجلات المستفيدين أو فصلها (الدمج يتطلب الموافقة دائماً).",
  "cfg_tooldesc_queryConversations": "يسرد المحادثات حسب الحالة أو المشغّل أو التاريخ.",
  "cfg_tooldesc_searchConversations": "يبحث في سجل محادثاتك.",
  "cfg_tooldesc_getConversationMetrics": "يعرض أوقات الاستجابة والتحويلات وإحصاءات الحلول.",
  "cfg_tooldesc_manageAutomation": "يقترح إنشاء أتمتة أو تعديلها.",
  "cfg_tooldesc_startIntegrationConnection": "ينشئ رابطاً لربط تكامل من صفحة الإعدادات.",
  "cfg_tooldesc_getChannelStatus": "يتحقق من اتصال قنوات واتساب وتيليجرام وإنستغرام.",
  "cfg_tooldesc_generateInsightsReport": "ينشئ تقريراً بالرؤى عبر بيانات نشاطك.",
  "cfg_tool_dependency_required_reason": "مضمَّن تلقائياً ما دام هذا القسم مفعّلاً — تعتمد عليه أدوات الحجز.",
  "cfg_tool_rag_no_documents_reason": "ارفع مستندات إلى قاعدة المعرفة أولاً — لا يوجد ما يبحث فيه الذكاء الاصطناعي بعد.",
  "cfg_tool_bundle_available_to_label": "متاح لـ",
  "cfg_tool_bundle_available_to_tooltip": "اختر من يمكنه البحث في مستنداتك: مساعد العملاء أو الوكيل الآلي أو كلاهما.",
  "cfg_tool_channel_not_connected_reason": "لا تتوفر لدى مؤسستك أي من القنوات التي تعمل عليها هذه الأداة ({{channels}}).",
  "cfg_tool_bundle_row_locked_reason": "جزء من استرجاع المستندات — استخدم مفتاح القسم لتشغيل الحزمة كاملة أو إيقافها.",
  "cfg_tool_bundle_structured_hint": "تُفعَّل استعلامات الجداول تلقائياً عند رفع ملفات Excel أو CSV.",
  "cfg_tsec_group_assistant_label": "مساعد العملاء",
  "cfg_tsec_group_assistant_tooltip": "ما يُسمح لمساعد الذكاء الاصطناعي الذي يرد على عملائك بفعله. فعّل قسماً كاملاً أو أوقفه، أو وسّعه لضبط الصلاحيات الفردية بدقة.",
  "cfg_tsec_group_system_agent_label": "الوكيل الآلي",
  "cfg_tsec_group_system_agent_tooltip": "مساعدك التشغيلي في الشريط الجانبي للمحادثة. يدير مساحة العمل نفسها: الجدولة الجماعية والتحليلات والمعرفة وجهات الاتصال. إيقافه يخفيه من الشريط الجانبي تماماً.",
  "cfg_tsec_system_agent_disabled_hint": "الوكيل الآلي متوقف — وهو مخفي من الشريط الجانبي للمحادثة ولا تعمل أي من أدواته.",
  "cfg_tsec_scheduling_label": "الحجز والجدولة",
  "cfg_tsec_scheduling_tooltip": "اسمح للمساعد بالتحقق من التوفر وحجز المواعيد للعملاء. إيقاف القسم يوقفها كلها مع الاحتفاظ باختياراتك لكل أداة. وسّع القسم للتحكم في العمليات المسموح بها بالضبط.",
  "cfg_tsec_knowledge_label": "المعرفة والبيانات",
  "cfg_tsec_knowledge_tooltip": "مفتاح واحد لاسترجاع المستندات: يبحث الذكاء الاصطناعي في معرفتك المرفوعة للإجابة على الأسئلة. أوقفه لمنع الذكاء الاصطناعي من قراءة مستنداتك.",
  "cfg_tsec_engagement_label": "التفاعل مع العملاء",
  "cfg_tsec_engagement_tooltip": "قدرات محادثة اختيارية — مشاركة موقعك وأزرار الرد السريع والتحويل إلى موظف وحفظ الملاحظات وجمع بيانات العملاء المحتملين. فعّل ما يحتاجه نشاطك فقط.",
  "cfg_tsec_sa_scheduling_label": "الجدولة الجماعية",
  "cfg_tsec_sa_scheduling_tooltip": "عمليات حجز جماعية عبر عدة عملاء ونطاقات زمنية.",
  "cfg_tsec_sa_insights_label": "التحليلات والرؤى",
  "cfg_tsec_sa_insights_tooltip": "تقارير للقراءة فقط: التحليلات والاستخدام والبحث في المحادثات وتلخيصها والرسوم البيانية وتقارير الرؤى.",
  "cfg_tsec_sa_knowledge_label": "إدارة المعرفة",
  "cfg_tsec_sa_knowledge_tooltip": "اسمح للوكيل باقتراح تغييرات على قاعدة المعرفة: إضافة المصادر أو تحديثها واستيعاب الملفات المرفوعة وإعادة التدريب.",
  "cfg_tsec_sa_contacts_label": "جهات الاتصال والمستفيدون",
  "cfg_tsec_sa_contacts_tooltip": "الاطلاع على سجلات جهات الاتصال والمستفيدين وإدارتها. العمليات الحساسة تتطلب موافقتك دائماً.",
  "cfg_tsec_sa_operations_label": "الأتمتة والقنوات",
  "cfg_tsec_sa_operations_tooltip": "إعدادات الوكيل وأتمتة الويب هوك والتكاملات وحالة القنوات.",
  "cfg_tsec_other_label": "أدوات أخرى",
  "cfg_tsec_other_tooltip": "أدوات أضيفت مؤخراً ولم تُصنّف بعد.",
  "cfg_tsec_enabled_count": "{{enabled}} من {{total}} مفعّلة",
  "cfg_tool_col_tool": "الأداة",
  "cfg_tool_col_approval": "الموافقة",
  "cfg_tool_col_enabled": "مفعّلة",
  "cfg_tool_agents_assistant": "المساعد",
  "cfg_tool_agents_system_agent": "الوكيل الآلي",
  "cfg_tool_agents_both": "كلاهما",
  "cfg_tool_section_bulk_aria": "تبديل جميع أدوات {{section}}",
  "cfg_tool_row_config_aria": "إعداد {{tool}}",
  "cfg_tool_requires_approval_aria": "طلب الموافقة لأداة {{tool}}",
  "cfg_tool_enabled_aria": "تفعيل {{tool}}",
  "cfg_tool_collect_lead_disabled_hint": "فعّل هذه الأداة لتحديد حقول العملاء المحتملين التي يجمعها المساعد.",
  "cfg_tool_collect_lead_misconfigured": "أضف حقلًا واحدًا على الأقل أدناه — لا يستطيع المساعد جمع العملاء المحتملين بدون مخطط حقول محدّد، ولا يمكن حفظ الإعدادات وهذه الأداة مفعّلة بلا حقول.",
  "cfgpage_apply_import": "تطبيق الاستيراد",
  "cfgpage_applying": "جارٍ التطبيق…",
  "cfgpage_calendar_columns_description": "الأعمدة الظاهرة في صفحة التقويم/جدول البيانات",
  "cfgpage_calendar_columns_title": "أعمدة التقويم",
  "cfgpage_choose_sections_to_import": "اختر الأقسام المراد استيرادها",
  "cfgpage_configuration_sections_aria": "أقسام الإعدادات",
  "cfgpage_documents_columns_description": "الأعمدة الظاهرة في صفحة المستندات",
  "cfgpage_documents_columns_title": "أعمدة المستندات",
  "cfgpage_drop_to_import": "أفلت للاستيراد",
  "cfgpage_export_failed": "فشل تصدير الإعدادات: {{message}}",
  "cfgpage_failed_load_page": "فشل تحميل صفحة الإعدادات",
  "cfgpage_import_file_input_label": "استيراد ملف الإعدادات",
  "cfgpage_import_parse_failed": "فشل تحليل الإعدادات: {{message}}",
  "cfgpage_import_tip_prefix": "تلميح — استخدم",
  "cfgpage_import_tip_suffix": "في شريط التنقل لتبديل الأقسام بأكملها دفعة واحدة.",
  "cfgpage_invalid_config_file": "ملف إعدادات غير صالح",
  "cfgpage_release_to_import_config": "حرّر لاستيراد الإعدادات",
  "cfgpage_section_ai_agents_description": "إعداد الإجابة متعددة الوكلاء لاسترجاع المعرفة: الوكيلان الباحث والمدقق اللذان يثبتان صحة إجابات قاعدة المعرفة ويتحققان منها",
  "cfgpage_section_ai_assistant_description": "إعداد نماذج الذكاء الاصطناعي وتوجيهات النظام والأدوات المتاحة",
  "cfgpage_section_appearance_description": "اختر لغات العرض المتاحة في تطبيقك",
  "cfgpage_section_business_description": "إعداد معلومات النشاط التجاري والمنطقة الزمنية والإعدادات الإقليمية",
  "cfgpage_section_calendar_display_description": "تخصيص طريقة ظهور الفعاليات والعروض المتاحة وتنسيقات الوقت وأنظمة الألوان",
  "cfgpage_section_calendar_display_title": "عرض التقويم",
  "cfgpage_section_columns_description": "تحديد الأعمدة الظاهرة في جداول البيانات",
  "cfgpage_section_email_templates_description": "إنشاء وإدارة قوالب البريد الإلكتروني لمؤسستك",
  "cfgpage_section_event_types_description": "إدارة أنواع الفعاليات القابلة للحجز — المدد والسعة وقواعد الحجز والألوان",
  "cfgpage_section_eyebrow": "قسم",
  "cfgpage_section_notification_rules_description": "إعداد توقيت وطريقة إرسال الإشعارات بناءً على أحداث دورة حياة الفعالية. تحدد كل قاعدة نوع المُحفّز والتوقيت والجمهور المستهدف وقالب واتساب.",
  "cfgpage_section_schedule_description": "حدد أيام العمل وساعات العمل ونطاقات التقويم المخصصة",
  "cfgpage_select_fields_for_section": "تحديد الحقول لقسم {{section}}",
  "cfgpage_selected_count": "تم تحديد {{count}}",
  "cfgpage_validation_fallback": "التحقق",
  "chat_ai_disabled_tooltip": "الذكاء الاصطناعي معطّل",
  "chat_ai_response_fallback": "رد الذكاء الاصطناعي",
  "chat_clear_search_text": "مسح نص البحث",
  "chat_close_search": "إغلاق البحث",
  "chat_context_cache_hits": "نتائج التخزين المؤقت",
  "chat_context_input": "المُدخل",
  "chat_context_input_percent": "المُدخل {{percent}}%",
  "chat_context_meter_summary": "المُدخل: {{input}}%، المُخرج: {{output}}%",
  "chat_context_output": "المُخرج",
  "chat_context_output_percent": "المُخرج {{percent}}%",
  "chat_context_total_cost": "التكلفة الإجمالية",
  "chat_document_action_added_suggestions_to": "تمت إضافة الاقتراحات إلى",
  "chat_document_action_adding_suggestions": "جارٍ إضافة الاقتراحات",
  "chat_document_action_created": "تم الإنشاء",
  "chat_document_action_creating": "جارٍ الإنشاء",
  "chat_document_action_updated": "تم التحديث",
  "chat_document_action_updating": "جارٍ التحديث",
  "chat_document_create_error": "خطأ أثناء إنشاء المستند: {{error}}",
  "chat_document_for_document": "للمستند",
  "chat_document_shared_view_unsupported": "عرض الملفات في المحادثات المشتركة غير مدعوم حاليًا.",
  "chat_document_update_error": "خطأ أثناء تحديث المستند: {{error}}",
  "chat_edit_message_placeholder": "عدّل رسالتك",
  "chat_export_meta_contact": "جهة الاتصال:",
  "chat_export_meta_exported": "تاريخ التصدير:",
  "chat_export_meta_messages": "الرسائل:",
  "chat_export_meta_phone": "الهاتف:",
  "chat_export_sender_assistant": "المساعد",
  "chat_export_sender_system_agent": "الوكيل النظامي",
  "chat_export_sender_user": "مستخدم",
  "chat_export_sender_you": "أنت",
  "chat_image_attachment_alt": "مرفق صورة من الرسالة",
  "chat_invalid_document_output_format": "تنسيق مخرجات المستند غير صالح",
  "chat_invalid_event_snapshot_format": "تنسيق لقطة الحدث غير صالح",
  "chat_invalid_interactive_buttons_input": "مدخلات أزرار التفاعل غير صالحة",
  "chat_invalid_interactive_list_input": "مدخلات قائمة التفاعل غير صالحة",
  "chat_interactive_selected_by_customer": "اختاره العميل",
  "chat_invalid_suggestions_output_format": "تنسيق مخرجات الاقتراحات غير صالح",
  "chat_invalid_weather_data_format": "تنسيق بيانات الطقس غير صالح",
  "chat_metrics_activity": "النشاط",
  "chat_metrics_audio_badge": "تحويل صوتي احتياطي",
  "chat_metrics_audio_duration": "مدة الصوت",
  "chat_metrics_audio_fallback_description": "حُوّلت هذه الرسالة الصوتية إلى نص لأن نموذج المحادثة المحدد لا يستقبل الصوت.",
  "chat_metrics_audio_transcription": "تحويل الصوت إلى نص",
  "chat_metrics_agent_role_main": "رئيسي",
  "chat_metrics_agent_role_researcher": "باحث",
  "chat_metrics_agent_role_verifier": "مُدقق",
  "chat_metrics_cost": "التكلفة",
  "chat_metrics_estimated": "تقديرية",
  "chat_metrics_first_response": "أول استجابة",
  "chat_metrics_from_cache": "من التخزين المؤقت",
  "chat_metrics_speed": "السرعة",
  "chat_metrics_status": "الحالة",
  "chat_metrics_steps": "الخطوات",
  "chat_metrics_superseded": "مسودات ملغاة",
  "chat_metrics_superseded_badge": "مسودات مدمجة",
  "chat_metrics_this_response": "هذه الاستجابة",
  "chat_metrics_tokens": "الرموز",
  "chat_metrics_tool_calls": "استدعاءات الأدوات",
  "chat_metrics_total_time": "الوقت الإجمالي",
  "chat_metrics_whole_chat": "المحادثة كاملة",
  "chat_next_match": "النتيجة التالية",
  "chat_pasted_image_label": "صورة ملصقة",
  "chat_attachment_upload_failed": "فشل إرفاق الملف",
  "chat_preview_file_label": "ملف",
  "chat_preview_image_label": "صورة",
  "chat_previous_match": "النتيجة السابقة",
  "chat_search_conversation": "بحث في المحادثة",
  "chat_search_jump_to_match": "الانتقال إلى النتيجة {{index}} من {{total}}",
  "chat_search_results_rail": "نتائج البحث",
  "chat_select_action": "اختيار",
  "chat_send_char_count": "إرسال · {{charCount}}/{{characterLimit}}",
  "chat_send_short": "إرسال",
  "chat_shell_ask_anything": "اسأل عن أي شيء…",
  "chat_system_agent_header": "محادثة الوكيل النظامي",
  "chat_tool_approval_allow": "سماح",
  "chat_tool_approval_always_allow": "السماح دائمًا",
  "chat_tool_approval_always_allow_tooltip": "الموافقة الآن وإيقاف طلب الموافقة لهذه الأداة على مستوى مؤسستك بالكامل. يمكنك إعادة تفعيله في أي وقت من الإعدادات ← المساعد الذكي.",
  "chat_tool_always_allow_success": "لن تتطلب هذه الأداة موافقة بعد الآن.",
  "chat_tool_always_allow_error": "تعذّر تحديث إعداد الموافقة. حاول مرة أخرى.",
  "chat_tool_status_approved": "تمت الموافقة",
  "chat_tool_status_denied": "مرفوض",
  "chat_tool_status_error": "خطأ",
  "chat_tool_status_running": "قيد التشغيل",
  "chat_weather_hourly_forecast": "توقعات الطقس بالساعة",
  "chat_weather_now": "الآن",
  "chat_weather_sunrise": "الشروق:",
  "chat_weather_sunset": "الغروب:",
  "chat_web_preview_console": "وحدة التحكم",
  "dash_ai_performance": "أداء الذكاء الاصطناعي",
  "dash_ai_token_usage_title": "استخدام رموز الذكاء الاصطناعي",
  "dash_api_calls_count": "{{count}} استدعاء API",
  "dash_avg_duration": "المتوسط {{value}}",
  "dash_badge_avg": "متوسط",
  "dash_badge_max": "أقصى",
  "dash_badge_med": "وسيط",
  "dash_bookings_abbr": "حجز",
  "dash_calls_count": "{{count}} استدعاء",
  "dash_cost_efficiency": "كفاءة التكلفة",
  "dash_cost_per_response": "{{cost}} / استجابة",
  "dash_export_none_selected": "(لم يتم تحديد أي عنصر)",
  "dash_latency": "زمن الاستجابة",
  "dash_messages_abbr": "رسالة",
  "dash_no_ai_usage_data": "لا توجد بيانات استخدام للذكاء الاصطناعي لهذه الفترة.",
  "dash_no_word_data": "لا توجد بيانات كلمات متاحة",
  "dash_rank_aria": "الترتيب {{count}}",
  "dash_runs_count": "{{count}} تشغيل",
  "dash_token_usage_input": "المدخلات",
  "dash_token_usage_output": "المخرجات",
  "dash_tool_calls_ratio": "{{errors}} / {{total}} استدعاء أداة",
  "dash_tool_errors": "أخطاء الأدوات",
  "dash_tooltip_input_tokens": "المدخلات: {{value}}",
  "dash_tooltip_output_tokens": "المخرجات: {{value}}",
  "dash_top_n_words": "أفضل {{count}} كلمة",
  "dash_total_cost": "التكلفة الإجمالية",
  "dash_elevenlabs_transcription_cost": "تفريغ ElevenLabs الصوتي",
  "dash_elevenlabs_transcription_detail": "مضمّن في التكلفة الإجمالية · {{count}} عمليات تفريغ",
  "dash_elevenlabs_transcription_explainer": "يُستخدم عند تفعيل قراءة الصوت عندما لا يدعم النموذج المحدد استقبال الصوت مباشرةً.",
  "dash_word_bar_tooltip": "الشريط {{count}}، القيمة: {{value}}",
  "dash_word_occurrences_aria": "{{word}}: {{count}} مرة",
  "demo_avatar_number": "الصورة الرمزية {{n}}",
  "demo_comments_count": "{{count}} تعليقات",
  "demo_connect": "اتصال",
  "demo_disconnect": "قطع الاتصال",
  "demo_open_integration": "فتح التكامل",
  "demo_nav_stack_intro": "سطح واحد مثبّت يتنقل عبر مجموعة من العروض بدلاً من فتح طبقة عائمة ثانية. يحتفظ كل منها بموضعه، ويعتم أو يتحوّل بدلاً من القفز، ويتراجع مستوى واحدًا في كل مرة بمفتاح Escape.",
  "demo_nav_stack_morph_caption": "يتحوّل السطح بالكامل إلى العرض التالي — يتغيّر العرض والارتفاع بسلاسة بينهما. للوحات التصفية والتفاصيل.",
  "demo_nav_stack_nested_caption": "تبقى البطاقات الأصلية ظاهرة ومعتمة خلف البطاقة الفرعية، بمحاذاة الصف الذي نقرت عليه. لقوائم الإجراءات والسياق.",
  "demo_nav_stack_panel_caption": "نفس التنقل ولكن ضمن الصفحة، دون طبقة عائمة — الإطار المستخدم داخل الأوراق ومناطق التبديل.",
  "demo_open_menu": "فتح القائمة",
  "demo_or_divider": "أو",
  "demo_section_bento": "بينتو",
  "demo_section_buttons_actions": "الأزرار والإجراءات",
  "demo_section_faq": "الأسئلة الشائعة",
  "demo_section_form_controls": "عناصر التحكم في النموذج",
  "demo_section_indicators": "المؤشرات",
  "demo_section_marketing_panel": "لوحة التسويق",
  "demo_section_menu_pill": "قائمة الحبة",
  "demo_section_navigable_overlays": "الطبقات القابلة للتنقل",
  "demo_section_real_time": "الوقت الفعلي",
  "demo_section_skeletons": "الهياكل العظمية",
  "demo_section_surfaces_cards": "الأسطح والبطاقات",
  "demo_send": "إرسال",
  "demo_sign_in_with_apple": "تسجيل الدخول باستخدام آبل",
  "demo_sign_in_with_github": "تسجيل الدخول باستخدام جيت هاب",
  "demo_sign_in_with_google": "تسجيل الدخول باستخدام جوجل",
  "demo_toggle_checkbox": "تبديل خانة الاختيار",
  "demo_toggle_connection": "تبديل الاتصال",
  "demo_toggle_radio": "تبديل زر الاختيار",
  "demo_toggle_switch": "تبديل المفتاح",
  "demo_unread_count": "{{count}} غير مقروءة",
  "docs_back_to_docs_index": "العودة إلى فهرس الدليل",
  "docs_breadcrumb": "مسار التنقل",
  "docs_calendar_demo_delete_confirm": "هل أنت متأكد أنك تريد حذف الحدث '{{title}}'",
  "docs_calendar_demo_interactive_hint": "تفاعلي -- انقر على التواريخ للإضافة، وعلى الأحداث للحذف، واسحب للنقل",
  "docs_calendar_demo_new_title_prompt": "يرجى إدخال عنوان جديد للحدث",
  "docs_calendar_demo_weekends": "عطلات نهاية الأسبوع",
  "docs_chat_demo_attach_file": "إرفاق ملف",
  "docs_chat_demo_copy": "نسخ",
  "docs_chat_demo_edit": "تعديل",
  "docs_chat_demo_emoji": "الرموز التعبيرية",
  "docs_chat_demo_online": "متصل",
  "docs_chat_demo_record_voice": "تسجيل صوتي",
  "docs_chat_demo_send_message": "إرسال الرسالة",
  "docs_chat_demo_type_message": "اكتب رسالة…",
  "docs_close_navigation": "إغلاق التنقل",
  "docs_copied": "تم النسخ",
  "docs_copy_code": "نسخ الكود",
  "docs_copy_page": "نسخ الصفحة",
  "docs_data_grid_demo_click_to_edit": "انقر على اسم للتعديل",
  "docs_data_grid_demo_contacts_shown": "جهات الاتصال · {{count}} معروضة",
  "docs_data_grid_demo_history": "السجل ↗",
  "docs_doc_not_found": "الصفحة غير موجودة",
  "docs_home": "الصفحة الرئيسية للدليل",
  "docs_label": "الدليل",
  "docs_language": "اللغة",
  "docs_link_to_section": "رابط إلى هذا القسم",
  "docs_next": "التالي",
  "docs_no_doc_exists_at": "لا توجد صفحة عند \"{{slug}}\".",
  "docs_no_matches": "لا توجد نتائج.",
  "docs_on_this_page": "في هذه الصفحة",
  "docs_open_app": "فتح التطبيق",
  "docs_page_navigation": "التنقل بين الصفحات",
  "docs_phone_connector_demo_all": "الكل",
  "docs_phone_connector_demo_all_countries": "جميع الدول",
  "docs_phone_connector_demo_country": "الدولة",
  "docs_phone_connector_demo_documents": "المستندات",
  "docs_phone_connector_demo_favorites": "المفضلة",
  "docs_phone_connector_demo_has_document": "لديه مستند",
  "docs_phone_connector_demo_no_contacts_match": "لا توجد جهات اتصال مطابقة للفلاتر المحددة",
  "docs_phone_connector_demo_no_countries_found": "لم يتم العثور على دول",
  "docs_phone_connector_demo_no_document": "بدون مستند",
  "docs_phone_connector_demo_no_matches_for": "لا توجد نتائج لـ \"{{search}}\"",
  "docs_phone_connector_demo_recent": "الأخيرة",
  "docs_phone_connector_demo_registered": "مسجَّل",
  "docs_phone_connector_demo_remove_filter": "إزالة الفلتر",
  "docs_phone_connector_demo_search_contacts": "ابحث عن جهات الاتصال…",
  "docs_phone_connector_demo_search_countries": "ابحث عن الدول…",
  "docs_phone_connector_demo_selected": "المحدد",
  "docs_phone_connector_demo_status": "الحالة",
  "docs_phone_connector_demo_unregistered": "غير مسجَّل",
  "docs_previous": "السابق",
  "docs_search_docs": "البحث في الدليل",
  "docs_search_documentation_ellipsis": "ابحث في التوثيق…",
  "docs_search_ellipsis": "بحث…",
  "docs_skip_to_content": "تخطَّ إلى المحتوى",
  "docs_switch_to_dark_theme": "التبديل إلى الوضع الداكن",
  "docs_switch_to_light_theme": "التبديل إلى الوضع الفاتح",
  "docs_tab_n": "تبويب {{n}}",
  "docs_tabs": "تبويبات",
  "docs_toggle_navigation": "إظهار/إخفاء التنقل",
  "evt_active_toggle_note": "الأنواع غير النشطة مخفية من قوائم الحجز الجديدة لكنها تبقى محفوظة للسجلات التاريخية.",
  "evt_add_event_type": "إضافة نوع فعالية",
  "evt_after_buffer_label": "الفاصل الزمني بعد الفعالية (بالدقائق)",
  "evt_allow_multiple_future_label": "السماح بفعاليات مستقبلية متعددة",
  "evt_allow_multiple_future_tooltip": "ما إذا كان يمكن لجهة اتصال واحدة أن تحتفظ بأكثر من فعالية قادمة من هذا النوع. الإيقاف (الافتراضي) يحدّ كل جهة اتصال بفعالية واحدة: حجز فعالية أخرى ينقل فعاليتها الحالية إلى الوقت الجديد بدلاً من إضافة فعالية ثانية.",
  "evt_allow_multiple_per_day_label": "السماح بفعاليات متعددة في اليوم نفسه",
  "evt_allow_multiple_per_day_tooltip": "ما إذا كان يمكن أن تقع فعاليات جهة الاتصال القادمة من هذا النوع في اليوم نفسه. عند الإيقاف، تقتصر كل جهة اتصال على فعالية واحدة في اليوم التقويمي، لذا يجب توزيع حجوزاتها على أيام مختلفة.",
  "evt_background_colour_label": "لون الخلفية",
  "evt_background_colour_tooltip": "تعبئة الخلفية لفعاليات المحادثة على التقويم.",
  "evt_before_buffer_label": "الفاصل الزمني قبل الفعالية (بالدقائق)",
  "evt_booking_horizon_label": "أفق الحجز (بالأيام)",
  "evt_booking_horizon_tooltip": "إلى أي مدى في المستقبل يمكن لهذا الدور حجز فعاليات من هذا النوع، محسوبة بالأيام التقويمية من اليوم. اتركه فارغًا لعدم وجود حد.",
  "evt_color_conflict_hint": "قد يصعب تمييز فعاليات هذه الأنواع عن بعضها على التقويم.",
  "evt_color_conflict_multiple": "هناك أنواع فعاليات أخرى تستخدم أنظمة ألوان مشابهة جدًا:",
  "evt_color_conflict_single": "هناك نوع فعالية آخر يستخدم نظام ألوان مشابهًا جدًا:",
  "evt_colors_fallback_note": "أي حقل فارغ يرجع إلى لون الإطار، ثم إلى إعداد سمة المؤسسة الافتراضي.",
  "evt_colors_label": "الألوان",
  "evt_colors_tooltip": "تُعرض تعبئة الخلفية والإطار وتسمية النص بشكل مستقل حتى تحافظ كل فعالية على تباين عالٍ. اترك أي حقل فارغًا لوراثة إعداد سمة المؤسسة الافتراضي.",
  "evt_coming_soon": "قريبًا",
  "evt_custom_fields_coming_soon_description": "أضف حقولًا خاصة بكل نوع فعالية (نص، رقم، تاريخ، قائمة اختيار، إلخ) تظهر كأعمدة في جدول البيانات وتتحقق من صحة الحجوزات الواردة.",
  "evt_custom_fields_save_first": "احفظ نوع الفعالية هذا أولًا لبدء إضافة حقول مخصصة.",
  "evt_custom_fields_title": "حقول مخصصة",
  "evt_deactivate_bookings_preserved": "سيتم الاحتفاظ بـ {{count}} حجز حالي، لكن لن يمكن إنشاء حجوزات جديدة من هذا النوع.",
  "evt_deactivate_confirm": "هل أنت متأكد من رغبتك في إلغاء تفعيل “{{label}}”؟ سيُطبَّق هذا عند النقر على زر الحفظ على مستوى الصفحة.",
  "evt_deactivate_no_bookings": "لا توجد حجوزات تستخدم هذا النوع بعد. يؤدي إلغاء التفعيل إلى إخفائه من نموذج الإنشاء مع الاحتفاظ بالسجل التاريخي.",
  "evt_deactivate_title": "إلغاء تفعيل نوع الفعالية",
  "evt_description_hint": "يُعرض للمساعد الذكي ليتمكن من مشاركة هذه التفاصيل مع الضيوف — اكتب السعر أو التفاصيل هنا.",
  "evt_description_label": "الوصف",
  "evt_resource_hint": "اجمع هذا النوع تحت مورد (شاليه، غرفة، كرسي، ...). عندها يمكن قصر التقويم على مورد واحد في كل مرة.",
  "evt_resource_label": "المورد",
  "evt_resource_placeholder": "بدون",
  "evt_resource_new": "مورد جديد…",
  "evt_resource_new_placeholder": "اسم المورد",
  "evt_resource_occupancy_label": "الحد الأقصى للإشغال",
  "evt_resource_occupancy_hint": "عدد الحجوزات التي يستوعبها هذا المورد في الوقت نفسه، عبر كل أنواع الأحداث المرتبطة به. لا تتعارض الأنواع المشتركة في المورد نفسه إلا عند بلوغ هذا العدد. القيمة مشتركة بين كل الأنواع على هذا المورد.",
  "evt_resource_occupancy_unlimited": "بلا حد",
  "calendar_occupancy_title": "إشغال التقويم",
  "calendar_occupancy_description": "أنواع الأحداث التي ليس لها مورد تتشارك التقويم: لا يتعارض بعضها مع بعض إلا عند تداخل هذا العدد من الحجوزات. الأنواع المرتبطة بمورد تستخدم الحد الأقصى لإشغال ذلك المورد بدلاً من ذلك.",
  "calendar_occupancy_label": "الحد الأقصى للإشغال",
  "evt_drawer_description_conversation": "فعاليات محادثة تديرها المنظومة تلقائيًا. يمكن تعديل التسمية ولون الخلفية فقط.",
  "evt_drawer_description_scheduled": "اضبط التسمية والمدة والسعة والحقول المخصصة. تُحفظ التغييرات مع زر الحفظ على مستوى الصفحة.",
  "evt_drawer_title_edit": "تعديل “{{label}}”",
  "evt_drawer_title_edit_conversation": "تعديل فعالية المحادثة",
  "evt_drawer_title_new": "نوع فعالية جديد",
  "evt_invalid_draft_title": "لا يمكن حفظ نوع الفعالية بعد",
  "evt_invalid_draft_description": "بعض القيم غير صالحة، لذا لا يمكن إدراج هذه التغييرات ضمن الحفظ:",
  "evt_invalid_draft_discard": "تجاهل التغييرات",
  "evt_row_pending_new": "جديد",
  "evt_row_pending_edited": "مُعدَّل",
  "evt_row_pending_removed": "سيُزال",
  "evt_duration_auto_computed_note": "محسوبة تلقائيًا من مدة الفترة الزمنية للمؤسسة ({{minutes}} دقيقة) والحد الأقصى للسعة لكل فترة.",
  "evt_duration_minutes_label": "المدة (بالدقائق)",
  "evt_duration_minutes_tooltip": "المدة التي تستغرقها حجوزات هذا النوع. تُستخدم لحساب وقت الانتهاء ومنع حجز الفترة نفسها في آن واحد.",
  "evt_duration_mode_auto_label": "تلقائي",
  "evt_duration_mode_label": "وضع المدة",
  "evt_duration_mode_manual_label": "يدوي",
  "evt_duration_mode_tooltip_auto_desc": "— يُشتق من مدة الفترة الزمنية للمؤسسة مقسومة على الحد الأقصى للفعاليات لكل فترة.",
  "evt_duration_mode_tooltip_manual_desc": "— قيمة ثابتة تحددها أدناه.",
  "evt_editor_heading": "أنواع الفعاليات",
  "evt_editor_subtitle_advanced": "انقر على بطاقة لتعديل المدة والسعة والألوان والحقول المخصصة. تُحفظ التغييرات مع زر الحفظ على مستوى الصفحة.",
  "evt_editor_subtitle_standard": "تستخدم أنواع الفعاليات الإعدادات الافتراضية على مستوى المؤسسة (الألوان، مدة الفترة، السعة). بدّل إلى الوضع المتقدم لتخصيصها فرديًا.",
  "evt_empty_state": "لا توجد أنواع فعاليات بعد. أنشئ واحدًا للبدء في استقبال الحجوزات.",
  "evt_field_label_placeholder": "مثال: الأولوية",
  "evt_identifier_label": "المعرّف",
  "evt_identifier_locked_note": "المعرّف مقفل بعد الحفظ لتجنب كسر الحجوزات الحالية.",
  "evt_identifier_tooltip": "مفتاح برمجي ثابت يُستخدم بواسطة الواجهة البرمجية ومفتاح التقويم. قابل للتعديل فقط ما دام نوع الفعالية مسودة.",
  "evt_label_placeholder": "مثال: فحص دوري",
  "evt_max_future_events_label": "الحد الأقصى للفعاليات المستقبلية لكل نوع",
  "evt_max_future_events_tooltip": "إجمالي عدد الفعاليات القادمة من هذا النوع التي يمكن لجهة اتصال واحدة الاحتفاظ بها في الوقت نفسه، سواء كانت في اليوم نفسه أو في أيام مختلفة ({{min}}–{{max}}).",
  "evt_max_per_slot_label": "الحد الأقصى لكل فترة",
  "evt_max_per_slot_tooltip": "أقصى عدد من الفعاليات يمكن لهذا الدور جدولتها في فترة زمنية واحدة. اتركه فارغًا لعدم وجود حد.",
  "evt_max_span_label": "السماح بالحجوزات متعددة الأيام",
  "evt_max_span_nights_label": "الحد الأقصى لعدد الليالي",
  "evt_max_span_nights_tooltip": "أطول إقامة يمكن أن يغطيها حجز واحد من هذا النوع، محسوبة بالليالي.",
  "evt_max_span_tooltip": "يتيح لحجز هذا النوع أن يمتد لعدة ليالٍ مع اختيار الضيف لتاريخ المغادرة. وتصبح المدة أعلاه هي أقصر إقامة مسموح بها.",
  "evt_min_notice_label": "الحد الأدنى لمهلة الحجز (بالدقائق)",
  "evt_min_notice_tooltip": "أقصر فجوة مسموح بها بين وقت طلب الحجز ووقت البدء المجدول.",
  "evt_no_custom_fields": "لا توجد حقول مخصصة بعد. أضف واحدًا أدناه لتوسيع نموذج الحجز وأعمدة جدول البيانات.",
  "evt_queue_deactivation": "إضافة إلغاء التفعيل إلى قائمة الانتظار",
  "evt_queue_field": "إضافة الحقل إلى قائمة الانتظار",
  "evt_queued_badge": "بانتظار الحفظ",
  "evt_queued_fields_save_note": "تُحفظ الحقول المنتظرة مع زر الحفظ على مستوى الصفحة.",
  "evt_requires_approval_label": "يتطلب موافقة المالك",
  "evt_requires_approval_tooltip": "تبقى الحجوزات الجديدة من هذا النوع معلّقة (وتحجز مواعيدها) حتى توافق عليها.",
  "evt_requires_approval_ttl_label": "مهلة الموافقة (بالساعات)",
  "evt_requires_approval_ttl_tooltip": "المدة التي يحتفظ فيها الحجز المعلّق بمواعيده قبل انتهاء صلاحيته. اتركه فارغًا للاحتفاظ به حتى تتخذ إجراءً.",
  "evt_role_agent_label": "الوكيل الذكي",
  "evt_role_agent_tooltip": "حدود للفعاليات التي يجدولها المساعد الذكي أو سير العمل الآلي.",
  "evt_role_secretary_label": "السكرتير / الواجهة",
  "evt_role_secretary_tooltip": "حدود للفعاليات التي تُجدول يدويًا عبر واجهة التقويم أو عمليات السكرتير.",
  "evt_scheduling_stub_intro": "ستتوفر قواعد الجدولة المتقدمة في إصدار لاحق. عناصر التحكم أدناه هي عناصر نائبة للعرض فقط.",
  "evt_show_in_grid": "إظهار في الجدول",
  "evt_similar_colors_detected": "تم اكتشاف ألوان متشابهة",
  "evt_soon_badge": "قريبًا",
  "evt_status_pending": "بانتظار الموافقة",
  "evt_stub_booking_limits_description": "حدّد عدد الحجوزات الممكنة من هذا النوع لكل يوم / أسبوع / شهر.",
  "evt_stub_booking_limits_title": "حدود الحجز",
  "evt_stub_recurrence_description": "امنح الحاضرين إمكانية حجز سلسلة متكررة في خطوة واحدة — يوميًا / أسبوعيًا / شهريًا.",
  "evt_stub_recurrence_title": "التكرار",
  "evt_stub_seats_description": "حجوزات جماعية حيث تستوعب فترة زمنية واحدة عدة حاضرين (مستوحاة من ميزة المقاعد في Cal.com).",
  "evt_stub_seats_title": "مقاعد لكل فترة زمنية",
  "evt_system_event_type": "نوع فعالية نظامي.",
  "evt_system_event_type_description": "تُسجَّل المحادثات تلقائيًا. يمكنك إعادة تسمية هذا الصف واختيار لون للتقويم، لكن السعة والمدة غير قابلتين للتعديل.",
  "evt_tab_basics": "أساسيات",
  "evt_tab_duration": "المدة",
  "evt_tab_rules": "القواعد",
  "evt_toast_add_field_failed": "فشل إضافة الحقل",
  "evt_toast_add_field_success": "تمت إضافة حقل الفعالية.",
  "evt_toast_deactivate_failed": "فشل إلغاء تفعيل نوع الفعالية",
  "evt_toast_deactivate_success": "تم حذف نوع الفعالية.",
  "evt_toast_id_required": "معرّف نوع الفعالية مطلوب",
  "evt_toast_org_required_add_field": "المؤسسة النشطة مطلوبة لإضافة حقل الفعالية",
  "evt_toast_org_required_deactivate": "المؤسسة النشطة مطلوبة لإلغاء تفعيل نوع الفعالية",
  "evt_toast_org_required_flush": "المؤسسة النشطة مطلوبة لحفظ أنواع الفعاليات",
  "evt_toast_org_required_generic": "المؤسسة النشطة مطلوبة",
  "evt_toast_org_required_list": "المؤسسة النشطة مطلوبة لتحميل أنواع الفعاليات",
  "evt_toast_org_required_remove_field": "المؤسسة النشطة مطلوبة لحذف حقل الفعالية",
  "evt_toast_org_required_reorder": "المؤسسة النشطة مطلوبة لإعادة ترتيب أنواع الفعاليات",
  "evt_toast_org_required_reorder_fields": "المؤسسة النشطة مطلوبة لإعادة ترتيب حقول الفعالية",
  "evt_toast_org_required_save": "المؤسسة النشطة مطلوبة لحفظ نوع الفعالية",
  "evt_toast_org_required_update_field": "المؤسسة النشطة مطلوبة لتحديث حقل الفعالية",
  "evt_toast_remove_field_failed": "فشل حذف الحقل",
  "evt_toast_remove_field_success": "تم حذف حقل الفعالية.",
  "evt_toast_reorder_failed": "فشل إعادة ترتيب أنواع الفعاليات",
  "evt_toast_reorder_success": "تمت إعادة ترتيب أنواع الفعاليات.",
  "evt_toast_reorder_fields_failed": "فشل إعادة ترتيب الحقول",
  "evt_toast_reorder_fields_success": "تمت إعادة ترتيب حقول الفعاليات.",
  "evt_toast_save_failed": "فشل حفظ نوع الفعالية",
  "evt_toast_save_success": "تم حفظ نوع الفعالية.",
  "evt_toast_update_field_failed": "فشل تحديث الحقل",
  "evt_toast_update_field_success": "تم تحديث حقل الفعالية.",
  "feat_admin_org_balance_add_credits_button": "إضافة رصيد",
  "feat_admin_org_balance_all_loaded": "تم تحميل الكل",
  "feat_admin_org_balance_column_balance": "الرصيد",
  "feat_admin_org_balance_column_credits_delta": "Δ الرصيد",
  "feat_admin_org_balance_column_description": "الوصف",
  "feat_admin_org_balance_column_kind": "النوع",
  "feat_admin_org_balance_column_usd_delta": "Δ USD",
  "feat_admin_org_balance_column_when": "الوقت",
  "feat_admin_org_balance_credit_dialog_description": "أضف رصيدًا يدويًا لهذه المؤسسة. يُسجَّل كمعاملة CREDIT_MANUAL وأنت الجهة المنفذة.",
  "feat_admin_org_balance_credit_dialog_title": "شحن رصيد المؤسسة",
  "feat_admin_org_balance_crediting_ellipsis": "جارٍ الشحن...",
  "feat_admin_org_balance_credits_placeholder": "مثال: 1000",
  "feat_admin_org_balance_credits_to_add_label": "الرصيد المراد إضافته",
  "feat_admin_org_balance_empty_all": "لا توجد معاملات رصيد بعد.",
  "feat_admin_org_balance_empty_filtered": "لا توجد معاملات مطابقة لهذا الفلتر.",
  "feat_admin_org_balance_filter_all": "الكل",
  "feat_admin_org_balance_filter_debits": "الخصومات",
  "feat_admin_org_balance_filter_direction": "الاتجاه",
  "feat_admin_org_balance_kind_adjustment_minus": "تسوية −",
  "feat_admin_org_balance_kind_adjustment_plus": "تسوية +",
  "feat_admin_org_balance_loaded_count": "تم تحميل {{count}} معاملات",
  "feat_admin_org_balance_reason_label": "السبب (اختياري)",
  "feat_admin_org_balance_reason_placeholder": "مثال: رصيد ترحيبي عند الإعداد",
  "feat_admin_org_balance_search_placeholder": "البحث في السجل…",
  "feat_admin_plans_add_row_button": "إضافة صف",
  "feat_admin_plans_column_model": "النموذج",
  "feat_admin_plans_column_usd_micros": "USD-micros",
  "feat_admin_plans_create_draft_button": "إنشاء مسودة",
  "feat_admin_plans_created_on": "أُنشئت في {{date}}",
  "feat_admin_plans_new_draft_description": "يستنسخ التسعير من أحدث نسخة لهذا المعرّف. الأسعار الجديدة تصبح فعّالة عند النشر.",
  "feat_admin_plans_new_draft_title": "مسودة جديدة",
  "feat_admin_plans_no_notes": "لا توجد ملاحظات",
  "feat_admin_plans_no_plans": "لا توجد خطط بعد.",
  "feat_admin_plans_no_pricing_rows": "لا توجد صفوف تسعير.",
  "feat_admin_plans_notes_label": "ملاحظات",
  "feat_admin_plans_notes_placeholder": "سبب أو سياق اختياري لهذه النسخة",
  "feat_admin_plans_phase_out_button": "إنهاء تدريجي",
  "feat_admin_plans_pricing_invalid": "يتطلب كل صف نموذجاً فريداً وأرصدة صحيحة غير سالبة وUSD-micros غير سالبة.",
  "feat_admin_plans_publish_button": "نشر",
  "feat_admin_plans_remove_row_button": "إزالة صف التسعير",
  "feat_admin_plans_save_before_publish": "احفظ تغييرات التسعير قبل نشر هذه النسخة.",
  "feat_admin_plans_save_pricing_button": "حفظ التسعير",
  "feat_admin_plans_slug_placeholder": "مثال: standard",
  "feat_admin_plans_slug_invalid": "استخدم 64 حرفاً كحد أقصى من الأحرف الإنجليزية الصغيرة والأرقام والشرطات المفردة فقط.",
  "feat_admin_plans_status_draft": "مسودة",
  "feat_admin_plans_status_phased_out": "منتهية تدريجياً",
  "feat_admin_plans_status_published": "منشورة",
  "feat_billing_ai_spend_by_member_assistant": "مساعد مراسلة العملاء",
  "feat_billing_ai_spend_by_member_description": "إنفاق الاستدلال المنسوب لكل عضو خلال الفترة.",
  "feat_billing_next_invoice_bill_date": "تاريخ الفوترة المتوقع",
  "feat_billing_next_invoice_title": "فاتورتك القادمة",
  "feat_billing_next_invoice_unnamed_line": "رسوم الاشتراك",
  "feat_billing_usage_ai_cost_label": "تكلفة الذكاء الاصطناعي (هذا الشهر)",
  "feat_billing_usage_chart_cap_label": "سقف الخطة",
  "feat_billing_usage_chart_description": "الإنفاق اليومي على الاستدلال خلال دورة الفوترة الحالية.",
  "feat_billing_usage_chart_range_all": "كل الوقت",
  "feat_billing_usage_chart_range_month": "هذا الشهر",
  "feat_billing_usage_chart_title": "التكلفة اليومية للذكاء الاصطناعي",
  "feat_billing_usage_models_column_cache_read": "قراءة التخزين المؤقت",
  "feat_billing_usage_models_column_cache_write": "كتابة التخزين المؤقت",
  "feat_billing_usage_models_column_cost": "التكلفة",
  "feat_billing_usage_models_column_input": "الإدخال",
  "feat_billing_usage_models_column_model": "النموذج",
  "feat_billing_usage_models_column_output": "الإخراج",
  "feat_billing_usage_models_column_total": "إجمالي الرموز",
  "feat_billing_usage_models_description": "استخدام النماذج اللغوية لكل نموذج مع عدد الرموز وقراءات التخزين المؤقت وتكلفة API.",
  "feat_billing_usage_models_title": "الاستخدام حسب النموذج",
  "feat_billing_usage_models_total_row": "الإجمالي",
  "feat_billing_usage_projected_label": "المتوقع بنهاية الشهر",
  "feat_billing_usage_upgrade_cta": "الترقية إلى {{plan}}",
  "feat_calendar_density_compact": "مضغوط",
  "feat_calendar_density_default": "افتراضي",
  "feat_calendar_density_spacious": "واسع",
  "feat_component_style_embossed": "بارز",
  "feat_component_style_flat": "عادي",
  "feat_documents_canvas_load_failed": "فشل تحميل لوحة المستند.",
  "feat_documents_init_failed": "فشل تهيئة المستند",
  "feat_documents_save_failed": "فشل حفظ المستند",
  "feat_documents_snapshot_damaged": "بيانات هذا المستند تالفة ولا يمكن فتحه.",
  "feat_documents_snapshot_load_failed": "فشل تحميل اللقطة",
  "feat_documents_snapshot_newer_version": "حُفظ هذا المستند بإصدار أحدث من التطبيق. حدّث الصفحة ثم حاول مجددًا.",
  "feat_documents_tldraw_init_failed": "تعذر تهيئة أداة الرسم.",
  "feat_documents_update_age_failed": "فشل تحديث عمر المستخدم",
  "feat_documents_update_name_failed": "فشل تحديث اسم المستخدم",
  "feat_documents_version_not_loaded": "لم يتم تحميل إصدار المستند؛ يتعذر الحفظ",
  "feat_documents_viewport_save_failed": "فشل حفظ إعدادات عرض المستند",
  "feat_fullscreen": "ملء الشاشة",
  "feat_language_switched_to_english": "تم التبديل إلى الإنجليزية",
  "feat_org_balance_balance_label": "الرصيد",
  "feat_org_balance_col_amount": "المقدار",
  "feat_org_balance_col_balance": "الرصيد",
  "feat_org_balance_col_date": "التاريخ",
  "feat_org_balance_col_description": "الوصف",
  "feat_org_balance_col_model": "النموذج",
  "feat_org_balance_col_usd": "دولار",
  "feat_org_balance_credits_description": "يتم خصم ردود الذكاء الاصطناعي من هذا الرصيد. يقوم مسؤول المنصة بإضافة الشحنات.",
  "feat_org_balance_credits_title": "الرصيد",
  "feat_org_balance_credits_unit": "رصيد",
  "feat_org_balance_filter_model": "نموذج الذكاء الاصطناعي",
  "feat_org_balance_kind_adjustment": "تسوية",
  "feat_org_balance_kind_ai_usage": "استخدام الذكاء الاصطناعي",
  "feat_org_balance_kind_credit_manual": "شحن يدوي",
  "feat_org_balance_kind_payment": "دفعة",
  "feat_org_balance_kind_refund": "استرداد",
  "feat_org_balance_load_more": "تحميل المزيد",
  "feat_org_balance_no_transactions": "لا توجد معاملات بعد.",
  "feat_org_balance_no_transactions_filtered": "لا توجد معاملات مطابقة للمرشحات.",
  "feat_org_balance_transactions_description": "كل تغيير في رصيد هذه المؤسسة، الأحدث أولاً.",
  "feat_org_balance_transactions_title": "معاملات الرصيد",
  "feat_org_balance_view_transactions": "عرض المعاملات",
  "feat_role_collapse_category": "طي {{label}}",
  "feat_role_expand_category": "توسيع {{label}}",
  "feat_role_name_placeholder": "مثال: محرر",
  "feat_role_no_permissions": "لا توجد صلاحيات متاحة",
  "feat_role_permission_aria": "صلاحية {{title}}",
  "feat_theme_changed_to": "تم تغيير المظهر إلى {{theme}}",
  "feat_untitled_template": "قالب بدون عنوان",
  "feat_vacation_delete_period_confirm": "هل أنت متأكد من حذف {{periodLabel}}؟ لا يمكن التراجع عن هذا الإجراء.",
  "feat_vacation_delete_template_aria": "حذف القالب",
  "feat_vacation_delete_template_confirm": "حذف قالب \"{{templateLabel}}\"؟ لا يمكن التراجع عن هذا الإجراء.",
  "feat_vacation_delete_template_title": "حذف قالب الإجازة",
  "feat_vacation_edit_template_aria": "تعديل القالب",
  "feat_vacation_message_label": "رسالة الإجازة",
  "feat_vacation_message_optional_placeholder": "رسالة الإجازة (اختياري)",
  "feat_vacation_message_write_placeholder": "اكتب رسالة الإجازة...",
  "feat_vacation_no_periods_hint": "أضف فترة لإيقاف الحجوزات مؤقتًا",
  "feat_vacation_no_templates": "لا توجد قوالب بعد",
  "feat_vacation_save_current_as_template": "+ حفظ الرسالة الحالية كقالب",
  "feat_vacation_save_template": "حفظ القالب",
  "feat_vacation_template_default_name": "قالب إجازة",
  "feat_vacation_template_dialog_desc": "احفظ اسمًا مختصرًا ورسالة يمكن إعادة استخدامها لاحقًا.",
  "feat_vacation_template_edit_title": "تعديل قالب الإجازة",
  "feat_vacation_template_label_short": "قالب",
  "feat_vacation_template_name_label": "اسم القالب",
  "feat_vacation_template_name_placeholder": "مثال: إجازة العيد",
  "feat_vacation_template_save_title": "حفظ قالب إجازة",
  "grid_add_button": "إضافة",
  "grid_choose_type": "اختر النوع",
  "grid_date_time_label": "التاريخ والوقت",
  "grid_end_date_time_label": "تاريخ ووقت الانتهاء",
  "grid_edit_event_title": "تعديل الموعد",
  "grid_event_type_aria": "نوع الموعد",
  "grid_events_export_title": "المواعيد",
  "grid_new_event_title": "موعد جديد",
  "grid_no_events_for_date": "لا توجد مواعيد لهذا التاريخ.",
  "grid_ready_to_save": "جاهز للحفظ",
  "grid_validation_error_count": "{{count}} من أخطاء التحقق",
  "grid_validation_event_type_required": "نوع الموعد مطلوب.",
  "grid_validation_phone_required": "رقم الهاتف مطلوب.",
  "grid_validation_checkout_after": "يجب أن تكون نهاية الحدث بعد بدايتها.",
  "grid_validation_checkout_not_allowed": "هذا النوع من الفعاليات ذو مدة ثابتة، لذا لا يمكن اختيار وقت انتهاء له. اختر وقت البداية فقط.",
  "grid_validation_checkout_too_early": "أقصر حجز من هذا النوع ينتهي {{minimum}}. اختر هذا الوقت أو وقتًا بعده.",
  "grid_validation_span_too_long": "يمكن حجز هذا النوع لمدة {{max}} ليلة كحد أقصى، وهذا الحجز {{nights}}.",
  "grid_span_hint": "ينتهي {{earliest}} كأقرب وقت، وحتى {{max}} ليلة.",
  "grid_span_hint_nights": "اختر وقت البداية، ثم وقت انتهاء لا يتجاوز {{max}} ليلة بعده.",
  "grid_validation_scheduled_time_required": "وقت الموعد مطلوب.",
  "landing_analytics_14day_trend": "اتجاه 14 يومًا",
  "landing_analytics_this_month": "هذا الشهر",
  "landing_analytics_vs_last_14days": "مقارنة بآخر 14 يومًا",
  "landing_cal_booking_count": "{{count}} حجز",
  "landing_cal_day_aria": "اليوم {{day}}",
  "landing_cal_no_bookings": "لا حجوزات",
  "landing_cal_open_day": "يوم متاح · اختر تاريخًا آخر على اليمين",
  "landing_cal_today_schedule": "جدول اليوم",
  "landing_chat_send": "إرسال",
  "landing_docs_annotate_page": "أضف ملاحظة على الصفحة",
  "landing_explore_screenshot_soon": "لقطة الشاشة قريبًا",
  "landing_flow_appointments": "المواعيد",
  "landing_flow_appointments_desc": "جدولة تلقائية",
  "landing_flow_conn_appt": "الذكاء الاصطناعي يحجز للعملاء",
  "landing_flow_conn_insights": "كل شيء يُتتبّع",
  "landing_flow_conn_kb": "الذكاء الاصطناعي يجيب من مستنداتك",
  "landing_flow_insights": "الإحصاءات",
  "landing_flow_insights_desc": "لوحة تحكم مباشرة",
  "landing_flow_kb": "قاعدة المعرفة",
  "landing_flow_kb_desc": "مستندات عملك",
  "landing_flow_messages": "الرسائل",
  "landing_flow_messages_desc": "محادثات العملاء",
  "landing_hero_trust_conversations": "محادثة عميل تمت معالجتها",
  "landing_hero_trust_conversion": "تُحلّ دون تدخّل بشري",
  "landing_hero_trust_always_on": "تغطية متواصلة بلا انقطاع",
  "landing_hero_trust_reply_speed": "يبدأ الرد خلال",
  "landing_kb_ingest_docs": "استيعاب المستندات المصدر",
  "landing_pricing_toggle_aria": "تبديل الفوترة السنوية",
  "landing_testimonials_aria": "آراء العملاء",
  "landing_uc_problem": "المشكلة",
  "landing_uc_solution": "الحل",
  "uc_support_eyebrow": "خدمة العملاء",
  "uc_support_hero_prefix": "احسم",
  "uc_support_hero_em": "‏69% من أسئلة الدعم",
  "uc_support_hero_suffix": "قبل أن يراها موظّف أصلًا.",
  "uc_support_hero_sub": "يجيب بافار من مركز المساعدة لديك، ويبحث عن المعلومة، ويُغلق الطلب داخل المحادثة. لا يتولّى فريقك إلا ما يحتاج فعلًا إلى شخص — على موقعك أو واتساب أو أي قناة يكتب فيها عملاؤك.",
  "uc_support_hero_cta": "ابدأ التجربة المجانية",
  "uc_support_hero_cta2": "شاهد عرضًا للدعم",
  "uc_support_demo_name": "الدعم",
  "uc_support_demo_sub": "واتساب · متصل",
  "uc_support_demo_m1": "مرحبًا — طلبي رقم 4821 ما زال قيد المعالجة.",
  "uc_support_demo_m2": "شُحن هذا الصباح وهو قيد التوصيل اليوم. أرسل لك رابط التتبّع؟",
  "uc_support_demo_m3": "نعم من فضلك",
  "uc_support_demo_m4": "أرسلته — وهو في بريدك أيضًا.",
  "uc_support_demo_time": "9:12 م",
  "uc_support_demo_card_title": "حُلَّ في محادثة واحدة",
  "uc_support_demo_card_l1": "الطلب 4821 · قيد التوصيل",
  "uc_support_demo_card_l2": "دون تدخّل موظّف",
  "uc_support_problems_title": "هل يبدو هذا مألوفًا؟",
  "uc_support_problems_sub": "معظم طلبات الدعم ليست صعبة — بل مكرّرة، وتصل في أوقات لا يراقب فيها أحد صندوق الوارد.",
  "uc_support_problem1_title": "الأسئلة العشرة نفسها، طوال اليوم",
  "uc_support_problem1_body": "أين طلبي، كيف يتم الاسترجاع، كيف أعيد ضبط كلمة المرور. إجابات سهلة تُسأل مئة مرة يوميًا، وتلتهم الساعات التي يجب أن يقضيها فريقك على الطلبات الصعبة.",
  "uc_support_problem2_title": "العملاء يكتبون بعد انتهاء دوامك",
  "uc_support_problem2_body": "المساء، وعطلة نهاية الأسبوع، ومناطق زمنية أخرى. سؤال يبقى بلا إجابة حتى الصباح يعني عميلًا فتح محادثة مع منافسك بالفعل.",
  "uc_support_problem3_title": "التحويلات تصل بلا سياق",
  "uc_support_problem3_body": "حين يحوّل الروبوت المحادثة، يبدأ موظّفك من الصفر — يعيد قراءة المحادثة، ويسأل عن رقم الطلب من جديد، ويعتذر عن الأمرين.",
  "uc_support_solutions_title": "كيف يتولّى بافار الدعم لديك",
  "uc_support_solutions_sub": "وكيل واحد مُدرَّب على محتواك — يجيب، ويحلّ، ويعرف تمامًا متى يتنحّى جانبًا.",
  "uc_support_sol1_kicker": "إجابات موثّقة",
  "uc_support_sol1_title": "إجابات من مستنداتك الحقيقية — دون اختلاق",
  "uc_support_sol1_body": "ارفع مركز المساعدة والسياسات والأسعار مرة واحدة. يقارن الوكيل بين كل الملفات ليصوغ إجابة دقيقة واحدة، ويذكر مصدرها — فلا يخترع سياسة ولا سعرًا.",
  "uc_support_sol1_b1": "يستشهد بمستنداتك المرفوعة في كل إجابة",
  "uc_support_sol1_b2": "يقول «سأتحقّق مع الفريق» بدل التخمين",
  "uc_support_sol1_demo_title": "قاعدة معرفة الدعم",
  "uc_support_sol1_demo_cited": "«يُقبل الاسترجاع خلال 30 يومًا من التسليم دون الحاجة إلى سبب.» — من سياسة الاسترجاع.pdf",
  "uc_support_sol1_file1": "سياسة الاسترجاع",
  "uc_support_sol1_file2": "تصدير مركز المساعدة",
  "uc_support_sol1_file3": "أسئلة الشحن والتوصيل",
  "uc_support_sol2_kicker": "على مدار الساعة",
  "uc_support_sol2_title": "كل رسالة تُجاب خلال ثوانٍ، في أي ساعة",
  "uc_support_sol2_body": "يردّ الوكيل في أقل من أربع ثوانٍ على كل قناة تربطها — دردشة الموقع وواتساب وتيليجرام وماسنجر — بالعربية أو الإنجليزية، بحسب لغة العميل.",
  "uc_support_sol2_b1": "وكيل واحد، وقاعدة معرفة واحدة، وكل القنوات",
  "uc_support_sol2_b2": "يبدّل اللغة أثناء المحادثة إذا بدّلها العميل",
  "uc_support_sol2_demo_sub": "واتساب · 3:42 ص",
  "uc_support_sol2_demo_m1": "هل اشتراكي ما زال فعّالًا؟",
  "uc_support_sol2_demo_m2": "نعم — فعّال حتى 16 فبراير ويتجدّد شهريًا. أحوّلك إلى الاشتراك السنوي وتوفّر 20%؟",
  "uc_support_sol2_demo_m3": "لا شكرًا، أطمئنّ فقط",
  "uc_support_sol2_demo_m4": "لا مشكلة — أنا هنا لأي استفسار آخر.",
  "uc_support_sol2_demo_card_title": "أُجيب في 3:42 صباحًا",
  "uc_support_sol2_demo_card_l1": "أول ردّ خلال 2.1 ثانية",
  "uc_support_sol2_demo_card_l2": "لا موظّفين متصلين",
  "uc_support_sol3_kicker": "تحويل نظيف",
  "uc_support_sol3_title": "يحوّل إلى موظّف ومعه المحادثة كاملة",
  "uc_support_sol3_body": "حين يتجاوز الطلب نطاق الوكيل، يسلّم المحادثة إلى فريقك في صندوق الوارد المشترك — النص الكامل، وبيانات العميل، وما جرّبه بالفعل. يكمل موظّفك من منتصف الجملة لا من الصفر.",
  "uc_support_sol3_b1": "نصّ كامل وسياق مع كل تحويل",
  "uc_support_sol3_b2": "تدخّل في أي محادثة في أي لحظة",
  "uc_support_sol3_demo_title": "صندوق الوارد المشترك · اليوم",
  "uc_support_sol3_row1_title": "الطلب 4821 · حالة التوصيل",
  "uc_support_sol3_row1_sub": "حلَّه الوكيل",
  "uc_support_sol3_row2_title": "منتج تالف · يطلب استبدالًا",
  "uc_support_sol3_row2_sub": "حُوِّل إلى نور · مع السياق كاملًا",
  "uc_support_sol3_row3_title": "إعادة ضبط كلمة المرور",
  "uc_support_sol3_row3_sub": "حلَّه الوكيل",
  "uc_support_sol3_row4_title": "استفسار عن طلب بالجملة",
  "uc_support_sol3_row4_sub": "وُجِّه إلى المبيعات",
  "uc_support_outcome_title": "ما تحصل عليه فرق الدعم مع بافار",
  "uc_support_outcome_sub": "طلبات مكرّرة أقل، وردود أولى أسرع، وفريق لا يمسّ إلا العمل الذي يستحق وقته.",
  "uc_support_outcome1_label": "لأول ردّ — ليلًا ونهارًا وفي العطلات",
  "uc_support_outcome2_label": "تغطية — مساءً وعطلات نهاية الأسبوع والأعياد",
  "uc_support_outcome3_label": "تتبدّلان أثناء المحادثة، دون تحويل",
  "uc_support_cta_title": "جاهز لتتوقّف عن الإجابة على السؤال نفسه مرّتين؟",
  "uc_support_cta_sub": "أطلق وكيل دعم مُدرَّبًا على محتواك في أقل من ساعة — دون مبرمجين ودون مكالمات إعداد.",
  "uc_support_cta_button": "ابدأ التجربة المجانية",
  "uc_sales_eyebrow": "المبيعات وجذب العملاء",
  "uc_sales_hero_prefix": "ردّ على كل عميل محتمل في",
  "uc_sales_hero_em": "أقل من 4 ثوانٍ",
  "uc_sales_hero_suffix": "واحجز الاجتماع وما زال مهتمًّا.",
  "uc_sales_hero_sub": "يجيب بافار عن أسئلة المنتج والأسعار خلال ثوانٍ، ويؤهّل العميل داخل المحادثة، ويضع الاجتماع مباشرة على تقويم مندوبيك — نهارًا وليلًا وفي العطلات.",
  "uc_sales_hero_cta": "ابدأ التجربة المجانية",
  "uc_sales_hero_cta2": "شاهد عرضًا للمبيعات",
  "uc_sales_demo_name": "المبيعات",
  "uc_sales_demo_sub": "دردشة الموقع · متصل",
  "uc_sales_demo_m1": "كم التكلفة لفريق من 40 شخصًا؟",
  "uc_sales_demo_m2": "على الباقة المميّزة: 39$ لكل مستخدم شهريًا عند الدفع السنوي — أي 1,560$ شهريًا. أحجز لك 15 دقيقة مع أحد المختصّين؟",
  "uc_sales_demo_m3": "بالتأكيد، بعد ظهر الخميس مناسب",
  "uc_sales_demo_m4": "حُجز — الدعوة في طريقها إليك.",
  "uc_sales_demo_time": "10:41 م",
  "uc_sales_demo_card_title": "عرض توضيحي محجوز",
  "uc_sales_demo_card_l1": "الخميس 16 يناير · 3:00 م",
  "uc_sales_demo_card_l2": "40 مستخدمًا · الباقة المميّزة",
  "uc_sales_problems_title": "هل يبدو هذا مألوفًا؟",
  "uc_sales_problems_sub": "الفرص موجودة — لكنها تتسرّب بين السؤال الأول والاجتماع الأول.",
  "uc_sales_problem1_title": "العملاء يفترون في انتظار الردّ",
  "uc_sales_problem1_body": "يسأل أحدهم عن الأسعار في التاسعة مساءً. وحين يردّ المندوب غدًا، يكون قد حجز مكالمة مع أوّل من ردّ عليه.",
  "uc_sales_problem2_title": "المندوبون يقضون يومهم في محادثات غير مؤهَّلة",
  "uc_sales_problem2_body": "نصف الاستفسارات لم تكن لتشتري أصلًا. وفرزها يدويًا أغلى طريقة لاكتشاف ذلك.",
  "uc_sales_problem3_title": "المتابعات تتوقّف بهدوء",
  "uc_sales_problem3_body": "الصفقة التي سكتت بعد العرض التوضيحي هي أسهل إيراد تتركه على الطاولة — كل شهر.",
  "uc_sales_solutions_title": "كيف يدير بافار خطّ مبيعاتك",
  "uc_sales_solutions_sub": "وكيل واحد يجيب، ويؤهّل، ويحجز، ويتابع — قبل أن يفتح المندوب حاسوبه.",
  "uc_sales_sol1_kicker": "لا تفقد عميلًا محتملًا",
  "uc_sales_sol1_title": "ردّ خلال ثوانٍ، والتقط بيانات العميل فورًا",
  "uc_sales_sol1_body": "لحظة أن يراسلك أحدهم — عبر أداة الموقع أو واتساب أو إنستغرام — يجيب الوكيل بتفاصيل المنتج والأسعار الحقيقية ويحفظ بياناته في نظام إدارة العملاء، قبل أن يفتر أو يراسل منافسًا.",
  "uc_sales_sol1_b1": "يردّ على مدار الساعة عبر كل قناة مربوطة",
  "uc_sales_sol1_b2": "يحفظ بيانات العميل لحظة مراسلته",
  "uc_sales_sol1_demo_sub": "إنستغرام · عميل محتمل جديد",
  "uc_sales_sol1_demo_m1": "هل تتكاملون مع نظام إدارة العملاء لدينا؟",
  "uc_sales_sol1_demo_m2": "نعم — مزامنة ثنائية الاتجاه، وواجهة REST API في الباقة المميّزة. ما النظام الذي تستخدمونه حاليًا؟",
  "uc_sales_sol1_demo_m3": "هَب‌سبوت، نحو 40 مستخدمًا",
  "uc_sales_sol1_demo_m4": "مناسب تمامًا — حفظت بياناتك حتى لا يضيع شيء.",
  "uc_sales_sol1_demo_card_title": "تم التقاط العميل",
  "uc_sales_sol1_demo_card_l1": "40 مستخدمًا · هَب‌سبوت",
  "uc_sales_sol1_demo_card_l2": "مؤهَّل · عبر إنستغرام",
  "uc_sales_sol2_kicker": "التأهيل داخل المحادثة",
  "uc_sales_sol2_title": "لا يصل المندوب إلا الجادّون",
  "uc_sales_sol2_body": "يطرح الوكيل الأسئلة التي كنت ستطرحها — حجم الفريق، والميزانية، والتوقيت، والأنظمة الحالية — ثم يقيّم العميل وفق قواعدك ويوجّهه. المناسبون يحصلون على اجتماع، والباقي على إجابة مفيدة وسلسلة متابعة.",
  "uc_sales_sol2_b1": "أسئلة التأهيل الخاصة بك، تُطرح في كل مرة",
  "uc_sales_sol2_b2": "يوجّه حسب الملاءمة — اجتماع، أو متابعة، أو اشتراك ذاتي",
  "uc_sales_sol2_demo_title": "خطّ المبيعات · اليوم",
  "uc_sales_sol2_row1_title": "شركة أكمي · 40 مستخدمًا",
  "uc_sales_sol2_row1_sub": "مؤهَّل ← عرض محجوز الخميس 3 م",
  "uc_sales_sol2_row2_title": "مستقلّ فردي",
  "uc_sales_sol2_row2_sub": "وُجِّه إلى التسجيل الذاتي",
  "uc_sales_sol2_row3_title": "نورث‌ويند · 200 مستخدم",
  "uc_sales_sol2_row3_sub": "حُوِّل إلى مندوب المؤسسات",
  "uc_sales_sol2_row4_title": "ستوديو تِن · قيد التقييم",
  "uc_sales_sol2_row4_sub": "بدأت سلسلة المتابعة",
  "uc_sales_sol3_kicker": "متابعات تحدث فعلًا",
  "uc_sales_sol3_title": "يلاحق كل صفقة تسكت",
  "uc_sales_sol3_body": "يلاحظ بافار توقّف المحادثة فيتابع — بأسلوب ودود يشبه علامتك وبلغة العميل — حتى يردّ أو ينسحب. فلا يمضي بهدوء إيرادٌ كسبتَ انتباهه بالفعل.",
  "uc_sales_sol3_b1": "متابعة تلقائية للمحادثات المتوقّفة",
  "uc_sales_sol3_b2": "يعيد حجز من تخلّف عن الحضور دون جهد من المندوب",
  "uc_sales_sol3_demo_sub": "واتساب · متابعة",
  "uc_sales_sol3_demo_m1": "مرحبًا نور — سألتِ الأسبوع الماضي عن باقة الأربعين مستخدمًا. أما زلتِ ترغبين في الجولة التوضيحية؟",
  "uc_sales_sol3_demo_m2": "نعم! آسفة، انشغلت. الجمعة؟",
  "uc_sales_sol3_demo_m3": "الجمعة 11:00 إذًا — أرسلت الدعوة.",
  "uc_sales_sol3_demo_card_title": "أُنعشت الصفقة",
  "uc_sales_sol3_demo_card_l1": "الجمعة 17 يناير · 11:00 ص",
  "uc_sales_sol3_demo_card_l2": "أُعيد تفعيلها بعد 7 أيام",
  "uc_sales_outcome_title": "ما تحصل عليه فرق المبيعات مع بافار",
  "uc_sales_outcome_sub": "عملاء أكثر تفاعلًا، وتقويم أكثر امتلاءً، ومتابعات تحدث سواء تذكّرها أحد أم لا.",
  "uc_sales_outcome1_label": "عميل محتمل يُترك في الانتظار حتى الصباح",
  "uc_sales_outcome2_label": "تأهيل وحجز عبر كل قناة",
  "uc_sales_outcome3_label": "كل القنوات، وكيل واحد، سجلّ واحد",
  "uc_sales_cta_title": "جاهز لتتوقّف عن خسارة العملاء بسبب ردّ متأخّر؟",
  "uc_sales_cta_sub": "أطلق وكيل مبيعات مُدرَّبًا على محتواك في أقل من ساعة — دون مبرمجين ودون مكالمات إعداد.",
  "uc_sales_cta_button": "ابدأ التجربة المجانية",
  "uc_status_open": "متاح",
  "uc_status_booked": "محجوز",
  "uc_status_full": "مكتمل",
  "uc_status_waitlist": "قائمة انتظار",
  "lib_org_slug_available": "المعرّف متاح",
  "lib_org_slug_check_failed": "تعذّر التحقق من التوفر — يرجى المحاولة مرة أخرى",
  "lib_org_slug_check_failed_retry": "تعذّر التحقق من التوفر — حاول مرة أخرى",
  "lib_org_slug_checking": "جارٍ التحقق من التوفر…",
  "lib_org_slug_hint": "أحرف إنجليزية صغيرة وأرقام وشرطات فقط. من 1 إلى 50 حرفًا.",
  "lib_org_slug_invalid": "معرّف غير صالح",
  "lib_org_slug_required": "المعرّف مطلوب",
  "lib_org_slug_taken": "هذا المعرّف مستخدم بالفعل",
  "lib_phone_combobox_required": "مكوّن اختيار رقم الهاتف مطلوب",
  "lib_phone_grid_editor_aria": "الهاتف",
  "lib_phone_select_placeholder": "اختر رقم هاتف",
  "lib_plan_guard_current_plan": "خطة المؤسسة الحالية",
  "lib_plan_guard_message": "خطة مؤسستك لا تشمل الوصول إلى هذه الصفحة.",
  "lib_plan_guard_required_plan": "الخطة المطلوبة",
  "notif_reply_send_failed": "فشل إرسال الرسالة",
  "page_accept_invitation_accept": "قبول",
  "page_accept_invitation_accept_failed": "تعذّر قبول الدعوة.",
  "page_accept_invitation_accepting": "جارٍ القبول…",
  "page_accept_invitation_administrator_fallback": "أحد المسؤولين",
  "page_accept_invitation_as": "بصفة",
  "page_accept_invitation_fetch_failed": "تعذّر تحميل تفاصيل الدعوة.",
  "page_accept_invitation_go_to_sign_in": "الذهاب إلى تسجيل الدخول",
  "page_accept_invitation_has_invited": "قام بدعوة",
  "page_accept_invitation_load_failed": "تعذّر تحميل هذه الدعوة. ربما تكون قد انتهت صلاحيتها أو أُلغيت.",
  "page_accept_invitation_mismatch_middle": "، وهو لا يطابق البريد الإلكتروني للدعوة (",
  "page_accept_invitation_mismatch_prefix": "تنبيه: أنت مسجّل الدخول باسم",
  "page_accept_invitation_mismatch_suffix": "). يرجى تسجيل الخروج ثم الدخول بالعنوان المدعو لقبول الدعوة.",
  "page_accept_invitation_org_fallback": "مؤسسة",
  "page_accept_invitation_payload_unexpected": "بيانات الدعوة غير متوقعة. يرجى المحاولة مرة أخرى.",
  "page_accept_invitation_reject": "رفض",
  "page_accept_invitation_reject_failed": "تعذّر رفض الدعوة.",
  "page_accept_invitation_rejecting": "جارٍ الرفض…",
  "page_accept_invitation_status_prefix": "حالة هذه الدعوة هي",
  "page_accept_invitation_status_suffix": ". ربما تكون قد قُبلت أو أُلغيت بالفعل.",
  "page_accept_invitation_title": "دعوة إلى مؤسسة",
  "page_accept_invitation_to_join": "للانضمام إلى",
  "page_accept_invitation_your_account_fallback": "حسابك",
  "page_admin_description": "إدارة المؤسسات والأعضاء وصحة النظام",
  "page_admin_eyebrow": "المشرف العام",
  "page_admin_tab_feedback": "ملاحظات التطبيق",
  "page_admin_tab_plans": "الخطط",
  "page_admin_tab_system": "صحة النظام",
  "page_admin_tab_waiting": "المستخدمون المنتظرون",
  "page_admin_title": "لوحة تحكم المشرف",
  "page_admin_validation_description": "يرجى تعبئة جميع حقول المؤسسة المطلوبة قبل الحفظ.",
  "page_admin_validation_title": "مشاكل في التحقق",
  "page_legal_dpa_description": "شروط بين المتحكم والمعالج لعملاء الأعمال.",
  "page_legal_dpa_title": "ملحق معالجة البيانات",
  "page_legal_index_description": "الشروط والسياسات التي تحكم Bavard.",
  "page_legal_nav_title": "الشؤون القانونية",
  "page_legal_not_found_description": "لا يوجد مستند قانوني بهذا العنوان.",
  "page_legal_not_found_title": "المستند غير موجود",
  "page_legal_privacy_description": "كيفية تعاملنا مع البيانات الشخصية، للحسابات والمستخدمين النهائيين.",
  "page_legal_privacy_title": "سياسة الخصوصية",
  "page_legal_subprocessors_description": "الأطراف الثالثة التي قد تعالج البيانات لتشغيل الخدمة.",
  "page_legal_subprocessors_title": "قائمة معالجي البيانات الفرعيين",
  "page_legal_terms_description": "الاتفاقية التي تحكم استخدامك لـ Bavard.",
  "page_legal_terms_title": "شروط الخدمة",
  "page_no_active_organization": "لا توجد مؤسسة نشطة.",
  "page_onboarding_checkout_continue": "المتابعة إلى الدفع",
  "page_onboarding_checkout_description_fallback": "تم إعداد مؤسستك، لكن لم تكتمل عملية الدفع بعد. تابع إلى Stripe لتفعيل اشتراكك.",
  "page_onboarding_checkout_description_suffix": "تم إعدادها، لكن لم تكتمل عملية الدفع بعد. تابع إلى Stripe لتفعيل اشتراكك.",
  "page_onboarding_checkout_error_fallback": "تعذّر بدء عملية الدفع",
  "page_onboarding_checkout_redirecting": "جارٍ التحويل…",
  "page_onboarding_checkout_title": "أكمل اشتراكك",
  "page_onboarding_success_payment_successful": "تم الدفع بنجاح",
  "page_onboarding_success_redirecting": "جارٍ تحويلك إلى التقويم…",
  "page_onboarding_success_verify_failed": "تعذّر التحقق من الاشتراك",
  "page_onboarding_success_verifying_default": "نقوم بتفعيل اشتراكك. عادةً ما يستغرق هذا بضع ثوانٍ فقط.",
  "page_onboarding_success_verifying_slow": "هذا يستغرق بعض الوقت. نقوم بتأكيد دفعتك مع Stripe.",
  "page_onboarding_success_verifying_subscription": "جارٍ التحقق من اشتراكك",
  "page_pending_org_accept_invitation_failed": "تعذّر قبول الدعوة",
  "page_pending_org_activation_prefix": "تم إنشاء مؤسستك تحت",
  "page_pending_org_activation_suffix": "وهي بانتظار التفعيل من قبل أحد مسؤولي المنصة. سيتم تحويلك إلى التطبيق فور تفعيلها — يرجى إبقاء هذه التبويبة مفتوحة.",
  "page_pending_org_charged_plan_suffix": "بفوترة",
  "page_pending_org_charged_prefix": "سيتم محاسبتك على خطة",
  "page_pending_org_charged_suffix": "— تابع إلى Stripe لإتمام الدفع.",
  "page_pending_org_check_again": "تحقّق مرة أخرى",
  "page_pending_org_create_and_continue": "إنشاء ومتابعة إلى الدفع",
  "page_pending_org_create_failed": "تعذّر إنشاء المؤسسة",
  "page_pending_org_create_no_id": "لم يُرجع إنشاء المؤسسة معرّفًا",
  "page_pending_org_create_org_title": "أنشئ مؤسستك",
  "page_pending_org_create_own": "إنشاء مؤسستي الخاصة",
  "page_pending_org_creating": "جارٍ الإنشاء…",
  "page_pending_org_display_name_label": "الاسم المعروض",
  "page_pending_org_display_name_placeholder": "يُستخدم المعرّف افتراضيًا",
  "page_pending_org_go_back": "رجوع",
  "page_pending_org_handle_hint": "اختر معرّفًا فريدًا. أحرف صغيرة وأرقام وشرطات فقط — مثل اسم قناة Discord.",
  "page_pending_org_handle_label": "المعرّف",
  "page_pending_org_invitation_org_fallback": "مؤسسة",
  "page_pending_org_invitations_title": "لديك دعوات معلّقة",
  "page_pending_org_invited_suffix": " تمت دعوته للانضمام إلى مؤسسة.",
  "page_pending_org_optional_suffix": "(اختياري)",
  "page_pending_org_pending_activation_title": "بانتظار التفعيل",
  "page_pending_org_role_prefix": "الدور:",
  "page_pending_org_setup_title": "أنشئ مؤسستك",
  "page_pending_org_signed_in_suffix": " مسجّل الدخول. أنشئ مؤسسة للمتابعة، أو انتظر حتى يقوم أحد المسؤولين بتعيينك إلى واحدة.",
  "page_pending_org_signing_out": "جارٍ تسجيل الخروج…",
  "page_pending_org_wait_for_assignment": "الانتظار للتعيين",
  "page_pending_org_waiting_prefix": "لقد وضعنا علامة على",
  "page_pending_org_waiting_suffix": "ليقوم أحد المسؤولين بتعيينك إلى مؤسسة. سيتم تحويلك إلى التطبيق فور إتمام التعيين.",
  "page_pending_org_waiting_title": "بانتظار التعيين",
  "page_team_title": "الفريق",
  "pg_actions_col_title": "الإجراءات",
  "pg_add_bench": "إضافة مقعد",
  "pg_add_chat_bench_aria": "إضافة مقعد محادثة",
  "pg_add_chat_panel_aria": "إضافة لوحة محادثة",
  "pg_add_short": "إضافة",
  "pg_add_to_panel_scope_aria": "إضافة إلى نطاق هذه اللوحة",
  "pg_ai_model_label": "نموذج الذكاء الاصطناعي",
  "pg_approve_all": "الموافقة على الكل ({{count}})",
  "pg_benches": "المقاعد",
  "pg_broad": "واسع",
  "pg_broadcast_hint": "في أي حقل كتابة: Ctrl+Shift+Enter يرسل الرسالة إلى جميع المقاعد دفعة واحدة — طلب واحد لعدة مسارات.",
  "pg_calendar_event_count": "{{count}} أحداث",
  "pg_calendar_viewing_date": "عرض {{date}}",
  "pg_chat_description_no_rag": "نموذج خالص — بدون استرجاع.",
  "pg_chat_description_rag": "استرجاع من المستندات المحددة.",
  "pg_clear_all_documents_description": "سيؤدي هذا إلى حذف {{count}} مستندات من البيئة التجريبية للمؤسسة الحالية نهائيًا. لن يتأثر أي من المستندات الفعلية.",
  "pg_clear_all_documents_title": "مسح كل مستندات البيئة التجريبية؟",
  "pg_collapse_calendar_aria": "طي التقويم",
  "pg_collapse_preview_aria": "طي المعاينة",
  "pg_collapse_sandbox_sidebar_aria": "طي الشريط الجانبي للبيئة التجريبية",
  "pg_collapse_sandbox_title": "طي البيئة التجريبية (التقويم والسجل)",
  "pg_collapse_tool_history_aria": "طي سجل الأدوات",
  "pg_composer_placeholder": "أرسل رسالة…",
  "pg_configure_panel": "إعداد {{name}}",
  "pg_configuring_panel": "جارٍ إعداد {{name}}",
  "pg_context_limit_help": "عدد الأدوار السابقة التي تُرسل. فارغ = بلا حدود.",
  "pg_context_message_limit_label": "حد رسائل السياق",
  "pg_delete_all": "حذف الكل",
  "pg_delete_document_aria": "حذف {{filename}}",
  "pg_delete_document_confirm_description": "سيؤدي هذا إلى حذف \"{{filename}}\" نهائيًا من مستودع البيئة التجريبية.",
  "pg_delete_document_confirm_title": "حذف {{filename}}؟",
  "pg_deny_all": "رفض الكل",
  "pg_documents_title": "مستندات البيئة التجريبية",
  "pg_documents_view_description": "مستودع معزول — الملفات المُسقطة تنضم تلقائيًا لنطاق {{name}}؛ مفتاح الصف يبدّل الإدراج لكل لوحة.",
  "pg_samples_title": "جرّب مستندًا نموذجيًا",
  "pg_samples_description": "يحتوي كل ملف على تنسيق يُربك محللات المستندات. أضف ملفًا ثم اسأل المساعد عنه.",
  "pg_samples_adding": "جارٍ الإضافة…",
  "pg_samples_fetch_failed": "تعذّر تحميل هذا النموذج. حاول مرة أخرى.",
  "pg_sample_hint_xlsx": "صفوف عنوان فوق الترويسة، وخلايا مدمجة، وجدولان في ورقة واحدة، وصيغ، وصف إجمالي، وورقة عربية من اليمين إلى اليسار، وورقة فارغة.",
  "pg_sample_hint_csv": "تصدير بأسلوب Excel: علامة ترتيب البايت، وفواصل وأسطر داخل علامات اقتباس، وفواصل آلاف، وأسماء عربية.",
  "pg_sample_hint_docx": "عناوين وقوائم متداخلة، وجدول بخلايا مدمجة، وصورة رسم بياني، وقسم عربي من اليمين إلى اليسار، وترويسة وتذييل، وصفحة أفقية.",
  "pg_sample_hint_pdf": "صفحات بعمودين، وترويسة وتذييل متكرران، وجداول، وصورة رسم بياني، وصفحة ممسوحة ضوئيًا تحتاج إلى التعرّف الضوئي.",
  "pg_sample_hint_md": "بيانات أمامية، وجدول، وقوائم متداخلة، وكتلة شيفرة أسطرها التي تبدأ بـ '#' ليست عناوين، وقسم طويل بلا عناوين فرعية.",
  "pg_sample_hint_txt": "نهايات أسطر Windows، وفقرة من جملة واحدة بطول 150 كلمة، وأزواج سؤال وجواب، وجدول مُحاذى بعلامات الجدولة، ونص عربي.",
  "pg_sample_hint_png": "قائمة طعام ثنائية اللغة بنقاط بين الأصناف والأسعار — تُقرأ بالتعرّف الضوئي.",
  "pg_sample_hint_jpg": "صورة مائلة ومظللة لإيصال — تُقرأ بالتعرّف الضوئي.",
  "pg_embed_stat_title": "عدد الرموز × التسعير لفهرسة هذا المستند",
  "pg_embedding_model_description": "يُستخدم لتضمين المستندات المرفوعة هنا. يُبحث في كل مستند بالنموذج الذي ضُمِّن به، لذا يؤثر تغيير النموذج على التحميلات الجديدة فقط.",
  "pg_empty_hint_no_model": "اختر نموذج ذكاء اصطناعي من اليسار أولاً.",
  "pg_empty_hint_ready": "أرسل رسالة لبدء المحادثة.",
  "pg_enable_rag_aria": "تفعيل قاعدة المعرفة والبحث في المستندات",
  "pg_knowledge_base_title": "قاعدة المعرفة",
  "pg_knowledge_base_description": "فعّل الوصول إلى المستندات وجميع أدوات البحث فيها معًا. تنطبق المستندات وإعدادات البحث على هذه اللوحة.",
  "pg_expand_calendar_aria": "توسيع التقويم",
  "pg_expand_preview_aria": "توسيع المعاينة",
  "pg_expand_tool_history_aria": "توسيع سجل الأدوات",
  "pg_export_bench_aria": "تصدير لقطة المقعد (JSON)",
  "pg_export_bench_title": "تصدير عمليات التشغيل والتشخيصات كملف JSON",
  "pg_file_size_title": "حجم الملف",
  "pg_focused": "مركّز",
  "pg_following_config": "يتبع الإعدادات",
  "pg_generic_chunk_label": "مقطع #{{index}}",
  "pg_header_meta": "منصة اختبار RAG · {{count}} مسارات متوازية · لا شيء يمس إعدادات المؤسسة",
  "pg_input_col_title": "المدخل",
  "pg_latency_col_title": "زمن الاستجابة",
  "pg_latest": "الأحدث",
  "pg_load_saved_prompt_placeholder": "تحميل موجه محفوظ…",
  "pg_load_saved_prompt_version_aria": "تحميل نسخة موجه محفوظة",
  "pg_loading_preview": "جارٍ تحميل المعاينة…",
  "pg_max_results_label": "الحد الأقصى للنتائج",
  "pg_model_section_title": "النموذج",
  "pg_model_selector_description": "يُستخدم في كل دورة محادثة.",
  "pg_n_more": "+{{count}} أخرى",
  "pg_no_chunks_available": "لا توجد مقاطع متاحة لـ {{filename}}.",
  "pg_no_events_in_range": "لا توجد أحداث في هذا النطاق",
  "pg_no_model": "لا يوجد نموذج",
  "pg_no_passes_yet": "لا توجد عمليات استرجاع بعد",
  "pg_no_sandbox_events": "لا توجد أحداث في البيئة التجريبية بعد. ستملأ أدوات تقويم الوكيل هذا العرض.",
  "pg_no_tool_calls_yet": "لا توجد استدعاءات أدوات بعد. ستظهر هنا الاستدعاءات التي يجريها الوكيل.",
  "pg_open_sandbox_sidebar_aria": "فتح الشريط الجانبي للبيئة التجريبية",
  "pg_open_sandbox_title": "فتح البيئة التجريبية (التقويم والسجل)",
  "pg_output_error_col_title": "المخرج / الخطأ",
  "pg_page_chunk_label": "صفحة {{page}}",
  "pg_panel_status_aria": "الحالة: {{status}}",
  "pg_panel_status_error": "خطأ",
  "pg_panel_status_idle": "خامل",
  "pg_panel_status_ready": "جاهز",
  "pg_panel_status_running": "قيد التشغيل",
  "pg_passes_chunks_summary": "{{count}} تمريرات · {{chunks}} مقاطع",
  "pg_pending_approvals_notice": "{{count}} استدعاءات أدوات بانتظار قرارك. حلّها في جدول السجل — الرسالة التالية التي ترسلها تنقل قراراتك إلى الوكيل.",
  "pg_prompt_kind_assistant": "المساعد",
  "pg_prompt_kind_system_agent": "وكيل النظام",
  "pg_query_embedding_tokens_title": "رموز تضمين الاستعلام",
  "pg_rag_section_description": "استند في الإجابات إلى مستنداتك.",
  "pg_remove_from_panel_scope_aria": "إزالة من نطاق هذه اللوحة",
  "pg_remove_panel_aria": "إزالة اللوحة",
  "pg_rerank_auto": "تلقائي",
  "pg_reset_playground": "إعادة تعيين البيئة التجريبية",
  "pg_reset_to_config": "إعادة التعيين للإعدادات",
  "pg_retrieval": "الاسترجاع",
  "pg_retrieval_empty_hint": "تظهر المقاطع المسترجعة هنا بعد كل عملية RAG — درجة التشابه لكل مقطع، لكل دور محادثة.",
  "pg_agent_mode_caption": "تجاوز لكل تشغيل في هذه المنصة. لا يغيّر وضع الإجابة الخاص بالمؤسسة.",
  "pg_agent_mode_unknown": "جارٍ تحميل وضع الإجابة الخاص بالمؤسسة…",
  "pg_agent_mode_no_stream_title": "تبدأ الإجابة بعد انتهاء البحث",
  "pg_agent_mode_no_stream_body": "يجمع الباحث الأدلة أولاً، لذا يبدأ الرد متأخراً. في الوضع 4 يظهر الرد كلمة بكلمة؛ وفي الوضع 5 يظهر كذلك فقط حين لا يمكن لتحقق لاحق أن يستبدله، وإلا فيظهر كاملاً بعد التحقق.",
  "pg_agent_mode_ignored_title": "إعدادات لا يستخدمها هذا الوضع",
  "pg_agent_mode_ignored_expected": "متوقعة وفق عقد الخادم — شغّل مرة واحدة لترى ما تجاهلته هذه المنصة فعلياً.",
  "pg_agent_mode_ignored_observed": "أبلغ عنها الخادم لآخر تشغيل في هذا الوضع.",
  "pg_agent_mode_inactive_tools_title": "أدوات غير متاحة في هذا الوضع",
  "pg_citation_chip_aria": "الاستشهاد {{marker}}",
  "pg_citation_location_file_only": "المستند كاملاً — دون موضع صفحة",
  "pg_citation_marker_caption": "المصدر [{{marker}}]",
  "pg_citation_reason_no_document": "لم يعد المستند المستشهد به موجوداً في المجموعة.",
  "pg_citation_reason_no_layout": "فُهرس هذا المستند دون تخطيط الصفحات، لذا يتعذر تمييز المقطع.",
  "pg_citation_reason_no_page_model": "لا يحتوي هذا النوع من الملفات على صفحات يمكن الإشارة إليها.",
  "pg_citation_reason_quote_not_located": "تعذر العثور على النص المقتبس في الصفحة.",
  "pg_citation_reason_resolution_failed": "تعذر تحديد موضع المقطع.",
  "pg_citations_sandbox_label": "المصادر · بيئة الاختبار",
  "pg_citations_turn_local_note": "الاستشهادات خاصة بهذا الدور فقط ولا تُحفظ.",
  "pg_ingest_title": "جارٍ تجهيز المستند",
  "pg_ingest_aria": "تقدم معالجة المستند",
  "pg_ingest_outcome_completed": "جاهز للبحث",
  "pg_ingest_outcome_failed": "فشلت المعالجة",
  "pg_ingest_parse_mode_local": "محلل محلي",
  "pg_ingest_parse_mode_managed": "محلل مُدار",
  "pg_ingest_status_pending": "في قائمة الانتظار للمعالجة",
  "pg_ingest_status_processing": "قيد المعالجة",
  "pg_ingest_cost_actual_title": "التكلفة التي أبلغ عنها المزودون لهذه المعالجة",
  "pg_ingest_cost_estimated_title": "تقديرية بناءً على عدد الرموز والأسعار المعلنة",
  "pg_ingest_cost_unknown_title": "استدعاءات تعذر تسعير تكلفتها",
  "pg_ingest_cost_not_reported": "لم يبلغ أي مزود عن تكلفة فعلية",
  "pg_ingest_cost_show_breakdown": "عرض التفاصيل",
  "pg_ingest_cost_hide_breakdown": "إخفاء التفاصيل",
  "pg_ingest_cost_ephemeral_hint": "هذه التفاصيل موجودة في هذا التبويب فقط وتختفي بعد إعادة التحميل.",
  "pg_retrieval_agent_query_title": "الاستعلام الذي بحث به الوكيل",
  "pg_retrieval_agent_summary": "{{count}} عمليات بحث للوكيل · {{hits}} نتيجة",
  "pg_retrieval_feed_agent_search": "بحث الوكيل",
  "pg_retrieval_feed_agent_search_hint": "استدعى الوكيل أداة البحث بنفسه أثناء الدور.",
  "pg_retrieval_feed_prompt_context": "سياق الموجّه",
  "pg_retrieval_feed_prompt_context_hint": "استُرجعت قبل الدور ووُضعت في الموجّه.",
  "pg_retrieval_leg_keyword": "كلمات",
  "pg_retrieval_leg_keyword_title": "طابقها البحث بالكلمات المفتاحية (النص الكامل)",
  "pg_retrieval_leg_semantic": "دلالي",
  "pg_retrieval_leg_semantic_title": "طابقها البحث الدلالي (المتجهات)",
  "pg_retrieval_measure_cos": "جيب التمام",
  "pg_retrieval_measure_cos_title": "تشابه جيب التمام بين الاستعلام والمقطع",
  "pg_retrieval_measure_rerank": "إعادة الترتيب",
  "pg_retrieval_measure_rerank_title": "درجة الصلة من أداة إعادة الترتيب",
  "pg_retrieval_measure_rrf": "دمج الترتيب",
  "pg_retrieval_measure_rrf_title": "دمج الترتيب التبادلي لنتائج البحث الدلالي والكلمات المفتاحية",
  "pg_runs_all_benches": "يشغّل كل المقاعد",
  "pg_sandbox": "البيئة التجريبية",
  "pg_sandbox_sidebar_aria": "الشريط الجانبي للبيئة التجريبية",
  "pg_search_stat_title": "التكلفة التراكمية لعمليات تضمين الاستعلام التي أعادت مقطعًا من هذا المستند",
  "pg_select_ai_model": "اختر نموذج الذكاء الاصطناعي",
  "pg_select_embedding_model": "اختر نموذج التضمين…",
  "pg_settings_sheet_description": "إعداد لوحة المحادثة النشطة: مفتاح RAG، نموذج الذكاء الاصطناعي، الاسترجاع، وموجه النظام.",
  "pg_settings_title_panel": "الإعدادات — {{name}}",
  "pg_sidebar_summary_no_rag": "محادثة نموذج خالصة — بدون استرجاع.",
  "pg_sidebar_summary_rag": "أضف مستندات وتحدث مع الاسترجاع.",
  "pg_strategy_contextual_hint": "إضافة سياق المستند قبل كل مقطع",
  "pg_strategy_standard_hint": "تقسيم → تضمين كما هو",
  "pg_stricter": "أكثر صرامة",
  "pg_structure_preview": "معاينة البنية",
  "pg_system_prompt_description": "اختياري. يُوضع قبل كل دور محادثة.",
  "pg_table_chunk_label": "مقطع جدول #{{index}}",
  "pg_tool_col_title": "الأداة",
  "pg_tool_history_title": "سجل الأدوات",
  "pg_tool_status_approved": "موافَق عليه",
  "pg_tool_status_awaiting": "بانتظار الموافقة",
  "pg_tool_status_denied": "مرفوض",
  "pg_tool_status_failed": "فشل",
  "pg_tool_status_ok": "تم",
  "pg_tool_status_pending": "قيد الانتظار",
  "pg_tool_status_running": "قيد التشغيل",
  "pg_tools_section_description": "تجاوز خاص بالبيئة التجريبية — قيود صفحة الإعدادات (الخطة، تقييد النماذج) غير مُطبَّقة.",
  "pg_touched_stat_title": "عدد عمليات تشغيل الوكيل التي أظهر فيها الاسترجاع مقطعًا من هذا المستند",
  "pg_docling_badge": "المحلّل",
  "pg_docling_checked_at": "تم التحقق في {{time}}",
  "pg_docling_checking": "جارٍ التحقق…",
  "pg_docling_collapse_label": "إخفاء حالة محلّل المستندات",
  "pg_docling_error_title": "أعاد محلّل المستندات خطأً",
  "pg_docling_key_rejected_hint": "الخدمة تعمل لكنها رفضت المفتاح، لذا لن تفيد إعادة تشغيلها. تحقّق من DOCLING_SERVE_API_KEY على الخادم.",
  "pg_docling_key_rejected_title": "رفض محلّل المستندات مفتاح الواجهة البرمجية",
  "pg_docling_recheck": "إعادة التحقق",
  "pg_docling_start_hint": "شغّله باستخدام",
  "pg_docling_unreachable_local_title": "محلّل المستندات المحلي لا يعمل",
  "pg_docling_unreachable_managed_title": "محلّل المستندات المُدار لا يستجيب",
  "pg_docling_unreachable_title": "محلّل المستندات لا يستجيب",
  "pg_docling_upload_blocked": "سيفشل رفع ملفات PDF وWord حتى يعود. لا يزال بالإمكان رفع جداول البيانات والنصوص والصور.",
  "phone_input_placeholder": "أضف رقم هاتف",
  "reset_password_error_failed": "تعذرت إعادة تعيين كلمة المرور",
  "team_account_status_desc_active": "تعطيل هذا العضو مؤقتًا. تبقى بياناته محفوظة لكن لا يمكنه تسجيل الدخول حتى إعادة التفعيل.",
  "team_account_status_desc_inactive": "هذا العضو معطّل ولا يمكنه تسجيل الدخول. أعد التفعيل لاستعادة الوصول.",
  "team_action_deactivate": "تعطيل العضو",
  "team_action_reactivate": "إعادة تفعيل العضو",
  "team_action_remove_from_org": "إزالة من المؤسسة",
  "team_action_remove_member": "إزالة العضو",
  "team_action_removing": "جارٍ الإزالة…",
  "team_action_saving": "جارٍ الحفظ…",
  "team_action_send_notice": "إرسال إشعار",
  "team_action_send_warning": "إرسال تحذير",
  "team_action_sending": "جارٍ الإرسال…",
  "team_actor_ai": "وكيل ذكاء اصطناعي",
  "team_actor_external": "مستخدم خارجي",
  "team_actor_member": "عضو المؤسسة",
  "team_actor_system": "النظام",
  "team_actor_unknown": "غير معروف",
  "team_avatar_fallback_name": "عضو",
  "team_badge_banned": "محظور",
  "team_badge_verified": "موثّق",
  "team_chat_history": "سجل المحادثة",
  "team_col_when": "الوقت",
  "team_confirm_remove_desc": "سيفقد {{name}} الوصول إلى هذه المؤسسة. يبقى حسابه وبياناته محفوظين، ويمكنك دعوته مجددًا لاحقًا.",
  "team_confirm_remove_title": "إزالة العضو؟",
  "team_danger_owner_desc": "لا يمكن إزالة مالكي المؤسسة.",
  "team_danger_remove_desc": "أزل هذا العضو من المؤسسة. يبقى حسابه وبياناته محفوظين، لكنه يفقد الوصول إلى هذه المؤسسة.",
  "team_day_earlier": "سابقًا",
  "team_dialog_member_detail_desc": "الملف الشخصي والنشاط والجلسات والإدارة لـ {{name}}.",
  "team_dialog_member_detail_sr": "تفاصيل العضو",
  "team_export_title_member_activity": "نشاط العضو",
  "team_heading_subtitle": "راقب النشاط والحضور والصلاحيات في أنحاء مؤسستك.",
  "team_heading_title": "الفريق",
  "team_kind_event": "حدث",
  "team_kind_joined": "انضمام",
  "team_kind_other": "أخرى",
  "team_kind_role": "دور",
  "team_kind_signed_in": "تسجيل دخول",
  "team_label_title": "العنوان",
  "team_last_active": "آخر نشاط {{time}}",
  "team_made_by": "بواسطة {{actor}} • {{timestamp}}",
  "team_member_for": "عضو منذ {{duration}}",
  "team_member_not_found": "العضو غير موجود.",
  "team_no_active_sessions": "لا توجد جلسات نشطة.",
  "team_no_activity_filtered": "لا يوجد نشاط يطابق هذه الفلاتر.",
  "team_no_activity_yet": "لا يوجد نشاط بعد.",
  "team_no_org_activity": "لا يوجد نشاط حديث للمؤسسة.",
  "team_notify_sheet_desc": "يصل إلى {{name}} كإشعار داخل التطبيق على أجهزته ويُسجَّل في سجل نشاطه الزمني.",
  "team_notify_sheet_title": "إرسال إشعار",
  "team_placeholder_message": "بماذا تريد إعلامهم؟",
  "team_placeholder_notice_title": "مثال: تذكير بجدول اليوم",
  "team_placeholder_warning_title": "مثال: حجز متعارض لموعد",
  "team_presence_idle": "خامل",
  "team_presence_offline": "غير متصل",
  "team_presence_online": "متصل",
  "team_role_admin": "مسؤول",
  "team_role_guest": "ضيف",
  "team_role_owner": "مالك",
  "team_role_secretary": "سكرتير",
  "team_row_account_created": "تاريخ إنشاء الحساب",
  "team_row_active_sessions": "الجلسات النشطة",
  "team_row_ban_reason": "سبب الحظر",
  "team_row_custom_role": "دور مخصص",
  "team_row_email": "البريد الإلكتروني",
  "team_row_last_sign_in": "آخر تسجيل دخول",
  "team_row_member_since": "عضو منذ",
  "team_row_org_role": "دور المؤسسة",
  "team_search_activity_placeholder": "ابحث في النشاط…",
  "team_section_account_status_title": "حالة الحساب",
  "team_section_communicate_desc": "أرسل إشعارًا داخل التطبيق إلى أجهزة هذا العضو، ويُسجَّل في سجل نشاطه الزمني.",
  "team_section_communicate_title": "التواصل",
  "team_section_danger_zone_title": "منطقة الخطر",
  "team_self_membership_notice": "أنت تشاهد عضويتك الخاصة. إجراءات الحالة والإزالة غير متاحة لحسابك الخاص.",
  "team_session_active": "{{ip}} · نشط {{time}}",
  "team_session_expires": "تنتهي {{time}}",
  "team_session_impersonated": "انتحال هوية",
  "team_severity_notice": "إشعار",
  "team_severity_warning": "تحذير",
  "team_stat_active_week": "نشط هذا الأسبوع",
  "team_stat_dormant": "غير نشط",
  "team_stat_online_now": "متصل الآن",
  "team_stat_pending_invites": "دعوات معلقة",
  "team_stat_seats_used": "المقاعد المستخدمة",
  "team_tab_manage": "إدارة",
  "team_tab_overview": "نظرة عامة",
  "team_tab_sessions": "الجلسات",
  "team_this_member": "هذا العضو",
  "team_time_days_ago": "منذ {{n}} ي",
  "team_time_hours_ago": "منذ {{n}} س",
  "team_time_just_now": "الآن",
  "team_time_minutes_ago": "منذ {{n}} د",
  "team_time_never": "أبدًا",
  "team_toast_deactivated_msg": "لم يعد بإمكان {{name}} تسجيل الدخول.",
  "team_toast_deactivated_title": "تم تعطيل العضو",
  "team_toast_delivered": "تم التسليم إلى {{count}} جهاز.",
  "team_toast_notice_sent": "تم إرسال الإشعار",
  "team_toast_reactivated_msg": "يمكن لـ {{name}} تسجيل الدخول مرة أخرى.",
  "team_toast_reactivated_title": "تمت إعادة تفعيل العضو",
  "team_toast_recorded_timeline": "تم تسجيله في السجل الزمني للعضو.",
  "team_toast_removed_msg": "تمت إزالة {{name}} من المؤسسة.",
  "team_toast_removed_title": "تمت إزالة العضو",
  "team_toast_warning_sent": "تم إرسال التحذير",
  "team_unknown_ip": "عنوان IP غير معروف",
  "team_word_activity": "النشاط",
  "team_word_members": "الأعضاء",
  "ui_a_ai_off_label": "الذكاء الاصطناعي متوقف",
  "ui_a_ai_off_tooltip": "الرد التلقائي بالذكاء الاصطناعي متوقف لهذا المستخدم",
  "ui_a_backend_banner_collapse_label": "عرض حالة الاتصال",
  "ui_a_calendar_aria_label": "التقويم",
  "ui_a_calendar_back_to_calendar": "العودة إلى التقويم",
  "ui_a_calendar_month_short_apr": "أبر",
  "ui_a_calendar_month_short_aug": "أغس",
  "ui_a_calendar_month_short_dec": "ديس",
  "ui_a_calendar_month_short_feb": "فبر",
  "ui_a_calendar_month_short_jan": "ينا",
  "ui_a_calendar_month_short_jul": "يول",
  "ui_a_calendar_month_short_jun": "يون",
  "ui_a_calendar_month_short_mar": "مار",
  "ui_a_calendar_month_short_may": "ماي",
  "ui_a_calendar_month_short_nov": "نوف",
  "ui_a_calendar_month_short_oct": "أكت",
  "ui_a_calendar_month_short_sep": "سبت",
  "ui_a_calendar_next_year": "السنة التالية",
  "ui_a_calendar_previous_year": "السنة السابقة",
  "ui_a_calendar_select_month_current": "اختيار الشهر، الحالي {{month}}",
  "ui_a_calendar_range_from": "يبدأ",
  "ui_a_calendar_range_to": "ينتهي",
  "ui_a_calendar_select_time": "اختيار الوقت",
  "ui_a_calendar_select_year_current": "اختيار السنة، الحالية {{year}}",
  "ui_a_calendar_selected_suffix": "محدد",
  "ui_a_calendar_this_year": "هذا العام",
  "ui_a_calendar_week_number": "أسبوع",
  "ui_a_calendar_weekday_short_fri": "ج",
  "ui_a_calendar_weekday_short_mon": "ن",
  "ui_a_calendar_weekday_short_sat": "س",
  "ui_a_calendar_weekday_short_sun": "ح",
  "ui_a_calendar_weekday_short_thu": "خ",
  "ui_a_calendar_weekday_short_tue": "ث",
  "ui_a_calendar_weekday_short_wed": "ر",
  "ui_a_code_diff_show_full": "عرض الفرق كاملاً",
  "ui_a_copy_failed": "فشل النسخ",
  "ui_a_emoji_loading_favorites": "جارٍ تحميل المفضلة…",
  "ui_a_emoji_next_favorites_page": "الصفحة التالية من المفضلة",
  "ui_a_emoji_previous_favorites_page": "الصفحة السابقة من المفضلة",
  "ui_a_feedback_message_required": "الرسالة مطلوبة",
  "ui_a_feedback_message_too_long": "الرسالة طويلة جدًا",
  "ui_a_feedback_org_required": "المؤسسة مطلوبة لإرسال الملاحظات",
  "ui_a_onboarding_go_to_step": "الانتقال إلى الخطوة {{step}}",
  "ui_a_onboarding_navigation": "التنقل في الإرشاد التعريفي",
  "ui_a_onboarding_step_of_total": "الخطوة {{step}} من {{total}}",
  "ui_a_pagination_go_to_next": "الانتقال إلى الصفحة التالية",
  "ui_a_pagination_go_to_previous": "الانتقال إلى الصفحة السابقة",
  "ui_a_pagination_more_pages": "المزيد من الصفحات",
  "ui_a_pagination_nav_label": "ترقيم الصفحات",
  "ui_a_pagination_next": "التالي",
  "ui_a_pagination_previous": "السابق",
  "ui_a_pricing_select_plan": "اختر خطة",
  "ui_a_pricing_yearly": "سنوي",
  "ui_a_slider_value": "قيمة المنزلق",
  "ui_a_toggle_expand": "تبديل التوسيع",
  "ui_a_validation_errors_announce": "{{count}} خطأ في التحقق: {{messages}}",
  "ui_a_validation_errors_resolved": "تم حل جميع أخطاء التحقق.",
  "ui_a_waveform_idle": "الموجة الصوتية خاملة",
  "ui_a_waveform_live": "موجة صوتية مباشرة",
  "ui_a_waveform_processing": "جارٍ معالجة الصوت",
  "ui_b_data_grid_clear_sort": "مسح الفرز",
  "ui_b_data_grid_collapse_detail_row": "طي صف التفاصيل",
  "ui_b_data_grid_collapse_item": "طي {{item}}",
  "ui_b_data_grid_column_menu": "قائمة عمود {{label}}",
  "ui_b_data_grid_detail_column": "التفاصيل",
  "ui_b_data_grid_expand_detail_row": "توسيع صف التفاصيل",
  "ui_b_data_grid_expand_item": "توسيع {{item}}",
  "ui_b_data_grid_loading_row": "صف الجدول قيد التحميل",
  "ui_b_data_grid_no_history_yet": "لا يوجد سجل بعد",
  "ui_b_data_grid_reset_width": "إعادة تعيين العرض",
  "ui_b_data_grid_resize_column": "تغيير حجم عمود {{label}}",
  "ui_b_data_grid_sort_column": "فرز {{label}}",
  "ui_b_data_grid_view_history": "عرض السجل",
  "ui_b_morph_surface_sent": "تم الإرسال",
  "ui_b_scrollbar_scroll_down": "التمرير لأسفل",
  "ui_b_scrollbar_scroll_up": "التمرير لأعلى",
  "ui_b_toolbar_add_row": "إضافة صف",
  "ui_b_toolbar_clear_search": "مسح البحث",
  "ui_b_toolbar_columns": "الأعمدة",
  "ui_b_toolbar_columns_visible_count": "{{visible}} من {{total}} ظاهر",
  "ui_b_toolbar_delete_selected": "حذف الصفوف المحددة",
  "ui_b_toolbar_selected_count": "{{count}} محدد",
  "ui_b_toolbar_export": "تصدير...",
  "ui_b_toolbar_filters": "عوامل التصفية",
  "contact_filter_state": "الحالة",
  "contact_filter_flags": "علامات",
  "contact_filter_favorites": "المفضلة",
  "contact_filter_bookings": "الحجوزات",
  "contact_filter_bookings_any": "لديه حجوزات",
  "contact_filter_bookings_upcoming": "حجز قادم",
  "contact_filter_bookings_none": "بدون حجوزات",
  "contact_filter_created": "تاريخ الإنشاء",
  "member_filter_role": "الدور",
  "member_filter_superuser": "مشرف النظام",
  "member_filter_sign_in": "تسجيل الدخول",
  "member_filter_never_signed_in": "لم يسجل الدخول مطلقًا",
  "member_filter_has_signed_in": "سجّل الدخول من قبل",
  "ui_b_toolbar_fullscreen": "ملء الشاشة",
  "ui_b_toolbar_hide_deleted": "إخفاء المحذوفة",
  "ui_b_toolbar_revive_selected": "استعادة الصفوف المحددة",
  "ui_b_toolbar_save_changes": "حفظ التغييرات",
  "ui_b_toolbar_saving": "جارٍ الحفظ...",
  "ui_b_toolbar_search_placeholder": "بحث...",
  "ui_b_toolbar_search_shortcut": "بحث (Ctrl+F)",
  "ui_b_toolbar_search_table": "البحث في الجدول",
  "ui_b_toolbar_show_all_columns": "إظهار جميع الأعمدة",
  "wgt_account_settings_sections_aria": "أقسام إعدادات الحساب",
  "wgt_contact_action_enable_ai": "تفعيل الذكاء الاصطناعي",
  "wgt_contact_actions_menu_aria": "إجراءات جهة الاتصال",
  "wgt_contact_add_favorite": "إضافة إلى المفضلة",
  "wgt_contact_archive": "أرشفة جهة الاتصال",
  "wgt_contact_block_set_inactive": "حظر (تعيين كغير نشط)",
  "wgt_contact_clear_failed": "تعذّر مسح المحادثة",
  "wgt_contact_export_conversation": "تصدير المحادثة",
  "wgt_contact_export_preparing": "جارٍ تجهيز التصدير…",
  "wgt_contact_load_messages_failed": "تعذّر تحميل الرسائل",
  "wgt_contact_open_documents": "فتح المستندات",
  "wgt_contact_remove_favorite": "إزالة من المفضلة",
  "wgt_contact_restore": "استعادة جهة الاتصال",
  "wgt_contact_save_first": "احفظ أولاً",
  "wgt_contact_unblock_set_active": "إلغاء الحظر (تعيين كنشط)",
  "wgt_contact_view_change_history": "عرض سجل التغييرات",
  "wgt_documents_add_files_failed": "تعذّرت إضافة الملفات إلى المستند.",
  "wgt_documents_checklist_add_item": "إضافة عنصر",
  "wgt_documents_checklist_delete_item": "حذف العنصر",
  "wgt_documents_checklist_hint": "انقر نقرًا مزدوجًا للتحرير",
  "wgt_documents_checklist_item_placeholder": "عنصر القائمة",
  "wgt_documents_checklist_title_placeholder": "قائمة تحقق",
  "wgt_documents_checklist_toggle_item": "تبديل العنصر",
  "wgt_documents_checklist_tool": "قائمة تحقق",
  "wgt_documents_enter_fullscreen": "الدخول في وضع ملء الشاشة",
  "wgt_documents_export_failed": "تعذّر تصدير المستند.",
  "wgt_documents_export_tldr": "تصدير ملف ‎.tldr",
  "wgt_documents_import_confirm_body": "استيراد “{{fileName}}” سيستبدل كل محتوى هذه اللوحة، وسيقوم الحفظ التلقائي بالكتابة فوق النسخة المحفوظة على الخادم.",
  "wgt_documents_import_confirm_export_first": "صدّر الحالية ثم استبدل",
  "wgt_documents_import_confirm_replace": "استبدال",
  "wgt_documents_import_confirm_title": "استبدال هذه اللوحة؟",
  "wgt_documents_import_failed_damaged": "هذا الملف تالف ولا يمكن استيراده.",
  "wgt_documents_import_failed_newer": "أُنشئ هذا الملف بإصدار أحدث من tldraw. حدّث التطبيق وحاول مجددًا.",
  "wgt_documents_import_failed_not_tldraw": "هذا الملف ليس ملف tldraw.",
  "wgt_documents_import_failed_too_old": "يستخدم هذا التنسيق إصدار tldraw قديمًا لا يمكن استيراده.",
  "wgt_documents_import_tldr": "استيراد ملف ‎.tldr…",
  "wgt_documents_offline_start_blank": "بدء مستند فارغ",
  "wgt_documents_offline_start_blank_warning": "إذا كان هناك مستند محفوظ على الخادم، فسيظهر عملك كتعارض يلزم حله بمجرد عودة الاتصال.",
  "wgt_documents_offline_unavailable_description": "لم يسبق فتح هذا المستند على هذا الجهاز، لذا لا توجد نسخة محلية لعرضها. أعد الاتصال لفتحه.",
  "wgt_documents_offline_unavailable_title": "غير متاح دون اتصال",
  "wgt_documents_table_add_column": "إضافة عمود",
  "wgt_documents_table_add_row": "إضافة صف",
  "wgt_documents_table_cell_checkbox": "تبديل القيمة",
  "wgt_documents_table_cell_select": "اختيار قيمة",
  "wgt_documents_table_cell_value": "قيمة الخلية",
  "wgt_documents_table_column_name": "اسم العمود",
  "wgt_documents_table_column_name_placeholder": "عمود",
  "wgt_documents_table_column_type": "نوع العمود",
  "wgt_documents_table_delete_column": "حذف العمود",
  "wgt_documents_table_delete_row": "حذف الصف",
  "wgt_documents_table_empty": "لا توجد صفوف",
  "wgt_documents_table_hint": "انقر نقرًا مزدوجًا للتحرير",
  "wgt_documents_table_options": "الخيارات",
  "wgt_documents_table_options_placeholder": "خيارات مفصولة بفواصل",
  "wgt_documents_table_tool": "جدول",
  "wgt_documents_table_type_checkbox": "مربع اختيار",
  "wgt_documents_table_type_number": "رقم",
  "wgt_documents_table_type_select": "قائمة",
  "wgt_documents_table_type_text": "نص",
  "wgt_documents_table_untitled_column": "بدون عنوان",
  "wgt_documents_unable_to_load_canvas": "تعذّر تحميل اللوحة",
  "wgt_documents_voice_note_cancel": "إلغاء",
  "wgt_documents_voice_note_delete": "حذف التسجيل",
  "wgt_documents_voice_note_hint": "اضغط تسجيل لالتقاط ملاحظة صوتية",
  "wgt_documents_voice_note_no_org": "لم يتم تحديد مؤسسة",
  "wgt_documents_voice_note_record": "تسجيل",
  "wgt_documents_voice_note_stop": "إيقاف",
  "wgt_documents_voice_note_tool": "ملاحظة صوتية",
  "wgt_documents_voice_note_upload_failed": "فشل رفع الملاحظة الصوتية",
  "wgt_documents_voice_note_uploading": "جارٍ الرفع…",
  "wgt_root_error_backend_check_1": "حدّث الصفحة بعد أن يُبلغ الخادم الخلفي أنه جاهز.",
  "wgt_root_error_backend_check_2": "تحقق من أن عنوان واجهة برمجة التطبيقات يطابق الخادم قيد التشغيل.",
  "wgt_root_error_backend_description": "تم تحميل الواجهة الأمامية، لكن طلبًا إلى واجهة برمجة التطبيقات لم يكتمل. يعني هذا عادةً أن الخادم ما زال يبدأ التشغيل، أو متوقف، أو أن عنوان الخادم الخلفي غير صحيح.",
  "wgt_root_error_backend_dev_check_1": "شغّل الخادم باستخدام `bun dev:server`.",
  "wgt_root_error_backend_dev_check_2": "القيمة الافتراضية لـ `VITE_BACKEND_URL` هي `http://127.0.0.1:4000`.",
  "wgt_root_error_backend_title": "تعذّر الوصول إلى الخادم الخلفي",
  "wgt_root_error_module_check_1": "حدّث الصفحة بعد أن تنتهي الواجهة الأمامية من البدء.",
  "wgt_root_error_module_check_2": "إذا استمرت المشكلة، أغلق هذا التبويب وافتح التطبيق مجددًا من عنوان الواجهة الأمامية الحالي.",
  "wgt_root_error_module_description": "هذا التبويب مفتوح، لكن المتصفح لم يتمكن من تنزيل وحدة المسار المطلوبة. عادةً ما يحل التحديث هذه المشكلة بعد إعادة تشغيل الواجهة الأمامية أو نشر إصدار جديد.",
  "wgt_root_error_module_dev_check_1": "تأكد من أن `bun dev` ما زال يعمل على المنفذ 3000.",
  "wgt_root_error_module_dev_check_2": "إذا أُعيد تشغيل Vite، انتظر حتى ينتهي من الترجمة قبل التحديث.",
  "wgt_root_error_module_title": "تعذّر تحميل كود الصفحة",
  "wgt_root_error_open_start_page": "فتح صفحة البداية",
  "wgt_root_error_status_backend": "اتصال الخادم الخلفي",
  "wgt_root_error_status_module": "وحدة الواجهة الأمامية",
  "wgt_root_error_status_unknown": "خطأ في التطبيق",
  "wgt_root_error_technical_details": "التفاصيل التقنية",
  "wgt_root_error_unknown_check_1": "حدّث الصفحة.",
  "wgt_root_error_unknown_check_2": "افتح التفاصيل التقنية وتحقق من طرفية المتصفح إذا تكرر الخطأ.",
  "wgt_root_error_unknown_description": "يمكن أن يعالج التحديث مشكلة ناتجة عن إعادة تشغيل، أو نشر إصدار جديد، أو انقطاع اتصال قصير. إذا استمرت المشكلة، فراجع التفاصيل التقنية أدناه لتحديد الجزء المتعطل.",
  "wgt_root_error_unknown_title": "واجهت الصفحة خطأً غير متوقع",
  "wgt_root_error_what_to_check": "ما الذي يجب التحقق منه",
  "wgt_router_go_home": "الذهاب إلى الصفحة الرئيسية",
  "wgt_router_loading_page": "جارٍ تحميل الصفحة",
  "wgt_router_page_not_found": "الصفحة غير موجودة",
  "wgt_tldraw_load_error_description": "تعذّر تحميل محرر الرسم. يرجى تحديث الصفحة للمحاولة مرة أخرى.",
  "wgt_tldraw_load_error_title": "تعذّر تحميل المحرر",
  "wgt_tours_theme_mode_system_short": "النظام",
  "name_validation_has_digits": "لا يمكن أن يحتوي الاسم على أرقام.",
  "name_validation_invalid": "الاسم غير صالح.",
  "name_validation_invalid_chars": "يمكن أن يحتوي الاسم على حروف ومسافات وشرطات فقط.",
  "name_validation_required": "الاسم مطلوب.",
  "name_validation_too_long": "الاسم طويل جدًا (الحد الأقصى 50 حرفًا).",
  "name_validation_too_short": "يجب أن يتضمن الاسم كلمتين على الأقل.",
  "name_validation_words_too_short": "يجب أن تتكوّن كل كلمة في الاسم من حرفين على الأقل.",
  "chat_drop_here_to_mention": "أفلت هنا للإشارة إلى جهة اتصال",
  "chat_release_to_mention_contact": "أفلت للإشارة إلى جهة الاتصال",
  "admin_organizations": "المؤسسات",
  "cfg2_ai_context_message_limit_label": "حد رسائل السياق",
  "cfg2_ai_context_message_limit_tip": "عدد الرسائل السابقة التي تُرسل إلى الذكاء الاصطناعي في كل طلب. كلما قلّ العدد قلّت التكلفة، وكلما زاد اتسع سجل المحادثة. اتركه فارغًا لعدم وضع حد.",
  "cfg_ai_processing_card_title": "صلاحيات ملفات الوكلاء",
  "cfg_ai_processing_card_description": "تحكّم بشكل مستقل في استلام كل نوع ملف وقراءته بالذكاء الاصطناعي وإرساله لكل وكيل.",
  "cfg_ai_audio_read_cost_title": "قد تؤدي قراءة الصوت إلى تكاليف تفريغ عبر ElevenLabs",
  "cfg_ai_audio_read_cost_description": "عند التفعيل، تُرسل الرسائل الصوتية مباشرةً إلى النماذج التي تدعم الصوت. أما النماذج التي لا تدعمه، فيقوم ElevenLabs بتفريغ كل تسجيل وتُحتسب التكلفة حسب مدة الصوت. أوقف قراءة الصوت لتعطيل المعالجة الصوتية المباشرة وتفريغ ElevenLabs مع بقاء التسجيلات محفوظة وقابلة للتشغيل.",
  "cfg_ai_process_images_label": "معالجة الصور الواردة",
  "cfg_ai_process_images_tooltip": "عند التفعيل، ينظر الذكاء الاصطناعي إلى الصور الواردة ويستخدمها في الإجابة. عند الإيقاف، تظل الصور تُستقبَل وتُخزَّن وتُعرَض، لكن يتجاهلها الذكاء الاصطناعي. يسري هذا حتى لو كان النموذج المختار قادرًا على رؤية الصور.",
  "cfg_ai_process_audio_label": "معالجة الرسائل الصوتية الواردة",
  "cfg_ai_process_audio_tooltip": "عند التفعيل، تستمع النماذج الداعمة للصوت إلى التسجيل الأصلي، بينما تستقبل النماذج الأخرى نصًا محولًا ومدفوع التكلفة من ElevenLabs. عند الإيقاف، تظل الرسائل الصوتية مخزنة وقابلة للتشغيل لكنها لا تُمرر إلى الذكاء الاصطناعي.",
  "cfg2_ai_fallback_model_hint": "جرّب نموذجًا آخر إذا فشل النموذج الأساسي.",
  "cfg2_ai_fallback_auto_primary_hint": "التوجيه التلقائي يختار النماذج ويتنقل بينها عند الفشل، لذا لا حاجة إلى نموذج احتياطي منفصل.",
  "cfg2_ai_fallback_model_label": "نموذج الذكاء الاصطناعي البديل",
  "cfg2_ai_knowledge_base_description": "ارفع مستندات مرجعية واضبط إعدادات الاسترجاع لبحث المستندات",
  "cfg2_rag_retrieval_gaps_title": "فجوات الاسترجاع",
  "cfg2_rag_retrieval_gaps_description": "عمليات بحث حديثة لم تجد إجابة في قاعدة المعرفة — مرشحات لإضافة مستندات جديدة.",
  "cfg2_rag_retrieval_gaps_summary": "{{count}} عملية بحث دون نتائج خلال آخر {{days}} أيام",
  "cfg2_rag_retrieval_gaps_empty": "لا توجد فجوات استرجاع خلال آخر {{days}} أيام.",
  "cfg2_rag_retrieval_gaps_empty_query": "(بدون نص بحث)",
  "cfg2_rag_retrieval_gaps_error": "تعذّر تحميل بيانات الاسترجاع.",
  "cfg2_ai_model_config_description": "اختر نماذج الذكاء الاصطناعي للردود التلقائية ومهام الوكيل",
  "cfg2_ai_model_config_title": "إعدادات نموذج الذكاء الاصطناعي",
  "cfg2_ai_primary_model_description": "اختر نموذج ذكاء اصطناعي محدد للردود التلقائية ومهام الوكيل.",
  "cfg2_ai_primary_model_label": "نموذج الذكاء الاصطناعي الأساسي",
  "cfg2_ai_tools_card_description": "اختر ما يُسمح للذكاء الاصطناعي بفعله. لكل قسم مفتاح رئيسي؛ وسّعه لضبط الأدوات الفردية. استخدم زر + لإضافة إجراءات مخصصة تستدعي واجهة برمجة التطبيقات الخاصة بك.",
  "cfg2_ai_tools_card_title": "أدوات الذكاء الاصطناعي",
  "cfg2_feature_include_reasoning_description": "يمكنه تضمين الاستدلال في الرد. يمكن للنموذج تضمين عملية تفكيره الداخلية في الناتج عند الطلب.",
  "cfg2_feature_include_reasoning_label": "يشمل الاستدلال",
  "cfg2_feature_parallel_description": "يدعم استدعاء الأدوات بشكل متوازٍ. يمكن للنموذج تنفيذ عدة أدوات في آنٍ واحد بدلًا من التسلسل، مما يحسّن سرعة الاستجابة.",
  "cfg2_feature_parallel_label": "متوازٍ",
  "cfg2_feature_reasoning_description": "يدعم إظهار الاستدلال. يمكن للنموذج عرض تفكيره خطوة بخطوة وتوضيح كيفية توصله إلى النتائج.",
  "cfg2_feature_response_format_description": "يدعم تنسيق الرد بصيغة JSON. يمكن للنموذج إعادة الردود بصيغة JSON صالحة، مما يفيد في التكامل البرمجي.",
  "cfg2_feature_structured_description": "يدعم مخطط الناتج المُهيكل. يمكن للنموذج إعادة البيانات بصيغة JSON محددة مسبقًا، مما يضمن ثبات بنية الناتج.",
  "cfg2_feature_structured_label": "مُهيكل",
  "cfg2_feature_tools_description": "يدعم استدعاء الوظائف/الأدوات. يمكن للنموذج تنفيذ الوظائف واستدعاء واجهات برمجة التطبيقات واستخدام أدوات خارجية لتنفيذ إجراءات تتجاوز توليد النص.",
  "cfg2_feature_web_search_description": "يدعم إمكانيات البحث على الويب. يمكن للنموذج البحث في الإنترنت للعثور على معلومات حديثة والإجابة عن الأسئلة ببيانات محدّثة.",
  "cfg2_modality_audio_description": "يقبل الصوت كمدخل.",
  "cfg2_modality_audio_label": "صوت",
  "cfg2_modality_embeddings_description": "ينتج تضمينات متجهية كثيفة كمخرج.",
  "cfg2_modality_embeddings_label": "تضمينات",
  "cfg2_modality_file_description": "يقبل مرفقات الملفات (PDF، مستندات، …) كمدخل.",
  "cfg2_modality_image_description": "يقبل الصور كمدخل (رؤية / متعدد الوسائط).",
  "cfg2_modality_text_description": "يقبل النص العادي كمدخل.",
  "cfg2_modality_video_description": "يقبل إطارات الفيديو كمدخل.",
  "cfg2_modality_video_label": "فيديو",
  "cfg2_model_context_tokens": "{{count}} رمز",
  "cfg2_model_providers_count": "{{count}} مزوّدين",
  "cfg2_model_stat_agentic": "الوكالة",
  "cfg2_model_stat_agentic_sublabel": "استدعاء الأدوات",
  "cfg2_model_stat_coding": "البرمجة",
  "cfg2_model_stat_intelligence": "الذكاء",
  "cfg2_model_stat_latency": "زمن الاستجابة",
  "cfg2_model_stat_latency_sublabel": "أول رمز",
  "cfg2_model_stat_math": "الرياضيات",
  "cfg2_model_stat_speed": "السرعة",
  "cfg2_model_stat_speed_sublabel": "رمز/ثانية",
  "cfg2_notif_field_days_after_label": "عدد الأيام بعد الموعد",
  "cfg2_notif_field_days_before_label": "عدد الأيام قبل الموعد",
  "cfg2_notif_field_delay_hours_label": "ساعات التأخير",
  "cfg2_notif_field_inactive_days_label": "أيام عدم النشاط",
  "cfg2_notif_field_scheduled_datetime_label": "التاريخ والوقت المجدولان",
  "cfg2_notif_field_send_at_time_label": "وقت الإرسال",
  "cfg2_notif_unit_day_after": "يوم بعد الموعد",
  "cfg2_notif_unit_day_before": "يوم قبل الموعد",
  "cfg2_notif_unit_day_inactivity": "يوم من عدم النشاط",
  "cfg2_notif_unit_days_after": "أيام بعد الموعد",
  "cfg2_notif_unit_days_before": "أيام قبل الموعد",
  "cfg2_notif_unit_days_inactivity": "أيام من عدم النشاط",
  "cfg2_notif_unit_delay_minute": "دقيقة بعد المُحفّز",
  "cfg2_notif_unit_delay_minutes": "دقائق بعد المُحفّز",
  "cfg2_notif_unit_hour_no_show": "ساعة بعد التغيب",
  "cfg2_notif_unit_hours_no_show": "ساعات بعد التغيب",
  "cfg2_rag_document_count": "{{count}} مستندات",
  "cfg2_rag_drop_files_here": "أفلت الملفات هنا…",
  "cfg2_rag_dropzone_browse_hint": "اسحب وأفلت الملفات أو انقر للتصفح",
  "cfg2_rag_dropzone_size_hint": "حتى 10 ميغابايت لكل ملف",
  "cfg2_rag_file_too_large": "الملف \"{{filename}}\" كبير جدًا. الحد الأقصى للحجم هو 10 ميغابايت.",
  "cfg2_rag_file_unsupported_type": "نوع الملف \"{{filename}}\" غير مدعوم. الأنواع المسموحة: PDF، DOCX، XLSX، CSV، MD، TXT، PNG، JPG.",
  "rag_viewer_aria": "عارض المستند",
  "rag_viewer_save": "حفظ وإعادة الفهرسة",
  "rag_viewer_markdown_face": "عرض Markdown",
  "rag_viewer_rendered": "منسّق",
  "rag_viewer_raw": "خام",
  "rag_viewer_edit_locked": "يتاح التعديل بعد انتهاء المعالجة.",
  "rag_viewer_too_large_to_edit": "هذا الملف أكبر من أن يُعدَّل هنا.",
  "rag_viewer_reindexing": "إعادة الفهرسة {{progress}}%",
  "rag_viewer_unsupported": "المعاينة غير متاحة لهذا النوع من الملفات.",
  "rag_viewer_layout_unavailable": "المعاينة المنسّقة غير متاحة لهذا المستند بعد.",
  "rag_viewer_download_original": "تنزيل الملف الأصلي",
  "rag_viewer_load_failed": "تعذّر تحميل هذا المستند.",
  "rag_viewer_file_unavailable": "الملف الأصلي غير محفوظ لهذا المستند.",
  "rag_viewer_text_truncated": "يُعرض أول {{shown}} من {{total}} حرفًا. الملفات بهذا الحجم للقراءة فقط هنا.",
  "rag_viewer_keep_editing": "متابعة التعديل",
  "rag_viewer_discard_title": "تجاهل التغييرات غير المحفوظة؟",
  "rag_viewer_discard_description": "لم تُحفظ تعديلاتك على {{filename}}.",
  "rag_viewer_add_row": "إضافة صف",
  "rag_viewer_add_column": "إضافة عمود",
  "rag_viewer_delete_row": "حذف الصف",
  "rag_viewer_delete_column": "حذف العمود",
  "rag_viewer_columns_capped": "يُعرض أول {{shown}} من {{total}} عمودًا.",
  "rag_viewer_empty_sheet": "هذه الورقة فارغة.",
  "rag_upload_progress": "جارٍ الرفع {{percent}}%",
  "rag_retry_action": "إعادة المعالجة",
  "rag_retry_started_toast": "أُعيد بدء المعالجة",
  "rag_retry_failed_toast": "تعذّرت إعادة بدء المعالجة",
  "staged_knowledge_unsupported_type": "نوع الملف \"{{filename}}\" غير مدعوم. الأنواع المسموحة: PDF، DOCX، XLSX، CSV، MD، TXT، ZIP.",
  "pg_stat_chunks": "مقاطع",
  "pg_stat_embed": "تضمين",
  "pg_stat_search": "بحث",
  "pg_stat_touched": "مُسترجع",
  "chat_character_limit": "حد الأحرف {{limit}}",
  "cfg2_rag_no_documents_yet": "لا توجد مستندات مرفوعة بعد. ارفع أول مستند لتفعيل البحث الدلالي.",
  "cfg2_rag_storage_capacity_label": "مساحة تخزين قاعدة المعرفة",
  "cfg2_rag_storage_full_hint": "التخزين ممتلئ — احذف مستندات أو قم بترقية خطتك لإضافة المزيد.",
  "cfg2_rag_storage_limit_reached": "تم الوصول إلى حد التخزين. احذف مستندات أو قم بترقية خطتك لإضافة المزيد.",
  "cfg2_system_defaults_ai_model_description": "النموذج الأساسي للردود التلقائية ومهام الوكيل.",
  "cfg2_system_defaults_ai_model_label": "نموذج الذكاء الاصطناعي",
  "cfg2_system_defaults_fallback_model_tip": "يحاول استخدام هذا النموذج تلقائيًا عند فشل النموذج الأساسي أو عدم توفره.",
  "cfg2_system_defaults_prompts_description": "اضبط مطالبات نظام الذكاء الاصطناعي لسلوك المساعد",
  "cfg2_system_prompt_drop_release_label": "أفلت لاستبدال المحتوى",
  "cfg2_system_prompt_edit_field_aria": "تعديل {{label}}",
  "cfg2_system_prompt_exit_button": "خروج",
  "cfg2_system_prompt_heading_1": "عنوان 1",
  "cfg2_system_prompt_heading_2": "عنوان 2",
  "cfg2_system_prompt_heading_3": "عنوان 3",
  "cfg2_system_prompt_import_tooltip": "استيراد ملف (txt، markdown، docx، pdf)",
  "cfg2_system_prompt_paragraph": "فقرة",
  "cfg2_system_prompt_quick_export_docx": "تصدير سريع · DOCX",
  "cfg2_system_prompt_quick_export_txt": "تصدير سريع · TXT",
  "clear_all": "مسح الكل",
  "date_picker_label": "التاريخ والوقت",
  "date_time_placeholder": "اختر التاريخ والوقت",
  "done": "تم",
  "edit": "تعديل",
  "failed_to_load_calendar": "فشل تحميل التقويم",
  "failed_to_load_dashboard": "فشل تحميل لوحة المعلومات",
  "failed_to_load_documents": "فشل تحميل المستندات",
  "failed_to_load_viewer": "فشل تحميل العارض",
  "main_navigation": "التنقل الرئيسي",
  "nav_rail_collapse": "طي شريط التنقل",
  "nav_rail_expand": "توسيع شريط التنقل",
  "model_selector_label": "اختر النموذج",
  "msg_no_data": "لا توجد بيانات",
  "no": "لا",
  "phone_select_or_create": "رقم الهاتف",
  "pull_to_refresh": "اسحب للتحديث",
  "refreshing": "جارٍ التحديث…",
  "styles": "الأنماط",
  "toast_handoff_description": "تم تعطيل الرد التلقائي بالذكاء الاصطناعي لهذه المحادثة. ينبغي أن يتولّى أحد الموظفين المحادثة.",
  "toast_handoff_resumed_short": "تمت إعادة تفعيل الرد التلقائي بالذكاء الاصطناعي",
  "toast_handoff_short": "التحويل إلى موظف",
  "toast_handoff_title": "التحويل إلى موظف • {{name}}",
  "yes": "نعم",
  "account_notifications_always_immediate": "فوري دائمًا",
  "account_notifications_category_assignedToYou_description": "تم إسناد محادثة إليك مباشرة.",
  "account_notifications_category_assignedToYou_label": "أُسندت إليك",
  "account_notifications_category_budgetCapReached_description": "أوقف حد ميزانية الذكاء الاصطناعي الاستخدام الإضافي.",
  "account_notifications_category_budgetCapReached_label": "تم بلوغ حد الميزانية",
  "account_notifications_category_campaignFinished_description": "انتهت حملة واتساب من الإرسال.",
  "account_notifications_category_campaignFinished_label": "اكتملت الحملة",
  "account_notifications_category_handoffRequested_description": "تحتاج محادثة إلى مساعدة من فريقك.",
  "account_notifications_category_handoffRequested_label": "طلب تحويل",
  "account_notifications_category_lowBalance_description": "رصيد مؤسستك الائتماني يوشك على النفاد.",
  "account_notifications_category_lowBalance_label": "الرصيد منخفض",
  "account_notifications_category_mention_description": "أشار إليك زميل في ملاحظة.",
  "account_notifications_category_mention_label": "إشارة",
  "account_notifications_category_slaBreach_description": "تجاوزت محادثة هدف وقت الاستجابة.",
  "account_notifications_category_slaBreach_label": "تجاوز اتفاقية الخدمة",
  "account_notifications_category_templateHealth_description": "تم رفض قالب واتساب أو إيقافه مؤقتًا أو تعطيله.",
  "account_notifications_category_templateHealth_label": "حالة القالب",
  "account_notifications_category_waitlistActivity_description": "تغيرت قائمة انتظار الحجز.",
  "account_notifications_category_waitlistActivity_label": "نشاط قائمة الانتظار",
  "account_notifications_column_email": "البريد",
  "account_notifications_column_webpush": "فوري",
  "account_notifications_email_enabled_label": "إشعارات البريد الإلكتروني",
  "account_notifications_email_frequency_digest": "ملخص يومي",
  "account_notifications_email_frequency_immediate": "فورًا",
  "account_notifications_email_frequency_label": "تكرار البريد الإلكتروني",
  "account_notifications_group_billing_title": "الفوترة",
  "account_notifications_group_team_title": "الفريق",
  "account_notifications_push_devices_current": "هذا الجهاز",
  "account_notifications_push_devices_description": "المتصفحات المسجلة حاليًا لتلقي إشعارات الويب.",
  "account_notifications_push_devices_empty": "لا توجد متصفحات مسجلة لإشعارات الويب.",
  "account_notifications_push_devices_last_used": "آخر استخدام",
  "account_notifications_push_devices_revoke": "إلغاء",
  "account_notifications_push_devices_revoke_failed": "تعذر إلغاء هذا الجهاز. حاول مرة أخرى.",
  "account_notifications_push_devices_title": "أجهزة الإشعارات",
  "account_notifications_quiet_hours_label": "ساعات الهدوء",
  "account_privacy_export_expired": "انتهت صلاحية الأرشيف الأخير. أنشئ تصديرًا جديدًا.",
  "account_privacy_export_failed": "فشل التصدير الأخير. أنشئ تصديرًا جديدًا.",
  "account_privacy_retention_stop_semantic_1_month": "شهر",
  "account_privacy_retention_stop_semantic_1_year": "سنة",
  "account_privacy_retention_stop_semantic_3_months": "3 أشهر",
  "account_privacy_retention_stop_semantic_6_months": "6 أشهر",
  "account_sessions_freshness_required": "لحماية حسابك، سجّل الدخول مجدداً لعرض جلساتك النشطة وإدارتها.",
  "account_sessions_sign_in_again": "تسجيل الدخول مجدداً",
  "account_sessions_subtitle_verification": "يلزم التحقق لعرض الأجهزة النشطة",
  "campaigns_add_contacts": "إضافة جهات اتصال",
  "campaigns_ai_replies": "ردود الذكاء الاصطناعي",
  "campaigns_all_statuses": "كل الحالات",
  "campaigns_approved_template": "القالب المعتمد",
  "campaigns_audience": "الجمهور",
  "campaigns_audience_clear": "مسح الكل",
  "campaigns_audience_count": "{{count}} جهات اتصال في هذا الجمهور",
  "campaigns_audience_description": "يمكن اختيار جهات الاتصال التي راسلتك عبر واتساب فقط.",
  "campaigns_audience_empty": "لم يتم اختيار أي جهة اتصال بعد",
  "campaigns_audience_empty_description": "ابحث في جهات اتصال واتساب بالاسم أو الرقم وأضف كل من تريد أن تصل إليه هذه الحملة.",
  "campaigns_daily_cap_exceeded": "هذا الجمهور يضم {{selected}} جهة اتصال، لكن يمكن الوصول إلى {{remaining}} فقط خلال الـ24 ساعة القادمة. احذف بعض جهات الاتصال أو أرسل البقية غدًا.",
  "campaigns_daily_cap_summary": "يسمح واتساب بـ {{limit}} جهة اتصال فريدة كل 24 ساعة متجددة. تم استخدام {{used}}، وتبقّى {{remaining}}.",
  "campaigns_audience_remove": "إزالة {{name}}",
  "campaigns_cancel": "إلغاء",
  "campaigns_cancel_confirm_description": "هل تريد إلغاء {{name}}؟ لن يتم إرسال الرسائل المتبقية في قائمة الانتظار.",
  "campaigns_cancel_confirm_title": "إلغاء الحملة؟",
  "campaigns_cancel_error": "تعذر إلغاء الحملة.",
  "campaigns_configuration": "الإعداد",
  "campaigns_contact": "جهة الاتصال",
  "campaigns_contacts": "جهات اتصال",
  "campaigns_content": "المحتوى",
  "campaigns_delivered": "تم التسليم",
  "campaigns_delivery_counters": "عدادات التسليم",
  "campaigns_delivery_funnel": "مسار التسليم",
  "campaigns_delivery_replies": "التسليم والردود",
  "campaigns_description": "أرسل قوالب واتساب المعتمدة إلى جمهور محدد وتابع التسليم لحظيًا.",
  "campaigns_detail_error": "تعذر تحميل الحملة.",
  "campaigns_diagnostic": "التشخيص",
  "campaigns_draft_audience_notice": "سيتم تثبيت {{count}} جهات اتصال محددة والتحقق منها مجددًا عند إرسال هذه المسودة.",
  "campaigns_draft_template_notice": "يتم تثبيت محتوى القالب المعتمد في لقطة غير قابلة للتغيير عند إرسال هذه المسودة.",
  "campaigns_drop_off": "تراجع",
  "campaigns_email_templates_description": "قوالب بريد إلكتروني قابلة لإعادة الاستخدام للتأكيدات والتذكيرات.",
  "campaigns_email_templates_title": "قوالب البريد الإلكتروني",
  "campaigns_empty": "لا توجد حملات بعد",
  "campaigns_empty_description": "أنشئ مسودة لاختيار المحتوى والجمهور.",
  "campaigns_example": "مثال",
  "campaigns_failed": "فشل",
  "campaigns_filter_status": "تصفية حسب الحالة",
  "campaigns_human_takeover": "تحويل إلى موظف",
  "campaigns_invalid_fields": "تحقق من اسم الحملة ومعرّف رقم الهاتف والقالب وتعيينات المتغيرات.",
  "campaigns_list_aria": "قائمة الحملات",
  "campaigns_load_error": "تعذر تحميل الحملات.",
  "campaigns_loading": "جارٍ تحميل الحملات…",
  "campaigns_loading_detail": "جارٍ تحميل الحملة…",
  "campaigns_mapping_json_error": "يجب أن تكون تعيينات المتغيرات كائن JSON.",
  "campaigns_meta_billing_warning": "ترسل الحملات قوالب الخدمة (Utility) فقط، ويُحتسب كل مستلم ضمن حصة الرسائل الشهرية في باقتك.",
  "campaigns_meta_limits": "حدود Meta",
  "campaigns_name": "اسم الحملة",
  "campaigns_nav_label": "الحملات",
  "campaigns_new": "حملة جديدة",
  "campaigns_no_campaign_matches": "لا توجد حملات تطابق هذا المرشح.",
  "campaigns_no_recipient_matches": "لا يوجد مستلمون يطابقون هذا المرشح.",
  "campaigns_outbound": "الرسائل الصادرة",
  "campaigns_outbound_breadcrumb": "الرسائل الصادرة / الحملات",
  "campaigns_phone": "الهاتف",
  "campaigns_phone_number_id": "معرّف رقم هاتف واتساب",
  "campaigns_quality_unavailable": "الجودة غير متاحة",
  "campaigns_queued": "في الانتظار",
  "campaigns_read": "تمت القراءة",
  "campaigns_read_replied": "قراءة / رد",
  "campaigns_recipients": "مستلمين",
  "campaigns_recipients_title": "المستلمون",
  "campaigns_replied": "تم الرد",
  "campaigns_replies": "الردود",
  "campaigns_save_draft": "حفظ المسودة",
  "campaigns_save_error": "تعذر حفظ الحملة.",
  "campaigns_search_placeholder": "ابحث بالاسم أو الهاتف",
  "campaigns_search_recipients": "البحث في المستلمين",
  "campaigns_select_template": "اختر قالبًا",
  "campaigns_templates_utility_only": "يمكن إرسال قوالب الخدمات المعتمدة فقط. الرسائل التسويقية غير مشمولة في خطتك لأن Meta تحاسب على كل رسالة منها.",
  "campaigns_templates_hidden_not_covered": "تم إخفاء {{count}} من القوالب المعتمدة لأن Meta صنّفتها كقوالب تسويقية أو مصادقة، وهذا غير مشمول في خطتك. عدّلها لتكون خاصة بالمعاملات فقط وأعد إرسالها لاستخدامها هنا.",
  "campaigns_send_now": "إرسال الآن",
  "campaigns_send_confirm_description": "هل تريد إرسال {{name}} إلى {{count}} جهات اتصال محددة؟ سيتم تثبيت الجمهور المؤهل والقالب قبل بدء التسليم.",
  "campaigns_send_confirm_title": "إرسال الحملة الآن؟",
  "campaigns_send_error": "تعذر إرسال الحملة.",
  "campaigns_sending": "جارٍ الإرسال",
  "campaigns_sent": "تم الإرسال",
  "campaigns_status": "الحالة",
  "campaigns_status_cancelled": "ملغاة",
  "campaigns_status_completed": "مكتملة",
  "campaigns_status_delivered": "تم التسليم",
  "campaigns_status_draft": "مسودة",
  "campaigns_status_failed": "فشلت",
  "campaigns_status_queued": "في الانتظار",
  "campaigns_status_read": "تمت القراءة",
  "campaigns_status_replied": "تم الرد",
  "campaigns_activity": "النشاط",
  "campaigns_overview": "نظرة عامة",
  "campaigns_name_label": "الاسم",
  "campaigns_channel_label": "القناة",
  "campaigns_channel_whatsapp": "واتساب",
  "campaigns_row_actions": "إجراءات الحملة",
  "campaigns_replies_label": "الردود",
  "campaigns_sent_at": "تاريخ الإرسال",
  "campaigns_snapshot_unavailable": "اللقطة غير متاحة",
  "campaigns_distribution": "التوزيع",
  "campaigns_open": "فتح",
  "campaigns_recipients_count": "المستلمون ({{shown}} من {{total}})",
  "campaigns_media_image": "صورة",
  "campaigns_media_video": "فيديو",
  "campaigns_media_document": "مستند",
  "campaigns_status_sending": "جارٍ الإرسال",
  "campaigns_status_sent": "تم الإرسال",
  "campaigns_tab_campaigns": "الحملات",
  "campaigns_tab_campaigns_tooltip": "الرسائل الجماعية التي ترسلها إلى جمهور محدد",
  "campaigns_tab_email_templates": "قوالب البريد الإلكتروني",
  "campaigns_tab_email_templates_tooltip": "قوالب بريد إلكتروني قابلة لإعادة الاستخدام للتأكيدات والتذكيرات",
  "campaigns_tab_whatsapp_templates": "قوالب واتساب",
  "campaigns_tab_whatsapp_templates_tooltip": "قوالب الرسائل المعتمدة من ميتا التي ترسلها حملاتك وتذكيراتك",
  "campaigns_title": "الحملات",
  "campaigns_limit_remaining": "تبقّى {{count}} في نافذة الـ24 ساعة هذه.",
  "campaigns_limit_unlimited": "بلا حد",
  "campaigns_limit_unverified_hint": "تسمح هذه المحفظة حاليًا بمراسلة 250 مستلمًا فريدًا خلال 24 ساعة متحركة. تتحكم Meta في زيادة المستوى. يتوفر نحو {{count}} مستلم.",
  "campaigns_unavailable": "غير متاح",
  "campaigns_whatsapp_only_notice": "الحملات ترسل قوالب واتساب. إنستغرام وتيليجرام وX قنوات محادثة فقط ولا يمكن البث إليها.",
  "campaigns_unique_contacts_24h": "جهات اتصال فريدة خلال 24 ساعة",
  "campaigns_unnamed": "بلا اسم",
  "campaigns_unnamed_contact": "جهة اتصال بلا اسم",
  "campaigns_variable_mappings": "تعيينات المتغيرات (JSON حسب المكوّن)",
  "cfg_ai_audio_label": "الصوت",
  "cfg_ai_audio_matrix_tooltip": "يتحكم كل مفتاح بشكل مستقل في إمكانية استقبال هذا الوكيل للصوت أو إرساله.",
  "cfg_ai_audio_unsupported_tooltip": "النموذج المحدد لا يدعم إدخال الصوت.",
  "cfg_ai_images_label": "الصور",
  "cfg_ai_images_matrix_tooltip": "يتحكم كل مفتاح بشكل مستقل في إمكانية استقبال هذا الوكيل للصور أو إرسالها.",
  "cfg_ai_images_unsupported_tooltip": "النموذج المحدد لا يدعم إدخال الصور.",
  "cfg_ai_media_type_column": "نوع الوسائط",
  "cfg_ai_processing_assistant_title": "المساعد الذكي (جهات الاتصال)",
  "cfg_ai_processing_system_agent_title": "وكيل النظام (لوحة التحكم)",
  "cfg_ai_receive_direction": "استقبال",
  "cfg_ai_read_direction": "قراءة",
  "cfg_ai_send_direction": "إرسال",
  "cfg_ai_media_images": "الصور",
  "cfg_ai_media_audio": "الصوت والرسائل الصوتية",
  "cfg_ai_media_video": "الفيديو",
  "cfg_ai_media_pdf": "PDF",
  "cfg_ai_media_document": "المستندات والملفات",
  "cfg_ai_media_effective_policy": "تُعرض الصلاحية الفعلية بعد تطبيق حدود الخطة والنموذج.",
  "cfg_ai_media_effective_policy_tip": "لا يعمل المفتاح إلا إذا سمحت به خطة المؤسسة وإعداد المؤسسة معًا. وتتطلب القراءة أيضًا نموذجًا أو محللًا محليًا متوافقًا.",
  "cfg_ai_media_plan_disabled_reason": "هذا الإجراء غير متاح ضمن خطة المؤسسة الحالية.",
  "cfg_ai_media_runtime_unsupported_reason": "سيُحفظ هذا التفضيل، لكن النموذج المحدد أو المحلل المحلي لا يستطيع تنفيذه حاليًا.",
  "cfg_system_agent_process_audio_label": "السماح برفع الصوت",
  "cfg_system_agent_process_audio_tooltip": "عند الإيقاف، لا يمكن رفع الصوت أو معاينته أو تسجيله أو إرساله إلى وكيل النظام، حتى لو كان النموذج يدعم الصوت.",
  "cfg_system_agent_process_images_label": "السماح برفع الصور",
  "cfg_system_agent_process_images_tooltip": "عند الإيقاف، لا يمكن رفع الصور أو معاينتها أو إرسالها إلى وكيل النظام، حتى لو كان النموذج يدعم الصور.",
  "cfgpage_section_event_types_title": "الفعاليات",
  "chat_voice_recording_too_short": "التسجيل قصير جدًا. اضغط مطولاً على الزر وحاول مرة أخرى.",
  "command_palette_billing_spend_policy": "ضوابط إنفاق الذكاء الاصطناعي",
  "command_palette_nav_campaigns": "الحملات",
  "contact_beneficiary_demote": "نقل إلى جهة اتصال",
  "contact_beneficiary_demote_confirm": "نقل كمستفيد",
  "contact_beneficiary_demote_desc": "اختر جهة الاتصال التي ستدير {{name}} كمستفيد.",
  "contact_beneficiary_demote_warning_named": "سيفقد {{name}} رقم هاتفه وسجل رسائله وملخصات المحادثات المحفوظة ومحادثاته النشطة. سيتم الاحتفاظ بحجوزاته ومستنداته. لا يمكن التراجع عن ذلك.",
  "dashboard_event_statuses": "حالات المواعيد",
  "dashboard_event_statuses_description": "المواعيد حسب الحالة المُعدّة خلال هذه الفترة",
  "event_status_cancelled": "ملغي",
  "event_status_completed": "مكتمل",
  "event_status_config_add": "إضافة حالة",
  "event_status_config_color": "لون الحالة",
  "event_status_config_description": "اختر الحالات المتاحة من التقويم. تُحفظ التغييرات فورًا، ولا يمكن حذف مؤكد أو مكتمل أو لم يحضر.",
  "event_status_config_edit": "تعديل الحالة",
  "event_status_config_heading": "حالات المواعيد",
  "event_status_config_name": "اسم الحالة",
  "event_status_config_name_placeholder": "مثال: وصل",
  "event_status_config_protected": "لا يمكن حذف هذه الحالة الافتراضية",
  "event_status_config_remove": "حذف الحالة",
  "event_status_config_remove_failed": "تعذر حذف حالة الموعد",
  "event_status_config_removed": "تم حذف حالة الموعد.",
  "event_status_config_save_failed": "تعذر حفظ حالة الموعد",
  "event_status_config_saved": "تم حفظ حالة الموعد.",
  "event_status_config_update": "تحديث",
  "event_status_confirmed": "مؤكد",
  "event_status_error_already_cancelled": "هذا الحجز ملغي بالفعل.",
  "event_status_error_already_completed": "هذا الحجز مكتمل بالفعل.",
  "event_status_error_already_confirmed": "هذا الحجز مؤكد بالفعل.",
  "event_status_error_already_no_show": "تم تحديد هذا الحجز كحالة عدم حضور بالفعل.",
  "event_status_error_booking_horizon": "هذا الحجز خارج فترة الحجز المسموح بها.",
  "event_status_error_cannot_cancel": "لا يمكن إلغاء هذا الحجز في حالته الحالية.",
  "event_status_error_complete_cancelled": "لا يمكن تحديد الحجز الملغي كمكتمل.",
  "event_status_error_complete_no_show": "لا يمكن تحديد حجز لم يحضر صاحبه كمكتمل.",
  "event_status_error_conflict": "تم تغيير هذا الحجز من مكان آخر. حدّث الصفحة وحاول مرة أخرى.",
  "event_status_error_day_closed": "هذا اليوم مغلق ولا يقبل الحجوزات.",
  "event_status_error_generic": "تعذر تحديث حالة الحجز. حاول مرة أخرى.",
  "event_status_error_no_show_cancelled": "لا يمكن تحديد الحجز الملغي كحالة عدم حضور.",
  "event_status_error_no_show_completed": "لا يمكن تحديد الحجز المكتمل كحالة عدم حضور.",
  "event_status_error_not_cancelled": "لا يمكن تأكيد الحجز إلا إذا كان ملغياً.",
  "event_status_error_not_found": "تعذر العثور على هذا الحجز.",
  "event_status_error_not_slot_start": "لا تبدأ الحجوزات في هذا الوقت.",
  "event_status_error_phone_mismatch": "لدى جهة الاتصال هذه رقم هاتف مختلف بالفعل.",
  "event_status_error_phone_taken": "رقم الهاتف هذا مرتبط بجهة اتصال أخرى.",
  "event_status_error_reinstate_failed": "تعذر استعادة هذا الحجز.",
  "event_status_error_reinstate_slot_taken": "هذا الموعد محجوز، فلا يمكن استعادة الحجز إليه.",
  "event_status_error_reschedule_failed": "تعذر نقل هذا الحجز.",
  "event_status_error_schedule_failed": "تعذر إنشاء هذا الحجز.",
  "event_status_error_slot_full": "هذا الموعد ممتلئ بالكامل.",
  "event_status_error_slot_unavailable": "لم يعد هذا الموعد متاحاً.",
  "event_status_error_user_capacity": "بلغت جهة الاتصال الحد المسموح به للحجوزات.",
  "event_status_no_show": "لم يحضر",
  "event_status_picker_label": "تعيين حالة الحجز",
  "feat_org_balance_cap_fallback_default": "لا يمكننا الرد تلقائياً حالياً — سيتابع معك أحد أعضاء الفريق.",
  "feat_org_balance_spend_policy_behavior": "السلوك عند بلوغ الحد",
  "feat_org_balance_spend_policy_cap": "الحد الشهري (أرصدة، اتركه فارغاً بدون حد)",
  "feat_org_balance_spend_policy_degrade": "التحويل إلى النموذج الاحتياطي (حد مرن)",
  "feat_org_balance_spend_policy_description": "اضبط تنبيهات انخفاض الرصيد وميزانية شهرية للأرصدة المفوترة.",
  "feat_org_balance_spend_policy_hard_stop": "إيقاف ردود الذكاء الاصطناعي (قد يحدث تجاوز محدود)",
  "feat_org_balance_spend_policy_message": "رسالة العميل",
  "feat_org_balance_spend_policy_period_spend": "إنفاق الذكاء الاصطناعي للفترة الحالية",
  "feat_org_balance_spend_policy_reached": "تم بلوغ الحد",
  "feat_org_balance_spend_policy_save": "حفظ الضوابط",
  "feat_org_balance_spend_policy_soft_cap_note": "يتم الخصم بعد الإرسال، لذلك قد تتجاوز الردود المتزامنة حد الإيقاف قليلاً. وضع النموذج الاحتياطي حد مرن ويستمر معه الإنفاق.",
  "feat_org_balance_spend_policy_thresholds": "حدود تنبيه انخفاض الرصيد (%)",
  "feat_org_balance_spend_policy_title": "ضوابط إنفاق الذكاء الاصطناعي",
  "notif_org_balance_low_body": "رصيد مؤسستك للذكاء الاصطناعي على وشك النفاد.",
  "notif_org_balance_low_title": "رصيد منخفض",
  "notif_org_budget_cap_body": "تم بلوغ ميزانية أرصدة الذكاء الاصطناعي للفترة الحالية.",
  "notif_org_budget_cap_title": "تم بلوغ ميزانية أرصدة الذكاء الاصطناعي",
  "booking_requirements_description": "اختر بيانات جهة الاتصال التي يجب جمعها في جميع طرق إنشاء المواعيد. يجب تفعيل خيار واحد على الأقل.",
  "booking_requirements_title": "متطلبات جهة اتصال الحجز",
  "booking_require_name_label": "طلب اسم جهة الاتصال",
  "booking_require_name_tooltip": "يمنع إنشاء الموعد حتى يتوفر اسم لجهة الاتصال.",
  "booking_require_phone_label": "طلب رقم هاتف",
  "booking_require_phone_tooltip": "يمنع إنشاء الموعد حتى يتوفر رقم هاتف منسق وفق الدولة المحددة.",
  "waitlist_active_entries": "طلبات نشطة",
  "waitlist_active_holds": "حجوزات مؤقتة",
  "waitlist_claims_week": "مطالبات هذا الأسبوع",
  "waitlist_config_description": "اعرض المواعيد المتاحة بعدل واحجزها مؤقتًا حتى يؤكد العميل.",
  "waitlist_contact": "جهة الاتصال",
  "waitlist_description": "تابع العملاء المنتظرين وعروض المواعيد والحجوزات المؤقتة والمطالبات الناجحة.",
  "waitlist_desired_time": "الوقت المطلوب",
  "waitlist_empty": "لا توجد طلبات انتظار تطابق عوامل التصفية.",
  "waitlist_enable": "تفعيل قائمة الانتظار",
  "waitlist_enable_first": "فعّل قائمة الانتظار أولًا.",
  "waitlist_event_type": "نوع الموعد",
  "waitlist_eyebrow": "الحجوزات",
  "waitlist_joined": "تاريخ الانضمام",
  "waitlist_nav_label": "قائمة الانتظار",
  "waitlist_offer_batch_size": "عدد العملاء في كل جولة",
  "waitlist_offers": "العروض",
  "waitlist_open_offers": "عروض مفتوحة",
  "waitlist_position": "الترتيب",
  "waitlist_status": "الحالة",
  "waitlist_title": "قائمة الانتظار",
  "waitlist_ttl_minutes": "انتهاء العرض (بالدقائق)",
  "whatsapp_templates_add_button": "إضافة زر",
  "whatsapp_templates_body": "نص الرسالة",
  "whatsapp_templates_builder_description": "أنشئ قالبًا لاعتماد Meta مع أمثلة لكل متغير.",
  "whatsapp_templates_builder_title": "إنشاء قالب واتساب",
  "whatsapp_templates_button_phone": "رقم الهاتف",
  "whatsapp_templates_button_text": "نص الزر",
  "whatsapp_templates_button_type": "نوع الزر",
  "whatsapp_templates_button_url": "رابط الموقع",
  "whatsapp_templates_buttons": "الأزرار",
  "whatsapp_templates_category": "الفئة",
  "whatsapp_templates_category_plan_hint": "تشمل خطتك قوالب الخدمات (المعاملات) فقط. لا تشمل القوالب التسويقية وقوالب المصادقة لأن Meta تحاسب على كل رسالة منها.",
  "whatsapp_templates_not_covered_badge": "غير مشمول في الخطة",
  "whatsapp_templates_not_covered_reason": "صنّفت Meta هذا القالب كقالب تسويقي أو مصادقة، وهذا غير مشمول في خطتك، لذا لا يمكن إرساله. عدّله ليكون خاصًا بالمعاملات فقط ثم أعد إرساله للمراجعة.",
  "whatsapp_templates_count": "{count} قوالب",
  "whatsapp_templates_create": "إنشاء قالب",
  "whatsapp_templates_create_error": "تعذر إنشاء القالب.",
  "whatsapp_templates_create_success": "تم إرسال القالب إلى Meta.",
  "whatsapp_templates_delete_confirm": "هل تريد حذف قالب واتساب هذا؟",
  "whatsapp_templates_delete_error": "تعذر حذف القالب.",
  "whatsapp_templates_delete_success": "تم حذف القالب.",
  "whatsapp_templates_description": "قوالب الرسائل المسجلة لدى ميتا. لا تستطيع الحملات والتذكيرات إرسال إلا قالبًا وافقت عليه ميتا.",
  "whatsapp_templates_edit": "تعديل",
  "whatsapp_templates_edit_error": "تعذر تعديل القالب.",
  "whatsapp_templates_edit_success": "تم إرسال تعديلات القالب إلى Meta.",
  "whatsapp_templates_edit_title": "تعديل قالب واتساب",
  "whatsapp_templates_empty": "لا توجد قوالب واتساب بعد.",
  "whatsapp_templates_examples": "أمثلة المتغيرات",
  "whatsapp_templates_footer": "التذييل",
  "whatsapp_templates_header": "الرأس",
  "whatsapp_templates_header_none": "بدون رأس",
  "whatsapp_templates_header_text": "رأس نصي",
  "whatsapp_templates_inline_create": "إنشاء قالب جديد",
  "whatsapp_templates_language": "اللغة",
  "whatsapp_templates_media_unsupported": "يجب إدارة رؤوس الوسائط في Meta لأنها تتطلب معرّف وسائط مرفوعًا.",
  "whatsapp_templates_name": "اسم القالب",
  "whatsapp_templates_not_configured": "اربط حساب واتساب للأعمال لإدارة القوالب.",
  "whatsapp_templates_parameters": "تنسيق المتغيرات",
  "whatsapp_templates_permission_missing": "لا يمكن لحساب Meta المتصل إدارة القوالب.",
  "whatsapp_templates_preview": "ستظهر معاينة الرسالة هنا.",
  "whatsapp_templates_remove_button": "إزالة الزر",
  "whatsapp_templates_save": "حفظ التعديلات",
  "whatsapp_templates_stale": "يتم عرض آخر بيانات قوالب تمت مزامنتها.",
  "whatsapp_templates_submit": "إرسال إلى Meta",
  "whatsapp_templates_title": "قوالب واتساب",
  "setup_wizard_title": "أهلاً بك! لنجهز مساعدك الذكي",
  "setup_wizard_subtitle": "خطوات قليلة وسريعة ويصبح مساعدك جاهزاً للتحدث مع عملائك.",
  "setup_step_business_title": "نشاطك التجاري",
  "setup_step_business_description": "عرّفنا بنشاطك — سيقدم المساعد نشاطك بهذا الاسم.",
  "setup_step_ai_title": "المساعد الذكي",
  "setup_step_ai_description": "اختر نموذج الذكاء الاصطناعي وطريقة تصرف مساعدك. اختر قالباً جاهزاً — لا حاجة للكتابة.",
  "setup_step_schedule_title": "ساعات العمل",
  "setup_step_schedule_description": "حدد المنطقة الزمنية وأيام العمل لتأتي الحجوزات في مواعيدها الصحيحة.",
  "setup_step_whatsapp_title": "المراسلة",
  "setup_step_whatsapp_description": "اربط واتساب أو تيليجرام أو إنستغرام أو أي مجموعة منها.",
  "setup_step_messaging_title": "ربط قناة المراسلة",
  "setup_step_messaging_description": "اربط قناة واحدة على الأقل للعملاء: واتساب أو تيليجرام أو إنستغرام أو X.",
  "setup_step_finish_title": "النهاية",
  "setup_step_finish_description": "كل شيء جاهز؟ تفضل بالدخول.",
  "setup_business_name_label": "اسم النشاط التجاري",
  "setup_business_name_placeholder": "مثال: عيادة سلمى للأسنان",
  "setup_business_name_hint": "يمكنك إضافة العنوان وبقية التفاصيل لاحقاً من الإعدادات.",
  "setup_test_in_playground": "جرّب مساعدك في ساحة التجربة",
  "setup_whatsapp_connected": "تم ربط قناة مراسلة العملاء. يمكن لعملائك مراسلتك وسيرد المساعد عليهم.",
  "setup_whatsapp_waiting": "اربط واتساب أو تيليجرام أو إنستغرام للمتابعة — تتحقق هذه الصفحة تلقائياً.",
  "setup_whatsapp_refresh": "تحقق مجدداً",
  "setup_messaging_connected": "تم ربط قناة المراسلة. يمكن للعملاء مراسلتك عبر واتساب أو تيليجرام أو إنستغرام أو X وسيرد المساعد على القناة نفسها.",
  "setup_messaging_waiting": "اربط واتساب أو تيليجرام أو إنستغرام أو X للمتابعة. تتحقق هذه الصفحة تلقائياً بعد حفظ بيانات اعتماد المؤسسة.",
  "setup_messaging_refresh": "تحقق مجدداً",
  "setup_back": "رجوع",
  "setup_continue": "متابعة",
  "setup_enter_app": "إنهاء ودخول",
  "setup_finished_toast": "اكتمل الإعداد — أهلاً بك!",
  "setup_finish_requirements_error": "هناك خطوة لم تكتمل بعد. يرجى مراجعة الخطوات المميّزة.",
  "setup_awaiting_admin_title": "اقتربنا",
  "setup_awaiting_admin_description": "ما زال مديرك يجهز مساحة العمل. ستحصل على الوصول فور انتهائه.",
  "setup_prompt_picker_label": "شخصية المساعد",
  "setup_prompt_picker_placeholder": "اختر نقطة بداية…",
  "setup_prompt_picker_templates_group": "قوالب جاهزة",
  "setup_prompt_picker_presets_group": "إعداداتك المحفوظة",
  "setup_prompt_picker_custom": "تعليمات مخصصة",
  "setup_prompt_instructions_label": "التعليمات",
  "setup_prompt_save_as_preset": "حفظ كإعداد محفوظ",
  "setup_prompt_preset_name_placeholder": "اسم الإعداد",
  "setup_prompt_preset_added": "تمت الإضافة — ستُحفظ مع إعداداتك.",
  "setup_prompt_preset_too_long": "هذه التعليمات أطول من أن تُحفظ كإعداد محفوظ (20٬000 حرف كحد أقصى).",
  "setup_prompt_preset_limit_reached": "لقد بلغت الحد الأقصى وهو 50 إعدادًا محفوظًا. احذف واحدًا لإضافة غيره.",
  "setup_prompt_template_support_name": "دعم العملاء",
  "setup_prompt_template_support_description": "يجيب عن الأسئلة ويحل المشكلات",
  "setup_prompt_template_sales_name": "مساعد المبيعات",
  "setup_prompt_template_sales_description": "يعرض خدماتك ويلتقط العملاء المهتمين",
  "setup_prompt_template_booking_name": "مساعد الحجوزات",
  "setup_prompt_template_booking_description": "يحجز المواعيد ويديرها",
  "setup_prompt_template_general_name": "مساعد عام",
  "setup_prompt_template_general_description": "مساعد ودود لكل المهام",
  "settings_editor_minimal_mode": "الوضع البسيط",
  "settings_editor_minimal_mode_desc": "إخفاء عناصر التحكم المتقدمة للتنسيق (التعبئة، الشرطة، منتقي الألوان) في شريط أدوات المحرر",
  "settings_editor_minimal_enabled": "تم تفعيل الوضع البسيط",
  "settings_editor_minimal_disabled": "تم تعطيل الوضع البسيط",
  "admin_b_ai_preset_limit_label": "حد إعدادات وكيل الذكاء الاصطناعي",
  "admin_b_custom_tool_limit_label": "حد الإجراءات المخصصة",
  "feat_billing_usage_presets_deleted": "إعداد مسبق محذوف",
  "feat_billing_usage_presets_description": "تفصيل تقريري لكل إعداد لمساعد الذكاء الاصطناعي.",
  "feat_billing_usage_presets_column_preset": "الإعداد المسبق",
  "feat_billing_usage_presets_title": "الاستخدام حسب إعداد الوكيل",
  "feat_billing_usage_presets_unattributed": "استخدام سابق",
  "config": {
    "aiAssistant": {
      "qaPairs": {
        "title": "أسئلة وأجوبة منسّقة",
        "description": "أنشئ أزواج أسئلة وأجوبة يرد بها المساعد حرفيًا.",
        "counter": "{{count}} زوج · {{used}} / {{cap}}",
        "addButton": "إضافة سؤال وجواب",
        "importButton": "استيراد .xlsx",
        "empty": "لا توجد أزواج أسئلة وأجوبة بعد. أضف واحدًا للإجابة عن الأسئلة الشائعة فورًا.",
        "loadError": "تعذّر تحميل أزواج الأسئلة والأجوبة.",
        "selectAllAria": "تحديد كل أزواج الأسئلة والأجوبة",
        "bulk": {
          "selected": "{{count}} محدد",
          "clear": "مسح",
          "delete": "حذف المحدد"
        },
        "status": {
          "pending": "في قائمة الانتظار",
          "processing": "قيد المعالجة",
          "completed": "نشط",
          "failed": "فشل"
        },
        "row": {
          "selectAria": "تحديد زوج السؤال والجواب",
          "enabledAria": "حالة تفعيل زوج السؤال والجواب",
          "timesAsked": "سُئل {{count}}×",
          "neverAsked": "لم يُسأل بعد",
          "actionsAria": "إجراءات السؤال والجواب",
          "edit": "تعديل",
          "stats": "إحصاءات الاستخدام",
          "delete": "حذف"
        },
        "delete": {
          "title": "حذف زوج السؤال والجواب؟",
          "description": "ستتم إزالة \"{{title}}\" من قاعدة معرفتك. لا يمكن التراجع عن هذا.",
          "confirm": "حذف"
        },
        "deleteMany": {
          "title": "حذف {{count}} من أزواج الأسئلة والأجوبة؟",
          "description": "ستتم إزالة أزواج الأسئلة والأجوبة المحددة نهائيًا. لا يمكن التراجع عن هذا."
        },
        "editor": {
          "createTitle": "إضافة سؤال وجواب",
          "editTitle": "تعديل السؤال والجواب",
          "description": "امنح المساعد مجموعة من الأسئلة وإجابة حرفية واحدة.",
          "titleLabel": "العنوان",
          "titlePlaceholder": "مثال: سياسة الاسترداد",
          "titleRequired": "العنوان مطلوب",
          "questionsLabel": "صيغ السؤال",
          "questionsMax": "حتى {{max}} صيغة",
          "questionsHint": "أضف كل صيغة يستخدمها عملاؤك، بكل لغة.",
          "questionAria": "صيغة السؤال {{index}}",
          "questionPlaceholder": "كيف أطلب استردادًا؟",
          "removeQuestionAria": "إزالة السؤال",
          "questionRequired": "أضف سؤالًا واحدًا على الأقل",
          "addQuestion": "إضافة سؤال",
          "answerLabel": "الإجابة",
          "answerDescription": "تُرسل حرفيًا عند مطابقة أحد الأسئلة.",
          "answerPlaceholder": "اكتب الرد الدقيق الذي يجب أن يرسله المساعد…",
          "answerRequired": "الإجابة مطلوبة",
          "answerTooLarge": "الإجابة كبيرة جدًا",
          "counter": "{{chars}} / {{max}} حرف · {{bytes}} بايت",
          "save": "حفظ",
          "cancel": "إلغاء"
        },
        "stats": {
          "title": "الاستخدام",
          "timesAsked": "عدد مرات السؤال",
          "lastAsked": "آخر سؤال",
          "created": "تاريخ الإنشاء",
          "never": "أبدًا",
          "last90Days": "آخر 90 يومًا",
          "noActivity": "لا يوجد نشاط بعد"
        },
        "toast": {
          "created": "تمت إضافة زوج السؤال والجواب.",
          "updated": "تم تحديث زوج السؤال والجواب.",
          "deleted": "تم حذف زوج السؤال والجواب.",
          "deletedMany": "تم حذف {{count}} من أزواج الأسئلة والأجوبة.",
          "imported": "تم استيراد {{created}} زوج أسئلة وأجوبة ({{skipped}} تم تخطيها).",
          "importedNoSkip": "تم استيراد {{created}} زوج أسئلة وأجوبة.",
          "createFailed": "تعذّر إنشاء زوج السؤال والجواب.",
          "updateFailed": "تعذّر تحديث زوج السؤال والجواب.",
          "deleteFailed": "تعذّر حذف زوج السؤال والجواب.",
          "importFailed": "تعذّر استيراد أزواج الأسئلة والأجوبة."
        }
      },
      "autoRefresh": {
        "label": "التحديث التلقائي",
        "description": "إبقاء مصادر الويب المرتبطة محدثة وفق جدول.",
        "cadenceLabel": "وتيرة التحديث",
        "daily": "يوميًا",
        "weekly": "أسبوعيًا",
        "helper": "تُعاد فهرسة مصادر الروابط وفق الجدول؛ أما الملفات والأسئلة والأجوبة فتكون فعّالة فورًا دائمًا.",
        "refreshNow": "تحديث الآن",
        "refreshedToast": "بدأ التحديث — تم إدراج {{count}} مهمة",
        "failedToast": "تعذّر بدء التحديث"
      }
    },
    "aiPresets": {
      "active": "نشط",
      "modelAuto": "اختيار النموذج تلقائياً",
      "fields": {
        "name": "اسم الإعداد",
        "description": "الوصف (اختياري)",
        "id": "معرّف الإعداد",
        "createdAt": "تاريخ الإنشاء",
        "updatedAt": "آخر تحديث"
      },
      "actions": {
        "cancel": "إلغاء",
        "create": "إنشاء الإعداد",
        "save": "حفظ التغييرات",
        "activate": "تفعيل",
        "edit": "تعديل…",
        "editActive": "تعديل في تبويب مساعد الذكاء الاصطناعي",
        "test": "اختبار في ساحة التجربة",
        "duplicate": "تكرار",
        "delete": "حذف",
        "new": "إعداد جديد…",
        "manage": "إدارة الإعدادات…"
      },
      "switcher": {
        "label": "إعداد الوكيل النشط",
        "switched": "تم التبديل إلى '{{name}}'"
      },
      "create": {
        "title": "إنشاء إعداد وكيل",
        "description": "أنشئ مسودة إعدادات من دون تغيير المساعد المباشر.",
        "startFrom": "البدء من",
        "current": "الإعداد الحالي",
        "blank": "إعداد فارغ",
        "duplicate": "نسخة من إعداد موجود",
        "template": "قالب البداية",
        "success": "تم إنشاء الإعداد",
        "switch": "التبديل إليه"
      },
      "edit": {
        "title": "تعديل إعداد الوكيل",
        "description": "لا تؤثر تغييرات الإعداد غير النشط في المحادثات المباشرة.",
        "prompt": "موجه النظام",
        "promptDescription": "التعليمات التي يستخدمها هذا الإعداد.",
        "tools": "الأدوات",
        "success": "تم تحديث الإعداد"
      },
      "manage": {
        "title": "إدارة إعدادات الوكيل",
        "description": "عدّل الإعدادات أو اختبرها أو كررها أو فعّلها أو احذفها.",
        "duplicated": "تم تكرار الإعداد",
        "deleted": "تم حذف الإعداد",
        "deleteTitle": "حذف الإعداد؟",
        "deleteDescription": "هل تريد حذف '{{name}}'؟ سيُحذف أيضاً سجل الموجه واختيار المستندات لهذا الإعداد."
      },
      "dirty": {
        "title": "تغييرات غير محفوظة في المساعد",
        "description": "هل تريد حفظ التغييرات في '{{name}}' قبل التبديل؟",
        "save": "حفظ وتبديل",
        "discard": "تجاهل وتبديل"
      },
      "quota": {
        "meter": "{{used}} من {{limit}} إعدادات",
        "unlimited": "{{used}} إعدادات · بلا حد",
        "reached": "تم بلوغ حد الإعدادات — {{used}} من {{limit}}"
      },
      "rag": {
        "scope": "المستندات المستخدمة في هذا الإعداد",
        "scopeDescription": "يبقى مفتاح التفعيل العام مفتاح الإيقاف على مستوى المؤسسة.",
        "all": "كل المستندات",
        "selected": "مستندات محددة",
        "allSummary": "كل المستندات",
        "selectedSummary": "مستندات محددة",
        "disabledGlobally": "معطّل لكل الإعدادات",
        "selectDocument": "تضمين {{name}} في هذا الإعداد",
        "saved": "تم تحديث صلاحية الوصول إلى المستندات",
        "failed": "تعذر تحديث صلاحية الوصول إلى المستندات."
      },
      "templates": {
        "none": {
          "name": "بلا قالب",
          "description": "ابدأ بموجه فارغ."
        },
        "support": {
          "name": "الدعم",
          "description": "دعم العملاء وحل المشكلات."
        },
        "sales": {
          "name": "المبيعات",
          "description": "تأهيل العملاء المحتملين وإرشادهم."
        },
        "booking": {
          "name": "الحجوزات",
          "description": "اكتشاف المواعيد وجدولتها."
        }
      },
      "errors": {
        "nameConflict": "يوجد إعداد بهذا الاسم بالفعل.",
        "quota": "تم بلوغ حد الإعدادات المسموح به في خطتك.",
        "deleteActive": "بدّل إلى إعداد آخر قبل حذف هذا الإعداد.",
        "generic": "تعذر تحديث الإعداد."
      },
      "playground": {
        "testing": "اختبار الإعداد '{{name}}'",
        "switch": "التبديل إلى هذا الإعداد",
        "ragLimitation": "يستخدم الاسترجاع في ساحة التجربة حالياً نطاق مستندات الإعداد النشط."
      },
      "channels": {
        "all": "كل القنوات",
        "allDescription": "الإعداد الذي تستخدمه كل قناة ما لم يكن لها إعداد خاص.",
        "railLabel": "اختر القناة التي تريد ضبطها",
        "override": "إعداد مخصص",
        "inherits": "يتبع الإعداد الافتراضي",
        "inheritOption": "اتباع الإعداد الافتراضي ({{name}})",
        "pick": "إعداد قناة {{channel}}",
        "pickDescription": "تستخدم الردود على {{channel}} هذا الإعداد — تعليماته ونموذجه وأدواته ومساره.",
        "bound": "أصبحت {{channel}} تستخدم '{{name}}'",
        "cleared": "عادت {{channel}} إلى الإعداد الافتراضي",
        "notConnected": "غير متصلة بعد — يمكنك اختيار إعداد الآن.",
        "pipelineSingle": "وكيل واحد",
        "pipelineResearcher": "إجابات مدعومة بالبحث",
        "pipelineVerifier": "إجابات مبحوثة ومُتحقَّق منها",
        "usedBy": "تستخدمه {{channels}}",
        "deleteWarning": "ستعود {{channels}} إلى الإعداد الافتراضي."
      }
    }
  },
  "ragDocuments": {
    "replace": {
      "action": "استبدال",
      "tooltip": "استبدال هذا الملف",
      "failedToast": "تعذّر استبدال المستند",
      "startedToast": "بدأ استبدال المستند.",
      "duplicateTitle": "موجود بالفعل في قاعدة المعرفة",
      "duplicateToast": "‏«{{filename}}» مطابق لمستند لديك بالفعل — إعادة الرفع لن تُحدّثه. استخدم الاستبدال لتحديث المستند.",
      "duplicateCta": "استبدال بدلاً من ذلك"
    },
    "summary": {
      "timesRetrieved": "مرات الاسترجاع",
      "retrievalCount": "{{count}} استرجاع",
      "lastUsed": "استُخدم {{time}}",
      "lastRetrieved": "آخر استرجاع",
      "notUsedYet": "لم يُستخدم بعد",
      "never": "أبدًا",
      "created": "أُضيف",
      "statsAction": "إحصاءات الاستخدام",
      "statsTitle": "استخدام المستند",
      "last90Days": "آخر ٩٠ يومًا",
      "files": "الملفات",
      "urls": "صفحات الويب",
      "qaPairs": "الأسئلة والأجوبة",
      "needsRefresh": "بحاجة إلى تحديث",
      "lastRefreshed": "آخر تحديث {{time}}"
    }
  },
  "field_status": "الحالة",
  "chat_tool_chart_title": "الرسم البياني",
  "chat_tool_chart_invalid": "تعذر عرض هذا الرسم البياني. تظهر القيم الخام أدناه.",
  "chat_tool_chart_show_table": "عرض جدول البيانات المتاح",
  "chat_tool_analytics_title": "التحليلات",
  "chat_tool_insights_title": "تقرير الرؤى",
  "chat_tool_insight_label": "رؤية",
  "chat_tool_knowledge_title": "المعرفة",
  "chat_tool_conversations_title": "المحادثات",
  "chat_tool_contact_title": "لقطة جهة الاتصال",
  "chat_tool_open_contact": "فتح جهات الاتصال",
  "chat_tool_automations_title": "الأتمتة",
  "chat_tool_status_title": "حالة الاتصال",
  "chat_tool_connect": "إدارة الاتصالات",
  "chat_tool_contact_change_preview": "معاينة تغيير جهة الاتصال",
  "chat_tool_contact_source": "جهة الاتصال المصدر",
  "chat_tool_contact_target": "جهة الاتصال الهدف",
  "chat_tool_contact_records_affected": "السجلات المتأثرة",
  "chat_tool_contact_delete_warning": "سيتم حذف جهة الاتصال مبدئيًا بعد الموافقة.",
  "chat_staged_upload_too_large": "يجب ألا يتجاوز حجم ملف المعرفة 50 ميغابايت.",
  "chat_staged_upload_too_many": "يمكنك تجهيز 5 ملفات كحد أقصى لكل رسالة.",
  "chat_daily_quota_reached": "تم بلوغ الحد اليومي لوكيل النظام.",
  "chat_daily_quota_limit": "الحد اليومي",
  "chat_daily_quota_resets": "إعادة الضبط في",
  "chat_daily_quota_upgrade": "مراجعة الخطة والاستخدام",
  "cfg_tool_approval_locked_contact_delete": "يتطلب حذف جهة الاتصال الموافقة دائمًا؛ ويظل المفتاح متحكمًا في التحديثات.",
  "cfg_tool_approval_locked_beneficiary_merge": "يتطلب دمج المستفيدين الموافقة دائمًا؛ ويظل المفتاح متحكمًا في الفصل.",
  "contact_identity_section": "هوية جهة الاتصال",
  "contact_link_action": "ربط",
  "contact_link_title": "ربط هوية جهة الاتصال",
  "contact_link_description": "اربط جهة الاتصال بجهة أساسية دون حذف أي سجل.",
  "contact_link_confirm": "ربط جهة الاتصال",
  "contact_link_success": "تم ربط جهة الاتصال.",
  "contact_link_failed": "تعذر ربط جهة الاتصال.",
  "contact_unlink_action": "إلغاء الربط",
  "contact_unlink_title": "إلغاء ربط الهوية",
  "contact_unlink_description": "افصل جهة الاتصال عن الجهة الأساسية مع الاحتفاظ بالسجل.",
  "contact_unlink_confirm": "إلغاء الربط",
  "contact_unlink_success": "تم إلغاء الربط.",
  "contact_unlink_failed": "تعذر إلغاء الربط.",
  "contact_merge_duplicate_action": "دمج جهة مكررة",
  "contact_merge_duplicate_hint": "دمج جهات الاتصال المكررة",
  "contact_merge_title": "دمج جهة اتصال مكررة",
  "contact_merge_description": "ادمج الجهة المكررة نهائيًا في الجهة الباقية. لا يمكن التراجع عن ذلك.",
  "contact_merge_direction_title": "اختر جهة الاتصال الباقية",
  "contact_merge_direction_hint": "تبقى الجهة الأحدث نشاطًا افتراضيًا.",
  "contact_merge_swap_direction": "عكس الاتجاه",
  "contact_merge_preview_loading": "جارٍ إعداد معاينة موثوقة…",
  "contact_merge_preview_failed": "تعذر تحميل معاينة الدمج. لم يتغير شيء.",
  "contact_merge_preview_title": "معاينة الدمج",
  "contact_merge_target_label": "جهة الاتصال المكررة",
  "contact_merge_target_search": "البحث في جهات الاتصال",
  "contact_merge_role_source": "جهة الاتصال المحددة",
  "contact_merge_role_loser": "سيتم دمجها",
  "contact_merge_role_winner": "ستبقى",
  "contact_merge_created": "تاريخ الإنشاء",
  "contact_merge_last_activity": "آخر نشاط",
  "contact_merge_bookings": "الحجوزات",
  "contact_merge_confirm": "دمج نهائي",
  "contact_identity_action_pending": "جارٍ التنفيذ…",
  "contact_merge_count_events": "الفعاليات",
  "contact_merge_count_conversations": "المحادثات",
  "contact_merge_count_messages": "الرسائل",
  "contact_merge_count_beneficiaries": "المستفيدون",
  "contact_merge_count_summaries": "الملخصات",
  "contact_merge_count_capturedLeads": "العملاء المحتملون",
  "contact_merge_count_feedbacks": "التقييمات",
  "contact_merge_count_identifiers": "المعرّفات",
  "contact_merge_count_waitlistEntries": "قائمة الانتظار",
  "contact_merge_count_slotOfferCandidates": "عروض المواعيد",
  "contact_merge_fields_title": "حقول جهة الاتصال النهائية",
  "contact_merge_field": "الحقل",
  "contact_merge_winner_value": "الجهة الباقية",
  "contact_merge_loser_value": "الجهة المكررة",
  "contact_merge_resolved_value": "النتيجة",
  "contact_merge_field_name": "الاسم",
  "contact_merge_field_nickname": "الاسم المستعار",
  "contact_merge_field_phoneE164": "الهاتف",
  "contact_merge_field_channel": "القناة",
  "contact_merge_field_countryCode": "الدولة",
  "contact_merge_field_isActive": "نشط",
  "contact_merge_identifiers_title": "المعرّفات",
  "contact_merge_primary_identifier": "المعرّف الأساسي: {{value}}",
  "contact_merge_primary_badge": "أساسي",
  "contact_merge_retired_badge": "متقاعد",
  "contact_merge_retained_badge": "محتفظ به",
  "contact_merge_threads_title": "سلاسل المحادثات",
  "contact_merge_thread_messages": "{{count}} رسالة",
  "contact_merge_thread_read_only": "محفوظ كسجل للقراءة فقط",
  "contact_merge_thread_retained": "محفوظ على جهة الاتصال الباقية",
  "contact_merge_warnings_title": "راجع التحذيرات",
  "contact_merge_warning_blocked": "حالة الحظر مختلفة بين الجهتين.",
  "contact_merge_warning_legacy_cluster": "الجهة المكررة مرتبطة مسبقًا بمجموعة هوية قديمة.",
  "contact_merge_warning_beneficiary": "تعارض اسم مستفيد: {{name}}",
  "contact_merge_warning_event": "تعارض وقت فعالية: {{at}}",
  "CONTACT_MERGE_SELF": "لا يمكن دمج جهة الاتصال في نفسها.",
  "CONTACT_NOT_FOUND": "إحدى جهتي الاتصال لم تعد موجودة.",
  "CONTACT_MERGE_TOMBSTONE": "تم دمج جهة الاتصال هذه نهائيًا من قبل.",
  "CONTACT_MERGE_IS_BENEFICIARY": "لا يمكن دمج المستفيد كجهة اتصال.",
  "CONTACT_MERGE_WINNER_NOT_ROOT": "اختر جهة الاتصال الأساسية لتكون الجهة الباقية.",
  "CONTACT_MERGE_DOCUMENT_INVALID": "يوجد مستند مرتبط يمنع هذا الدمج.",
  "CONTACT_UNMERGE_HARD_MERGED": "لا يمكن إلغاء ربط دمج نهائي.",
  "contact_merge_success": "تم دمج جهتي الاتصال بنجاح.",
  "contact_history_event_merged_in": "تم دمج جهة مكررة",
  "contact_history_event_merged_away": "تم دمجها في جهة أخرى",
  "contact_history_merge_non_revertible": "دمج نهائي",
  "ui_b_filters_add": "إضافة فلتر",
  "ui_b_filters_clear_all": "مسح الكل",
  "ui_b_filters_max": "الأقصى",
  "ui_b_filters_min": "الأدنى",
  "ui_b_filters_no_values": "لا نتائج.",
  "ui_b_filters_op_after": "بعد",
  "ui_b_filters_op_before": "قبل",
  "ui_b_filters_op_between": "بين",
  "ui_b_filters_op_contains": "يحتوي على",
  "ui_b_filters_op_ends_with": "ينتهي بـ",
  "ui_b_filters_op_eq": "=",
  "ui_b_filters_op_gt": ">",
  "ui_b_filters_op_includes_all": "يشمل الكل",
  "ui_b_filters_op_is": "هو",
  "ui_b_filters_op_is_any_of": "أي من",
  "ui_b_filters_op_is_empty": "فارغ",
  "ui_b_filters_op_is_not": "ليس",
  "ui_b_filters_op_is_not_any_of": "ليس أياً من",
  "ui_b_filters_op_is_not_empty": "غير فارغ",
  "ui_b_filters_op_lt": "<",
  "ui_b_filters_op_neq": "≠",
  "ui_b_filters_op_not_contains": "لا يحتوي على",
  "ui_b_filters_op_starts_with": "يبدأ بـ",
  "ui_b_filters_operator": "معامل {{label}}",
  "ui_b_filters_remove": "إزالة فلتر {{label}}",
  "ui_b_filters_search_values": "بحث…",
  "ui_b_filters_select_placeholder": "اختر…",
  "ui_b_filters_value": "قيمة {{label}}",
  "member_filter_last_sign_in": "تاريخ آخر تسجيل دخول",
  "sync_conflict_matrix_property": "الخاصية",
  "sync_conflict_matrix_version": "الإصدار",
  "sync_conflict_matrix_date": "تاريخ التعديل",
  "sync_conflict_matrix_time": "وقت التعديل",
  "sync_conflict_matrix_size": "حجم JSON",
  "sync_conflict_matrix_pages": "الصفحات",
  "sync_conflict_local_version": "الإصدار {{version}} + تعديلات محلية",
  "sync_conflict_unversioned_local": "تعديلات محلية بلا إصدار",
  "sync_conflict_differences_title": "مواضع الاختلاف بين النسختين",
  "sync_conflict_page_column": "الصفحة",
  "sync_conflict_status_column": "الحالة",
  "sync_conflict_items_column": "العناصر (الجهاز / الخادم)",
  "sync_conflict_status_conflicted": "تعديلات متعارضة",
  "sync_conflict_status_changed": "مختلفة",
  "sync_conflict_status_unchanged": "متطابقة",
  "sync_conflict_status_local_only": "على هذا الجهاز فقط",
  "sync_conflict_status_server_only": "على الخادم فقط",
  "sync_conflict_untitled_page": "صفحة بلا عنوان",
  "sync_conflict_document_bucket": "عناصر على مستوى المستند",
  "sync_conflict_conflicting_items": "عناصر متعارضة: {{count}}",
  "sync_conflict_show_page": "عرض هذه الصفحة في كلتا المعاينتين",
  "sync_preview_page_count": "الصفحة {{current}} من {{total}}",
  "leads_fields_saved_toast": "تم حفظ حقول العملاء المحتملين.",
  "leads_fields_save_failed": "تعذر حفظ حقول العملاء المحتملين.",
  "leads_updated_toast": "تم تحديث العميل المحتمل.",
  "leads_update_failed": "تعذر تحديث العميل المحتمل.",
  "leads_moved_to_trash_toast": "تم نقل العميل المحتمل إلى سلة المحذوفات.",
  "leads_delete_failed": "تعذر نقل العميل المحتمل إلى سلة المحذوفات.",
  "leads_restored_toast": "تمت استعادة العميل المحتمل.",
  "leads_restore_failed": "تعذرت استعادة العميل المحتمل.",
  "leads_deleted_permanently_toast": "تم حذف العميل المحتمل نهائيًا.",
  "leads_hard_delete_failed": "تعذر حذف العميل المحتمل نهائيًا.",
  "toast_vacation_update_failed": "تعذر تحديث فترات الإجازة.",
  "toast_vacation_period_deleted": "تم حذف فترة الإجازة.",
  "toast_vacation_delete_failed": "تعذر حذف فترة الإجازة.",
  "toast_vacation_template_created": "تم إنشاء قالب الإجازة.",
  "toast_vacation_template_updated": "تم تحديث قالب الإجازة.",
  "toast_vacation_template_deleted": "تم حذف قالب الإجازة.",
  "toast_vacation_template_create_failed": "تعذر إنشاء قالب الإجازة.",
  "toast_vacation_template_update_failed": "تعذر تحديث قالب الإجازة.",
  "toast_vacation_template_delete_failed": "تعذر حذف قالب الإجازة.",
  "waitlist_join_success": "تمت إضافة العميل إلى قائمة الانتظار.",
  "waitlist_join_failed": "تعذرت إضافة العميل إلى قائمة الانتظار.",
  "waitlist_cancel_success": "تم إلغاء إدخال قائمة الانتظار.",
  "waitlist_cancel_failed": "تعذر إلغاء إدخال قائمة الانتظار.",
  "summaries_deleted_toast": "تم حذف الملخص.",
  "summaries_delete_failed": "تعذر حذف الملخص.",
  "feedbacks_deleted_toast": "تم حذف الملاحظة.",
  "feedbacks_delete_failed": "تعذر حذف الملاحظة.",
  "feedbacks_comment_added_toast": "تمت إضافة التعليق.",
  "feedbacks_comment_add_failed": "تعذرت إضافة التعليق.",
  "contact_consolidate_success": "تم دمج جهات الاتصال.",
  "feat_org_balance_spend_policy_saved": "تم حفظ ضوابط إنفاق الذكاء الاصطناعي.",
  "feat_org_balance_spend_policy_save_failed": "تعذر حفظ ضوابط إنفاق الذكاء الاصطناعي.",
  "account_notifications_push_devices_revoke_success": "تم إلغاء جهاز الإشعارات.",
  "account_notifications_preferences_update_failed": "تعذر تحديث تفضيلات الإشعارات.",
  "chat_ai_toggle_failed": "تعذر تحديث إعداد الذكاء الاصطناعي للمحادثة.",
  "messenger_bulk_archive_empty_toast": "لا توجد محادثات مقروءة لأرشفتها.",
  "messenger_bulk_archived_toast": "تمت أرشفة {{count}} محادثة.",
  "messenger_bulk_archive_failed": "تعذرت أرشفة كل المحادثات المقروءة.",
  "messenger_archived_toast": "تمت أرشفة المحادثة.",
  "messenger_unarchived_toast": "تم إلغاء أرشفة المحادثة.",
  "messenger_archive_failed": "تعذرت أرشفة المحادثة.",
  "messenger_unarchive_failed": "تعذر إلغاء أرشفة المحادثة.",
  "messenger_label_assigned_toast": "تم تعيين التصنيف.",
  "messenger_label_assign_failed": "تعذر تعيين التصنيف.",
  "messenger_label_removed_toast": "تمت إزالة التصنيف.",
  "messenger_label_remove_failed": "تعذرت إزالة التصنيف.",
  "messenger_label_create_failed": "تعذر إنشاء التصنيف.",
  "messenger_label_created_assignment_failed": "تم إنشاء التصنيف، لكن تعذر تعيينه للمحادثة.",
  "messenger_label_created_toast": "تم إنشاء التصنيف.",
  "campaigns_updated_toast": "تم تحديث الحملة.",
  "campaigns_update_error": "تعذر تحديث الحملة.",
  "campaigns_sent_toast": "بدأ إطلاق الحملة.",
  "campaigns_draft_saved_toast": "تم حفظ مسودة الحملة.",
  "campaigns_cancelled_toast": "تم إلغاء الحملة.",
  "citation_check_failed": "تعذر التحقق من الاستشهادات.",
  "messenger_label_deleted_toast": "تم حذف التصنيف.",
  "messenger_label_delete_failed": "تعذر حذف التصنيف.",
  "pending_org_intent_update_failed": "تعذر حفظ اختيار إعداد المؤسسة.",
  "admin_a_suspend_success": "تم تعليق المؤسسة.",
  "admin_a_unsuspend_success": "تمت استعادة وصول المؤسسة.",
  "admin_a_quarantine_success": "تم حجر المؤسسة.",
  "admin_a_release_success": "تم رفع الحجر عن المؤسسة.",
  "feat_app_feedback_toast_status_updated": "تم تحديث حالة الملاحظة.",
  "feat_admin_org_balance_toast_credit_success": "تمت إضافة {{count}} رصيد إلى المؤسسة.",
  "feat_admin_plans_toast_create_draft_success": "تم إنشاء مسودة الخطة.",
  "feat_admin_plans_toast_update_pricing_success": "تم حفظ تسعير الخطة.",
  "feat_admin_plans_toast_publish_success": "تم نشر الخطة.",
  "feat_admin_plans_toast_phase_out_success": "تم إيقاف الخطة تدريجيًا.",
  "feat_playground_toast_delete_document_success": "تم حذف مستند مساحة التجربة.",
  "feat_playground_toast_toggle_document_success": "تم تحديث حالة مستند مساحة التجربة.",
  "feat_playground_toast_clear_success": "تم مسح مساحة التجربة.",
  "feat_account_privacy_toast_request_deletion_success": "تمت جدولة حذف الحساب.",
  "feat_account_privacy_toast_cancel_deletion_success": "تم إلغاء حذف الحساب.",
  "feat_app_config_toast_upload_document_started": "تمت إضافة مستند المعرفة وبدأت معالجته.",
  "feat_app_config_toast_delete_document_success": "تم حذف مستند المعرفة.",
  "feat_app_config_toast_schema_preload_enabled": "تم تفعيل التحميل المسبق للمخطط.",
  "feat_app_config_toast_schema_preload_disabled": "تم تعطيل التحميل المسبق للمخطط.",
  "feat_app_config_toast_image_policy_updated": "تم تحديث معالجة صور المستند.",
  "feat_app_config_toast_document_enabled": "تم تفعيل مستند المعرفة.",
  "feat_app_config_toast_document_disabled": "تم تعطيل مستند المعرفة.",
  "feat_app_config_toast_apply_strategy_started": "تم تطبيق استراتيجية التضمين وبدأت إعادة المعالجة.",
  "contact_blocked_toast": "تم حظر جهة الاتصال.",
  "contact_unblocked_toast": "تم إلغاء حظر جهة الاتصال.",
  "contact_archived_toast": "تمت أرشفة جهة الاتصال.",
  "contact_restored_toast": "تمت استعادة جهة الاتصال.",
  "contact_beneficiary_added_toast": "تمت إضافة المستفيد.",
  "contact_beneficiary_renamed_toast": "تمت إعادة تسمية المستفيد.",
  "contact_beneficiary_moved_toast": "تم نقل المستفيد.",
  "contact_beneficiary_merged_toast": "تم دمج المستفيدين.",
  "contact_beneficiary_separated_toast": "تم فصل المستفيد إلى جهة اتصال.",
  "contact_beneficiary_pulled_toast": "تم نقل جهة الاتصال تحت جهة الاتصال هذه.",
  "contact_beneficiary_demoted_toast": "تم نقل جهة الاتصال إلى المستفيدين.",
  "contact_beneficiary_archived_toast": "تمت أرشفة المستفيد.",
  "cfg_val_google_maps_url": "أدخل رابط خرائط Google (مثل https://maps.app.goo.gl/… أو https://www.google.com/maps?q=…).",
  "cfg_val_column_problem": "العمود \"{{column}}\" {{reason}}",
  "cfg_val_column_missing_generic": "ينقصه {{field}}.",
  "cfg_val_column_identifier": "ليس له معرّف. المعرّف هو المفتاح الذي تُخزَّن به قيمة كل صف، فبدونه لا يمكن للعمود أن يحمل أي بيانات.",
  "cfg_val_column_data_type": "ليس له نوع بيانات. يختار الجدول محرّر الخلية (مربع نص، منتقي تاريخ، قائمة منسدلة، …) بناءً على نوع البيانات، ولا يمكنه عرض الخلية بدونه.",
  "cfg_val_column_width": "ليس له عرض. يوزّع الجدول الأعمدة بالبكسل ويتخطّى أي عمود لم يُحدَّد عرضه.",
  "cfg_val_column_database_field": "غير مرتبط بأي حقل في السجل. اختر الحقل الذي يقرأ منه — العمود غير المرتبط يظهر فارغًا في كل صف.",
  "cfg_val_column_type_mismatch": "مرتبط بحقل في السجل لا يطابق نوعه نوع بيانات العمود. غيّر أحدهما ليتطابقا، وإلا فسيفشل الجدول في قراءة القيم الموجودة.",
  "cfg_val_column_dropdown_options": "قائمة منسدلة بلا خيارات. أضف خيارًا واحدًا على الأقل، وإلا فلن يمكن اختيار أي شيء في هذا العمود.",
  "cfg_val_working_days_empty": "لا يوجد يوم عمل مُفعَّل. مع إغلاق كل الأيام لا يستطيع التقويم عرض أي موعد متاح، فلا يمكن إجراء أي حجز إطلاقًا.",
  "cfg_val_default_hours_missing": "وقت الفتح والإغلاق الافتراضي غير مكتمل. كل يوم عمل ليس له استثناء خاص يعتمد على هذه الفترة، فلا يمكن توليد المواعيد حتى يُضبط الوقتان.",
  "cfg_val_default_hours_order": "وقت الإغلاق الافتراضي ({{end}}) ليس بعد وقت الفتح ({{start}})، فيصبح طول يوم العمل صفرًا أو سالبًا. الفترات الممتدة عبر منتصف الليل غير مدعومة — استخدم استثناء نطاق تواريخ بدلًا من ذلك.",
  "cfg_val_slot_duration_missing": "مدة الموعد غير محددة أو تساوي صفرًا. يبني التقويم المواعيد المتاحة بقسمة يوم العمل على هذه القيمة، وهو أمر مستحيل عند الصفر.",
  "cfg_val_slot_division_minute": "{{scope}} من {{start}} إلى {{end}} ({{minutes}} دقيقة)، ولا تقسمها مدة {{duration}} بالتساوي — ستتبقى دقيقة واحدة في نهاية اليوم. اختر مدة موعد تقسم الفترة عددًا صحيحًا من المرات، أو غيّر وقت الإغلاق.",
  "cfg_val_slot_division_minutes": "{{scope}} من {{start}} إلى {{end}} ({{minutes}} دقيقة)، ولا تقسمها مدة {{duration}} بالتساوي — ستتبقى {{remainder}} دقيقة في نهاية اليوم. اختر مدة موعد تقسم الفترة عددًا صحيحًا من المرات، أو غيّر وقت الإغلاق.",
  "cfg_val_scope_default_day": "يوم العمل الافتراضي",
  "cfg_val_scope_day_override": "استثناء يوم {{day}}",
  "cfg_val_event_types_empty": "لم يُعرَّف أي نوع موعد. نوع الموعد هو ما يحجزه العميل (استشارة، فحص، …) — وبدون أي نوع لا تجد أدوات الحجز لدى المساعد ولا مسار الحجز شيئًا لعرضه.",
  "cfg_val_event_type_no_id": "نوع الموعد رقم {{n}} ليس له معرّف. المعرّف هو ما تشير إليه الحجوزات والتذكيرات وأدوات المساعد، فلا يمكن حفظ الصف بدونه.",
  "cfg_val_event_type_no_name": "نوع الموعد رقم {{n}} ليس له اسم. الاسم هو ما يراه العملاء عند اختيار ما يحجزونه وما يقرؤه المساعد عليهم.",
  "cfg_val_booking_requirements": "خيارا «طلب الاسم» و«طلب رقم الهاتف» كلاهما مُعطَّل، فقد يُنشأ حجز دون أي وسيلة لتحديد هوية العميل أو التواصل معه. أعد تفعيل أحدهما على الأقل.",
  "cfg_val_day_override_order": "استثناء يوم {{day}} يُغلق عند {{end}}، وهو ليس بعد وقت الفتح {{start}}. هذه الفترة لا تغطي أي وقت، فلن يكون ليوم {{day}} أي مواعيد.",
  "cfg_val_range_override_hours": "استثناء نطاق التواريخ \"{{label}}\" به مشكلة في ساعات العمل: وقت إغلاق ليس بعد وقت الفتح، أو ساعات لا تقسمها مدة الموعد بالتساوي. افتح الاستثناء وصحّح الأوقات التي يشير إليها — فما دام غير صالح لا يستطيع التقويم توليد مواعيد للتواريخ التي يغطيها.",
  "cfg_val_day_overlapping_ranges": "اليوم {{day}} به فترات عمل متداخلة",
  "cfg_val_slot_duration_positive": "يجب أن تكون مدة الموعد أكبر من صفر",
  "cfg_val_event_type_required": "مطلوب نوع موعد واحد على الأقل",
  "cfg_val_id_required": "المعرّف مطلوب",
  "cfg_val_reminder_name_required": "التذكير يحتاج إلى اسم.",
  "cfg_val_reminder_name_too_long": "اجعل اسم التذكير أقل من 50 حرفًا.",
  "cfg_val_reminder_no_name": "التذكير رقم {{n}} بلا اسم. {{reason}}",
  "cfg_val_reminder_bad_name": "اسم التذكير \"{{name}}\" يحتوي على رموز لا يستطيع المجدول استخدامها. {{reason}}",
  "cfg_val_reminder_no_template": "التذكير \"{{label}}\" لم يُختَر له قالب رسالة. لا يوصّل واتساب إلا القوالب المعتمدة مسبقًا، فسيُسقَط هذا التذكير عند الإرسال.",
  "cfg_val_reminder_no_language": "التذكير \"{{label}}\" ليس له لغة قالب. يُعتمَد القالب لكل لغة على حدة، فيحتاج المزوّد إلى معرفة أي نسخة لغوية يرسل.",
  "cfg_val_reminder_unmapped_vars": "التذكير \"{{label}}\" يترك {{vars}} دون ربط. يجب ربط كل متغيّر في القالب بحقل من حقول الحجز، وإلا رفض المزوّد الرسالة.",
  "cfg_val_rule_no_name": "قاعدة الإشعار رقم {{n}} بلا اسم. الاسم هو ما تُعرَف به القاعدة في سجل الإرسال، فالقاعدة بلا اسم يتعذّر تتبّعها بعد تنفيذها.",
  "cfg_val_rule_no_template": "قاعدة الإشعار \"{{label}}\" لم يُختَر لها قالب رسالة. لا يوصّل واتساب إلا القوالب المعتمدة مسبقًا، فستُسقَط هذه القاعدة عند الإرسال.",
  "cfg_val_rule_unmapped_vars": "قاعدة الإشعار \"{{label}}\" تترك {{vars}} دون ربط. يجب ربط كل متغيّر في القالب بقيمة، وإلا رفض المزوّد الرسالة.",
  "cfg_val_rule_no_recipients": "القاعدة المخصّصة \"{{label}}\" بلا مستلمين. القاعدة المخصّصة غير مرتبطة بحجز، فليس لديها جمهور تستنتجه — اختر رقم هاتف واحدًا على الأقل لإرسالها إليه.",
  "cfg_val_rule_no_send_time": "القاعدة المخصّصة \"{{label}}\" بلا تاريخ ووقت إرسال. القاعدة المخصّصة تُنفَّذ في لحظة محدّدة لا نسبةً إلى حجز، فلن تُنفَّذ أبدًا بدونهما.",
  "cfg_val_custom_rule_scheduled_at": "تاريخ ووقت الإرسال مطلوبان للقواعد المخصّصة",
  "cfg_val_no_calendar_view": "لا يوجد عرض تقويم مُفعَّل. تعرض صفحة التقويم أحد هذه العروض، فبدون أي عرض مُفعَّل لا يوجد ما تعرضه.",
  "cfg_val_default_view_not_enabled": "\"{{view}}\" مضبوط كعرض افتراضي لكنه ليس ضمن العروض المُفعَّلة، فسيفتح التقويم على عرض لا يستطيع أحد العودة إليه. فعّله، أو اختر عرضًا افتراضيًا من القائمة المُفعَّلة.",
  "cfg_val_must_be_one_of": "يجب أن يكون أحد التالي: {{values}}",
  "cfg_val_no_theme_enabled": "لا توجد سمة مُفعَّلة. يختار كل عضو مظهره من هذه القائمة، فالقائمة الفارغة تترك التطبيق بلا سمة يعرضها.",
  "cfg_val_no_language_enabled": "لا توجد لغة عرض مُفعَّلة. يعتمد التطبيق وقوالب الإشعارات وأدوات المساعد المرتبطة باللغة جميعها على هذه القائمة في تحديد لغتها.",
  "cfg_val_no_calendar_columns": "جدول التقويم بلا أعمدة. كل حقل حجز يظهر في الجدول يأتي من هذه القائمة، فسيظهر الجدول فارغًا.",
  "cfg_val_no_document_columns": "جدول المستندات بلا أعمدة. كل حقل يظهر في جدول المستندات يأتي من هذه القائمة، فسيظهر الجدول فارغًا.",
  "cfg_val_language_required": "مطلوب لغة واحدة على الأقل",
  "cfg_val_english_required": "يجب أن تكون الإنجليزية (en) مُضمَّنة دائمًا",
  "cfg_val_system_prompt_missing": "المساعد بلا تعليمات. بدونها يردّ بسلوك النموذج العام بدلًا من نبرة عملك وسياساته وحدوده. اكتب تعليمات في محرّر التعليمات، أو طبّق أحد إعدادات المساعد المحفوظة من المبدّل أعلى هذا القسم.",
  "cfg_val_context_window_label": "نافذة سياق {{model}} البالغة {{tokens}} رمزًا",
  "cfg_val_system_prompt_over_context": "التعليمات تبلغ نحو {{tokens}} رمزًا، وهي لا تتّسع داخل {{window}}. تُرسَل التعليمات مع كل رسالة، فسيُرفض الطلب قبل حتى قراءة سؤال العميل. اختصرها، أو اختر نموذجًا بنافذة أكبر.",
  "cfg_val_system_prompt_no_headroom": "التعليمات تبلغ نحو {{tokens}} رمزًا، و{{window}} لا تترك سوى {{left}} لكل ما تبقّى — أقل من {{reserved}} رمزًا محجوزة للردّ وسجل المحادثة. اختصر التعليمات، أو اخفض الحد الأقصى لرموز الإخراج، أو اختر نموذجًا بنافذة أكبر.",
  "cfg_val_max_output_above_window": "الحد الأقصى لرموز الإخراج ({{tokens}}) يستهلك كامل نافذة {{model}} البالغة {{window}} رمزًا، فلا يبقى شيء للتعليمات ولا لرسالة العميل. اجعل مساحة الإخراج أقل بكثير من حجم النافذة.",
  "cfg_val_model_cannot_call_tools": "{{model}} لا يدعم استدعاء الأدوات، لكن الأدوات مُفعَّلة بالأسفل. لن يستدعي المساعد أيًّا منها دون أي تنبيه — فلن يستطيع الحجز ولا البحث ولا قراءة قاعدة المعرفة. اختر نموذجًا يدعم الأدوات أو عطّل الأدوات كلها.",
  "cfg_val_the_selected_model": "النموذج المختار",
  "cfg_val_the_selected_model_caps": "النموذج المختار",
  "cfg_val_kb_source": "مصدر واحد في قاعدة المعرفة",
  "cfg_val_kb_sources": "{{count}} مصدرًا في قاعدة المعرفة",
  "cfg_val_kb_tools_off": "لقد رفعت {{sources}}، لكن أدوات قاعدة المعرفة مُعطَّلة، فلن يستطيع المساعد قراءة أي منها. أعد تفعيل أدوات قاعدة المعرفة، أو احذف المصادر.",
  "cfg_val_kb_retrieval_disabled": "لقد رفعت {{sources}}، لكن لا توجد أداة استرجاع مستندات مُفعَّلة، فليس لدى المساعد وسيلة للبحث فيها. فعّل أداة قاعدة المعرفة (البحث في المستندات).",
  "cfg_val_kb_no_embedding_model": "لقد رفعت {{sources}}، لكن لم يُختَر نموذج تضمين. يجري البحث في المستندات المرفوعة بمقارنة التضمينات، فبدونه سيعود كل بحث في قاعدة المعرفة بلا نتيجة.",
  "cfg_val_scheduling_actions_disabled": "الحجز مُفعَّل للمساعد، لكن كل إجراءات الحجز (الحجز، إعادة الجدولة، الإلغاء، الانضمام لقائمة الانتظار) مُعطَّلة. يستطيع المساعد إخبار العميل بالمواعيد المتاحة ثم لا يفعل بها شيئًا — فعّل إجراء حجز واحدًا على الأقل، أو عطّل أدوات الحجز بالكامل.",
  "cfg_val_researcher_model_missing": "وضع الإجابة {{mode}} يشغّل وكيل بحث فرعيًا قبل الردّ، لكن لم يُختَر نموذج للبحث، فلا يوجد ما تعمل عليه هذه الخطوة. اختر نموذجًا، أو ارجع إلى الوضع 1 (وكيل واحد).",
  "cfg_val_verifier_model_missing": "وضع الإجابة 5 يتحقّق من كل مسودة إجابة قبل إرسالها، لكن لم يُختَر نموذج للتحقّق، فلا يوجد ما يعمل عليه التحقّق. اختر نموذجًا، أو ارجع إلى الوضع 4.",
  "cfg_val_lead_fields_missing": "جمع بيانات العملاء المحتملين مُفعَّل لكن لم يُعرَّف أي حقل، فلن يسأل المساعد عن شيء ولن يحفظ شيئًا. أضف حقلًا واحدًا على الأقل، أو عطّل جمع البيانات.",
  "cfg_val_save_feedback_language": "تسجيل الملاحظات مُفعَّل لكن لغة ملخّصه ليست ضمن لغات العرض المُفعَّلة، فسيُكتب كل ملخّص بلغة لا يستطيع التطبيق عرضها. اختر لغة من القائمة المُفعَّلة.",
  "cfg_val_summarize_language": "ملخّصات المحادثات مُفعَّلة لكن لغة الملخّص ليست ضمن لغات العرض المُفعَّلة، فسيُكتب كل ملخّص بلغة لا يستطيع التطبيق عرضها. اختر لغة من القائمة المُفعَّلة.",
  "cfg_val_tool_language_required": "{{label}} مطلوبة للأداة {{tool}}.",
  "cfg_val_tool_language_not_enabled": "يجب أن تكون لغة الملخّص إحدى لغات العرض المُفعَّلة.",
  "cfg_val_fallback_not_allowed": "عندما يكون النموذج الأساسي «auto» فهو يتولّى التوجيه الاحتياطي بنفسه. عطّل النموذج الاحتياطي أو اختر نموذجًا أساسيًا محدّدًا أولًا.",
  "cfg_val_fallback_required": "اختر نموذجًا احتياطيًا للنموذج الأساسي — حدّد نموذجًا، أو استخدم «auto».",
  "cfg_val_fallback_invalid_model": "يجب أن يكون النموذج الاحتياطي اختيارًا صالحًا لنموذج",
  "cfg_val_fallback_same_as_primary": "لا يمكن أن يستخدم النموذج الاحتياطي النموذج والمزوّد نفسيهما المستخدمين في النموذج الأساسي. اختر نموذجًا أو مزوّدًا مختلفًا.",
  "cfg_req_business_name": "يعرّف المساعد بنفسه باسم عملك، وكل قالب إشعار يُذيَّل به. إن تُرك فارغًا وصلت العملاء رسائل من مُرسِل بلا اسم.",
  "cfg_req_business_address": "يجيب المساعد عن سؤال «أين تقعون؟» من هذا الحقل، ويُدرَج في كل إرشادات وصول يقدّمها. إن تُرك فارغًا اضطُر لإخبار العملاء بأنه لا يعرف موقع العمل.",
  "cfg_req_business_floor_unit": "الطابق أو الوحدة هو آخر جزء من إرشادات الوصول التي يقدّمها المساعد — فعنوان الشارع وحده يترك العملاء واقفين في المدخل. اكتب «الطابق الأرضي» هنا إن لم يكن هناك سواه.",
  "cfg_req_business_landmark": "المَعلَم القريب هو ما يستخدمه المساعد لإرشاد العملاء الذين لا يجدون المدخل من عنوان الشارع وحده. اذكر أقرب مبنى أو تقاطع معروف.",
  "cfg_req_business_maps_url": "هذا هو رابط الخريطة الذي يرسله المساعد عندما يطلب العميل إرشادات الوصول. تحديد موقع بالمنتقي أدناه يملؤه نيابةً عنك.",
  "cfg_req_country_prefix": "كل رقم هاتف يُكتب بدون رمز دولة يُوحَّد وفق هذه البادئة. إن تُركت فارغة تعذّر مطابقة الأرقام المحلية بجهات اتصالها ولم تصل الرسائل إلى أحد.",
  "cfg_req_timezone": "كل وقت حجز ووقت إرسال تذكير وطابع زمني يذكره المساعد يُحسَب بهذه المنطقة الزمنية. إن تُركت فارغة فلا سبيل لمعرفة ما تعنيه «الثالثة عصرًا».",
  "cfg_req_llm_model": "لم يُختَر أي نموذج ذكاء اصطناعي، فليس لدى المساعد ما يعمل عليه — ولن يستطيع الردّ على رسالة واحدة. اختر النموذج الذي سيستخدمه.",
  "cfg_req_working_days": "تُولَّد المواعيد المتاحة من أيام العمل. وبدون اختيار أي يوم لا يستطيع التقويم عرض أي موعد قابل للحجز.",
  "cfg_req_default_working_hours": "كل يوم عمل ليس له استثناء خاص يعتمد على وقتي الفتح والإغلاق هذين، فلا يمكن توليد المواعيد حتى يُضبطا معًا.",
  "cfg_req_event_types": "نوع الموعد هو ما يحجزه العميل. وبدون تعريف أي نوع لا يجد مسار الحجز ولا أدوات الحجز لدى المساعد شيئًا لعرضه.",
  "cfg_req_generic": "{{label}} مطلوب في خطتك وهو فارغ حاليًا. املأه لتتمكّن من الحفظ.",
  "cfg_val_label_working_days": "أيام العمل",
  "cfg_val_label_default_hours": "ساعات العمل الافتراضية",
  "cfg_val_label_slot_duration": "مدة الموعد",
  "cfg_val_label_event_types": "أنواع المواعيد",
  "cfg_val_label_booking_requirements": "متطلبات الحجز",
  "cfg_val_label_day_override": "استثناءات — {{day}}",
  "cfg_val_label_range_override": "استثناء نطاق تواريخ — {{label}}",
  "cfg_val_label_reminder": "تذكير — {{label}}",
  "cfg_val_label_notification_rule": "قاعدة إشعار — {{label}}",
  "cfg_val_label_available_views": "عروض التقويم المتاحة",
  "cfg_val_label_default_view": "عرض التقويم الافتراضي",
  "cfg_val_label_themes": "السمات",
  "cfg_val_label_languages": "اللغات",
  "cfg_val_list_calendar_columns": "أعمدة التقويم",
  "cfg_val_list_documents_columns": "أعمدة المستندات",
  "cfg_val_label_document_columns": "أعمدة المستندات",
  "cfg_val_label_system_prompt": "تعليمات النظام",
  "cfg_val_label_max_output_tokens": "الحد الأقصى لرموز الإخراج",
  "cfg_val_label_ai_model": "نموذج الذكاء الاصطناعي",
  "cfg_val_label_ai_tools": "أدوات الذكاء الاصطناعي",
  "cfg_val_label_kb_tools": "أدوات قاعدة المعرفة",
  "cfg_val_label_embedding_model": "نموذج التضمين",
  "cfg_val_label_researcher_model": "نموذج البحث",
  "cfg_val_label_verifier_model": "نموذج التحقّق",
  "cfg_val_label_lead_collection": "جمع بيانات العملاء المحتملين",
  "cfg_val_label_feedback_language": "لغة ملخّص الملاحظات",
  "cfg_val_label_summary_language": "لغة الملخّص",
  "cfg_val_section_appearance_themes": "المظهر > السمات",
  "cfg_val_section_appearance_languages": "المظهر > اللغات",
  "cfg_val_section_calendar_columns": "البيانات > أعمدة التقويم",
  "cfg_val_section_documents_columns": "البيانات > أعمدة المستندات",
  "cfg_val_context_appearance_data": "المظهر والبيانات",
  "cfg_val_weekday_sunday": "الأحد",
  "cfg_val_weekday_monday": "الاثنين",
  "cfg_val_weekday_tuesday": "الثلاثاء",
  "cfg_val_weekday_wednesday": "الأربعاء",
  "cfg_val_weekday_thursday": "الخميس",
  "cfg_val_weekday_friday": "الجمعة",
  "cfg_val_weekday_saturday": "السبت",
  "cfg_val_weekday_unknown": "اليوم {{n}}",
  "cfg_val_latitude_range": "يجب أن يكون خط العرض بين -90 و90 درجة.",
  "cfg_val_longitude_range": "يجب أن يكون خط الطول بين -180 و180 درجة.",
  "cfg_val_country_prefix_shape": "أدخل بادئة الاتصال بالشكل + متبوعًا بـ 1 إلى 4 أرقام (مثل +966).",
  "cfg_val_timezone_unknown": "اختر منطقة زمنية من القائمة — هذا ليس اسم منطقة زمنية معروفًا في قاعدة IANA.",
  "campaigns_capacity_preview": "{{eligible}} مستلم مؤهل · {{unique}} مستلم يومي جديد · {{monthly}} رسالة شهرية متاحة",
  "campaigns_capacity_unavailable": "السعة غير متاحة. حدّث البيانات قبل الإرسال.",
  "campaigns_capacity_checking": "جارٍ التحقق من سعة الإرسال…",
  "campaigns_setup_required": "يلزم إعداد واتساب",
  "campaigns_sender_blocked": "الإرسال عبر واتساب مقيّد",
  "campaigns_capacity_reserved": "{{count}} مستلم محجوز",
  "campaigns_capacity_delivered": "تم رصد تسليم الرسائل إلى {{count}} مستلم",
  "campaigns_monthly_capacity": "رسائل الحملات الشهرية: {{used}} مستخدمة · {{reserved}} محجوزة · {{limit}} مسموحة",
  "campaigns_capacity_next": "موعد تحرير السعة المتوقع: {{time}}",
  "campaigns_capacity_checked": "آخر تحقق ناجح: {{time}}",
  "campaigns_refresh_capacity": "تحديث السعة",
  "campaigns_worker_required": "يلزم تشغيل عامل الحملات"
}
